import React from "react";
import { ContextLanguage } from "../context/Context.Language";
import {
  TEXT_ANTIBACTERIAL_SANITISER,
  TEXT_BABY_WASH,
  TEXT_BLEACHING_FOR_WHITES,
  TEXT_BOTTLE,
  TEXT_COMFORTER_OR_DUVET_INSERT,
  TEXT_DEODORANT_DISINFECTION,
  TEXT_DUVET_COVER_OR_BED_SHEET,
  TEXT_HANG,
  TEXT_HANG_PLUS,
  TEXT_HIGH_TEMPERATURE_WASH,
  TEXT_IRON,
  TEXT_LAUNDRY_PERFUME,
  TEXT_LOW_HEAT_DRY,
  TEXT_NOSOFTENER,
  TEXT_ORGANIC_WASH,
  TEXT_PIECES,
  TEXT_PIECES_MY_LAUNDRY,
  TEXT_PILLOWS,
  TEXT_PROGRAM_MYWASH,
  TEXT_PROTECTION_WATERPROOF,
  TEXT_SMOOTH_STARCH,
  TEXT_STAIN_REMOVAL,
  TEXT_UPTO,
  TYPE_CASH,
  TYPE_HOME,
  TYPE_MASTERCARD,
  TYPE_MYDRY,
  TYPE_MYIRON,
  TYPE_MYSHOES,
  TYPE_MYWASH,
  TYPE_OTHER,
  TYPE_VISA,
  TYPE_WORK,
} from "./useConstants";
import { STATE_CONSTANTS_PROGRAM } from "./useConstantState";

export const mock_configs = {
  EN: {
    configs: [
      {
        _id: "631185cb50dac232a373a66c",
        pickup_title: "Contactless Pick-Up & Return",
        pickup_description:
          "Contactless Pick-Up &amp; Return is our standard. To ensure a smooth process, double-check your\nAddress and Edit it if necessary. With Google Maps integrated into our system, you can simply\nsearch for your address by its name or choose it from the map, the same as doing it from\nGoogle Maps itself. Additionally, we kindly ask you to provide us with your Address Details as\nthis will help us to find your laundry and shoes at your home, hotel or any place you want as\nlong as it is readily accessible. Just give us a little hint, e.g. “I will leave the laundry with the\nreceptionist” or “I placed the bags in the mailroom”. If you wish to hand over or receive your\nlaundry and shoes personally, kindly also notify us of this in the Address Details before placing\nyour order. Then, simply choose your preferred pick-up and return date and a time-slot and\n\nyou are ready to go!",
        pickup_image_key_desktop: "1662697705165_Frame 52882.png",
        pickup_image_key_mobile: "1662697705803_Frame 52882.png",
        same_day_title: "Same Day Express Service",
        same_day_description:
          "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
        same_day_image_key_desktop: "1662697784705_timer 1.png",
        same_day_image_key_mobile: "1662697785026_timer 1.png",
        order_summary_title: "Same Day Express Service",
        order_summary_description:
          "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
        order_summary_image_key_desktop: "1662697890856_Add-ons (2).png",
        order_summary_image_key_mobile: "1662697891273_Add-ons (2).png",
        payment_method_image_key_desktop: "1662697963638_Add-ons (3).png",
        payment_method_image_key_mobile: "1662697964048_Add-ons (3).png",
        program_method_title: "Select Your Service",
        program_method_description:
          "Whether you select My Wash, My Iron or My Shoes, our professional laundry service as well as our shoe cleaning service are fully customisable meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday.\n",
        program_method_image_key_desktop: "1668581615885_Add-ons (1).png",
        program_method_image_key_mobile: "Add-ons (1).png",
        createdAt: "2022-09-02T04:25:47.152Z",
        updatedAt: "2022-12-22T10:44:00.955Z",
        same_day_price: 300,
        extra_service_image_key_desktop: "1664526329460_Extras (1).png",
        extra_service_image_key_mobile: "1664526330025_Extras (1).png",
        water_title: "Finn Drinking Water",
        water_description:
          "Each time you book our professional laundry service or shoe cleaning service, you now also\nhave the option of ordering our family-owned Finn Drinking Water to be delivered to your\ndoorstep when we pick up your order. Finn is available in 3 different bottle sizes: 350 ml, 600 ml\nand 1.5 l. We are able to deliver you a fixed quantity of 3 packs of the 350 ml bottle (48 bottles)\nOR 3 packs of the 600 ml bottle (36 bottles) OR 3 packs of the 1.5 l bottle (18 bottles) per order.\nWe limit each order to a total of 3 packs of one bottle size due to the capacity limitations of our\ndelivery boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly\ngrowing in popularity due to its extraordinary taste and attractive pricing strategy compared\nto international brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
        water_image_key_desktop: "1664526410948_Add-ons (46).png",
        water_image_key_mobile: "1664526411236_Add-ons (46).png",
        pickup_description_2:
          "Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-\n16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-\n16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express\nShoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and\nwill be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day\nExpress Service is only available in Bangkok and can be booked before and until 11:30 am on the\nsame day you wish to use the service. For all orders, we will return it on or before the scheduled\n\ntime if we finish it earlier.",
        same_day_description_2: "",
        order_summary_description_2: "",
        program_method_description_2:
          "We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Service is only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time if we finish it earlier.",
        program_method_description_2_en:
          "We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Service is only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time if we finish it earlier.",
        program_method_description_2_th:
          "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-\n16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน\nซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน\nหมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
        program_method_description_en:
          "Whether you select My Wash, My Iron or My Shoes, our professional laundry service as well as our shoe cleaning service are fully customisable meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday.\n",
        program_method_description_th:
          "ไม่ว่าคุณจะเลือก My Wash, My Iron หรือ My Shoes\n\nบริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร\nสะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
        program_method_title_en: "Select Your Service",
        program_method_title_th: "เลือกบริการ",
        pickup_description_2_en:
          "Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-\n16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-\n16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express\nShoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and\nwill be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day\nExpress Service is only available in Bangkok and can be booked before and until 11:30 am on the\nsame day you wish to use the service. For all orders, we will return it on or before the scheduled\n\ntime if we finish it earlier.",
        pickup_description_en:
          "Contactless Pick-Up &amp; Return is our standard. To ensure a smooth process, double-check your\nAddress and Edit it if necessary. With Google Maps integrated into our system, you can simply\nsearch for your address by its name or choose it from the map, the same as doing it from\nGoogle Maps itself. Additionally, we kindly ask you to provide us with your Address Details as\nthis will help us to find your laundry and shoes at your home, hotel or any place you want as\nlong as it is readily accessible. Just give us a little hint, e.g. “I will leave the laundry with the\nreceptionist” or “I placed the bags in the mailroom”. If you wish to hand over or receive your\nlaundry and shoes personally, kindly also notify us of this in the Address Details before placing\nyour order. Then, simply choose your preferred pick-up and return date and a time-slot and\n\nyou are ready to go!",
        pickup_title_en: "Contactless Pick-Up & Return",
        pickup_description_2_th:
          "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์\n\n14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น.\n\nนอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น.\n\nและส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\n\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
        pickup_description_th:
          "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีการรับและส่งคืนออเดอร์แบบไร้การสัมผัสเป็นมาตรฐาน\n\nเพื่อให้แน่ใจว่าออเดอร์ของคุณดำเนินตามขั้นตอนอย่างเรียบร้อย\nโปรดตรวจสอบที่อยู่ของคุณอีกครั้งและแก้ไขหากจำเป็น\n\nคุณสามารถค้นหาที่อยู่โดยพิมพ์ชื่อหรือเลือกจากแผนที่กูเกิ้ลในระบบของเรา เช่นเดียวกับการใช้กูเกิ้ลแมพ\n\nนอกจากนี้กรุณาให้รายละเอียดที่อยู่เพิ่มเติมเพื่อความชัดเจน\n\nซึ่งจะช่วยให้เราไปรับผ้าและรองเท้าของคุณได้ทุกที่ ไม่ว่าจะเป็นบ้าน โรงแรม หรือสถานที่อื่นๆที่คุณต้องการ\n\nเพียงแค่บอกเรา เช่น ฝากไว้กับประชาสัมพันธ์ หรือ วางไว้ในห้องรับจดหมาย\nหากคุณต้องการรับและส่งคืนออเดอร์ด้วยตนเอง (เจอผู้รับส่ง)\nกรุณาแจ้งในช่องรายละเอียดที่อยู่ก่อนสั่งออเดอร์ จากนั้นเลือกวันและเวลารับส่งคืน\n\nเท่านี้ก็พร้อมเริ่มต้นได้เลย!",
        pickup_title_th: "รับและส่งคืนแบบไร้การสัมผัส",
        same_day_description_2_en: "",
        same_day_description_en:
          "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
        same_day_title_en: "Same Day Express Service",
        same_day_description_2_th: "",
        same_day_description_th:
          "เฉพาะในกรุงเทพเท่านั้น เมื่อเลือกบริการส่งคืนด่วนในวันเดียวกัน เราจะไปรับออเดอร์ในช่วงเวลา 10:00-\n\n12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ",
        same_day_title_th: "บริการส่งคืนด่วนในวันเดียวกัน",
        order_summary_description_2_en: "",
        order_summary_description_en:
          "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
        order_summary_title_en: "Same Day Express Service",
        order_summary_description_2_th: "",
        order_summary_description_th:
          "สรุปออเดอร์ ประกอบด้วย รายละเอียดของบริการทั้งหมด (My Wash, My Iron หรือ My Shoes) แพ็กเกจ\n(S, M หรือ L) และตัวเลือกเพิ่มเติม (เช่น รีดผ้า) ซึ่งอยู่ในบริการซักผ้าและทำความสะอาดรองเท้าที่คุณเลือก\nกรุณาตรวจสอบอย่างละเอียดก่อนทำการสั่งออเดอร์หรือคลิกที่ปุ่ม แก้ไข หากคุณต้องการเปลี่ยนแปลง",
        order_summary_title_th: "สรุปออเดอร์",
        water_description_2_th: "",
        water_description_th:
          "ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\n\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ น้ำดื่มฟินมีขวด 3 ขนาด ได้แก่\n\n350 มล. 600 มล. และ 1.5 ล. โดยจัดส่งแต่ละ\n\nออเดอร์ในปริมาณที่กำหนดคือ 3 แพ็กของขวด 350 มล. (48 ขวด) หรือ 3 แพ็กของขวด 600 มล. (36\nขวด) หรือ 3 แพ็กของขวด 1.5 ล. (18 ขวด) เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3\nแพ็กต่อหนึ่งออเดอร์ เนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
        water_title_th: "น้ำดื่มฟิน",
        water_description_2_en: "",
        water_description_en:
          "Each time you book our professional laundry service or shoe cleaning service, you now also\nhave the option of ordering our family-owned Finn Drinking Water to be delivered to your\ndoorstep when we pick up your order. Finn is available in 3 different bottle sizes: 350 ml, 600 ml\nand 1.5 l. We are able to deliver you a fixed quantity of 3 packs of the 350 ml bottle (48 bottles)\nOR 3 packs of the 600 ml bottle (36 bottles) OR 3 packs of the 1.5 l bottle (18 bottles) per order.\nWe limit each order to a total of 3 packs of one bottle size due to the capacity limitations of our\ndelivery boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly\ngrowing in popularity due to its extraordinary taste and attractive pricing strategy compared\nto international brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
        water_title_en: "Finn Drinking Water",
        water_description_2: "",
      },
    ],
    config: {
      _id: "631185cb50dac232a373a66c",
      pickup_title: "Contactless Pick-Up & Return",
      pickup_description:
        "Contactless Pick-Up &amp; Return is our standard. To ensure a smooth process, double-check your\nAddress and Edit it if necessary. With Google Maps integrated into our system, you can simply\nsearch for your address by its name or choose it from the map, the same as doing it from\nGoogle Maps itself. Additionally, we kindly ask you to provide us with your Address Details as\nthis will help us to find your laundry and shoes at your home, hotel or any place you want as\nlong as it is readily accessible. Just give us a little hint, e.g. “I will leave the laundry with the\nreceptionist” or “I placed the bags in the mailroom”. If you wish to hand over or receive your\nlaundry and shoes personally, kindly also notify us of this in the Address Details before placing\nyour order. Then, simply choose your preferred pick-up and return date and a time-slot and\n\nyou are ready to go!",
      pickup_image_key_desktop: "1662697705165_Frame 52882.png",
      pickup_image_key_mobile: "1662697705803_Frame 52882.png",
      same_day_title: "Same Day Express Service",
      same_day_description:
        "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
      same_day_image_key_desktop: "1662697784705_timer 1.png",
      same_day_image_key_mobile: "1662697785026_timer 1.png",
      order_summary_title: "Same Day Express Service",
      order_summary_description:
        "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
      order_summary_image_key_desktop: "1662697890856_Add-ons (2).png",
      order_summary_image_key_mobile: "1662697891273_Add-ons (2).png",
      payment_method_image_key_desktop: "1662697963638_Add-ons (3).png",
      payment_method_image_key_mobile: "1662697964048_Add-ons (3).png",
      program_method_title: "Select Your Service",
      program_method_description:
        "Whether you select My Wash, My Iron or My Shoes, our professional laundry service as well as our shoe cleaning service are fully customisable meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday.\n",
      program_method_image_key_desktop: "1668581615885_Add-ons (1).png",
      program_method_image_key_mobile: "Add-ons (1).png",
      createdAt: "2022-09-02T04:25:47.152Z",
      updatedAt: "2022-12-22T10:44:00.955Z",
      same_day_price: 300,
      extra_service_image_key_desktop: "1664526329460_Extras (1).png",
      extra_service_image_key_mobile: "1664526330025_Extras (1).png",
      water_title: "Finn Drinking Water",
      water_description:
        "Each time you book our professional laundry service or shoe cleaning service, you now also\nhave the option of ordering our family-owned Finn Drinking Water to be delivered to your\ndoorstep when we pick up your order. Finn is available in 3 different bottle sizes: 350 ml, 600 ml\nand 1.5 l. We are able to deliver you a fixed quantity of 3 packs of the 350 ml bottle (48 bottles)\nOR 3 packs of the 600 ml bottle (36 bottles) OR 3 packs of the 1.5 l bottle (18 bottles) per order.\nWe limit each order to a total of 3 packs of one bottle size due to the capacity limitations of our\ndelivery boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly\ngrowing in popularity due to its extraordinary taste and attractive pricing strategy compared\nto international brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      water_image_key_desktop: "1664526410948_Add-ons (46).png",
      water_image_key_mobile: "1664526411236_Add-ons (46).png",
      pickup_description_2:
        "Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-\n16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-\n16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express\nShoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and\nwill be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day\nExpress Service is only available in Bangkok and can be booked before and until 11:30 am on the\nsame day you wish to use the service. For all orders, we will return it on or before the scheduled\n\ntime if we finish it earlier.",
      same_day_description_2: "",
      order_summary_description_2: "",
      program_method_description_2:
        "We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Service is only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time if we finish it earlier.",
      program_method_description_2_en:
        "We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Service is only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time if we finish it earlier.",
      program_method_description_2_th:
        "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-\n16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน\nซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน\nหมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
      program_method_description_en:
        "Whether you select My Wash, My Iron or My Shoes, our professional laundry service as well as our shoe cleaning service are fully customisable meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday.\n",
      program_method_description_th:
        "ไม่ว่าคุณจะเลือก My Wash, My Iron หรือ My Shoes\n\nบริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร\nสะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
      program_method_title_en: "Select Your Service",
      program_method_title_th: "เลือกบริการ",
      pickup_description_2_en:
        "Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-\n16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-\n16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express\nShoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and\nwill be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day\nExpress Service is only available in Bangkok and can be booked before and until 11:30 am on the\nsame day you wish to use the service. For all orders, we will return it on or before the scheduled\n\ntime if we finish it earlier.",
      pickup_description_en:
        "Contactless Pick-Up &amp; Return is our standard. To ensure a smooth process, double-check your\nAddress and Edit it if necessary. With Google Maps integrated into our system, you can simply\nsearch for your address by its name or choose it from the map, the same as doing it from\nGoogle Maps itself. Additionally, we kindly ask you to provide us with your Address Details as\nthis will help us to find your laundry and shoes at your home, hotel or any place you want as\nlong as it is readily accessible. Just give us a little hint, e.g. “I will leave the laundry with the\nreceptionist” or “I placed the bags in the mailroom”. If you wish to hand over or receive your\nlaundry and shoes personally, kindly also notify us of this in the Address Details before placing\nyour order. Then, simply choose your preferred pick-up and return date and a time-slot and\n\nyou are ready to go!",
      pickup_title_en: "Contactless Pick-Up & Return",
      pickup_description_2_th:
        "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์\n\n14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น.\n\nนอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น.\n\nและส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\n\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
      pickup_description_th:
        "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีการรับและส่งคืนออเดอร์แบบไร้การสัมผัสเป็นมาตรฐาน\n\nเพื่อให้แน่ใจว่าออเดอร์ของคุณดำเนินตามขั้นตอนอย่างเรียบร้อย\nโปรดตรวจสอบที่อยู่ของคุณอีกครั้งและแก้ไขหากจำเป็น\n\nคุณสามารถค้นหาที่อยู่โดยพิมพ์ชื่อหรือเลือกจากแผนที่กูเกิ้ลในระบบของเรา เช่นเดียวกับการใช้กูเกิ้ลแมพ\n\nนอกจากนี้กรุณาให้รายละเอียดที่อยู่เพิ่มเติมเพื่อความชัดเจน\n\nซึ่งจะช่วยให้เราไปรับผ้าและรองเท้าของคุณได้ทุกที่ ไม่ว่าจะเป็นบ้าน โรงแรม หรือสถานที่อื่นๆที่คุณต้องการ\n\nเพียงแค่บอกเรา เช่น ฝากไว้กับประชาสัมพันธ์ หรือ วางไว้ในห้องรับจดหมาย\nหากคุณต้องการรับและส่งคืนออเดอร์ด้วยตนเอง (เจอผู้รับส่ง)\nกรุณาแจ้งในช่องรายละเอียดที่อยู่ก่อนสั่งออเดอร์ จากนั้นเลือกวันและเวลารับส่งคืน\n\nเท่านี้ก็พร้อมเริ่มต้นได้เลย!",
      pickup_title_th: "รับและส่งคืนแบบไร้การสัมผัส",
      same_day_description_2_en: "",
      same_day_description_en:
        "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
      same_day_title_en: "Same Day Express Service",
      same_day_description_2_th: "",
      same_day_description_th:
        "เฉพาะในกรุงเทพเท่านั้น เมื่อเลือกบริการส่งคืนด่วนในวันเดียวกัน เราจะไปรับออเดอร์ในช่วงเวลา 10:00-\n\n12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ",
      same_day_title_th: "บริการส่งคืนด่วนในวันเดียวกัน",
      order_summary_description_2_en: "",
      order_summary_description_en:
        "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
      order_summary_title_en: "Same Day Express Service",
      order_summary_description_2_th: "",
      order_summary_description_th:
        "สรุปออเดอร์ ประกอบด้วย รายละเอียดของบริการทั้งหมด (My Wash, My Iron หรือ My Shoes) แพ็กเกจ\n(S, M หรือ L) และตัวเลือกเพิ่มเติม (เช่น รีดผ้า) ซึ่งอยู่ในบริการซักผ้าและทำความสะอาดรองเท้าที่คุณเลือก\nกรุณาตรวจสอบอย่างละเอียดก่อนทำการสั่งออเดอร์หรือคลิกที่ปุ่ม แก้ไข หากคุณต้องการเปลี่ยนแปลง",
      order_summary_title_th: "สรุปออเดอร์",
      water_description_2_th: "",
      water_description_th:
        "ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\n\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ น้ำดื่มฟินมีขวด 3 ขนาด ได้แก่\n\n350 มล. 600 มล. และ 1.5 ล. โดยจัดส่งแต่ละ\n\nออเดอร์ในปริมาณที่กำหนดคือ 3 แพ็กของขวด 350 มล. (48 ขวด) หรือ 3 แพ็กของขวด 600 มล. (36\nขวด) หรือ 3 แพ็กของขวด 1.5 ล. (18 ขวด) เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3\nแพ็กต่อหนึ่งออเดอร์ เนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      water_title_th: "น้ำดื่มฟิน",
      water_description_2_en: "",
      water_description_en:
        "Each time you book our professional laundry service or shoe cleaning service, you now also\nhave the option of ordering our family-owned Finn Drinking Water to be delivered to your\ndoorstep when we pick up your order. Finn is available in 3 different bottle sizes: 350 ml, 600 ml\nand 1.5 l. We are able to deliver you a fixed quantity of 3 packs of the 350 ml bottle (48 bottles)\nOR 3 packs of the 600 ml bottle (36 bottles) OR 3 packs of the 1.5 l bottle (18 bottles) per order.\nWe limit each order to a total of 3 packs of one bottle size due to the capacity limitations of our\ndelivery boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly\ngrowing in popularity due to its extraordinary taste and attractive pricing strategy compared\nto international brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      water_title_en: "Finn Drinking Water",
      water_description_2: "",
    },
  },
  TH: {
    configs: [
      {
        _id: "631185cb50dac232a373a66c",
        pickup_title: "รับและส่งคืนแบบไร้การสัมผัส",
        pickup_description:
          "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีการรับและส่งคืนออเดอร์แบบไร้การสัมผัสเป็นมาตรฐาน\n\nเพื่อให้แน่ใจว่าออเดอร์ของคุณดำเนินตามขั้นตอนอย่างเรียบร้อย\nโปรดตรวจสอบที่อยู่ของคุณอีกครั้งและแก้ไขหากจำเป็น\n\nคุณสามารถค้นหาที่อยู่โดยพิมพ์ชื่อหรือเลือกจากแผนที่กูเกิ้ลในระบบของเรา เช่นเดียวกับการใช้กูเกิ้ลแมพ\n\nนอกจากนี้กรุณาให้รายละเอียดที่อยู่เพิ่มเติมเพื่อความชัดเจน\n\nซึ่งจะช่วยให้เราไปรับผ้าและรองเท้าของคุณได้ทุกที่ ไม่ว่าจะเป็นบ้าน โรงแรม หรือสถานที่อื่นๆที่คุณต้องการ\n\nเพียงแค่บอกเรา เช่น ฝากไว้กับประชาสัมพันธ์ หรือ วางไว้ในห้องรับจดหมาย\nหากคุณต้องการรับและส่งคืนออเดอร์ด้วยตนเอง (เจอผู้รับส่ง)\nกรุณาแจ้งในช่องรายละเอียดที่อยู่ก่อนสั่งออเดอร์ จากนั้นเลือกวันและเวลารับส่งคืน\n\nเท่านี้ก็พร้อมเริ่มต้นได้เลย!",
        pickup_image_key_desktop: "1662697705165_Frame 52882.png",
        pickup_image_key_mobile: "1662697705803_Frame 52882.png",
        same_day_title: "บริการส่งคืนด่วนในวันเดียวกัน",
        same_day_description:
          "เฉพาะในกรุงเทพเท่านั้น เมื่อเลือกบริการส่งคืนด่วนในวันเดียวกัน เราจะไปรับออเดอร์ในช่วงเวลา 10:00-\n\n12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ",
        same_day_image_key_desktop: "1662697784705_timer 1.png",
        same_day_image_key_mobile: "1662697785026_timer 1.png",
        order_summary_title: "สรุปออเดอร์",
        order_summary_description:
          "สรุปออเดอร์ ประกอบด้วย รายละเอียดของบริการทั้งหมด (My Wash, My Iron หรือ My Shoes) แพ็กเกจ\n(S, M หรือ L) และตัวเลือกเพิ่มเติม (เช่น รีดผ้า) ซึ่งอยู่ในบริการซักผ้าและทำความสะอาดรองเท้าที่คุณเลือก\nกรุณาตรวจสอบอย่างละเอียดก่อนทำการสั่งออเดอร์หรือคลิกที่ปุ่ม แก้ไข หากคุณต้องการเปลี่ยนแปลง",
        order_summary_image_key_desktop: "1662697890856_Add-ons (2).png",
        order_summary_image_key_mobile: "1662697891273_Add-ons (2).png",
        payment_method_image_key_desktop: "1662697963638_Add-ons (3).png",
        payment_method_image_key_mobile: "1662697964048_Add-ons (3).png",
        program_method_title: "เลือกบริการ",
        program_method_description:
          "ไม่ว่าคุณจะเลือก My Wash, My Iron หรือ My Shoes\n\nบริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร\nสะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
        program_method_image_key_desktop: "1668581615885_Add-ons (1).png",
        program_method_image_key_mobile: "Add-ons (1).png",
        createdAt: "2022-09-02T04:25:47.152Z",
        updatedAt: "2022-12-22T10:44:00.955Z",
        same_day_price: 300,
        extra_service_image_key_desktop: "1664526329460_Extras (1).png",
        extra_service_image_key_mobile: "1664526330025_Extras (1).png",
        water_title: "น้ำดื่มฟิน",
        water_description:
          "ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\n\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ น้ำดื่มฟินมีขวด 3 ขนาด ได้แก่\n\n350 มล. 600 มล. และ 1.5 ล. โดยจัดส่งแต่ละ\n\nออเดอร์ในปริมาณที่กำหนดคือ 3 แพ็กของขวด 350 มล. (48 ขวด) หรือ 3 แพ็กของขวด 600 มล. (36\nขวด) หรือ 3 แพ็กของขวด 1.5 ล. (18 ขวด) เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3\nแพ็กต่อหนึ่งออเดอร์ เนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
        water_image_key_desktop: "1664526410948_Add-ons (46).png",
        water_image_key_mobile: "1664526411236_Add-ons (46).png",
        pickup_description_2:
          "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์\n\n14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น.\n\nนอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น.\n\nและส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\n\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
        same_day_description_2: "",
        order_summary_description_2: "",
        program_method_description_2:
          "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-\n16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน\nซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน\nหมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
        program_method_description_2_en:
          "We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Service is only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time if we finish it earlier.",
        program_method_description_2_th:
          "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-\n16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน\nซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน\nหมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
        program_method_description_en:
          "Whether you select My Wash, My Iron or My Shoes, our professional laundry service as well as our shoe cleaning service are fully customisable meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday.\n",
        program_method_description_th:
          "ไม่ว่าคุณจะเลือก My Wash, My Iron หรือ My Shoes\n\nบริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร\nสะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
        program_method_title_en: "Select Your Service",
        program_method_title_th: "เลือกบริการ",
        pickup_description_2_en:
          "Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-\n16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-\n16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express\nShoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and\nwill be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day\nExpress Service is only available in Bangkok and can be booked before and until 11:30 am on the\nsame day you wish to use the service. For all orders, we will return it on or before the scheduled\n\ntime if we finish it earlier.",
        pickup_description_en:
          "Contactless Pick-Up &amp; Return is our standard. To ensure a smooth process, double-check your\nAddress and Edit it if necessary. With Google Maps integrated into our system, you can simply\nsearch for your address by its name or choose it from the map, the same as doing it from\nGoogle Maps itself. Additionally, we kindly ask you to provide us with your Address Details as\nthis will help us to find your laundry and shoes at your home, hotel or any place you want as\nlong as it is readily accessible. Just give us a little hint, e.g. “I will leave the laundry with the\nreceptionist” or “I placed the bags in the mailroom”. If you wish to hand over or receive your\nlaundry and shoes personally, kindly also notify us of this in the Address Details before placing\nyour order. Then, simply choose your preferred pick-up and return date and a time-slot and\n\nyou are ready to go!",
        pickup_title_en: "Contactless Pick-Up & Return",
        pickup_description_2_th:
          "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์\n\n14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น.\n\nนอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น.\n\nและส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\n\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
        pickup_description_th:
          "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีการรับและส่งคืนออเดอร์แบบไร้การสัมผัสเป็นมาตรฐาน\n\nเพื่อให้แน่ใจว่าออเดอร์ของคุณดำเนินตามขั้นตอนอย่างเรียบร้อย\nโปรดตรวจสอบที่อยู่ของคุณอีกครั้งและแก้ไขหากจำเป็น\n\nคุณสามารถค้นหาที่อยู่โดยพิมพ์ชื่อหรือเลือกจากแผนที่กูเกิ้ลในระบบของเรา เช่นเดียวกับการใช้กูเกิ้ลแมพ\n\nนอกจากนี้กรุณาให้รายละเอียดที่อยู่เพิ่มเติมเพื่อความชัดเจน\n\nซึ่งจะช่วยให้เราไปรับผ้าและรองเท้าของคุณได้ทุกที่ ไม่ว่าจะเป็นบ้าน โรงแรม หรือสถานที่อื่นๆที่คุณต้องการ\n\nเพียงแค่บอกเรา เช่น ฝากไว้กับประชาสัมพันธ์ หรือ วางไว้ในห้องรับจดหมาย\nหากคุณต้องการรับและส่งคืนออเดอร์ด้วยตนเอง (เจอผู้รับส่ง)\nกรุณาแจ้งในช่องรายละเอียดที่อยู่ก่อนสั่งออเดอร์ จากนั้นเลือกวันและเวลารับส่งคืน\n\nเท่านี้ก็พร้อมเริ่มต้นได้เลย!",
        pickup_title_th: "รับและส่งคืนแบบไร้การสัมผัส",
        same_day_description_2_en: "",
        same_day_description_en:
          "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
        same_day_title_en: "Same Day Express Service",
        same_day_description_2_th: "",
        same_day_description_th:
          "เฉพาะในกรุงเทพเท่านั้น เมื่อเลือกบริการส่งคืนด่วนในวันเดียวกัน เราจะไปรับออเดอร์ในช่วงเวลา 10:00-\n\n12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ",
        same_day_title_th: "บริการส่งคืนด่วนในวันเดียวกัน",
        order_summary_description_2_en: "",
        order_summary_description_en:
          "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
        order_summary_title_en: "Same Day Express Service",
        order_summary_description_2_th: "",
        order_summary_description_th:
          "สรุปออเดอร์ ประกอบด้วย รายละเอียดของบริการทั้งหมด (My Wash, My Iron หรือ My Shoes) แพ็กเกจ\n(S, M หรือ L) และตัวเลือกเพิ่มเติม (เช่น รีดผ้า) ซึ่งอยู่ในบริการซักผ้าและทำความสะอาดรองเท้าที่คุณเลือก\nกรุณาตรวจสอบอย่างละเอียดก่อนทำการสั่งออเดอร์หรือคลิกที่ปุ่ม แก้ไข หากคุณต้องการเปลี่ยนแปลง",
        order_summary_title_th: "สรุปออเดอร์",
        water_description_2_th: "",
        water_description_th:
          "ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\n\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ น้ำดื่มฟินมีขวด 3 ขนาด ได้แก่\n\n350 มล. 600 มล. และ 1.5 ล. โดยจัดส่งแต่ละ\n\nออเดอร์ในปริมาณที่กำหนดคือ 3 แพ็กของขวด 350 มล. (48 ขวด) หรือ 3 แพ็กของขวด 600 มล. (36\nขวด) หรือ 3 แพ็กของขวด 1.5 ล. (18 ขวด) เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3\nแพ็กต่อหนึ่งออเดอร์ เนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
        water_title_th: "น้ำดื่มฟิน",
        water_description_2_en: "",
        water_description_en:
          "Each time you book our professional laundry service or shoe cleaning service, you now also\nhave the option of ordering our family-owned Finn Drinking Water to be delivered to your\ndoorstep when we pick up your order. Finn is available in 3 different bottle sizes: 350 ml, 600 ml\nand 1.5 l. We are able to deliver you a fixed quantity of 3 packs of the 350 ml bottle (48 bottles)\nOR 3 packs of the 600 ml bottle (36 bottles) OR 3 packs of the 1.5 l bottle (18 bottles) per order.\nWe limit each order to a total of 3 packs of one bottle size due to the capacity limitations of our\ndelivery boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly\ngrowing in popularity due to its extraordinary taste and attractive pricing strategy compared\nto international brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
        water_title_en: "Finn Drinking Water",
        water_description_2: "",
      },
    ],
    config: {
      _id: "631185cb50dac232a373a66c",
      pickup_title: "รับและส่งคืนแบบไร้การสัมผัส",
      pickup_description:
        "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีการรับและส่งคืนออเดอร์แบบไร้การสัมผัสเป็นมาตรฐาน\n\nเพื่อให้แน่ใจว่าออเดอร์ของคุณดำเนินตามขั้นตอนอย่างเรียบร้อย\nโปรดตรวจสอบที่อยู่ของคุณอีกครั้งและแก้ไขหากจำเป็น\n\nคุณสามารถค้นหาที่อยู่โดยพิมพ์ชื่อหรือเลือกจากแผนที่กูเกิ้ลในระบบของเรา เช่นเดียวกับการใช้กูเกิ้ลแมพ\n\nนอกจากนี้กรุณาให้รายละเอียดที่อยู่เพิ่มเติมเพื่อความชัดเจน\n\nซึ่งจะช่วยให้เราไปรับผ้าและรองเท้าของคุณได้ทุกที่ ไม่ว่าจะเป็นบ้าน โรงแรม หรือสถานที่อื่นๆที่คุณต้องการ\n\nเพียงแค่บอกเรา เช่น ฝากไว้กับประชาสัมพันธ์ หรือ วางไว้ในห้องรับจดหมาย\nหากคุณต้องการรับและส่งคืนออเดอร์ด้วยตนเอง (เจอผู้รับส่ง)\nกรุณาแจ้งในช่องรายละเอียดที่อยู่ก่อนสั่งออเดอร์ จากนั้นเลือกวันและเวลารับส่งคืน\n\nเท่านี้ก็พร้อมเริ่มต้นได้เลย!",
      pickup_image_key_desktop: "1662697705165_Frame 52882.png",
      pickup_image_key_mobile: "1662697705803_Frame 52882.png",
      same_day_title: "บริการส่งคืนด่วนในวันเดียวกัน",
      same_day_description:
        "เฉพาะในกรุงเทพเท่านั้น เมื่อเลือกบริการส่งคืนด่วนในวันเดียวกัน เราจะไปรับออเดอร์ในช่วงเวลา 10:00-\n\n12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ",
      same_day_image_key_desktop: "1662697784705_timer 1.png",
      same_day_image_key_mobile: "1662697785026_timer 1.png",
      order_summary_title: "สรุปออเดอร์",
      order_summary_description:
        "สรุปออเดอร์ ประกอบด้วย รายละเอียดของบริการทั้งหมด (My Wash, My Iron หรือ My Shoes) แพ็กเกจ\n(S, M หรือ L) และตัวเลือกเพิ่มเติม (เช่น รีดผ้า) ซึ่งอยู่ในบริการซักผ้าและทำความสะอาดรองเท้าที่คุณเลือก\nกรุณาตรวจสอบอย่างละเอียดก่อนทำการสั่งออเดอร์หรือคลิกที่ปุ่ม แก้ไข หากคุณต้องการเปลี่ยนแปลง",
      order_summary_image_key_desktop: "1662697890856_Add-ons (2).png",
      order_summary_image_key_mobile: "1662697891273_Add-ons (2).png",
      payment_method_image_key_desktop: "1662697963638_Add-ons (3).png",
      payment_method_image_key_mobile: "1662697964048_Add-ons (3).png",
      program_method_title: "เลือกบริการ",
      program_method_description:
        "ไม่ว่าคุณจะเลือก My Wash, My Iron หรือ My Shoes\n\nบริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร\nสะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
      program_method_image_key_desktop: "1668581615885_Add-ons (1).png",
      program_method_image_key_mobile: "Add-ons (1).png",
      createdAt: "2022-09-02T04:25:47.152Z",
      updatedAt: "2022-12-22T10:44:00.955Z",
      same_day_price: 300,
      extra_service_image_key_desktop: "1664526329460_Extras (1).png",
      extra_service_image_key_mobile: "1664526330025_Extras (1).png",
      water_title: "น้ำดื่มฟิน",
      water_description:
        "ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\n\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ น้ำดื่มฟินมีขวด 3 ขนาด ได้แก่\n\n350 มล. 600 มล. และ 1.5 ล. โดยจัดส่งแต่ละ\n\nออเดอร์ในปริมาณที่กำหนดคือ 3 แพ็กของขวด 350 มล. (48 ขวด) หรือ 3 แพ็กของขวด 600 มล. (36\nขวด) หรือ 3 แพ็กของขวด 1.5 ล. (18 ขวด) เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3\nแพ็กต่อหนึ่งออเดอร์ เนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      water_image_key_desktop: "1664526410948_Add-ons (46).png",
      water_image_key_mobile: "1664526411236_Add-ons (46).png",
      pickup_description_2:
        "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์\n\n14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น.\n\nนอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น.\n\nและส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\n\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
      same_day_description_2: "",
      order_summary_description_2: "",
      program_method_description_2:
        "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-\n16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน\nซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน\nหมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
      program_method_description_2_en:
        "We also offer a Same Day Express Laundry Service and Same Day Express Shoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day Express Service is only available in Bangkok and can be booked before and until 11:30 am on the same day you wish to use the service. For all orders, we will return it on or before the scheduled time if we finish it earlier.",
      program_method_description_2_th:
        "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์ 14:00-\n16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น. นอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน\nซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน\nหมายเหตุ บริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
      program_method_description_en:
        "Whether you select My Wash, My Iron or My Shoes, our professional laundry service as well as our shoe cleaning service are fully customisable meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-16:00 on Tuesday.\n",
      program_method_description_th:
        "ไม่ว่าคุณจะเลือก My Wash, My Iron หรือ My Shoes\n\nบริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร\nสะดวกในการสั่งออเดอร์ รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์",
      program_method_title_en: "Select Your Service",
      program_method_title_th: "เลือกบริการ",
      pickup_description_2_en:
        "Our standard turnaround time is 24 hours. For example: If you have chosen the time-slot 14:00-\n16:00 for the Pick-Up of your order on Monday, then your order will be returned between 14:00-\n16:00 on Tuesday. We also offer a Same Day Express Laundry Service and Same Day Express\nShoe Cleaning Service where your order is picked up between 10:00-12:00 in the morning and\nwill be returned between 16:00-19:00 in the early evening of the same day. Note: our Same Day\nExpress Service is only available in Bangkok and can be booked before and until 11:30 am on the\nsame day you wish to use the service. For all orders, we will return it on or before the scheduled\n\ntime if we finish it earlier.",
      pickup_description_en:
        "Contactless Pick-Up &amp; Return is our standard. To ensure a smooth process, double-check your\nAddress and Edit it if necessary. With Google Maps integrated into our system, you can simply\nsearch for your address by its name or choose it from the map, the same as doing it from\nGoogle Maps itself. Additionally, we kindly ask you to provide us with your Address Details as\nthis will help us to find your laundry and shoes at your home, hotel or any place you want as\nlong as it is readily accessible. Just give us a little hint, e.g. “I will leave the laundry with the\nreceptionist” or “I placed the bags in the mailroom”. If you wish to hand over or receive your\nlaundry and shoes personally, kindly also notify us of this in the Address Details before placing\nyour order. Then, simply choose your preferred pick-up and return date and a time-slot and\n\nyou are ready to go!",
      pickup_title_en: "Contactless Pick-Up & Return",
      pickup_description_2_th:
        "เรามีบริการรับส่งคืนผ้าแบบมาตรฐานภายใน 24 ชั่วโมง เช่น หากคุณเลือกเวลาไปรับออเดอร์วันจันทร์\n\n14:00-16:00 น. เราจะส่งคืนออเดอร์วันอังคาร 14:00-16:00 น.\n\nนอกจากนี้เรายังมีบริการส่งคืนด่วนในวันเดียวกัน ซึ่งจะไปรับออเดอร์ในช่วงเวลา 10:00-12:00 น.\n\nและส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\n\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ\n\nร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้จะส่งคืนทุกออเดอร์ตรงเวลาหรือก่อนเวลาหากออเดอร์เรีย\n\nบร้อยเร็วกว่าที่กำหนด",
      pickup_description_th:
        "ร้านซักผ้าและทำความสะอาดรองเท้ามายลอนดรี้มีการรับและส่งคืนออเดอร์แบบไร้การสัมผัสเป็นมาตรฐาน\n\nเพื่อให้แน่ใจว่าออเดอร์ของคุณดำเนินตามขั้นตอนอย่างเรียบร้อย\nโปรดตรวจสอบที่อยู่ของคุณอีกครั้งและแก้ไขหากจำเป็น\n\nคุณสามารถค้นหาที่อยู่โดยพิมพ์ชื่อหรือเลือกจากแผนที่กูเกิ้ลในระบบของเรา เช่นเดียวกับการใช้กูเกิ้ลแมพ\n\nนอกจากนี้กรุณาให้รายละเอียดที่อยู่เพิ่มเติมเพื่อความชัดเจน\n\nซึ่งจะช่วยให้เราไปรับผ้าและรองเท้าของคุณได้ทุกที่ ไม่ว่าจะเป็นบ้าน โรงแรม หรือสถานที่อื่นๆที่คุณต้องการ\n\nเพียงแค่บอกเรา เช่น ฝากไว้กับประชาสัมพันธ์ หรือ วางไว้ในห้องรับจดหมาย\nหากคุณต้องการรับและส่งคืนออเดอร์ด้วยตนเอง (เจอผู้รับส่ง)\nกรุณาแจ้งในช่องรายละเอียดที่อยู่ก่อนสั่งออเดอร์ จากนั้นเลือกวันและเวลารับส่งคืน\n\nเท่านี้ก็พร้อมเริ่มต้นได้เลย!",
      pickup_title_th: "รับและส่งคืนแบบไร้การสัมผัส",
      same_day_description_2_en: "",
      same_day_description_en:
        "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
      same_day_title_en: "Same Day Express Service",
      same_day_description_2_th: "",
      same_day_description_th:
        "เฉพาะในกรุงเทพเท่านั้น เมื่อเลือกบริการส่งคืนด่วนในวันเดียวกัน เราจะไปรับออเดอร์ในช่วงเวลา 10:00-\n\n12:00 น. และส่งคืนในช่วงเวลา 16:00-19:00 น. ของวันเดียวกัน หมายเหตุ\nบริการส่งคืนด่วนในวันเดียวกันมีเฉพาะในกรุงเทพเท่านั้น และสามารถจองได้จนถึง 11:30 น.\n\nของวันที่คุณต้องการใช้บริการ",
      same_day_title_th: "บริการส่งคืนด่วนในวันเดียวกัน",
      order_summary_description_2_en: "",
      order_summary_description_en:
        "For Bangkok only – When activating our Same Day Express Service, your order is picked up\nbetween 10:00-12:00 in the morning and will be returned between 16:00-19:00 in the early\nevening of the same day. Note: our Same Day Express Service is only available in Bangkok and\ncan be booked before and until 11:30 am on the same day you wish to use the service.",
      order_summary_title_en: "Same Day Express Service",
      order_summary_description_2_th: "",
      order_summary_description_th:
        "สรุปออเดอร์ ประกอบด้วย รายละเอียดของบริการทั้งหมด (My Wash, My Iron หรือ My Shoes) แพ็กเกจ\n(S, M หรือ L) และตัวเลือกเพิ่มเติม (เช่น รีดผ้า) ซึ่งอยู่ในบริการซักผ้าและทำความสะอาดรองเท้าที่คุณเลือก\nกรุณาตรวจสอบอย่างละเอียดก่อนทำการสั่งออเดอร์หรือคลิกที่ปุ่ม แก้ไข หากคุณต้องการเปลี่ยนแปลง",
      order_summary_title_th: "สรุปออเดอร์",
      water_description_2_th: "",
      water_description_th:
        "ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\n\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ น้ำดื่มฟินมีขวด 3 ขนาด ได้แก่\n\n350 มล. 600 มล. และ 1.5 ล. โดยจัดส่งแต่ละ\n\nออเดอร์ในปริมาณที่กำหนดคือ 3 แพ็กของขวด 350 มล. (48 ขวด) หรือ 3 แพ็กของขวด 600 มล. (36\nขวด) หรือ 3 แพ็กของขวด 1.5 ล. (18 ขวด) เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3\nแพ็กต่อหนึ่งออเดอร์ เนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      water_title_th: "น้ำดื่มฟิน",
      water_description_2_en: "",
      water_description_en:
        "Each time you book our professional laundry service or shoe cleaning service, you now also\nhave the option of ordering our family-owned Finn Drinking Water to be delivered to your\ndoorstep when we pick up your order. Finn is available in 3 different bottle sizes: 350 ml, 600 ml\nand 1.5 l. We are able to deliver you a fixed quantity of 3 packs of the 350 ml bottle (48 bottles)\nOR 3 packs of the 600 ml bottle (36 bottles) OR 3 packs of the 1.5 l bottle (18 bottles) per order.\nWe limit each order to a total of 3 packs of one bottle size due to the capacity limitations of our\ndelivery boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly\ngrowing in popularity due to its extraordinary taste and attractive pricing strategy compared\nto international brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      water_title_en: "Finn Drinking Water",
      water_description_2: "",
    },
  },
};

export const mock_data_order = [
  {
    _id: "1",
    order_number: "Order #01714107395-010722-1058",
    createdAt: "Wed, 15.04.2022, 12:45",
    payment: TYPE_VISA,
    price: "$100.00",
    status: "PROCESSING",
  },
  {
    _id: "2",
    order_number: "Order #01714107395-010722-1059",
    createdAt: "Wed, 15.04.2022, 12:45",
    payment: TYPE_CASH,
    price: "$100.00",
    status: "COMPLETED",
  },
  {
    _id: "3",
    order_number: "Order #01714107395-010722-1060",
    createdAt: "Wed, 15.04.2022, 12:45",
    payment: TYPE_MASTERCARD,
    price: "$100.00",
    status: "CANCELED",
  },
];

export const mock_data_order_info = [
  {
    _id: "1",
    status: "PROCESSING",
    payment: TYPE_VISA,
    order_number: "Order #01714107395-010722-1058",
    createdAt: "Wed, 15.04.2022, 12:45",
    datepickup: "Wed, 03.03.2022, 08:00-10:00 ",
    datereturn: "Thu, 04.03.2022, 10:00-12:00",
    address:
      "My Condo, 188/322 Supalai Primariva, Sukhumvite 49, Klong Toei, Wattana, Bangkok",
    program: TEXT_PROGRAM_MYWASH,
    size: "S",
    des: `Up to 22 ${TEXT_PIECES_MY_LAUNDRY}`,
    priscesize: "฿395",
    addons1: TEXT_IRON,
    priceaddons1: "฿50",
    addons2: TEXT_HANG,
    priceaddons2: "฿60",
    subtotal: "฿895.00",
  },
];

//TAB
export const TAB_SIZE_MY_WASH = (language) => {
  return [
    {
      _id: "101",
      size: "S",
      des: `${TEXT_UPTO[language]} 22 ${TEXT_PIECES_MY_LAUNDRY[language]}`,
      price: 395,
      type: STATE_CONSTANTS_PROGRAM.MY_WASH,
      master: true,
    },

    {
      _id: "101",
      size: "M",
      des: `${TEXT_UPTO[language]} 22 ${TEXT_PIECES_MY_LAUNDRY[language]}`,
      price: 695,
      type: STATE_CONSTANTS_PROGRAM.MY_WASH,
      master: true,
    },
    {
      _id: "101",
      size: "L",
      des: `${TEXT_UPTO[language]} 22 ${TEXT_PIECES_MY_LAUNDRY[language]}`,
      price: 995,
      type: STATE_CONSTANTS_PROGRAM.MY_WASH,
      master: true,
    },
  ];
};

export const TAB_SIZE_MY_SHOES = (language) => {
  return [
    {
      _id: "102",
      size: "1 Pair",
      des: "For 1 Pair of shoes",
      price: "395",
      type: STATE_CONSTANTS_PROGRAM.MY_SHOE,
      master: true,
    },
    {
      _id: "102",
      size: "2 Pairs",
      des: "For 2 Pairs of shoes",
      price: "695",
      type: STATE_CONSTANTS_PROGRAM.MY_SHOE,
      master: true,
    },
    {
      _id: "102",
      size: "3 Pairs",
      des: "For 3 Pairs of shoes",
      price: "995",
      type: STATE_CONSTANTS_PROGRAM.MY_SHOE,
      master: true,
    },
  ];
};

export const TAB_SIZE_MY_IRON = (language) => {
  return [
    {
      _id: "103",
      size: "S",
      des: `${TEXT_UPTO[language]} 22 ${TEXT_PIECES_MY_LAUNDRY[language]}`,
      price: 395,
      type: STATE_CONSTANTS_PROGRAM.MY_IRON,
      master: true,
    },
    {
      _id: "103",
      size: "M",
      des: `${TEXT_UPTO[language]} 22 ${TEXT_PIECES_MY_LAUNDRY[language]}`,
      price: 695,
      type: STATE_CONSTANTS_PROGRAM.MY_IRON,
      master: true,
    },
    {
      _id: "103",
      size: "L",
      des: `${TEXT_UPTO[language]} 22 ${TEXT_PIECES_MY_LAUNDRY[language]}`,
      price: 995,
      type: STATE_CONSTANTS_PROGRAM.MY_IRON,
      master: true,
    },
  ];
};

export const TAB_SIZE_MY_DRY = (language) => {
  return [
    {
      _id: "104",
      size: "S",
      des: `${TEXT_UPTO[language]} 5 ${TEXT_PIECES[language]} `,
      price: 745,
      type: STATE_CONSTANTS_PROGRAM.MY_DRY,
      master: true,
    },
    {
      _id: "104",
      size: "M",
      des: `${TEXT_UPTO[language]} 5 ${TEXT_PIECES[language]} `,
      price: 945,
      type: STATE_CONSTANTS_PROGRAM.MY_DRY,
      master: true,
    },
    {
      _id: "104",
      size: "L",
      des: `${TEXT_UPTO[language]} 5 ${TEXT_PIECES[language]} `,
      price: 1145,
      type: STATE_CONSTANTS_PROGRAM.MY_DRY,
      master: true,
    },
  ];
};

//INFO

export const mock_mywash_s_package = [
  {
    img: "/images/infomywash.png",
    title: "My Wash S Package",
    des1: "The My Wash S Package includes the washing & folding of up to 22 items of clothing, towels, pillow cases and more at a fixed price – regardless of their combined weight – with no surprises. You can customise My Wash with several Add-Ons such as “Iron” so that we not only wash & fold your clothes but also iron them for you. Your laundry will be returned to you within 24 hours as standard unless you go for our Same-Day Service which requires Pick-Up at 08:00-10:00 am to enable Return at 16:00-19:00 on the same day. Note: our Same-Day service can be booked before and until 09:30 am on the day you wish to use the service. We can also take care of your bedding items – just select the related Add-On as an extra.",
    des2: " Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how much it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal to the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package. 1, 2, 3 – so easy!",
    des3: "We are glad to serve you with our laundry expertise!",
  },
];

export const mock_myiron_s_package = [
  {
    img: "/images/infomyiron.png",
    title: "My Iron S Package",
    des1: "The My Wash S Package includes the washing & folding of up to 22 items of clothing, towels, pillow cases and more at a fixed price – regardless of their combined weight – with no surprises. You can customise My Wash with several Add-Ons such as “Iron” so that we not only wash & fold your clothes but also iron them for you. Your laundry will be returned to you within 24 hours as standard unless you go for our Same-Day Service which requires Pick-Up at 08:00-10:00 am to enable Return at 16:00-19:00 on the same day. Note: our Same-Day service can be booked before and until 09:30 am on the day you wish to use the service. We can also take care of your bedding items – just select the related Add-On as an extra.",
    des2: " Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how much it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal to the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package. 1, 2, 3 – so easy!",
    des3: "We are glad to serve you with our laundry expertise!",
  },
];

export const mock_myshoes_s_package = [
  {
    img: "/images/infomyshoes.png",
    title: "My Shoes 1 Pair ",
    des1: "The My Shoes 1 Pair Package includes the cleaning of 1 pair of shoes at a fixed price and with no surprises. You can customise My Shoes with Add-Ons such as “Protection & Waterproofing” and “Deodorant & Disinfection”. Your cleaned shoes will be returned to you within 24 hours as standard unless you go for our Same-Day Service which requires Pick-Up at 08:00-10:00 am to enable Return at 16:00-19:00 on the same day. Note: our Same-Day service can be booked before and until 09:30 am on the day you wish to use the service.",
    des2: "We are glad to serve you with our shoe cleaning expertise!",
  },
];

export const mock_drinking_info = [
  {
    img: "/images/infodrinking.png",
    title: "Finn Drinking Water",
    des1: "Each time you book our laundry or shoe-cleaning services, you now also have the option of ordering our family-owned Finn Drinking Water to be delivered to your doorstep when we pick up your order. Finn is available in 3 different bottle and packaging sizes: 16 x 355 ml, 12 x 600 ml and 6 x 1.5 l. Each order quantity is limited to a total of 3 packs of one packaging size due to the capacity limitations of our delivery boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in popularity due to its extraordinary taste and attractive pricing strategy compared to international brands. Try Finn one time and you will never want any other brand of drinking water again! ",
  },
];

export const mock_iron_addon_info = [
  {
    img: "/images/infoaddoniron.png",
    title: "Iron",
    des1: "For EVERY piece of your laundry that is suitable for ironing, we iron it to creaseless perfection. Shirts, dresses, trousers, towels, pillow cases and more, all at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your order. By default, we not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. If you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the “Smooth Starch” Add-On after you have already selected the “Iron” Add-On.",
  },
];

//ADDONS
export const mock_data_addons_mywash = [
  {
    _id: "1",
    img: "/icons/addon_iron.png",
    title: TEXT_IRON,
    des: "We iron your laundry – crease-free",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "2",
    img: "/icons/addon_nosoftener.png",
    title: TEXT_NOSOFTENER,
    des: "We will not use Softener at all",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "3",
    img: "/icons/addon_smoothstarch.png",
    title: TEXT_SMOOTH_STARCH,
    des: "For the ultimate ironing results",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "4",
    img: "/icons/addon_antibacterial.png",
    title: TEXT_ANTIBACTERIAL_SANITISER,
    des: "For hygienically-clean laundry",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "5",
    img: "/icons/addon_perfume.png",
    title: TEXT_LAUNDRY_PERFUME,
    des: "The extra kick of freshness",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "6",
    img: "/icons/addon_hightemp.png",
    title: TEXT_HIGH_TEMPERATURE_WASH,
    des: "We wash at 60°C",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "7",
    img: "/icons/addon_organicwash.png",
    title: TEXT_ORGANIC_WASH,
    des: "The best organic laundry choice",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "8",
    img: "/icons/addon_lowheatdry.png",
    title: TEXT_LOW_HEAT_DRY,
    des: "Drying at a low temperature",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "9",
    img: "/icons/addon_babywash.png",
    title: TEXT_BABY_WASH,
    des: "Ideal for sensitive baby skin",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "10",
    img: "/icons/addon_hang.png",
    title: TEXT_HANG,
    des: "We hang on YOUR hangers",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "11",
    img: "/icons/addon_stainremoval.png",
    title: TEXT_STAIN_REMOVAL,
    des: "Removing stains from A to Z",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "12",
    img: "/icons/addon_hangplus.png",
    title: TEXT_HANG_PLUS,
    des: "We hang on OUR hangers",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
];
export const mock_data_addons_mydry = [
  {
    _id: "1z",
    img: "/icons/addon_iron.png",
    title: TEXT_IRON,
    des: "We iron your laundry – crease-free",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "2z",
    img: "/icons/addon_nosoftener.png",
    title: TEXT_NOSOFTENER,
    des: "We will not use Softener at all",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "3z",
    img: "/icons/addon_smoothstarch.png",
    title: TEXT_SMOOTH_STARCH,
    des: "For the ultimate ironing results",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "4z",
    img: "/icons/addon_antibacterial.png",
    title: TEXT_ANTIBACTERIAL_SANITISER,
    des: "For hygienically-clean laundry",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "z5",
    img: "/icons/addon_perfume.png",
    title: TEXT_LAUNDRY_PERFUME,
    des: "The extra kick of freshness",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "z6",
    img: "/icons/addon_hightemp.png",
    title: TEXT_HIGH_TEMPERATURE_WASH,
    des: "We wash at 60°C",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "z7",
    img: "/icons/addon_organicwash.png",
    title: TEXT_ORGANIC_WASH,
    des: "The best organic laundry choice",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "z8",
    img: "/icons/addon_lowheatdry.png",
    title: TEXT_LOW_HEAT_DRY,
    des: "Drying at a low temperature",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "z9",
    img: "/icons/addon_babywash.png",
    title: TEXT_BABY_WASH,
    des: "Ideal for sensitive baby skin",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "z10",
    img: "/icons/addon_hang.png",
    title: TEXT_HANG,
    des: "We hang on YOUR hangers",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "z11",
    img: "/icons/addon_stainremoval.png",
    title: TEXT_STAIN_REMOVAL,
    des: "Removing stains from A to Z",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "z12",
    img: "/icons/addon_hangplus.png",
    title: TEXT_HANG_PLUS,
    des: "We hang on OUR hangers",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
];

export const mock_data_addons_myiron = [
  {
    _id: "13",
    img: "/icons/addon_smoothstarch.png",
    title: TEXT_SMOOTH_STARCH,
    des: "For the ultimate ironing results",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_IRON,
  },
  {
    _id: "14",
    img: "/icons/addon_hang.png",
    title: TEXT_HANG,
    des: "We hang on YOUR hangers",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_IRON,
  },
  {
    _id: "15",
    img: "/icons/addon_perfume.png",
    title: TEXT_LAUNDRY_PERFUME,
    des: "The extra kick of freshness",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_IRON,
  },
  {
    _id: "16",
    img: "/icons/addon_hangplus.png",
    title: TEXT_HANG_PLUS,
    des: "We hang on OUR hangers",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_IRON,
  },
  {
    _id: "17",
    img: "/icons/addon_antibacterial.png",
    title: TEXT_ANTIBACTERIAL_SANITISER,
    des: "For hygienically-clean laundry",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_IRON,
  },
];
export const mock_data_addons_myshoes = [
  {
    _id: "18",
    img: "/icons/addon_protection.png",
    title: TEXT_PROTECTION_WATERPROOF,
    des: "Keep your shoes safe and sound",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_SHOE,
  },
  {
    _id: "19",
    img: "/icons/addon_deodorant.png",
    title: TEXT_DEODORANT_DISINFECTION,
    des: "Makes your shoes smell like new",
    price: 80,
    type: STATE_CONSTANTS_PROGRAM.MY_SHOE,
  },
];

//EXTRAS
export const mock_data_extra_mywash = [
  {
    _id: "20",
    img: "/icons/extra_comforter.png",
    title: TEXT_COMFORTER_OR_DUVET_INSERT,
    des: "For 1 piece",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "21",
    img: "/icons/extra_pillows.png",
    title: TEXT_PILLOWS,
    des: "For 2 pillows",
    price: 100,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "22",
    img: "/icons/extra_coverbedsheet.png",
    title: TEXT_DUVET_COVER_OR_BED_SHEET,
    des: "For 1 piece",
    price: 150,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
  {
    _id: "23",
    img: "/icons/extra_bleaching.png",
    title: TEXT_BLEACHING_FOR_WHITES,
    des: "For 5 white items",
    price: 150,
    type: STATE_CONSTANTS_PROGRAM.MY_WASH,
  },
];
export const mock_data_extra_myclearn = [
  {
    _id: "j20",
    img: "/icons/extra_comforter.png",
    title: TEXT_COMFORTER_OR_DUVET_INSERT,
    des: "For 1 piece",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "j21",
    img: "/icons/extra_pillows.png",
    title: TEXT_PILLOWS,
    des: "For 2 pillows",
    price: 100,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "j22",
    img: "/icons/extra_coverbedsheet.png",
    title: TEXT_DUVET_COVER_OR_BED_SHEET,
    des: "For 1 piece",
    price: 150,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
  {
    _id: "j23",
    img: "/icons/extra_bleaching.png",
    title: TEXT_BLEACHING_FOR_WHITES,
    des: "For 5 white items",
    price: 150,
    type: STATE_CONSTANTS_PROGRAM.MY_DRY,
  },
];

export const mock_data_extra_myshoes = [
  {
    _id: "k20",
    img: "/icons/extra_comforter.png",
    title: TEXT_COMFORTER_OR_DUVET_INSERT,
    des: "For 1 piece",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_SHOE,
  },
  {
    _id: "k21",
    img: "/icons/extra_pillows.png",
    title: TEXT_PILLOWS,
    des: "For 2 pillows",
    price: 100,
    type: STATE_CONSTANTS_PROGRAM.MY_SHOE,
  },
  {
    _id: "k22",
    img: "/icons/extra_coverbedsheet.png",
    title: TEXT_DUVET_COVER_OR_BED_SHEET,
    des: "For 1 piece",
    price: 150,
    type: STATE_CONSTANTS_PROGRAM.MY_SHOE,
  },
  {
    _id: "k23",
    img: "/icons/extra_bleaching.png",
    title: TEXT_BLEACHING_FOR_WHITES,
    des: "For 5 white items",
    price: 150,
    type: STATE_CONSTANTS_PROGRAM.MY_SHOE,
  },
];

export const mock_data_extra_myiron = [
  {
    _id: "24",
    img: "/icons/extra_comforter.png",
    title: TEXT_COMFORTER_OR_DUVET_INSERT,
    des: "For 1 piece",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_IRON,
  },
  {
    _id: "25",
    img: "/icons/extra_coverbedsheet.png",
    title: TEXT_DUVET_COVER_OR_BED_SHEET,
    des: "For 1 piece",
    price: 150,
    type: STATE_CONSTANTS_PROGRAM.MY_IRON,
  },
];

//DRINKING WATER
export const mock_data_drinking_water = [
  {
    _id: "26",
    img: "/icons/water_355.png",
    title: `355 ml ${TEXT_BOTTLE}`,
    des: "We deliver 3 packs of 16 bottles (48 bottles)",
    price: 50,
    type: STATE_CONSTANTS_PROGRAM.MY_WATER,
  },
  {
    _id: "27",
    img: "/icons/water_1.5.png",
    title: `1.5 l ${TEXT_BOTTLE}`,
    des: "We deliver 3 packs of 6 bottles (18 bottles)",
    price: 100,
    type: STATE_CONSTANTS_PROGRAM.MY_WATER,
  },
  {
    _id: "28",
    img: "/icons/water_600.png",
    title: `600 ml ${TEXT_BOTTLE}`,
    des: "We deliver 3 packs of 12 bottles (36 bottles)",
    price: 150,
    type: STATE_CONSTANTS_PROGRAM.MY_WATER,
  },
];

//BUSKET
export const mock_data_address_busket = "188/322 Supalai Primariva";
export const mock_data_addressdetails_busket = {
  EN: "Please tell us where exactly we can pick up and return your order (e.g. your front door, reception, security office, lobby, mailroom, etc.)",
  TH: "กรุณาบอกจุดรับ-ส่งคืนผ้าให้ชัดเจน (เช่น รับโดยตรงจากคุณ หรือที่แผนกต้อนรับ, รปภ., ล็อบบี้, ห้องรับจดหมาย เป็นต้น)",
};
export const mock_data_pickup_busket = "Wed, 03.03.2022, 08:00-10:00";
export const mock_data_return_busket = "Thu, 04.03.2022, 10:00-12:00";

//ADDRESS
export const mock_data_address_select = [
  {
    type: TYPE_HOME,
    title: "Condo Supalai",
    address: "Supalai Prima Riva Main Entrance, Rama3",
    details: "วางไว้ที่ Lobby เลยค่ะ ห้อง 895",
    primary: true,
  },
  {
    type: TYPE_WORK,
    title: "Work",
    address: "Banoffee Studio , ltd, Rungsit Pathum Thani",
    details: "No address details added",
    primary: false,
  },
  {
    type: TYPE_OTHER,
    title: "Condo Supalai",
    address: "Supalai Prima Riva Main Entrance, Rama3",
    details: "วางไว้ที่ Lobby เลยค่ะ ห้อง 895",
    primary: false,
  },
];

// export const mock_data_program = [
//   TAB_SIZE_MY_WASH[0],
//   TAB_SIZE_MY_IRON[0],
//   // TAB_SIZE_MY_DRY[0],
//   TAB_SIZE_MY_SHOES[0],
// ];

export const mock_data_program = (language) => {
  return [
    TAB_SIZE_MY_WASH(language)[0],
    TAB_SIZE_MY_IRON(language)[0],
    TAB_SIZE_MY_DRY(language)[0],
    TAB_SIZE_MY_SHOES(language)[0],
  ];
};

export const mock_data_address = [
  {
    district: "คลองจั่น",
    amphoe: "บางกะปิ",
    province: "กรุงเทพมหานคร",
    zipcode: 10240,
    district_code: "100601",
    amphoe_code: 1006,
    province_code: 10,
    latitude: 13.752,
    longitide: 100.586,
  },
  {
    district: "หัวหมาก",
    amphoe: "บางกะปิ",
    province: "กรุงเทพมหานคร",
    zipcode: 10250,
    district_code: "100608",
    amphoe_code: 1006,
    province_code: 10,
    latitude: 13.756,
    longitide: 100.66,
  },
  {
    district: "ท่าข้าม",
    amphoe: "บางขุนเทียน",
    province: "กรุงเทพมหานคร",
    zipcode: 10150,
    district_code: "102105",
    amphoe_code: 1021,
    province_code: 10,
    latitude: 13.555,
    longitide: 100.434,
  },
  {
    district: "แสมดำ",
    amphoe: "บางขุนเทียน",
    province: "กรุงเทพมหานคร",
    zipcode: 10150,
    district_code: "102107",
    amphoe_code: 1021,
    province_code: 10,
    latitude: 13.694,
    longitide: 100.45,
  },
  {
    district: "บางโคล่",
    amphoe: "บางคอแหลม",
    province: "กรุงเทพมหานคร",
    zipcode: 10120,
    district_code: "103103",
    amphoe_code: 1031,
    province_code: 10,
    latitude: 13.694,
    longitide: 100.516,
  },
  {
    district: "วัดพระยาไกร",
    amphoe: "บางคอแหลม",
    province: "กรุงเทพมหานคร",
    zipcode: 10120,
    district_code: "103102",
    amphoe_code: 1031,
    province_code: 10,
    latitude: 13.696,
    longitide: 100.494,
  },
  {
    district: "บางซื่อ",
    amphoe: "บางซื่อ",
    province: "กรุงเทพมหานคร",
    zipcode: 10800,
    district_code: "102901",
    amphoe_code: 1029,
    province_code: 10,
    latitude: 13.82,
    longitide: 100.529,
  },
];

export const mock_data_address_location_select = [
  {
    district: "Klong Chan",
    amphoe: "Bangkapi",
    province: "Bangkok",
    zipcode: 10240,
    district_code: "100601",
    amphoe_code: 1006,
    province_code: 10,
    latitude: 13.752,
    longitide: 100.586,
  },
];

export const mock_data_glossary_en = {
  addons: [
    {
      _id: "63134c67185a14333bd12ea1",
      language: "EN",
      name: "Iron",
      s: 1,
      m: 100,
      l: 150,
      status: true,
      description: "Ironing items by smooth starch",
      image_key_desktop: "1662699151208_Add-ons (7).png",
      image_key_mobile: "1662699151533_Add-ons (7).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, we iron EVERY piece of your laundry that is suitable for ironing. Shirts, dresses, trousers, towels, pillow cases and more, all ironed to creaseless perfection at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your laundry service order.",
      type: "ADDON",
      ex: "Iron",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-12-19T04:40:08.766Z",
      icon_key: "1662633765156_44_Property 1=Variant27.png",
      addon_description_2:
        "As our quality laundry service standard, we do not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. However, to meet your individual laundry service requirements, and if you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the Smooth Starch Add-On after you have already selected the Iron Add-On.",
      addon_description_2_en:
        "As our quality laundry service standard, we do not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. However, to meet your individual laundry service requirements, and if you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the Smooth Starch Add-On after you have already selected the Iron Add-On.",
      addon_description_2_th:
        "เราจะไม่ใช้น้ำยารีดผ้าเรียบใดๆ ในการรีดหรือซักผ้า\n\nฐานรองรีดของเราใช้เทคโนโลยีใหม่ล่าสุดเพื่อให้เสื้อผ้าของคุณเรียบสวยไร้รอยยับมากที่สุด\nหากคุณต้องการความเรียบเนียน กลิ่นหอม และความสมบูรณ์แบบในการรีดขั้นสูงสุด โปรดเลือกเพิ่มเติม\n\nน้ำยารีดผ้าเรียบ หลังจากเลือก รีดผ้า แล้ว",
      addon_description_en:
        "As an Add-On to our professional laundry service, we iron EVERY piece of your laundry that is suitable for ironing. Shirts, dresses, trousers, towels, pillow cases and more, all ironed to creaseless perfection at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your laundry service order.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้มีบริการรีดผ้าให้คุณ สำหรับผ้าทุกชิ้นที่เหมาะต่อการรีด ทั้งเสื้อเชิ้ต ชุดกระโปรง\n\nกางเกง ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอนให้คุณแน่ใจ\nหากมีรายการใดที่คุณไม่ต้องการให้เรารีด หรือมีสิ่งใดที่เราต้องให้ความสนใจเป็นพิเศษ",
      description_en: "Ironing items by smooth starch",
      description_th: "บริการรีดผ้าเรียบ ไร้รอยยับ",
      name_en: "Iron",
      name_th: "รีดผ้า",
      ex_en: "Iron",
      ex_th: "รีดผ้า",
    },
    {
      _id: "631413c80fd8fc3bfd89d79e",
      language: "EN",
      name: "High Temperature Wash",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "We wash at 60°C",
      image_key_desktop: "1668590690011_Add-ons (15).png",
      image_key_mobile: "1668590690508_Add-ons (15).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As a professional laundry service, we recommend the High Temperature Wash at 60°C Add-\nOn for towels, bedding and baby clothes as standard or for your regular clothes after you\nhave recovered from a cold or viral infection.",
      ex: "High Temperature Wash ",
      createdAt: "2022-09-04T02:56:08.859Z",
      updatedAt: "2022-11-18T11:58:42.380Z",
      type: "ADDON",
      icon_key: "1668590690623_Add-ons (14).png",
      addon_description_2_en:
        "With our High Temperature Wash, your laundry\nwill be hygienically clean, while bacteria and viruses will be eliminated. If you have specific high\nhygiene requirements, we recommend combining our High Temperature Wash with our\nAntibacterial Sanitiser Add-On to create the complete clean and sanitised laundry service. You\ncan tell us in the Special Request box before placing your laundry service order if you want us\nto wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude\n\nspecific items from the High Temperature Wash and treat them separately.",
      addon_description_2_th:
        "ด้วยการซักอุณหภูมิสูงของเราทำให้ผ้าสะอาดถูกสุขอนามัย และยังฆ่าเชื้อแบคทีเรียและไวรัสได้อีกด้วย\nขอแนะนำให้รวมการซักด้วยอุณหภูมิสูงกับผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียเพื่อสุขอนามัยขั้นพิเศษ\n\nหากคุณต้องการให้เราซักที่อุณหภูมิอื่นเช่น 50 หรือ 90 องศาเซลเซียส\nหรือประสงค์จะแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As a professional laundry service, we recommend the High Temperature Wash at 60°C Add-\nOn for towels, bedding and baby clothes as standard or for your regular clothes after you\nhave recovered from a cold or viral infection.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ขอแนะนำให้ซักผ้าด้วยอุณหภูมิสูงที่ 60 องศาเซลเซียส สำหรับผ้าเช็ดตัว เครื่องนอน\nเสื้อผ้าเด็กทารกเป็นมาตรฐาน หรือสำหรับเสื้อผ้าทั่วไปหลังจากที่หายจากอาการหวัดหรือติดเชื้อไวรัสแล้ว",
      description_en: "We wash at 60°C",
      description_th: "เราซักที่ 60 องศาเซลเซียส",
      name_en: "High Temperature Wash",
      name_th: "ซักด้วยอุณหภูมิสูง",
      ex_en: "High Temperature Wash ",
      ex_th: "ซักด้วยอุณหภูมิสูง",
      addon_description_2:
        "With our High Temperature Wash, your laundry\nwill be hygienically clean, while bacteria and viruses will be eliminated. If you have specific high\nhygiene requirements, we recommend combining our High Temperature Wash with our\nAntibacterial Sanitiser Add-On to create the complete clean and sanitised laundry service. You\ncan tell us in the Special Request box before placing your laundry service order if you want us\nto wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude\n\nspecific items from the High Temperature Wash and treat them separately.",
    },
    {
      _id: "6314264c7a1baccc80de71b5",
      language: "EN",
      name: "350 ml bottle",
      status: false,
      description: "We deliver 3 packs of 16 bottles (48 bottles)",
      image_key_desktop: "1662709691037_Frame 52878 (1).png",
      image_key_mobile: "1662709691409_Frame 52878 (1).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      type: "WATER",
      price: 50,
      ex: "350 ml bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-18T07:08:20.308Z",
      icon_key: "1662709691547_Frame 52878.png",
      addon_description_2:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 16 bottles (48 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      ex_en: "350 ml bottle",
      ex_th: "ขวด 350 มิลลิลิตร",
      name_en: "350 ml bottle",
      name_th: "ขวด 350 มิลลิลิตร",
    },
    {
      _id: "631428327a1baccc80de71c2",
      language: "EN",
      name: "Up to 22 pieces or 1 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662707669485_Add-ons (27).png",
      image_key_mobile: "1662707669866_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      type: "PACKAGE",
      ex: "My Wash Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-12-06T08:36:06.839Z",
      size: "S",
      price: 1,
      master: true,
      master_type: "My Wash",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 22 pieces or 1 x My Laundry Bag",
      name_th: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
    },
    {
      _id: "63142d2e7a1baccc80de71f6",
      language: "EN",
      name: "Comforter or Duvet Insert",
      status: false,
      description: "For 1 piece",
      image_key_desktop: "1662708818450_Add-ons (28).png",
      image_key_mobile: "1662708818835_Add-ons (28).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "In addition to your regular laundry, we are happy to take care of your comforter or duvet\ninsert as well as part of our professional laundry service.",
      type: "EXTRA",
      price: 50,
      ex: "Comforter or Duvet Insert",
      createdAt: "2022-09-04T04:44:30.024Z",
      updatedAt: "2022-11-16T14:40:27.166Z",
      icon_key: "1662633859153_13_Property 1=Comforter or Duvet Insert.png",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 comforter or duvet insert in addition to your regular laundry for each order.\nOur comforter or duvet insert service includes washing AND ironing, where possible, as default.\nAll other Add-Ons chosen for your laundry will apply for the comforter or duvet insert\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_th:
        "ทั้งนี้บริการผ้านวมหรือผ้าห่มของเรารวมการซักและรีด หากรีดได้ เป็นมาตรฐาน\n\nส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\n\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your comforter or duvet\ninsert as well as part of our professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Comforter or Duvet Insert",
      ex_th: "ผ้านวม หรือ ผ้าห่ม",
      name_en: "Comforter or Duvet Insert",
      name_th: "ผ้านวม หรือ ผ้าห่ม",
      addon_description_2:
        "Please be informed that we can pick\nup a maximum of 1 comforter or duvet insert in addition to your regular laundry for each order.\nOur comforter or duvet insert service includes washing AND ironing, where possible, as default.\nAll other Add-Ons chosen for your laundry will apply for the comforter or duvet insert\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
    },
    {
      _id: "63142e637a1baccc80de71ff",
      language: "EN",
      name: "Up to 44 pieces or 2 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662707802497_Add-ons (27).png",
      image_key_mobile: "1662707802853_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      type: "PACKAGE",
      ex: "My Wash Packages: S, M and L",
      createdAt: "2022-09-04T04:49:39.328Z",
      updatedAt: "2022-11-16T15:11:14.871Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Wash",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 44 pieces or 2 x My Laundry Bag",
      name_th: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "631462cf7a1baccc80de7205",
      language: "EN",
      name: "Up to 66 pieces or 3 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662707883149_Add-ons (27).png",
      image_key_mobile: "1662707883497_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      type: "PACKAGE",
      price: 995,
      ex: "My Wash Packages: S, M and L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:28:02.766Z",
      size: "L",
      master: true,
      master_type: "My Wash",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 66 pieces or 3 x My Laundry Bag",
      name_th: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "63134c67185a14333bd12ea2",
      language: "EN",
      name: "Smooth Starch",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "For the ultimate ironing results",
      image_key_desktop: "1662713749933_Add-ons (12).png",
      image_key_mobile: "1662713750525_Add-ons (12).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an Add-On to our professional ironing service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer. We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free",
      type: "ADDON",
      ex: "Smooth Starch",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T15:16:45.196Z",
      icon_key: "1662634995246_41_Property 1=Smooth Starch.png",
      addon_description_2_en:
        "fragrance, and pure ironing perfection as part of our premium ironing service. Smooth Starch\nwill give your clothes and bedding items the ultimate neat and crisp appearance.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\nซึ่งจะช่วยให้ผ้าและเครื่องนอนของคุณเรียบเนียนสดชื่นมีชีวิตชีวามากที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer. We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "fragrance, and pure ironing perfection as part of our premium ironing service. Smooth Starch\nwill give your clothes and bedding items the ultimate neat and crisp appearance.",
    },
    {
      _id: "6314264c7a1baccc80de71b6",
      language: "EN",
      name: "1.5 l bottle",
      status: false,
      description: "We deliver 3 packs of 6 bottles (18 bottles)",
      image_key_desktop: "1662709539412_Add-ons (36).png",
      image_key_mobile: "1662709539762_Add-ons (36).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      type: "WATER",
      price: 100,
      ex: "1.5 l bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:06.225Z",
      icon_key: "1662709539873_Add-ons (35).png",
      addon_description_2_en:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 6 bottles (18 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "1.5 l bottle",
      name_th: "ขวด 1.5 ลิตร",
      addon_description_2:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
    },
    {
      _id: "631428327a1baccc80de71c3",
      language: "EN",
      name: "Up to 22 pieces or 1 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662715257667_Add-ons (40).png",
      image_key_mobile: "1662715258054_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      type: "PACKAGE",
      ex: "My Iron Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:23:35.419Z",
      size: "S",
      price: 395,
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 22 pieces or 1 x My Laundry Bag",
      name_th: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "63142d2e7a1baccc80de71f7",
      language: "EN",
      name: "Comforter or Duvet Insert",
      status: false,
      description: "For 1 piece",
      image_key_desktop: "1662714264226_Add-ons (28).png",
      image_key_mobile: "1662714264591_Add-ons (28).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "In addition to your regular ironing, we are happy to take care of your comforter or duvet insert\nas well as part of our professional ironing service.",
      type: "EXTRA",
      price: 50,
      ex: "Comforter or Duvet Insert",
      createdAt: "2022-09-04T04:44:30.024Z",
      updatedAt: "2022-11-16T15:19:59.658Z",
      icon_key: "1662635128836_13_Property 1=Comforter or Duvet Insert.png",
      addon_description_2_en:
        "Please be informed that we can pick up a\nmaximum of 1 comforter or duvet insert in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the comforter or duvet insert automatically,\nunless you advise us differently in the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular ironing, we are happy to take care of your comforter or duvet insert\nas well as part of our professional ironing service.",
      addon_description_th:
        "นอกจากการรีดผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Comforter or Duvet Insert",
      ex_th: "ผ้านวม หรือ ผ้าห่ม",
      name_en: "Comforter or Duvet Insert",
      name_th: "ผ้านวม หรือ ผ้าห่ม",
      addon_description_2:
        "Please be informed that we can pick up a\nmaximum of 1 comforter or duvet insert in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the comforter or duvet insert automatically,\nunless you advise us differently in the Special Request box before placing your ironing service\n\norder.",
    },
    {
      _id: "631428327a1baccc80de71d4",
      language: "EN",
      name: "Up to 44 pieces or 2 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662715436595_Add-ons (40).png",
      image_key_mobile: "1662715436948_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      type: "PACKAGE",
      ex: "My Iron Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:25:03.421Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 44 pieces or 2 x My Laundry Bag",
      name_th: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "631462cf7a1baccc80de7207",
      language: "EN",
      name: "Up to 66 pieces or 3 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662715520829_Add-ons (40).png",
      image_key_mobile: "1662715521203_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      type: "PACKAGE",
      price: 995,
      ex: "My Iron Packages: S, M and L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:26:26.865Z",
      size: "L",
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 66 pieces or 3 x My Laundry Bag",
      name_th: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "6314264c7a1baccc80de71c6",
      language: "EN",
      name: "600 ml bottle",
      status: false,
      description: "We deliver 3 packs of 12 bottles (36 bottles)",
      image_key_desktop: "1662709814171_Add-ons (38).png",
      image_key_mobile: "1662709814550_Add-ons (38).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      type: "WATER",
      price: 150,
      ex: "1.5 l bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:12.696Z",
      icon_key: "1662709814728_Add-ons (37).png",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 12 bottles (36 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "600 ml bottle",
      name_th: "ขวด 600 มิลลิลิตร",
      addon_description_2:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
    },
    {
      _id: "631428327a1baccc80de71d3",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 5 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Description for the Pop-up at Add-Ons",
      type: "PACKAGE",
      ex: "Up to 5 pieces",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-15T10:08:29.184Z",
      size: "S",
      price: 745,
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Description for the Pop-up at Add-Ons",
      addon_description_2_th: "Description for the Pop-up at Add-Ons",
      addon_description_en: "Description for the Pop-up at Add-Ons",
      addon_description_th: "Description for the Pop-up at Add-Ons",
      description_en: "Up to 5 pieces",
      description_th: "Up to 5 pieces",
      ex_en: "Up to 5 pieces",
      ex_th: "Up to 5 pieces",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Description for the Pop-up at Add-Ons",
    },
    {
      _id: "631428327a1baccc80de71e4",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 10 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Description for the Pop-up at Add-Ons",
      type: "PACKAGE",
      ex: "Up to 10 pieces",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-15T10:09:07.157Z",
      size: "M",
      price: 1045,
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Description for the Pop-up at Add-Ons",
      addon_description_2_th: "Description for the Pop-up at Add-Ons",
      addon_description_en: "Description for the Pop-up at Add-Ons",
      addon_description_th: "Description for the Pop-up at Add-Ons",
      description_en: "Up to 10 pieces",
      description_th: "Up to 10 pieces",
      ex_en: "Up to 10 pieces",
      ex_th: "Up to 10 pieces",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Description for the Pop-up at Add-Ons",
    },
    {
      _id: "631462cf7a1baccc80de72f7",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 15 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Ex. Lorem ipsum dolor sit amet ...",
      type: "PACKAGE",
      price: 1345,
      ex: "Title for the Pop-up at Add-Ons",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-15T10:09:30.272Z",
      size: "L",
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_2_th: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_en: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_th: "Ex. Lorem ipsum dolor sit amet ...",
      description_en: "Up to 15 pieces",
      description_th: "Up to 15 pieces",
      ex_en: "Title for the Pop-up at Add-Ons",
      ex_th: "Title for the Pop-up at Add-Ons",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Ex. Lorem ipsum dolor sit amet ...",
    },
    {
      _id: "63134c67185a14333bd12da2",
      language: "EN",
      name: "Protection & Waterproofing ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Keep your shoes safe and sound",
      image_key_desktop: "1662716152579_Add-ons (42).png",
      image_key_mobile: "1662716152884_Add-ons (42).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "Our Protection &amp; Waterproofing Add-On keeps your favourite shoes safe from external factors such as rain and dirt.",
      type: "ADDON",
      ex: "Protection & Waterproofing ",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T14:55:07.017Z",
      icon_key: "1662716153013_Add-ons (41).png",
      name_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      name_en: "Protection & Waterproofing ",
      addon_description_en:
        "Our Protection &amp; Waterproofing Add-On keeps your favourite shoes safe from external factors such as rain and dirt.",
      addon_description_2_en:
        "A protective film prevents moisture from penetrating into the shoes while still keeping them breathable and blocks dirt right at the surface to stop any unremovable stains forming. Our shoe cleaning service not only protects your new and favourite shoes but also extends their durability and longevity and is suitable for shoes of all colours and types, from sneakers to leather shoes. We recommend combining Protection &amp; Waterproofing with our Interior Shoe Cleansing and Shoe Perfume Add-Ons to experience the best of our premium shoe cleaning service.",
      addon_description_th:
        "best of our premium shoe cleaning service. ร้านทำความสะอาดรองเท้ามายลอนดรี้มีบริการเคลือบและกันน้ำ ซึ่งช่วยปกป้องรองเท้าคู่โปรดของคุณให้ปลอดภัยจากปัจจัยภายนอก ทั้งฝนและคราบสกปรกต่างๆ โดยมีฟิล์มเคลือบป้องกันไม่ให้ความชื้นซึมเข้าสู่รองเท้า และยังช่วยระบายอากาศได้ดี พร้อมทั้งยับยั้งการเกิดคราบสกปรกบนพื้นผิว รวมถึงป้องกันการก่อตัวของคราบที่ฝังแน่น",
      addon_description_2_th:
        "บริการนี้ไม่เพียงแต่ปกป้องรองเท้าคู่ใหม่สุดโปรดของคุณเท่านั้น แต่ยังช่วยยืดอายุการใช้งานให้นานและเหมาะสำหรับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ร้านทำความสะอาดรองเท้า มายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำร่วมกับบริการทำความสะอาดรองเท้า ด้านในและน้ำหอมสำหรับรองเท้า เพื่อบริการสปารองเท้าระดับพรีเมียมที่ดีที่สุด",
      description_en: "Keep your shoes safe and sound",
      description_th: "ปกป้องรองเท้าของคุณให้ปลอดภัย",
      ex_en: "Protection & Waterproofing ",
      ex_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      addon_description_2:
        "A protective film prevents moisture from penetrating into the shoes while still keeping them breathable and blocks dirt right at the surface to stop any unremovable stains forming. Our shoe cleaning service not only protects your new and favourite shoes but also extends their durability and longevity and is suitable for shoes of all colours and types, from sneakers to leather shoes. We recommend combining Protection &amp; Waterproofing with our Interior Shoe Cleansing and Shoe Perfume Add-Ons to experience the best of our premium shoe cleaning service.",
    },
    {
      _id: "631428327a1baccc80de71e3",
      language: "EN",
      name: "For 1 Pair of shoes",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662716358264_Add-ons (45).png",
      image_key_mobile: "1662716358638_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      type: "PACKAGE",
      ex: "My Shoes Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:13:53.954Z",
      size: "S",
      price: 395,
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 1 Pair of shoes",
      name_th: "สำหรับรองเท้า 1 คู่",
      addon_description_2:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
    },
    {
      _id: "631428327a1baccd80de71e4",
      language: "EN",
      name: "For 2 Pair of shoes",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662716639481_Add-ons (45).png",
      image_key_mobile: "1662716639823_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      type: "PACKAGE",
      ex: "My Shoes Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:14:06.960Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 2 Pair of shoes",
      name_th: "สำหรับรองเท้า 2 คู่",
      addon_description_2:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
    },
    {
      _id: "631462cf7a1baccc80ef7207",
      language: "EN",
      name: "For 3 Pair of shoes",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662716709914_Add-ons (45).png",
      image_key_mobile: "1662716710303_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      type: "PACKAGE",
      price: 995,
      ex: "My Shoes Packages: S, M and L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:14:19.358Z",
      size: "L",
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 3 Pair of shoes",
      name_th: "สำหรับรองเท้า 3 คู่",
      addon_description_2:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
    },
    {
      _id: "631ac4517cbbbb34e17f8b19",
      language: "EN",
      name: "Smooth Starch",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "For the ultimate ironing results",
      image_key_desktop: "1662953321455_Add-ons (12).png",
      image_key_mobile: "1662953321745_Add-ons (12).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer.",
      type: "ADDON",
      ex: "Smooth Starch",
      icon_key: "1662699611185_Add-ons (11).png",
      createdAt: "2022-09-09T04:42:57.735Z",
      updatedAt: "2022-11-16T09:32:13.437Z",
      addon_description_2_en:
        "We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free\nfragrance, and pure ironing perfection as part of our premium laundry service. Smooth Starch\nwill give your laundry the ultimate neat and crisp appearance it deserves. You can only select\n\nthe Smooth Starch Add-On if you have already selected the Iron Add-On.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\n\nซึ่งจะช่วยให้ผ้าของคุณสะอาดเรียบร้อยและสดชื่นมีชีวิตชีวามากที่สุด โปรดเลือกเพิ่มเติม น้ำยารีดผ้าเรียบ\n\nหลังจากเลือก รีดผ้า แล้วเท่านั้น",
      addon_description_en:
        "As an Add-On to our professional laundry service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free\nfragrance, and pure ironing perfection as part of our premium laundry service. Smooth Starch\nwill give your laundry the ultimate neat and crisp appearance it deserves. You can only select\n\nthe Smooth Starch Add-On if you have already selected the Iron Add-On.",
    },
    {
      _id: "631ac7117cbbbb34e17f8bb4",
      language: "EN",
      name: "Low Heat Dry",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Drying at a low temperature",
      image_key_desktop: "1668591084915_Add-ons (18).png",
      image_key_mobile: "1668591085221_Add-ons (18).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As standard when you use our professional laundry service, we dry your laundry at an\nappropriate temperature.",
      type: "ADDON",
      ex: "Low Heat Dry",
      icon_key: "1668591085350_Add-ons (17).png",
      createdAt: "2022-09-09T04:54:41.784Z",
      updatedAt: "2022-11-16T12:51:11.973Z",
      addon_description_2_en:
        "With our special Low Heat Dry Add-On, your laundry will be dried at\na low temperature over a longer period. Use the Special Request box before placing your\nlaundry service order if you want us to dry your laundry at a specific temperature, such as 30°C\n\nor 40°C.",
      addon_description_2_th:
        "เมื่อคุณเลือกเพิ่มเติม\nอบแห้งด้วยอุณหภูมิต่ำ เราจะอบเสื้อผ้าของคุณด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ\nหากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่นเช่น 30 หรือ 40 องศาเซลเซียส\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As standard when you use our professional laundry service, we dry your laundry at an\nappropriate temperature.",
      addon_description_th:
        "ในฐานะที่ร้านซักอบรีดมายลอนดรี้เป็นมืออาชีพ\n\nเสื้อผ้าทั้งหมดของคุณจะแห้งด้วยอุณหภูมิที่เหมาะสมตามมาตรฐานของเรา",
      description_en: "Drying at a low temperature",
      description_th: "อบผ้าแห้งโดยใช้อุณหภูมิต่ำ",
      ex_en: "Low Heat Dry",
      ex_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      name_en: "Low Heat Dry",
      name_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      addon_description_2:
        "With our special Low Heat Dry Add-On, your laundry will be dried at\na low temperature over a longer period. Use the Special Request box before placing your\nlaundry service order if you want us to dry your laundry at a specific temperature, such as 30°C\n\nor 40°C.",
    },
    {
      _id: "631adaa316368678b8ed8e59",
      language: "EN",
      name: "Laundry Perfume",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "The extra kick of freshness",
      image_key_desktop: "1662704288283_Add-ons (4).png",
      image_key_mobile: "1662704288867_Add-ons (4).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, our Laundry Perfume is suitable for all\ntypes of fabrics (incl. microfiber and functional wear) and comes with a long-lasting and\nfresh flowery fragrance day after day.",
      type: "ADDON",
      ex: "Laundry Perfume",
      icon_key: "1662704289024_Add-ons (5).png",
      createdAt: "2022-09-09T06:18:11.475Z",
      updatedAt: "2022-11-16T09:33:44.927Z",
      addon_description_2_en:
        "You will smell the Laundry Perfume not only directly after\nwashing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Laundry Perfume does not contain fabric softeners.\nHowever, if you have known allergies you should consider whether this Add-On is suitable for\nyou. Our tip: choose Laundry Perfume every time you use our professional laundry service for\n\nthe best long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับซักผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับซักผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Laundry Perfume is suitable for all\ntypes of fabrics (incl. microfiber and functional wear) and comes with a long-lasting and\nfresh flowery fragrance day after day.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำหอมสำหรับซักผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการซักไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Laundry Perfume",
      ex_th: "น้ำหอมสำหรับซักผ้า",
      name_en: "Laundry Perfume",
      name_th: "น้ำหอมสำหรับซักผ้า",
      addon_description_2:
        "You will smell the Laundry Perfume not only directly after\nwashing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Laundry Perfume does not contain fabric softeners.\nHowever, if you have known allergies you should consider whether this Add-On is suitable for\nyou. Our tip: choose Laundry Perfume every time you use our professional laundry service for\n\nthe best long-lasting smell.",
    },
    {
      _id: "631adb1416368678b8ed8e5e",
      language: "EN",
      name: "Make Whites White Again",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Revive the shining white colour",
      image_key_desktop: "1668591998344_white_shirt.png",
      image_key_mobile: "1668591998663_white_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "A value-added option of our premium laundry service is the Make Whites White Again Add-\nOn which was especially designed to remove the effects of greying and yellowing from white\nfabrics to give them back their original uniform and bright whiteness to the highest extent\npossible.",
      type: "ADDON",
      ex: "Make Whites White Again",
      icon_key: "1668591998771_Default.png",
      createdAt: "2022-09-09T06:20:04.856Z",
      updatedAt: "2022-11-16T09:49:29.916Z",
      addon_description_2_en:
        "Make Whites White Again can be applied with any type of practical clothes (as well\nas white clothes with colour elements) to make them shine brilliant white again. When you\nchoose our Make White White Again Add-On, we separate all the suitable white fabrics\nincluded in your laundry and treat them separately. Of course, all your other chosen Add-Ons\nstill apply as well. If you want us to focus on some of your whites only or in particular, please tell\n\nus in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะผ้าสีขาวบางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A value-added option of our premium laundry service is the Make Whites White Again Add-\nOn which was especially designed to remove the effects of greying and yellowing from white\nfabrics to give them back their original uniform and bright whiteness to the highest extent\npossible.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nซึ่งได้รับการดีไซน์เป็นพิเศษเพื่อขจัดคราบสีเทาและสีเหลืองออกจากผ้าขาว\nทำให้กลับมาขาวสว่างสดใสดังเดิมมากที่สุด นอกจากนี้ตัวเลือก ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nยังใช้ได้กับเสื้อผ้าทั่วไป (รวมถึงผ้าขาวที่มีสีอื่นอยู่ด้วย) เพื่อให้กลับมาขาวเปล่งประกายได้อีกครั้ง\nเมื่อคุณเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง เราจะดูแลผ้าขาวของคุณแยกจากผ้าอื่นๆ",
      description_en: "Revive the shining white colour",
      description_th: "คืนประกายขาวสดใส",
      ex_en: "Make Whites White Again",
      ex_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      name_en: "Make Whites White Again",
      name_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      addon_description_2:
        "Make Whites White Again can be applied with any type of practical clothes (as well\nas white clothes with colour elements) to make them shine brilliant white again. When you\nchoose our Make White White Again Add-On, we separate all the suitable white fabrics\nincluded in your laundry and treat them separately. Of course, all your other chosen Add-Ons\nstill apply as well. If you want us to focus on some of your whites only or in particular, please tell\n\nus in the Special Request box before placing your laundry service order.",
    },
    {
      _id: "631adb9016368678b8ed8e62",
      language: "EN",
      name: "Organic Wash",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "The best organic laundry choice",
      image_key_desktop: "1662704526308_Add-ons (16).png",
      image_key_mobile: "1662704526640_Add-ons (16).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service our Organic Wash comes with no dyes,\nfragrances or preservatives. Our organic detergents and softeners contain only plant-based,\nnaturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents\nand softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do\nnot wish us to use softener in your Organic Wash as part of our quality laundry service, please",
      type: "ADDON",
      ex: "e",
      icon_key: "1662704526746_Add-ons (6).png",
      createdAt: "2022-09-09T06:22:08.116Z",
      updatedAt: "2022-11-16T07:51:49.741Z",
      addon_description_2_en:
        "select the free of charge No Softener Add-On. Organic products are especially gentle to the\nenvironment and therefore strongly recommended. PS: We use a variety of locally and\ninternationally sourced Organic Wash products in our premium laundry service. Use the\nSpecial Request box before placing your laundry service order to tell us your preferences and\n\nwe will fulfil your request whenever possible.",
      addon_description_2_th:
        "กรุณาเลือกเพิ่มเติม ไม่ใช้น้ำยาปรับผ้านุ่ม ผลิตภัณฑ์ออร์แกนิคเป็นมิตรกับสิ่งแวดล้อม\nจึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้ เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service our Organic Wash comes with no dyes,\nfragrances or preservatives. Our organic detergents and softeners contain only plant-based,\nnaturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents\nand softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do\nnot wish us to use softener in your Organic Wash as part of our quality laundry service, please",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิค\n\nซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ\nนอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย\nและยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ",
      description_en: "The best organic laundry choice",
      description_th: "ตัวเลือกดีที่สุดสำหรับทุกคน",
      ex_en: "e",
      ex_th: "t",
      name_en: "Organic Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าออร์แกนิค",
      addon_description_2:
        "select the free of charge No Softener Add-On. Organic products are especially gentle to the\nenvironment and therefore strongly recommended. PS: We use a variety of locally and\ninternationally sourced Organic Wash products in our premium laundry service. Use the\nSpecial Request box before placing your laundry service order to tell us your preferences and\n\nwe will fulfil your request whenever possible.",
    },
    {
      _id: "631adbfc16368678b8ed8e66",
      language: "EN",
      name: "Make Blacks Black Again",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "Revive the true black colour",
      image_key_desktop: "1668592348437_black_shirt.png",
      image_key_mobile: "1668592348780_black_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "A speciality of our premium laundry service is the Make Blacks Black Again Add-On which\nrevives and protects the deep black shade of all your black clothes to make them look as\ngood as new again.",
      type: "ADDON",
      ex: "Make Blacks Black Again",
      icon_key: "1668592348904_Default 2.png",
      createdAt: "2022-09-09T06:23:56.397Z",
      updatedAt: "2022-11-16T09:52:29.518Z",
      addon_description_2_en:
        "Washed-out and faded black clothes will be revived and their colour\nrestored. We recommend repeating the application of our Make Blacks Black Again Add-On\nevery time you notice that your clothes are beginning to fade. When you choose our Make\nBlacks Black Again Add-On, we separate all the suitable black clothes included in your laundry\nand treat them separately. Of course, all your other chosen Add-Ons still apply as well. If you\nwant us to focus on some of your black items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "เราขอแนะนำให้ใช้ตัวเลือกนี้ซ้ำทุกครั้งที่คุณสังเกตเห็นว่าเสื้อผ้าเริ่มมีสีจางลง เมื่อคุณเลือกเพิ่มเติม\nให้ผ้าดำกลับมาสีดำอีกครั้ง เราจะดูแลผ้าสีดำของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ\nที่คุณเลือกจะถูกนำไปใช้ด้วย หากคุณต้องการให้เราเน้นเฉพาะผ้าสีดำบางตัวหรือจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้า\n\nมายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Blacks Black Again Add-On which\nrevives and protects the deep black shade of all your black clothes to make them look as\ngood as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าดำกลับมาสีดำอีกครั้ง\nซึ่งจะช่วยฟื้นคืนสภาพเฉดสีดำให้กลับมาเข้มดังเดิมและปกป้องผ้าสีดำให้ดูดีเหมือนใหม่\n\nช่วยให้สีที่ตกและซีดจางกลับมามีสีดำเข้มอีกครั้ง",
      description_en: "Revive the true black colour",
      description_th: "คืนสภาพสีดำอย่างแท้จริง",
      ex_en: "Make Blacks Black Again",
      ex_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      name_en: "Make Blacks Black Again",
      name_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      addon_description_2:
        "Washed-out and faded black clothes will be revived and their colour\nrestored. We recommend repeating the application of our Make Blacks Black Again Add-On\nevery time you notice that your clothes are beginning to fade. When you choose our Make\nBlacks Black Again Add-On, we separate all the suitable black clothes included in your laundry\nand treat them separately. Of course, all your other chosen Add-Ons still apply as well. If you\nwant us to focus on some of your black items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
    },
    {
      _id: "631adc6816368678b8ed8e6a",
      language: "EN",
      name: "Baby Wash",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Ideal for sensitive baby skin",
      image_key_desktop: "1662704743693_Add-ons (20).png",
      image_key_mobile: "1662704744064_Add-ons (20).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, our Baby Wash is specially designed for\nsensitive skin requirements and dermatologically tested to prevent allergic reactions.",
      type: "ADDON",
      ex: "e",
      icon_key: "1662704744202_Add-ons (19).png",
      createdAt: "2022-09-09T06:25:44.737Z",
      updatedAt: "2022-11-16T07:52:28.602Z",
      addon_description_2_en:
        "Baby Wash detergents and softeners we use in our quality laundry service are hypoallergenic\nand free of dyes but still strong in removing all the stains your baby loves to make. If you wish\nus to use only detergent and no softener in your Baby Wash, please select the free of charge\nNo Softener Add-On. Good to know: We use a variety of locally and internationally sourced\nBaby Wash products in our premium laundry service. Use the Special Request box before\nplacing your laundry service order to tell us your preferences and we will fulfil your request\n\nwhenever possible.",
      addon_description_2_th:
        "หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าสำหรับเด็กของคุณ กรุณาเลือกเพิ่มเติม\nไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ เรามีผลิตภัณฑ์ซักผ้าสำหรับเด็กทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Baby Wash is specially designed for\nsensitive skin requirements and dermatologically tested to prevent allergic reactions.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ซักผ้าสำหรับเด็ก\n\nซึ่งได้รับการออกแบบเป็นพิเศษเพื่อผิวบอบบางและผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า\nป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้",
      description_en: "Ideal for sensitive baby skin",
      description_th: "เหมาะสำหรับผิวบอบบางของเด็กทารก",
      ex_en: "e",
      ex_th: "t",
      name_en: "Baby Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าสำหรับเด็ก",
      addon_description_2:
        "Baby Wash detergents and softeners we use in our quality laundry service are hypoallergenic\nand free of dyes but still strong in removing all the stains your baby loves to make. If you wish\nus to use only detergent and no softener in your Baby Wash, please select the free of charge\nNo Softener Add-On. Good to know: We use a variety of locally and internationally sourced\nBaby Wash products in our premium laundry service. Use the Special Request box before\nplacing your laundry service order to tell us your preferences and we will fulfil your request\n\nwhenever possible.",
    },
    {
      _id: "631adccc16368678b8ed8e6e",
      language: "EN",
      name: "Make Jeans Blue Again",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "For genuine blue denim",
      image_key_desktop: "1668592518986_jean.png",
      image_key_mobile: "1668592519291_jean.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "A speciality of our premium laundry service is the Make Jeans Blue Again Add-On which\nrevives the original blue colour and protects the classic denim look of all your blue denim\njeans, trousers, skirts, jackets and shirts, to make them look as good as new again.",
      type: "ADDON",
      ex: "Make Jeans Blue Again",
      icon_key: "1668592519406_Default 3.png",
      createdAt: "2022-09-09T06:27:24.518Z",
      updatedAt: "2022-11-16T09:55:19.780Z",
      addon_description_2_en:
        "Washed-\nout and faded colours will be replaced and the typical jeans look will be restored and\nmaintained. We recommend Make Jeans Blue Again solely for classic blue denim items in\norder to give them back their original intensity. When you choose our Make Jeans Blue Again\nAdd-On, we separate all the suitable blue jeans and other denim fabrics included in your\nlaundry and treat them separately. Of course, all your other chosen Add-Ons still apply as well.\nIf you want us to focus on some denim items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "ช่วยให้สีที่ตกและซีดจางกลับมาสีน้ำเงินเข้มอีกครั้ง อีกทั้งฟื้นฟูสภาพและคงเอกลักษณ์ของยีนส์ไว้\nเราขอแนะนำตัวเลือก ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง ใช้กับผ้าเดนิมสีน้ำเงินคลาสสิกเท่านั้น\nเพื่อให้สีของผ้ากลับมาเข้มดั่งเดิม เมื่อคุณเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nเราจะดูแลยีนส์สีน้ำเงินและผ้าเดนิมของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะยีนส์บางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Jeans Blue Again Add-On which\nrevives the original blue colour and protects the classic denim look of all your blue denim\njeans, trousers, skirts, jackets and shirts, to make them look as good as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nซึ่งจะช่วยฟื้นคืนสภาพสีน้ำเงินกลับมาดังเดิมและรักษาภาพลักษณ์อันคลาสสิกของผ้าเดนิมให้กับยีนส์สีน้ำเงิน\nไม่ว่าจะเป็นกางเกง กระโปรง แจ็คเก็ต หรือเสื้อเชิ้ต เพื่อทำให้กลับมาดูดีเหมือนใหม่อีกครั้ง",
      description_en: "For genuine blue denim",
      description_th: "สำหรับผ้าเดนิมสีน้ำเงินแท้",
      ex_en: "Make Jeans Blue Again",
      ex_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      name_en: "Make Jeans Blue Again",
      name_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      addon_description_2:
        "Washed-\nout and faded colours will be replaced and the typical jeans look will be restored and\nmaintained. We recommend Make Jeans Blue Again solely for classic blue denim items in\norder to give them back their original intensity. When you choose our Make Jeans Blue Again\nAdd-On, we separate all the suitable blue jeans and other denim fabrics included in your\nlaundry and treat them separately. Of course, all your other chosen Add-Ons still apply as well.\nIf you want us to focus on some denim items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
    },
    {
      _id: "631add2516368678b8ed8e72",
      language: "EN",
      name: "Stain Removal",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "Removing stains from A to Z",
      image_key_desktop: "1662704932262_Add-ons (24).png",
      image_key_mobile: "1662704932575_Add-ons (24).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "When you select the Stain Removal Add-On, our professional laundry service team screens\nevery item of your laundry from head to toe and makes every effort to remove any stains we\nfind. We can remove many kinds of stains, such as oil, sauces, ketchup, chocolate,\nmayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk,\nyogurt, cream, mould, blood, pus, ballpoint pens, ink, felt tip pens, highlighters, coloured pencils,",
      type: "ADDON",
      ex: "e",
      icon_key: "1662704932707_Add-ons (23).png",
      createdAt: "2022-09-09T06:28:53.237Z",
      updatedAt: "2022-11-16T12:52:35.070Z",
      addon_description_2_en:
        "water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle\nwax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on\nsome items of your laundry in particular, you can tell us in the Special Request box before\n\nplacing your laundry service order.",
      addon_description_2_th:
        "เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์\n\nหมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล\nหากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "When you select the Stain Removal Add-On, our professional laundry service team screens\nevery item of your laundry from head to toe and makes every effort to remove any stains we\nfind. We can remove many kinds of stains, such as oil, sauces, ketchup, chocolate,\nmayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk,\nyogurt, cream, mould, blood, pus, ballpoint pens, ink, felt tip pens, highlighters, coloured pencils,",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้จะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด เราสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต\nมายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา\nคราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้",
      description_en: "Removing stains from A to Z",
      description_th: "ขจัดคราบต่างๆอย่างละเอียด",
      ex_en: "e",
      ex_th: "t",
      name_en: "Stain Removal",
      name_th: "ขจัดคราบ",
      addon_description_2:
        "water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle\nwax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on\nsome items of your laundry in particular, you can tell us in the Special Request box before\n\nplacing your laundry service order.",
    },
    {
      _id: "631add7b16368678b8ed8e76",
      language: "EN",
      name: "Hang",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "We hang on YOUR hangers",
      image_key_desktop: "1668592982195_Add-ons (22).png",
      image_key_mobile: "1668592982478_Add-ons (22).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an optional Add-On of our professional laundry service, we can hang up all hangable\nclothes on YOUR hangers.",
      type: "ADDON",
      ex: "Hang",
      icon_key: "1668592982585_Add-ons (21).png",
      createdAt: "2022-09-09T06:30:19.518Z",
      updatedAt: "2022-11-16T10:03:02.861Z",
      addon_description_2_en:
        "Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your laundry. If there are any specific items in your laundry\nwhich you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your laundry service order.",
      addon_description_2_th: "",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we can hang up all hangable\nclothes on YOUR hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า\nหากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2:
        "Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your laundry. If there are any specific items in your laundry\nwhich you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your laundry service order.",
    },
    {
      _id: "631aecbfad41fef36839ec6d",
      language: "EN",
      name: "Pillows",
      status: false,
      description: "For 2 pillows",
      image_key_desktop: "1662708926562_Add-ons (30).png",
      image_key_mobile: "1662708926877_Add-ons (30).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "In addition to your regular laundry, we are happy to take care of your pillows as well as part of\nour professional laundry service.",
      type: "EXTRA",
      price: 100,
      ex: "Pillows",
      icon_key: "1662708927048_Add-ons (29).png",
      createdAt: "2022-09-09T07:35:27.424Z",
      updatedAt: "2022-11-16T14:41:33.446Z",
      addon_description_2:
        "Please be informed that we can pick up a maximum of 2\npillows in addition to your regular laundry for each order. Our pillow service includes washing\nand drying as default. All other Add-Ons chosen for your laundry will apply for the pillows\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_en:
        "Please be informed that we can pick up a maximum of 2\npillows in addition to your regular laundry for each order. Our pillow service includes washing\nand drying as default. All other Add-Ons chosen for your laundry will apply for the pillows\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_th:
        "ทั้งนี้บริการซักหมอนของเรารวมการซักและอบแห้งเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ\nทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับหมอนโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your pillows as well as part of\nour professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักผ้ามายลอนดรี้ยินดีที่จะดูแลหมอนของคุณด้วย\nโดยเราสามารถรับหมอนได้สูงสุด 2 ใบ ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 2 pillows",
      description_th: "สำหรับหมอน 2 ใบ",
      ex_en: "Pillows",
      ex_th: "หมอน",
      name_en: "Pillows",
      name_th: "หมอน",
    },
    {
      _id: "631aed49fb27f882880c3093",
      language: "EN",
      name: "Bed Sheet or Duvet Cover",
      status: false,
      description: "For 1 piece",
      image_key_desktop: "1662709064359_Add-ons (32).png",
      image_key_mobile: "1662709064672_Add-ons (32).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "In addition to your regular laundry, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional laundry service.",
      type: "EXTRA",
      price: 150,
      ex: "Bed Sheet or Duvet Cover",
      icon_key: "1662709064774_Add-ons (31).png",
      createdAt: "2022-09-09T07:37:45.144Z",
      updatedAt: "2022-11-16T14:42:13.787Z",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular laundry for each order.\nOur bed sheet or duvet cover service includes washing AND ironing as default. All other Add-\nOns chosen for your laundry will apply for the bed sheet or duvet cover automatically, unless\nyou advise us differently in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง\nทั้งนี้บริการผ้าปูที่นอนหรือปลอกผ้านวมของเรารวมการซักและรีดเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Bed Sheet or Duvet Cover",
      ex_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      name_en: "Bed Sheet or Duvet Cover",
      name_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      addon_description_2:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular laundry for each order.\nOur bed sheet or duvet cover service includes washing AND ironing as default. All other Add-\nOns chosen for your laundry will apply for the bed sheet or duvet cover automatically, unless\nyou advise us differently in the Special Request box before placing your laundry service order.",
    },
    {
      _id: "631b005d08f6c6a6bd127b01",
      language: "EN",
      name: "Hang",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "We hang on YOUR hangers",
      image_key_desktop: "1662713948630_Add-ons (22).png",
      image_key_mobile: "1662713948971_Add-ons (22).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an optional Add-On of our professional ironing service, we can hang up all hangable\nclothes on YOUR hangers. Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your order. If there are any specific items in your order",
      type: "ADDON",
      ex: "Hang",
      icon_key: "1662713949093_Add-ons (21).png",
      createdAt: "2022-09-09T08:59:09.812Z",
      updatedAt: "2022-11-16T15:17:25.996Z",
      addon_description_2_en:
        "which you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we can hang up all hangable\nclothes on YOUR hangers. Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your order. If there are any specific items in your order",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2:
        "which you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your ironing service order.",
    },
    {
      _id: "631b00a1d51e9672eb237938",
      language: "EN",
      name: "Ironing Perfume",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "The extra kick of freshness",
      image_key_desktop: "1662714017029_Add-ons (4).png",
      image_key_mobile: "1662714017427_Add-ons (4).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an Add-On to our professional ironing service, our Ironing Perfume is suitable for all types\nof fabrics (incl. microfiber and functional wear) and comes with a long-lasting and fresh\nflowery fragrance day after day.",
      type: "ADDON",
      ex: "Ironing Perfume",
      icon_key: "1662714017569_Add-ons (5).png",
      createdAt: "2022-09-09T09:00:17.934Z",
      updatedAt: "2022-11-16T15:17:54.435Z",
      addon_description_2_en:
        "You will smell the Ironing Perfume not only directly after\nironing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Ironing Perfume does not contain fabric softeners.\nHowever, if you have known allergies, you should consider whether this Add-On is suitable for\nyou. Our tip: choose Ironing Perfume every time you use our professional ironing service for the\n\nbest long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับรีดผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับรีดผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, our Ironing Perfume is suitable for all types\nof fabrics (incl. microfiber and functional wear) and comes with a long-lasting and fresh\nflowery fragrance day after day.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำหอมสำหรับรีดผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการรีดไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Ironing Perfume",
      ex_th: "น้ำหอมสำหรับรีดผ้า",
      name_en: "Ironing Perfume",
      name_th: "น้ำหอมสำหรับรีดผ้า",
      addon_description_2:
        "You will smell the Ironing Perfume not only directly after\nironing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Ironing Perfume does not contain fabric softeners.\nHowever, if you have known allergies, you should consider whether this Add-On is suitable for\nyou. Our tip: choose Ironing Perfume every time you use our professional ironing service for the\n\nbest long-lasting smell.",
    },
    {
      _id: "631b00f0d51e9672eb23794b",
      language: "EN",
      name: "Hang Plus+",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "We hang on OUR hangers",
      image_key_desktop: "1662714096131_Add-ons (26).png",
      image_key_mobile: "1662714096477_Add-ons (26).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an optional Add-On of our professional ironing service, we hang all hangable clothes on\nOUR basic hangers.",
      type: "ADDON",
      ex: "Hang Plus+",
      icon_key: "1662714096607_Add-ons (25).png",
      createdAt: "2022-09-09T09:01:36.978Z",
      updatedAt: "2022-11-16T15:18:34.118Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your order which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your order which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your ironing service\n\norder.",
    },
    {
      _id: "631b0159d51e9672eb23797c",
      language: "EN",
      name: "Antibacterial Sanitiser",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "For hygienically-clean laundry",
      image_key_desktop: "1662714200531_Add-ons (13).png",
      image_key_mobile: "1662714200900_Add-ons (13).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As part of our professional ironing service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      type: "ADDON",
      ex: "Antibacterial Sanitiser",
      icon_key: "1662714201026_Add-ons (8).png",
      createdAt: "2022-09-09T09:03:21.398Z",
      updatedAt: "2022-11-16T15:19:19.256Z",
      addon_description_2_en:
        "extra layer of support for an even more hygienically-clean ironing service, our Antibacterial\nSanitiser is free of bleach and can be used with all types of fabrics including children’s clothes.\n\nWe recommend Antibacterial Sanitiser for every ironing service.",
      addon_description_2_th:
        "นอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\n\nรวมทั้งเสื้อผ้าเด็กด้วย\n\nเราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียทุกครั้งที่คุณใช้บริการรีดผ้าของเรา",
      addon_description_en:
        "As part of our professional ironing service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย\n\nซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส รวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย\n\nช่วยเพิ่มระดับของการรีดผ้าให้ถูกสุขอนามัยยิ่งขึ้น",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการรีดผ้าที่ถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "extra layer of support for an even more hygienically-clean ironing service, our Antibacterial\nSanitiser is free of bleach and can be used with all types of fabrics including children’s clothes.\n\nWe recommend Antibacterial Sanitiser for every ironing service.",
    },
    {
      _id: "631b01dcd51e9672eb2379af",
      language: "EN",
      name: "Duvet Cover or Bed Sheet ",
      status: false,
      description: "For 1 piece",
      image_key_desktop: "1662714331435_Add-ons (32).png",
      image_key_mobile: "1662714331763_Add-ons (32).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "In addition to your regular ironing, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional ironing service.",
      type: "EXTRA",
      price: 150,
      ex: "Duvet Cover or Bed Sheet ",
      icon_key: "1662714331974_Add-ons (31).png",
      createdAt: "2022-09-09T09:05:32.438Z",
      updatedAt: "2022-11-16T15:21:01.478Z",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the bed sheet or duvet cover automatically,\nunless you advise us differently in the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ\n\nทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular ironing, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional ironing service.",
      addon_description_th:
        "นอกจากการรีดผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Duvet Cover or Bed Sheet ",
      ex_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      name_en: "Duvet Cover or Bed Sheet ",
      name_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      addon_description_2:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the bed sheet or duvet cover automatically,\nunless you advise us differently in the Special Request box before placing your ironing service order.",
    },
    {
      _id: "631b094c8d95618757de7d7f",
      language: "EN",
      name: "Deodorant & Disinfection ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Makes your shoes smell like new",
      image_key_desktop: "1662716235912_Add-ons (43).png",
      image_key_mobile: "1662716236277_Add-ons (43).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "With our premium shoe cleaning service, we ensure your shoes look as good as new again – this is our professional shoe cleaning service standard. If you not only want your shoes to look neat on the outside but also care about their inner hygiene, we recommend choosing our Interior Shoe Cleansing Add-On,",
      type: "ADDON",
      ex: "Deodorant & Disinfection ",
      icon_key: "1662716236437_Add-ons (44).png",
      createdAt: "2022-09-09T09:37:17.020Z",
      updatedAt: "2022-11-16T14:56:48.536Z",
      name_th: "ทำความสะอาดรองเท้าด้านใน",
      name_en: "Deodorant & Disinfection ",
      addon_description_en:
        "With our premium shoe cleaning service, we ensure your shoes look as good as new again – this is our professional shoe cleaning service standard. If you not only want your shoes to look neat on the outside but also care about their inner hygiene, we recommend choosing our Interior Shoe Cleansing Add-On,",
      addon_description_2_en:
        "where we will particularly focus on cleaning and disinfecting the often forgotten interior of your shoes, including the insoles as well. Combining Interior Shoe Cleaning with our other Protection &amp; Waterproofing and Shoe Perfume Add-Ons will give your most treasured shoes the ultimate spa experience they deserve. Our professional shoe cleaning service is available for shoes of all colours and types, from sneakers to leather shoes, while we specialise in white shoes and white sneakers made from leather or other modern fabrics.",
      addon_description_th:
        "ร้านทำความสะอาดรองเท้ามายลอนดรี้ให้คุณแน่ใจว่ารองเท้าของคุณจะดูดีเหมือนใหม่อีกครั้ง นี่เป็นมาตรฐานบริการของเรา หากคุณต้องการให้รองเท้าดูดีจากภายนอก และมีสุขอนามัยที่ดีจากภายในด้วย เราขอแนะนำให้คุณเลือกบริการทำความสะอาดรองเท้าด้านใน",
      addon_description_2_th:
        "ซึ่งจะเน้นการทำความสะอาดและฆ่าเชื้อโรครองเท้าด้านในที่มักถูกมองข้าม รวมถึงพื้นรองเท้าด้วย ร้านทำความสะอาดรองเท้ามายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมทำความสะอาดรองเท้าด้านในร่วมกับ ผลิตภัณฑ์เคลือบและกันน้ำและน้ำหอมสำหรับรองเท้า เพื่อสัมผัสประสบการณ์สปารองเท้าขั้นสูงสุด เรายินดีให้บริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง และยังเชี่ยวชาญในการทำความสะอาดรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัยด้วย",
      description_en: "Makes your shoes smell like new",
      description_th: "คืนสุขอนามัยอย่างล้ำลึกถึงพื้นรองเท้า",
      ex_en: "Deodorant & Disinfection ",
      ex_th: "ทำความสะอาดรองเท้าด้านใน",
      addon_description_2:
        "where we will particularly focus on cleaning and disinfecting the often forgotten interior of your shoes, including the insoles as well. Combining Interior Shoe Cleaning with our other Protection &amp; Waterproofing and Shoe Perfume Add-Ons will give your most treasured shoes the ultimate spa experience they deserve. Our professional shoe cleaning service is available for shoes of all colours and types, from sneakers to leather shoes, while we specialise in white shoes and white sneakers made from leather or other modern fabrics.",
    },
    {
      _id: "63720392a142589973ec1e9a",
      language: "EN",
      name: "No Softener ",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "We will not use Softener at all",
      image_key_desktop: "1668587084343_Add-ons (10).png",
      image_key_mobile: "1668587084846_Add-ons (10).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "You can rely on us not to use any softener with your laundry – clear, easy and free of charge.",
      type: "ADDON",
      ex: "No Softener ",
      icon_key: "1668587084964_Add-ons (9).png",
      createdAt: "2022-11-14T09:00:02.224Z",
      updatedAt: "2022-11-16T12:54:02.992Z",
      addon_description_2_en: "",
      addon_description_2_th: "",
      addon_description_en:
        "You can rely on us not to use any softener with your laundry – clear, easy and free of charge.",
      addon_description_th:
        "ให้คุณมั่นใจว่าเราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆในการซักผ้าของคุณ ชัดเจน ง่าย และฟรี",
      description_en: "We will not use Softener at all",
      description_th: "เราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆ",
      ex_en: "No Softener ",
      ex_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      name_en: "No Softener ",
      name_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      addon_description_2: "",
    },
    {
      _id: "637203f8a142589973ec1ea0",
      language: "EN",
      name: "Hang Plus+",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "We hang on OUR hangers",
      image_key_desktop: "1668593118092_Add-ons (26).png",
      image_key_mobile: "1668593118353_Add-ons (26).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an optional Add-On of our professional laundry service, we hang all hangable clothes on\nOUR basic hangers.",
      type: "ADDON",
      ex: "Hang Plus+",
      icon_key: "1668593118489_Add-ons (25).png",
      createdAt: "2022-11-14T09:01:44.505Z",
      updatedAt: "2022-11-16T10:05:18.764Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your laundry which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your laundry service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your laundry which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your laundry service\n\norder.",
    },
    {
      _id: "63720417a142589973ec1ea9",
      language: "EN",
      name: "Antibacterial Sanitiser",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "For hygienically-clean laundry",
      image_key_desktop: "1670562040139_1668587273739_Add-ons (13).png",
      image_key_mobile: "1668587274101_Add-ons (13).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As part of our professional laundry service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      type: "ADDON",
      ex: "Antibacterial Sanitiser",
      icon_key: "1668587274241_Add-ons (8).png",
      createdAt: "2022-11-14T09:02:15.384Z",
      updatedAt: "2022-12-09T05:00:41.761Z",
      addon_description_2_en:
        "Providing an\nextra layer of support to the detergent for an even more hygienically-clean laundry service, our\nAntibacterial Sanitiser is free of bleach and can be used with all types of fabrics including\nchildren’s clothes. We recommend Antibacterial Sanitiser for every wash, while for particularly\nhigh hygiene demands, it can be combined with our High Temperature Wash Add-On option to\n\ncreate your very own customised laundry service experience.",
      addon_description_2_th:
        "ช่วยเพิ่มประสิทธิภาพของการซักผ้าให้สะอาดถูกสุขอนามัยยิ่งขึ้น\nนอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\nรวมทั้งเสื้อผ้าเด็กด้วย เราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียสำหรับทุกการซักผ้า\nโดยใช้ร่วมกับตัวเลือกเพิ่มเติมการซักด้วยอุณหภูมิสูง เพื่อสุขอนามัยขั้นพิเศษ",
      addon_description_en:
        "As part of our professional laundry service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย ซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส\nรวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการซักผ้าที่สะอาดถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "Providing an\nextra layer of support to the detergent for an even more hygienically-clean laundry service, our\nAntibacterial Sanitiser is free of bleach and can be used with all types of fabrics including\nchildren’s clothes. We recommend Antibacterial Sanitiser for every wash, while for particularly\nhigh hygiene demands, it can be combined with our High Temperature Wash Add-On option to\n\ncreate your very own customised laundry service experience.",
    },
  ],
  water: [
    {
      _id: "6314264c7a1baccc80de71b5",
      language: "EN",
      name: "350 ml bottle",
      status: false,
      description: "We deliver 3 packs of 16 bottles (48 bottles)",
      image_key_desktop: "1662709691037_Frame 52878 (1).png",
      image_key_mobile: "1662709691409_Frame 52878 (1).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      type: "WATER",
      price: 50,
      ex: "350 ml bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-18T07:08:20.308Z",
      icon_key: "1662709691547_Frame 52878.png",
      addon_description_2:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 16 bottles (48 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      ex_en: "350 ml bottle",
      ex_th: "ขวด 350 มิลลิลิตร",
      name_en: "350 ml bottle",
      name_th: "ขวด 350 มิลลิลิตร",
    },
    {
      _id: "6314264c7a1baccc80de71b6",
      language: "EN",
      name: "1.5 l bottle",
      status: false,
      description: "We deliver 3 packs of 6 bottles (18 bottles)",
      image_key_desktop: "1662709539412_Add-ons (36).png",
      image_key_mobile: "1662709539762_Add-ons (36).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      type: "WATER",
      price: 100,
      ex: "1.5 l bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:06.225Z",
      icon_key: "1662709539873_Add-ons (35).png",
      addon_description_2_en:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 6 bottles (18 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "1.5 l bottle",
      name_th: "ขวด 1.5 ลิตร",
      addon_description_2:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
    },
    {
      _id: "6314264c7a1baccc80de71c6",
      language: "EN",
      name: "600 ml bottle",
      status: false,
      description: "We deliver 3 packs of 12 bottles (36 bottles)",
      image_key_desktop: "1662709814171_Add-ons (38).png",
      image_key_mobile: "1662709814550_Add-ons (38).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      type: "WATER",
      price: 150,
      ex: "1.5 l bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:12.696Z",
      icon_key: "1662709814728_Add-ons (37).png",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 12 bottles (36 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "600 ml bottle",
      name_th: "ขวด 600 มิลลิลิตร",
      addon_description_2:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
    },
  ],
  childrens: [
    {
      _id: "631ac7117cbbbb34e17f8bb4",
      language: "EN",
      name: "Low Heat Dry",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Drying at a low temperature",
      image_key_desktop: "1668591084915_Add-ons (18).png",
      image_key_mobile: "1668591085221_Add-ons (18).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As standard when you use our professional laundry service, we dry your laundry at an\nappropriate temperature.",
      type: "ADDON",
      ex: "Low Heat Dry",
      icon_key: "1668591085350_Add-ons (17).png",
      createdAt: "2022-09-09T04:54:41.784Z",
      updatedAt: "2022-11-16T12:51:11.973Z",
      addon_description_2_en:
        "With our special Low Heat Dry Add-On, your laundry will be dried at\na low temperature over a longer period. Use the Special Request box before placing your\nlaundry service order if you want us to dry your laundry at a specific temperature, such as 30°C\n\nor 40°C.",
      addon_description_2_th:
        "เมื่อคุณเลือกเพิ่มเติม\nอบแห้งด้วยอุณหภูมิต่ำ เราจะอบเสื้อผ้าของคุณด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ\nหากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่นเช่น 30 หรือ 40 องศาเซลเซียส\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As standard when you use our professional laundry service, we dry your laundry at an\nappropriate temperature.",
      addon_description_th:
        "ในฐานะที่ร้านซักอบรีดมายลอนดรี้เป็นมืออาชีพ\n\nเสื้อผ้าทั้งหมดของคุณจะแห้งด้วยอุณหภูมิที่เหมาะสมตามมาตรฐานของเรา",
      description_en: "Drying at a low temperature",
      description_th: "อบผ้าแห้งโดยใช้อุณหภูมิต่ำ",
      ex_en: "Low Heat Dry",
      ex_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      name_en: "Low Heat Dry",
      name_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      addon_description_2:
        "With our special Low Heat Dry Add-On, your laundry will be dried at\na low temperature over a longer period. Use the Special Request box before placing your\nlaundry service order if you want us to dry your laundry at a specific temperature, such as 30°C\n\nor 40°C.",
    },
    {
      _id: "631b0159d51e9672eb23797c",
      language: "EN",
      name: "Antibacterial Sanitiser",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "For hygienically-clean laundry",
      image_key_desktop: "1662714200531_Add-ons (13).png",
      image_key_mobile: "1662714200900_Add-ons (13).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As part of our professional ironing service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      type: "ADDON",
      ex: "Antibacterial Sanitiser",
      icon_key: "1662714201026_Add-ons (8).png",
      createdAt: "2022-09-09T09:03:21.398Z",
      updatedAt: "2022-11-16T15:19:19.256Z",
      addon_description_2_en:
        "extra layer of support for an even more hygienically-clean ironing service, our Antibacterial\nSanitiser is free of bleach and can be used with all types of fabrics including children’s clothes.\n\nWe recommend Antibacterial Sanitiser for every ironing service.",
      addon_description_2_th:
        "นอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\n\nรวมทั้งเสื้อผ้าเด็กด้วย\n\nเราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียทุกครั้งที่คุณใช้บริการรีดผ้าของเรา",
      addon_description_en:
        "As part of our professional ironing service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย\n\nซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส รวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย\n\nช่วยเพิ่มระดับของการรีดผ้าให้ถูกสุขอนามัยยิ่งขึ้น",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการรีดผ้าที่ถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "extra layer of support for an even more hygienically-clean ironing service, our Antibacterial\nSanitiser is free of bleach and can be used with all types of fabrics including children’s clothes.\n\nWe recommend Antibacterial Sanitiser for every ironing service.",
    },
    {
      _id: "631adc6816368678b8ed8e6a",
      language: "EN",
      name: "Baby Wash",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Ideal for sensitive baby skin",
      image_key_desktop: "1662704743693_Add-ons (20).png",
      image_key_mobile: "1662704744064_Add-ons (20).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, our Baby Wash is specially designed for\nsensitive skin requirements and dermatologically tested to prevent allergic reactions.",
      type: "ADDON",
      ex: "e",
      icon_key: "1662704744202_Add-ons (19).png",
      createdAt: "2022-09-09T06:25:44.737Z",
      updatedAt: "2022-11-16T07:52:28.602Z",
      addon_description_2_en:
        "Baby Wash detergents and softeners we use in our quality laundry service are hypoallergenic\nand free of dyes but still strong in removing all the stains your baby loves to make. If you wish\nus to use only detergent and no softener in your Baby Wash, please select the free of charge\nNo Softener Add-On. Good to know: We use a variety of locally and internationally sourced\nBaby Wash products in our premium laundry service. Use the Special Request box before\nplacing your laundry service order to tell us your preferences and we will fulfil your request\n\nwhenever possible.",
      addon_description_2_th:
        "หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าสำหรับเด็กของคุณ กรุณาเลือกเพิ่มเติม\nไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ เรามีผลิตภัณฑ์ซักผ้าสำหรับเด็กทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Baby Wash is specially designed for\nsensitive skin requirements and dermatologically tested to prevent allergic reactions.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ซักผ้าสำหรับเด็ก\n\nซึ่งได้รับการออกแบบเป็นพิเศษเพื่อผิวบอบบางและผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า\nป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้",
      description_en: "Ideal for sensitive baby skin",
      description_th: "เหมาะสำหรับผิวบอบบางของเด็กทารก",
      ex_en: "e",
      ex_th: "t",
      name_en: "Baby Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าสำหรับเด็ก",
      addon_description_2:
        "Baby Wash detergents and softeners we use in our quality laundry service are hypoallergenic\nand free of dyes but still strong in removing all the stains your baby loves to make. If you wish\nus to use only detergent and no softener in your Baby Wash, please select the free of charge\nNo Softener Add-On. Good to know: We use a variety of locally and internationally sourced\nBaby Wash products in our premium laundry service. Use the Special Request box before\nplacing your laundry service order to tell us your preferences and we will fulfil your request\n\nwhenever possible.",
    },
    {
      _id: "631b094c8d95618757de7d7f",
      language: "EN",
      name: "Deodorant & Disinfection ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Makes your shoes smell like new",
      image_key_desktop: "1662716235912_Add-ons (43).png",
      image_key_mobile: "1662716236277_Add-ons (43).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "With our premium shoe cleaning service, we ensure your shoes look as good as new again – this is our professional shoe cleaning service standard. If you not only want your shoes to look neat on the outside but also care about their inner hygiene, we recommend choosing our Interior Shoe Cleansing Add-On,",
      type: "ADDON",
      ex: "Deodorant & Disinfection ",
      icon_key: "1662716236437_Add-ons (44).png",
      createdAt: "2022-09-09T09:37:17.020Z",
      updatedAt: "2022-11-16T14:56:48.536Z",
      name_th: "ทำความสะอาดรองเท้าด้านใน",
      name_en: "Deodorant & Disinfection ",
      addon_description_en:
        "With our premium shoe cleaning service, we ensure your shoes look as good as new again – this is our professional shoe cleaning service standard. If you not only want your shoes to look neat on the outside but also care about their inner hygiene, we recommend choosing our Interior Shoe Cleansing Add-On,",
      addon_description_2_en:
        "where we will particularly focus on cleaning and disinfecting the often forgotten interior of your shoes, including the insoles as well. Combining Interior Shoe Cleaning with our other Protection &amp; Waterproofing and Shoe Perfume Add-Ons will give your most treasured shoes the ultimate spa experience they deserve. Our professional shoe cleaning service is available for shoes of all colours and types, from sneakers to leather shoes, while we specialise in white shoes and white sneakers made from leather or other modern fabrics.",
      addon_description_th:
        "ร้านทำความสะอาดรองเท้ามายลอนดรี้ให้คุณแน่ใจว่ารองเท้าของคุณจะดูดีเหมือนใหม่อีกครั้ง นี่เป็นมาตรฐานบริการของเรา หากคุณต้องการให้รองเท้าดูดีจากภายนอก และมีสุขอนามัยที่ดีจากภายในด้วย เราขอแนะนำให้คุณเลือกบริการทำความสะอาดรองเท้าด้านใน",
      addon_description_2_th:
        "ซึ่งจะเน้นการทำความสะอาดและฆ่าเชื้อโรครองเท้าด้านในที่มักถูกมองข้าม รวมถึงพื้นรองเท้าด้วย ร้านทำความสะอาดรองเท้ามายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมทำความสะอาดรองเท้าด้านในร่วมกับ ผลิตภัณฑ์เคลือบและกันน้ำและน้ำหอมสำหรับรองเท้า เพื่อสัมผัสประสบการณ์สปารองเท้าขั้นสูงสุด เรายินดีให้บริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง และยังเชี่ยวชาญในการทำความสะอาดรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัยด้วย",
      description_en: "Makes your shoes smell like new",
      description_th: "คืนสุขอนามัยอย่างล้ำลึกถึงพื้นรองเท้า",
      ex_en: "Deodorant & Disinfection ",
      ex_th: "ทำความสะอาดรองเท้าด้านใน",
      addon_description_2:
        "where we will particularly focus on cleaning and disinfecting the often forgotten interior of your shoes, including the insoles as well. Combining Interior Shoe Cleaning with our other Protection &amp; Waterproofing and Shoe Perfume Add-Ons will give your most treasured shoes the ultimate spa experience they deserve. Our professional shoe cleaning service is available for shoes of all colours and types, from sneakers to leather shoes, while we specialise in white shoes and white sneakers made from leather or other modern fabrics.",
    },
    {
      _id: "631adccc16368678b8ed8e6e",
      language: "EN",
      name: "Make Jeans Blue Again",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "For genuine blue denim",
      image_key_desktop: "1668592518986_jean.png",
      image_key_mobile: "1668592519291_jean.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "A speciality of our premium laundry service is the Make Jeans Blue Again Add-On which\nrevives the original blue colour and protects the classic denim look of all your blue denim\njeans, trousers, skirts, jackets and shirts, to make them look as good as new again.",
      type: "ADDON",
      ex: "Make Jeans Blue Again",
      icon_key: "1668592519406_Default 3.png",
      createdAt: "2022-09-09T06:27:24.518Z",
      updatedAt: "2022-11-16T09:55:19.780Z",
      addon_description_2_en:
        "Washed-\nout and faded colours will be replaced and the typical jeans look will be restored and\nmaintained. We recommend Make Jeans Blue Again solely for classic blue denim items in\norder to give them back their original intensity. When you choose our Make Jeans Blue Again\nAdd-On, we separate all the suitable blue jeans and other denim fabrics included in your\nlaundry and treat them separately. Of course, all your other chosen Add-Ons still apply as well.\nIf you want us to focus on some denim items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "ช่วยให้สีที่ตกและซีดจางกลับมาสีน้ำเงินเข้มอีกครั้ง อีกทั้งฟื้นฟูสภาพและคงเอกลักษณ์ของยีนส์ไว้\nเราขอแนะนำตัวเลือก ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง ใช้กับผ้าเดนิมสีน้ำเงินคลาสสิกเท่านั้น\nเพื่อให้สีของผ้ากลับมาเข้มดั่งเดิม เมื่อคุณเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nเราจะดูแลยีนส์สีน้ำเงินและผ้าเดนิมของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะยีนส์บางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Jeans Blue Again Add-On which\nrevives the original blue colour and protects the classic denim look of all your blue denim\njeans, trousers, skirts, jackets and shirts, to make them look as good as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nซึ่งจะช่วยฟื้นคืนสภาพสีน้ำเงินกลับมาดังเดิมและรักษาภาพลักษณ์อันคลาสสิกของผ้าเดนิมให้กับยีนส์สีน้ำเงิน\nไม่ว่าจะเป็นกางเกง กระโปรง แจ็คเก็ต หรือเสื้อเชิ้ต เพื่อทำให้กลับมาดูดีเหมือนใหม่อีกครั้ง",
      description_en: "For genuine blue denim",
      description_th: "สำหรับผ้าเดนิมสีน้ำเงินแท้",
      ex_en: "Make Jeans Blue Again",
      ex_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      name_en: "Make Jeans Blue Again",
      name_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      addon_description_2:
        "Washed-\nout and faded colours will be replaced and the typical jeans look will be restored and\nmaintained. We recommend Make Jeans Blue Again solely for classic blue denim items in\norder to give them back their original intensity. When you choose our Make Jeans Blue Again\nAdd-On, we separate all the suitable blue jeans and other denim fabrics included in your\nlaundry and treat them separately. Of course, all your other chosen Add-Ons still apply as well.\nIf you want us to focus on some denim items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
    },
    {
      _id: "631b005d08f6c6a6bd127b01",
      language: "EN",
      name: "Hang",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "We hang on YOUR hangers",
      image_key_desktop: "1662713948630_Add-ons (22).png",
      image_key_mobile: "1662713948971_Add-ons (22).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an optional Add-On of our professional ironing service, we can hang up all hangable\nclothes on YOUR hangers. Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your order. If there are any specific items in your order",
      type: "ADDON",
      ex: "Hang",
      icon_key: "1662713949093_Add-ons (21).png",
      createdAt: "2022-09-09T08:59:09.812Z",
      updatedAt: "2022-11-16T15:17:25.996Z",
      addon_description_2_en:
        "which you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we can hang up all hangable\nclothes on YOUR hangers. Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your order. If there are any specific items in your order",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2:
        "which you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your ironing service order.",
    },
    {
      _id: "631add7b16368678b8ed8e76",
      language: "EN",
      name: "Hang",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "We hang on YOUR hangers",
      image_key_desktop: "1668592982195_Add-ons (22).png",
      image_key_mobile: "1668592982478_Add-ons (22).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an optional Add-On of our professional laundry service, we can hang up all hangable\nclothes on YOUR hangers.",
      type: "ADDON",
      ex: "Hang",
      icon_key: "1668592982585_Add-ons (21).png",
      createdAt: "2022-09-09T06:30:19.518Z",
      updatedAt: "2022-11-16T10:03:02.861Z",
      addon_description_2_en:
        "Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your laundry. If there are any specific items in your laundry\nwhich you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your laundry service order.",
      addon_description_2_th: "",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we can hang up all hangable\nclothes on YOUR hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า\nหากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2:
        "Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your laundry. If there are any specific items in your laundry\nwhich you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your laundry service order.",
    },
    {
      _id: "631b00f0d51e9672eb23794b",
      language: "EN",
      name: "Hang Plus+",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "We hang on OUR hangers",
      image_key_desktop: "1662714096131_Add-ons (26).png",
      image_key_mobile: "1662714096477_Add-ons (26).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an optional Add-On of our professional ironing service, we hang all hangable clothes on\nOUR basic hangers.",
      type: "ADDON",
      ex: "Hang Plus+",
      icon_key: "1662714096607_Add-ons (25).png",
      createdAt: "2022-09-09T09:01:36.978Z",
      updatedAt: "2022-11-16T15:18:34.118Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your order which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your order which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your ironing service\n\norder.",
    },
    {
      _id: "631adb1416368678b8ed8e5e",
      language: "EN",
      name: "Make Whites White Again",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Revive the shining white colour",
      image_key_desktop: "1668591998344_white_shirt.png",
      image_key_mobile: "1668591998663_white_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "A value-added option of our premium laundry service is the Make Whites White Again Add-\nOn which was especially designed to remove the effects of greying and yellowing from white\nfabrics to give them back their original uniform and bright whiteness to the highest extent\npossible.",
      type: "ADDON",
      ex: "Make Whites White Again",
      icon_key: "1668591998771_Default.png",
      createdAt: "2022-09-09T06:20:04.856Z",
      updatedAt: "2022-11-16T09:49:29.916Z",
      addon_description_2_en:
        "Make Whites White Again can be applied with any type of practical clothes (as well\nas white clothes with colour elements) to make them shine brilliant white again. When you\nchoose our Make White White Again Add-On, we separate all the suitable white fabrics\nincluded in your laundry and treat them separately. Of course, all your other chosen Add-Ons\nstill apply as well. If you want us to focus on some of your whites only or in particular, please tell\n\nus in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะผ้าสีขาวบางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A value-added option of our premium laundry service is the Make Whites White Again Add-\nOn which was especially designed to remove the effects of greying and yellowing from white\nfabrics to give them back their original uniform and bright whiteness to the highest extent\npossible.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nซึ่งได้รับการดีไซน์เป็นพิเศษเพื่อขจัดคราบสีเทาและสีเหลืองออกจากผ้าขาว\nทำให้กลับมาขาวสว่างสดใสดังเดิมมากที่สุด นอกจากนี้ตัวเลือก ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nยังใช้ได้กับเสื้อผ้าทั่วไป (รวมถึงผ้าขาวที่มีสีอื่นอยู่ด้วย) เพื่อให้กลับมาขาวเปล่งประกายได้อีกครั้ง\nเมื่อคุณเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง เราจะดูแลผ้าขาวของคุณแยกจากผ้าอื่นๆ",
      description_en: "Revive the shining white colour",
      description_th: "คืนประกายขาวสดใส",
      ex_en: "Make Whites White Again",
      ex_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      name_en: "Make Whites White Again",
      name_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      addon_description_2:
        "Make Whites White Again can be applied with any type of practical clothes (as well\nas white clothes with colour elements) to make them shine brilliant white again. When you\nchoose our Make White White Again Add-On, we separate all the suitable white fabrics\nincluded in your laundry and treat them separately. Of course, all your other chosen Add-Ons\nstill apply as well. If you want us to focus on some of your whites only or in particular, please tell\n\nus in the Special Request box before placing your laundry service order.",
    },
    {
      _id: "63134c67185a14333bd12ea1",
      language: "EN",
      name: "Iron",
      s: 1,
      m: 100,
      l: 150,
      status: true,
      description: "Ironing items by smooth starch",
      image_key_desktop: "1662699151208_Add-ons (7).png",
      image_key_mobile: "1662699151533_Add-ons (7).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, we iron EVERY piece of your laundry that is suitable for ironing. Shirts, dresses, trousers, towels, pillow cases and more, all ironed to creaseless perfection at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your laundry service order.",
      type: "ADDON",
      ex: "Iron",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-12-19T04:40:08.766Z",
      icon_key: "1662633765156_44_Property 1=Variant27.png",
      addon_description_2:
        "As our quality laundry service standard, we do not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. However, to meet your individual laundry service requirements, and if you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the Smooth Starch Add-On after you have already selected the Iron Add-On.",
      addon_description_2_en:
        "As our quality laundry service standard, we do not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. However, to meet your individual laundry service requirements, and if you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the Smooth Starch Add-On after you have already selected the Iron Add-On.",
      addon_description_2_th:
        "เราจะไม่ใช้น้ำยารีดผ้าเรียบใดๆ ในการรีดหรือซักผ้า\n\nฐานรองรีดของเราใช้เทคโนโลยีใหม่ล่าสุดเพื่อให้เสื้อผ้าของคุณเรียบสวยไร้รอยยับมากที่สุด\nหากคุณต้องการความเรียบเนียน กลิ่นหอม และความสมบูรณ์แบบในการรีดขั้นสูงสุด โปรดเลือกเพิ่มเติม\n\nน้ำยารีดผ้าเรียบ หลังจากเลือก รีดผ้า แล้ว",
      addon_description_en:
        "As an Add-On to our professional laundry service, we iron EVERY piece of your laundry that is suitable for ironing. Shirts, dresses, trousers, towels, pillow cases and more, all ironed to creaseless perfection at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your laundry service order.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้มีบริการรีดผ้าให้คุณ สำหรับผ้าทุกชิ้นที่เหมาะต่อการรีด ทั้งเสื้อเชิ้ต ชุดกระโปรง\n\nกางเกง ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอนให้คุณแน่ใจ\nหากมีรายการใดที่คุณไม่ต้องการให้เรารีด หรือมีสิ่งใดที่เราต้องให้ความสนใจเป็นพิเศษ",
      description_en: "Ironing items by smooth starch",
      description_th: "บริการรีดผ้าเรียบ ไร้รอยยับ",
      name_en: "Iron",
      name_th: "รีดผ้า",
      ex_en: "Iron",
      ex_th: "รีดผ้า",
    },
    {
      _id: "631adaa316368678b8ed8e59",
      language: "EN",
      name: "Laundry Perfume",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "The extra kick of freshness",
      image_key_desktop: "1662704288283_Add-ons (4).png",
      image_key_mobile: "1662704288867_Add-ons (4).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, our Laundry Perfume is suitable for all\ntypes of fabrics (incl. microfiber and functional wear) and comes with a long-lasting and\nfresh flowery fragrance day after day.",
      type: "ADDON",
      ex: "Laundry Perfume",
      icon_key: "1662704289024_Add-ons (5).png",
      createdAt: "2022-09-09T06:18:11.475Z",
      updatedAt: "2022-11-16T09:33:44.927Z",
      addon_description_2_en:
        "You will smell the Laundry Perfume not only directly after\nwashing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Laundry Perfume does not contain fabric softeners.\nHowever, if you have known allergies you should consider whether this Add-On is suitable for\nyou. Our tip: choose Laundry Perfume every time you use our professional laundry service for\n\nthe best long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับซักผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับซักผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Laundry Perfume is suitable for all\ntypes of fabrics (incl. microfiber and functional wear) and comes with a long-lasting and\nfresh flowery fragrance day after day.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำหอมสำหรับซักผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการซักไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Laundry Perfume",
      ex_th: "น้ำหอมสำหรับซักผ้า",
      name_en: "Laundry Perfume",
      name_th: "น้ำหอมสำหรับซักผ้า",
      addon_description_2:
        "You will smell the Laundry Perfume not only directly after\nwashing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Laundry Perfume does not contain fabric softeners.\nHowever, if you have known allergies you should consider whether this Add-On is suitable for\nyou. Our tip: choose Laundry Perfume every time you use our professional laundry service for\n\nthe best long-lasting smell.",
    },
    {
      _id: "631b00a1d51e9672eb237938",
      language: "EN",
      name: "Ironing Perfume",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "The extra kick of freshness",
      image_key_desktop: "1662714017029_Add-ons (4).png",
      image_key_mobile: "1662714017427_Add-ons (4).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an Add-On to our professional ironing service, our Ironing Perfume is suitable for all types\nof fabrics (incl. microfiber and functional wear) and comes with a long-lasting and fresh\nflowery fragrance day after day.",
      type: "ADDON",
      ex: "Ironing Perfume",
      icon_key: "1662714017569_Add-ons (5).png",
      createdAt: "2022-09-09T09:00:17.934Z",
      updatedAt: "2022-11-16T15:17:54.435Z",
      addon_description_2_en:
        "You will smell the Ironing Perfume not only directly after\nironing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Ironing Perfume does not contain fabric softeners.\nHowever, if you have known allergies, you should consider whether this Add-On is suitable for\nyou. Our tip: choose Ironing Perfume every time you use our professional ironing service for the\n\nbest long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับรีดผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับรีดผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, our Ironing Perfume is suitable for all types\nof fabrics (incl. microfiber and functional wear) and comes with a long-lasting and fresh\nflowery fragrance day after day.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำหอมสำหรับรีดผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการรีดไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Ironing Perfume",
      ex_th: "น้ำหอมสำหรับรีดผ้า",
      name_en: "Ironing Perfume",
      name_th: "น้ำหอมสำหรับรีดผ้า",
      addon_description_2:
        "You will smell the Ironing Perfume not only directly after\nironing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Ironing Perfume does not contain fabric softeners.\nHowever, if you have known allergies, you should consider whether this Add-On is suitable for\nyou. Our tip: choose Ironing Perfume every time you use our professional ironing service for the\n\nbest long-lasting smell.",
    },
    {
      _id: "631adbfc16368678b8ed8e66",
      language: "EN",
      name: "Make Blacks Black Again",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "Revive the true black colour",
      image_key_desktop: "1668592348437_black_shirt.png",
      image_key_mobile: "1668592348780_black_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "A speciality of our premium laundry service is the Make Blacks Black Again Add-On which\nrevives and protects the deep black shade of all your black clothes to make them look as\ngood as new again.",
      type: "ADDON",
      ex: "Make Blacks Black Again",
      icon_key: "1668592348904_Default 2.png",
      createdAt: "2022-09-09T06:23:56.397Z",
      updatedAt: "2022-11-16T09:52:29.518Z",
      addon_description_2_en:
        "Washed-out and faded black clothes will be revived and their colour\nrestored. We recommend repeating the application of our Make Blacks Black Again Add-On\nevery time you notice that your clothes are beginning to fade. When you choose our Make\nBlacks Black Again Add-On, we separate all the suitable black clothes included in your laundry\nand treat them separately. Of course, all your other chosen Add-Ons still apply as well. If you\nwant us to focus on some of your black items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "เราขอแนะนำให้ใช้ตัวเลือกนี้ซ้ำทุกครั้งที่คุณสังเกตเห็นว่าเสื้อผ้าเริ่มมีสีจางลง เมื่อคุณเลือกเพิ่มเติม\nให้ผ้าดำกลับมาสีดำอีกครั้ง เราจะดูแลผ้าสีดำของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ\nที่คุณเลือกจะถูกนำไปใช้ด้วย หากคุณต้องการให้เราเน้นเฉพาะผ้าสีดำบางตัวหรือจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้า\n\nมายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Blacks Black Again Add-On which\nrevives and protects the deep black shade of all your black clothes to make them look as\ngood as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าดำกลับมาสีดำอีกครั้ง\nซึ่งจะช่วยฟื้นคืนสภาพเฉดสีดำให้กลับมาเข้มดังเดิมและปกป้องผ้าสีดำให้ดูดีเหมือนใหม่\n\nช่วยให้สีที่ตกและซีดจางกลับมามีสีดำเข้มอีกครั้ง",
      description_en: "Revive the true black colour",
      description_th: "คืนสภาพสีดำอย่างแท้จริง",
      ex_en: "Make Blacks Black Again",
      ex_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      name_en: "Make Blacks Black Again",
      name_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      addon_description_2:
        "Washed-out and faded black clothes will be revived and their colour\nrestored. We recommend repeating the application of our Make Blacks Black Again Add-On\nevery time you notice that your clothes are beginning to fade. When you choose our Make\nBlacks Black Again Add-On, we separate all the suitable black clothes included in your laundry\nand treat them separately. Of course, all your other chosen Add-Ons still apply as well. If you\nwant us to focus on some of your black items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
    },
    {
      _id: "637203f8a142589973ec1ea0",
      language: "EN",
      name: "Hang Plus+",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "We hang on OUR hangers",
      image_key_desktop: "1668593118092_Add-ons (26).png",
      image_key_mobile: "1668593118353_Add-ons (26).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an optional Add-On of our professional laundry service, we hang all hangable clothes on\nOUR basic hangers.",
      type: "ADDON",
      ex: "Hang Plus+",
      icon_key: "1668593118489_Add-ons (25).png",
      createdAt: "2022-11-14T09:01:44.505Z",
      updatedAt: "2022-11-16T10:05:18.764Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your laundry which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your laundry service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your laundry which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your laundry service\n\norder.",
    },
    {
      _id: "63720417a142589973ec1ea9",
      language: "EN",
      name: "Antibacterial Sanitiser",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "For hygienically-clean laundry",
      image_key_desktop: "1670562040139_1668587273739_Add-ons (13).png",
      image_key_mobile: "1668587274101_Add-ons (13).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As part of our professional laundry service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      type: "ADDON",
      ex: "Antibacterial Sanitiser",
      icon_key: "1668587274241_Add-ons (8).png",
      createdAt: "2022-11-14T09:02:15.384Z",
      updatedAt: "2022-12-09T05:00:41.761Z",
      addon_description_2_en:
        "Providing an\nextra layer of support to the detergent for an even more hygienically-clean laundry service, our\nAntibacterial Sanitiser is free of bleach and can be used with all types of fabrics including\nchildren’s clothes. We recommend Antibacterial Sanitiser for every wash, while for particularly\nhigh hygiene demands, it can be combined with our High Temperature Wash Add-On option to\n\ncreate your very own customised laundry service experience.",
      addon_description_2_th:
        "ช่วยเพิ่มประสิทธิภาพของการซักผ้าให้สะอาดถูกสุขอนามัยยิ่งขึ้น\nนอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\nรวมทั้งเสื้อผ้าเด็กด้วย เราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียสำหรับทุกการซักผ้า\nโดยใช้ร่วมกับตัวเลือกเพิ่มเติมการซักด้วยอุณหภูมิสูง เพื่อสุขอนามัยขั้นพิเศษ",
      addon_description_en:
        "As part of our professional laundry service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย ซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส\nรวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการซักผ้าที่สะอาดถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "Providing an\nextra layer of support to the detergent for an even more hygienically-clean laundry service, our\nAntibacterial Sanitiser is free of bleach and can be used with all types of fabrics including\nchildren’s clothes. We recommend Antibacterial Sanitiser for every wash, while for particularly\nhigh hygiene demands, it can be combined with our High Temperature Wash Add-On option to\n\ncreate your very own customised laundry service experience.",
    },
    {
      _id: "63720392a142589973ec1e9a",
      language: "EN",
      name: "No Softener ",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "We will not use Softener at all",
      image_key_desktop: "1668587084343_Add-ons (10).png",
      image_key_mobile: "1668587084846_Add-ons (10).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "You can rely on us not to use any softener with your laundry – clear, easy and free of charge.",
      type: "ADDON",
      ex: "No Softener ",
      icon_key: "1668587084964_Add-ons (9).png",
      createdAt: "2022-11-14T09:00:02.224Z",
      updatedAt: "2022-11-16T12:54:02.992Z",
      addon_description_2_en: "",
      addon_description_2_th: "",
      addon_description_en:
        "You can rely on us not to use any softener with your laundry – clear, easy and free of charge.",
      addon_description_th:
        "ให้คุณมั่นใจว่าเราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆในการซักผ้าของคุณ ชัดเจน ง่าย และฟรี",
      description_en: "We will not use Softener at all",
      description_th: "เราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆ",
      ex_en: "No Softener ",
      ex_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      name_en: "No Softener ",
      name_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      addon_description_2: "",
    },
    {
      _id: "631413c80fd8fc3bfd89d79e",
      language: "EN",
      name: "High Temperature Wash",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "We wash at 60°C",
      image_key_desktop: "1668590690011_Add-ons (15).png",
      image_key_mobile: "1668590690508_Add-ons (15).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As a professional laundry service, we recommend the High Temperature Wash at 60°C Add-\nOn for towels, bedding and baby clothes as standard or for your regular clothes after you\nhave recovered from a cold or viral infection.",
      ex: "High Temperature Wash ",
      createdAt: "2022-09-04T02:56:08.859Z",
      updatedAt: "2022-11-18T11:58:42.380Z",
      type: "ADDON",
      icon_key: "1668590690623_Add-ons (14).png",
      addon_description_2_en:
        "With our High Temperature Wash, your laundry\nwill be hygienically clean, while bacteria and viruses will be eliminated. If you have specific high\nhygiene requirements, we recommend combining our High Temperature Wash with our\nAntibacterial Sanitiser Add-On to create the complete clean and sanitised laundry service. You\ncan tell us in the Special Request box before placing your laundry service order if you want us\nto wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude\n\nspecific items from the High Temperature Wash and treat them separately.",
      addon_description_2_th:
        "ด้วยการซักอุณหภูมิสูงของเราทำให้ผ้าสะอาดถูกสุขอนามัย และยังฆ่าเชื้อแบคทีเรียและไวรัสได้อีกด้วย\nขอแนะนำให้รวมการซักด้วยอุณหภูมิสูงกับผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียเพื่อสุขอนามัยขั้นพิเศษ\n\nหากคุณต้องการให้เราซักที่อุณหภูมิอื่นเช่น 50 หรือ 90 องศาเซลเซียส\nหรือประสงค์จะแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As a professional laundry service, we recommend the High Temperature Wash at 60°C Add-\nOn for towels, bedding and baby clothes as standard or for your regular clothes after you\nhave recovered from a cold or viral infection.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ขอแนะนำให้ซักผ้าด้วยอุณหภูมิสูงที่ 60 องศาเซลเซียส สำหรับผ้าเช็ดตัว เครื่องนอน\nเสื้อผ้าเด็กทารกเป็นมาตรฐาน หรือสำหรับเสื้อผ้าทั่วไปหลังจากที่หายจากอาการหวัดหรือติดเชื้อไวรัสแล้ว",
      description_en: "We wash at 60°C",
      description_th: "เราซักที่ 60 องศาเซลเซียส",
      name_en: "High Temperature Wash",
      name_th: "ซักด้วยอุณหภูมิสูง",
      ex_en: "High Temperature Wash ",
      ex_th: "ซักด้วยอุณหภูมิสูง",
      addon_description_2:
        "With our High Temperature Wash, your laundry\nwill be hygienically clean, while bacteria and viruses will be eliminated. If you have specific high\nhygiene requirements, we recommend combining our High Temperature Wash with our\nAntibacterial Sanitiser Add-On to create the complete clean and sanitised laundry service. You\ncan tell us in the Special Request box before placing your laundry service order if you want us\nto wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude\n\nspecific items from the High Temperature Wash and treat them separately.",
    },
    {
      _id: "631adb9016368678b8ed8e62",
      language: "EN",
      name: "Organic Wash",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "The best organic laundry choice",
      image_key_desktop: "1662704526308_Add-ons (16).png",
      image_key_mobile: "1662704526640_Add-ons (16).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service our Organic Wash comes with no dyes,\nfragrances or preservatives. Our organic detergents and softeners contain only plant-based,\nnaturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents\nand softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do\nnot wish us to use softener in your Organic Wash as part of our quality laundry service, please",
      type: "ADDON",
      ex: "e",
      icon_key: "1662704526746_Add-ons (6).png",
      createdAt: "2022-09-09T06:22:08.116Z",
      updatedAt: "2022-11-16T07:51:49.741Z",
      addon_description_2_en:
        "select the free of charge No Softener Add-On. Organic products are especially gentle to the\nenvironment and therefore strongly recommended. PS: We use a variety of locally and\ninternationally sourced Organic Wash products in our premium laundry service. Use the\nSpecial Request box before placing your laundry service order to tell us your preferences and\n\nwe will fulfil your request whenever possible.",
      addon_description_2_th:
        "กรุณาเลือกเพิ่มเติม ไม่ใช้น้ำยาปรับผ้านุ่ม ผลิตภัณฑ์ออร์แกนิคเป็นมิตรกับสิ่งแวดล้อม\nจึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้ เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service our Organic Wash comes with no dyes,\nfragrances or preservatives. Our organic detergents and softeners contain only plant-based,\nnaturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents\nand softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do\nnot wish us to use softener in your Organic Wash as part of our quality laundry service, please",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิค\n\nซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ\nนอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย\nและยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ",
      description_en: "The best organic laundry choice",
      description_th: "ตัวเลือกดีที่สุดสำหรับทุกคน",
      ex_en: "e",
      ex_th: "t",
      name_en: "Organic Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าออร์แกนิค",
      addon_description_2:
        "select the free of charge No Softener Add-On. Organic products are especially gentle to the\nenvironment and therefore strongly recommended. PS: We use a variety of locally and\ninternationally sourced Organic Wash products in our premium laundry service. Use the\nSpecial Request box before placing your laundry service order to tell us your preferences and\n\nwe will fulfil your request whenever possible.",
    },
    {
      _id: "63134c67185a14333bd12da2",
      language: "EN",
      name: "Protection & Waterproofing ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Keep your shoes safe and sound",
      image_key_desktop: "1662716152579_Add-ons (42).png",
      image_key_mobile: "1662716152884_Add-ons (42).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "Our Protection &amp; Waterproofing Add-On keeps your favourite shoes safe from external factors such as rain and dirt.",
      type: "ADDON",
      ex: "Protection & Waterproofing ",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T14:55:07.017Z",
      icon_key: "1662716153013_Add-ons (41).png",
      name_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      name_en: "Protection & Waterproofing ",
      addon_description_en:
        "Our Protection &amp; Waterproofing Add-On keeps your favourite shoes safe from external factors such as rain and dirt.",
      addon_description_2_en:
        "A protective film prevents moisture from penetrating into the shoes while still keeping them breathable and blocks dirt right at the surface to stop any unremovable stains forming. Our shoe cleaning service not only protects your new and favourite shoes but also extends their durability and longevity and is suitable for shoes of all colours and types, from sneakers to leather shoes. We recommend combining Protection &amp; Waterproofing with our Interior Shoe Cleansing and Shoe Perfume Add-Ons to experience the best of our premium shoe cleaning service.",
      addon_description_th:
        "best of our premium shoe cleaning service. ร้านทำความสะอาดรองเท้ามายลอนดรี้มีบริการเคลือบและกันน้ำ ซึ่งช่วยปกป้องรองเท้าคู่โปรดของคุณให้ปลอดภัยจากปัจจัยภายนอก ทั้งฝนและคราบสกปรกต่างๆ โดยมีฟิล์มเคลือบป้องกันไม่ให้ความชื้นซึมเข้าสู่รองเท้า และยังช่วยระบายอากาศได้ดี พร้อมทั้งยับยั้งการเกิดคราบสกปรกบนพื้นผิว รวมถึงป้องกันการก่อตัวของคราบที่ฝังแน่น",
      addon_description_2_th:
        "บริการนี้ไม่เพียงแต่ปกป้องรองเท้าคู่ใหม่สุดโปรดของคุณเท่านั้น แต่ยังช่วยยืดอายุการใช้งานให้นานและเหมาะสำหรับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ร้านทำความสะอาดรองเท้า มายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำร่วมกับบริการทำความสะอาดรองเท้า ด้านในและน้ำหอมสำหรับรองเท้า เพื่อบริการสปารองเท้าระดับพรีเมียมที่ดีที่สุด",
      description_en: "Keep your shoes safe and sound",
      description_th: "ปกป้องรองเท้าของคุณให้ปลอดภัย",
      ex_en: "Protection & Waterproofing ",
      ex_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      addon_description_2:
        "A protective film prevents moisture from penetrating into the shoes while still keeping them breathable and blocks dirt right at the surface to stop any unremovable stains forming. Our shoe cleaning service not only protects your new and favourite shoes but also extends their durability and longevity and is suitable for shoes of all colours and types, from sneakers to leather shoes. We recommend combining Protection &amp; Waterproofing with our Interior Shoe Cleansing and Shoe Perfume Add-Ons to experience the best of our premium shoe cleaning service.",
    },
    {
      _id: "63134c67185a14333bd12ea2",
      language: "EN",
      name: "Smooth Starch",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "For the ultimate ironing results",
      image_key_desktop: "1662713749933_Add-ons (12).png",
      image_key_mobile: "1662713750525_Add-ons (12).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an Add-On to our professional ironing service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer. We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free",
      type: "ADDON",
      ex: "Smooth Starch",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T15:16:45.196Z",
      icon_key: "1662634995246_41_Property 1=Smooth Starch.png",
      addon_description_2_en:
        "fragrance, and pure ironing perfection as part of our premium ironing service. Smooth Starch\nwill give your clothes and bedding items the ultimate neat and crisp appearance.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\nซึ่งจะช่วยให้ผ้าและเครื่องนอนของคุณเรียบเนียนสดชื่นมีชีวิตชีวามากที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer. We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "fragrance, and pure ironing perfection as part of our premium ironing service. Smooth Starch\nwill give your clothes and bedding items the ultimate neat and crisp appearance.",
    },
    {
      _id: "631ac4517cbbbb34e17f8b19",
      language: "EN",
      name: "Smooth Starch",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "For the ultimate ironing results",
      image_key_desktop: "1662953321455_Add-ons (12).png",
      image_key_mobile: "1662953321745_Add-ons (12).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer.",
      type: "ADDON",
      ex: "Smooth Starch",
      icon_key: "1662699611185_Add-ons (11).png",
      createdAt: "2022-09-09T04:42:57.735Z",
      updatedAt: "2022-11-16T09:32:13.437Z",
      addon_description_2_en:
        "We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free\nfragrance, and pure ironing perfection as part of our premium laundry service. Smooth Starch\nwill give your laundry the ultimate neat and crisp appearance it deserves. You can only select\n\nthe Smooth Starch Add-On if you have already selected the Iron Add-On.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\n\nซึ่งจะช่วยให้ผ้าของคุณสะอาดเรียบร้อยและสดชื่นมีชีวิตชีวามากที่สุด โปรดเลือกเพิ่มเติม น้ำยารีดผ้าเรียบ\n\nหลังจากเลือก รีดผ้า แล้วเท่านั้น",
      addon_description_en:
        "As an Add-On to our professional laundry service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free\nfragrance, and pure ironing perfection as part of our premium laundry service. Smooth Starch\nwill give your laundry the ultimate neat and crisp appearance it deserves. You can only select\n\nthe Smooth Starch Add-On if you have already selected the Iron Add-On.",
    },
    {
      _id: "631add2516368678b8ed8e72",
      language: "EN",
      name: "Stain Removal",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "Removing stains from A to Z",
      image_key_desktop: "1662704932262_Add-ons (24).png",
      image_key_mobile: "1662704932575_Add-ons (24).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "When you select the Stain Removal Add-On, our professional laundry service team screens\nevery item of your laundry from head to toe and makes every effort to remove any stains we\nfind. We can remove many kinds of stains, such as oil, sauces, ketchup, chocolate,\nmayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk,\nyogurt, cream, mould, blood, pus, ballpoint pens, ink, felt tip pens, highlighters, coloured pencils,",
      type: "ADDON",
      ex: "e",
      icon_key: "1662704932707_Add-ons (23).png",
      createdAt: "2022-09-09T06:28:53.237Z",
      updatedAt: "2022-11-16T12:52:35.070Z",
      addon_description_2_en:
        "water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle\nwax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on\nsome items of your laundry in particular, you can tell us in the Special Request box before\n\nplacing your laundry service order.",
      addon_description_2_th:
        "เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์\n\nหมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล\nหากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "When you select the Stain Removal Add-On, our professional laundry service team screens\nevery item of your laundry from head to toe and makes every effort to remove any stains we\nfind. We can remove many kinds of stains, such as oil, sauces, ketchup, chocolate,\nmayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk,\nyogurt, cream, mould, blood, pus, ballpoint pens, ink, felt tip pens, highlighters, coloured pencils,",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้จะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด เราสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต\nมายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา\nคราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้",
      description_en: "Removing stains from A to Z",
      description_th: "ขจัดคราบต่างๆอย่างละเอียด",
      ex_en: "e",
      ex_th: "t",
      name_en: "Stain Removal",
      name_th: "ขจัดคราบ",
      addon_description_2:
        "water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle\nwax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on\nsome items of your laundry in particular, you can tell us in the Special Request box before\n\nplacing your laundry service order.",
    },
  ],
};

export const mock_data_glossary_th = {
  addons: [
    {
      _id: "63134c67185a14333bd12ea1",
      language: "EN",
      name: "รีดผ้า",
      s: 1,
      m: 100,
      l: 150,
      status: true,
      description: "บริการรีดผ้าเรียบ ไร้รอยยับ",
      image_key_desktop: "1662699151208_Add-ons (7).png",
      image_key_mobile: "1662699151533_Add-ons (7).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้มีบริการรีดผ้าให้คุณ สำหรับผ้าทุกชิ้นที่เหมาะต่อการรีด ทั้งเสื้อเชิ้ต ชุดกระโปรง\n\nกางเกง ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอนให้คุณแน่ใจ\nหากมีรายการใดที่คุณไม่ต้องการให้เรารีด หรือมีสิ่งใดที่เราต้องให้ความสนใจเป็นพิเศษ",
      type: "ADDON",
      ex: "รีดผ้า",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-12-19T04:40:08.766Z",
      icon_key: "1662633765156_44_Property 1=Variant27.png",
      addon_description_2:
        "เราจะไม่ใช้น้ำยารีดผ้าเรียบใดๆ ในการรีดหรือซักผ้า\n\nฐานรองรีดของเราใช้เทคโนโลยีใหม่ล่าสุดเพื่อให้เสื้อผ้าของคุณเรียบสวยไร้รอยยับมากที่สุด\nหากคุณต้องการความเรียบเนียน กลิ่นหอม และความสมบูรณ์แบบในการรีดขั้นสูงสุด โปรดเลือกเพิ่มเติม\n\nน้ำยารีดผ้าเรียบ หลังจากเลือก รีดผ้า แล้ว",
      addon_description_2_en:
        "As our quality laundry service standard, we do not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. However, to meet your individual laundry service requirements, and if you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the Smooth Starch Add-On after you have already selected the Iron Add-On.",
      addon_description_2_th:
        "เราจะไม่ใช้น้ำยารีดผ้าเรียบใดๆ ในการรีดหรือซักผ้า\n\nฐานรองรีดของเราใช้เทคโนโลยีใหม่ล่าสุดเพื่อให้เสื้อผ้าของคุณเรียบสวยไร้รอยยับมากที่สุด\nหากคุณต้องการความเรียบเนียน กลิ่นหอม และความสมบูรณ์แบบในการรีดขั้นสูงสุด โปรดเลือกเพิ่มเติม\n\nน้ำยารีดผ้าเรียบ หลังจากเลือก รีดผ้า แล้ว",
      addon_description_en:
        "As an Add-On to our professional laundry service, we iron EVERY piece of your laundry that is suitable for ironing. Shirts, dresses, trousers, towels, pillow cases and more, all ironed to creaseless perfection at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your laundry service order.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้มีบริการรีดผ้าให้คุณ สำหรับผ้าทุกชิ้นที่เหมาะต่อการรีด ทั้งเสื้อเชิ้ต ชุดกระโปรง\n\nกางเกง ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอนให้คุณแน่ใจ\nหากมีรายการใดที่คุณไม่ต้องการให้เรารีด หรือมีสิ่งใดที่เราต้องให้ความสนใจเป็นพิเศษ",
      description_en: "Ironing items by smooth starch",
      description_th: "บริการรีดผ้าเรียบ ไร้รอยยับ",
      name_en: "Iron",
      name_th: "รีดผ้า",
      ex_en: "Iron",
      ex_th: "รีดผ้า",
    },
    {
      _id: "631413c80fd8fc3bfd89d79e",
      language: "EN",
      name: "ซักด้วยอุณหภูมิสูง",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "เราซักที่ 60 องศาเซลเซียส",
      image_key_desktop: "1668590690011_Add-ons (15).png",
      image_key_mobile: "1668590690508_Add-ons (15).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ขอแนะนำให้ซักผ้าด้วยอุณหภูมิสูงที่ 60 องศาเซลเซียส สำหรับผ้าเช็ดตัว เครื่องนอน\nเสื้อผ้าเด็กทารกเป็นมาตรฐาน หรือสำหรับเสื้อผ้าทั่วไปหลังจากที่หายจากอาการหวัดหรือติดเชื้อไวรัสแล้ว",
      ex: "ซักด้วยอุณหภูมิสูง",
      createdAt: "2022-09-04T02:56:08.859Z",
      updatedAt: "2022-11-18T11:58:42.380Z",
      type: "ADDON",
      icon_key: "1668590690623_Add-ons (14).png",
      addon_description_2_en:
        "With our High Temperature Wash, your laundry\nwill be hygienically clean, while bacteria and viruses will be eliminated. If you have specific high\nhygiene requirements, we recommend combining our High Temperature Wash with our\nAntibacterial Sanitiser Add-On to create the complete clean and sanitised laundry service. You\ncan tell us in the Special Request box before placing your laundry service order if you want us\nto wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude\n\nspecific items from the High Temperature Wash and treat them separately.",
      addon_description_2_th:
        "ด้วยการซักอุณหภูมิสูงของเราทำให้ผ้าสะอาดถูกสุขอนามัย และยังฆ่าเชื้อแบคทีเรียและไวรัสได้อีกด้วย\nขอแนะนำให้รวมการซักด้วยอุณหภูมิสูงกับผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียเพื่อสุขอนามัยขั้นพิเศษ\n\nหากคุณต้องการให้เราซักที่อุณหภูมิอื่นเช่น 50 หรือ 90 องศาเซลเซียส\nหรือประสงค์จะแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As a professional laundry service, we recommend the High Temperature Wash at 60°C Add-\nOn for towels, bedding and baby clothes as standard or for your regular clothes after you\nhave recovered from a cold or viral infection.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ขอแนะนำให้ซักผ้าด้วยอุณหภูมิสูงที่ 60 องศาเซลเซียส สำหรับผ้าเช็ดตัว เครื่องนอน\nเสื้อผ้าเด็กทารกเป็นมาตรฐาน หรือสำหรับเสื้อผ้าทั่วไปหลังจากที่หายจากอาการหวัดหรือติดเชื้อไวรัสแล้ว",
      description_en: "We wash at 60°C",
      description_th: "เราซักที่ 60 องศาเซลเซียส",
      name_en: "High Temperature Wash",
      name_th: "ซักด้วยอุณหภูมิสูง",
      ex_en: "High Temperature Wash ",
      ex_th: "ซักด้วยอุณหภูมิสูง",
      addon_description_2:
        "ด้วยการซักอุณหภูมิสูงของเราทำให้ผ้าสะอาดถูกสุขอนามัย และยังฆ่าเชื้อแบคทีเรียและไวรัสได้อีกด้วย\nขอแนะนำให้รวมการซักด้วยอุณหภูมิสูงกับผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียเพื่อสุขอนามัยขั้นพิเศษ\n\nหากคุณต้องการให้เราซักที่อุณหภูมิอื่นเช่น 50 หรือ 90 องศาเซลเซียส\nหรือประสงค์จะแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "6314264c7a1baccc80de71b5",
      language: "EN",
      name: "ขวด 350 มิลลิลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      image_key_desktop: "1662709691037_Frame 52878 (1).png",
      image_key_mobile: "1662709691409_Frame 52878 (1).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 50,
      ex: "ขวด 350 มิลลิลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-18T07:08:20.308Z",
      icon_key: "1662709691547_Frame 52878.png",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 16 bottles (48 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      ex_en: "350 ml bottle",
      ex_th: "ขวด 350 มิลลิลิตร",
      name_en: "350 ml bottle",
      name_th: "ขวด 350 มิลลิลิตร",
    },
    {
      _id: "631428327a1baccc80de71c2",
      language: "EN",
      name: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662707669485_Add-ons (27).png",
      image_key_mobile: "1662707669866_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Wash S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-12-06T08:36:06.839Z",
      size: "S",
      price: 1,
      master: true,
      master_type: "My Wash",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 22 pieces or 1 x My Laundry Bag",
      name_th: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
    },
    {
      _id: "63142d2e7a1baccc80de71f6",
      language: "EN",
      name: "ผ้านวม หรือ ผ้าห่ม",
      status: false,
      description: "สำหรับ 1 ผืน",
      image_key_desktop: "1662708818450_Add-ons (28).png",
      image_key_mobile: "1662708818835_Add-ons (28).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      type: "EXTRA",
      price: 50,
      ex: "ผ้านวม หรือ ผ้าห่ม",
      createdAt: "2022-09-04T04:44:30.024Z",
      updatedAt: "2022-11-16T14:40:27.166Z",
      icon_key: "1662633859153_13_Property 1=Comforter or Duvet Insert.png",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 comforter or duvet insert in addition to your regular laundry for each order.\nOur comforter or duvet insert service includes washing AND ironing, where possible, as default.\nAll other Add-Ons chosen for your laundry will apply for the comforter or duvet insert\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_th:
        "ทั้งนี้บริการผ้านวมหรือผ้าห่มของเรารวมการซักและรีด หากรีดได้ เป็นมาตรฐาน\n\nส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\n\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your comforter or duvet\ninsert as well as part of our professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Comforter or Duvet Insert",
      ex_th: "ผ้านวม หรือ ผ้าห่ม",
      name_en: "Comforter or Duvet Insert",
      name_th: "ผ้านวม หรือ ผ้าห่ม",
      addon_description_2:
        "ทั้งนี้บริการผ้านวมหรือผ้าห่มของเรารวมการซักและรีด หากรีดได้ เป็นมาตรฐาน\n\nส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\n\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "63142e637a1baccc80de71ff",
      language: "EN",
      name: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662707802497_Add-ons (27).png",
      image_key_mobile: "1662707802853_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Wash S, M และ L",
      createdAt: "2022-09-04T04:49:39.328Z",
      updatedAt: "2022-11-16T15:11:14.871Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Wash",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 44 pieces or 2 x My Laundry Bag",
      name_th: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
    },
    {
      _id: "631462cf7a1baccc80de7205",
      language: "EN",
      name: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662707883149_Add-ons (27).png",
      image_key_mobile: "1662707883497_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      price: 995,
      ex: "แพ็กเกจ My Wash S, M และ L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:28:02.766Z",
      size: "L",
      master: true,
      master_type: "My Wash",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 66 pieces or 3 x My Laundry Bag",
      name_th: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
    },
    {
      _id: "63134c67185a14333bd12ea2",
      language: "EN",
      name: "น้ำยารีดผ้าเรียบ",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "ให้ผ้าเรียบเนียนที่สุด",
      image_key_desktop: "1662713749933_Add-ons (12).png",
      image_key_mobile: "1662713750525_Add-ons (12).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      type: "ADDON",
      ex: "น้ำยารีดผ้าเรียบ",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T15:16:45.196Z",
      icon_key: "1662634995246_41_Property 1=Smooth Starch.png",
      addon_description_2_en:
        "fragrance, and pure ironing perfection as part of our premium ironing service. Smooth Starch\nwill give your clothes and bedding items the ultimate neat and crisp appearance.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\nซึ่งจะช่วยให้ผ้าและเครื่องนอนของคุณเรียบเนียนสดชื่นมีชีวิตชีวามากที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer. We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\nซึ่งจะช่วยให้ผ้าและเครื่องนอนของคุณเรียบเนียนสดชื่นมีชีวิตชีวามากที่สุด",
    },
    {
      _id: "6314264c7a1baccc80de71b6",
      language: "EN",
      name: "ขวด 1.5 ลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      image_key_desktop: "1662709539412_Add-ons (36).png",
      image_key_mobile: "1662709539762_Add-ons (36).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 100,
      ex: "ขวด 1.5 ลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:06.225Z",
      icon_key: "1662709539873_Add-ons (35).png",
      addon_description_2_en:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 6 bottles (18 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "1.5 l bottle",
      name_th: "ขวด 1.5 ลิตร",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
    },
    {
      _id: "631428327a1baccc80de71c3",
      language: "EN",
      name: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662715257667_Add-ons (40).png",
      image_key_mobile: "1662715258054_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Iron S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:23:35.419Z",
      size: "S",
      price: 395,
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 22 pieces or 1 x My Laundry Bag",
      name_th: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
    },
    {
      _id: "63142d2e7a1baccc80de71f7",
      language: "EN",
      name: "ผ้านวม หรือ ผ้าห่ม",
      status: false,
      description: "สำหรับ 1 ผืน",
      image_key_desktop: "1662714264226_Add-ons (28).png",
      image_key_mobile: "1662714264591_Add-ons (28).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "นอกจากการรีดผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      type: "EXTRA",
      price: 50,
      ex: "ผ้านวม หรือ ผ้าห่ม",
      createdAt: "2022-09-04T04:44:30.024Z",
      updatedAt: "2022-11-16T15:19:59.658Z",
      icon_key: "1662635128836_13_Property 1=Comforter or Duvet Insert.png",
      addon_description_2_en:
        "Please be informed that we can pick up a\nmaximum of 1 comforter or duvet insert in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the comforter or duvet insert automatically,\nunless you advise us differently in the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular ironing, we are happy to take care of your comforter or duvet insert\nas well as part of our professional ironing service.",
      addon_description_th:
        "นอกจากการรีดผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Comforter or Duvet Insert",
      ex_th: "ผ้านวม หรือ ผ้าห่ม",
      name_en: "Comforter or Duvet Insert",
      name_th: "ผ้านวม หรือ ผ้าห่ม",
      addon_description_2:
        "ส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631428327a1baccc80de71d4",
      language: "EN",
      name: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662715436595_Add-ons (40).png",
      image_key_mobile: "1662715436948_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Iron S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:25:03.421Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 44 pieces or 2 x My Laundry Bag",
      name_th: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
    },
    {
      _id: "631462cf7a1baccc80de7207",
      language: "EN",
      name: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662715520829_Add-ons (40).png",
      image_key_mobile: "1662715521203_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      price: 995,
      ex: "แพ็กเกจ My Iron S, M และ L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:26:26.865Z",
      size: "L",
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 66 pieces or 3 x My Laundry Bag",
      name_th: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
    },
    {
      _id: "6314264c7a1baccc80de71c6",
      language: "EN",
      name: "ขวด 600 มิลลิลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      image_key_desktop: "1662709814171_Add-ons (38).png",
      image_key_mobile: "1662709814550_Add-ons (38).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 150,
      ex: "ขวด 1.5 ลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:12.696Z",
      icon_key: "1662709814728_Add-ons (37).png",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 12 bottles (36 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "600 ml bottle",
      name_th: "ขวด 600 มิลลิลิตร",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
    },
    {
      _id: "631428327a1baccc80de71d3",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 5 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Description for the Pop-up at Add-Ons",
      type: "PACKAGE",
      ex: "Up to 5 pieces",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-15T10:08:29.184Z",
      size: "S",
      price: 745,
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Description for the Pop-up at Add-Ons",
      addon_description_2_th: "Description for the Pop-up at Add-Ons",
      addon_description_en: "Description for the Pop-up at Add-Ons",
      addon_description_th: "Description for the Pop-up at Add-Ons",
      description_en: "Up to 5 pieces",
      description_th: "Up to 5 pieces",
      ex_en: "Up to 5 pieces",
      ex_th: "Up to 5 pieces",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Description for the Pop-up at Add-Ons",
    },
    {
      _id: "631428327a1baccc80de71e4",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 10 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Description for the Pop-up at Add-Ons",
      type: "PACKAGE",
      ex: "Up to 10 pieces",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-15T10:09:07.157Z",
      size: "M",
      price: 1045,
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Description for the Pop-up at Add-Ons",
      addon_description_2_th: "Description for the Pop-up at Add-Ons",
      addon_description_en: "Description for the Pop-up at Add-Ons",
      addon_description_th: "Description for the Pop-up at Add-Ons",
      description_en: "Up to 10 pieces",
      description_th: "Up to 10 pieces",
      ex_en: "Up to 10 pieces",
      ex_th: "Up to 10 pieces",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Description for the Pop-up at Add-Ons",
    },
    {
      _id: "631462cf7a1baccc80de72f7",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 15 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Ex. Lorem ipsum dolor sit amet ...",
      type: "PACKAGE",
      price: 1345,
      ex: "Title for the Pop-up at Add-Ons",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-15T10:09:30.272Z",
      size: "L",
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_2_th: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_en: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_th: "Ex. Lorem ipsum dolor sit amet ...",
      description_en: "Up to 15 pieces",
      description_th: "Up to 15 pieces",
      ex_en: "Title for the Pop-up at Add-Ons",
      ex_th: "Title for the Pop-up at Add-Ons",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Ex. Lorem ipsum dolor sit amet ...",
    },
    {
      _id: "63134c67185a14333bd12da2",
      language: "EN",
      name: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "ปกป้องรองเท้าของคุณให้ปลอดภัย",
      image_key_desktop: "1662716152579_Add-ons (42).png",
      image_key_mobile: "1662716152884_Add-ons (42).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "best of our premium shoe cleaning service. ร้านทำความสะอาดรองเท้ามายลอนดรี้มีบริการเคลือบและกันน้ำ ซึ่งช่วยปกป้องรองเท้าคู่โปรดของคุณให้ปลอดภัยจากปัจจัยภายนอก ทั้งฝนและคราบสกปรกต่างๆ โดยมีฟิล์มเคลือบป้องกันไม่ให้ความชื้นซึมเข้าสู่รองเท้า และยังช่วยระบายอากาศได้ดี พร้อมทั้งยับยั้งการเกิดคราบสกปรกบนพื้นผิว รวมถึงป้องกันการก่อตัวของคราบที่ฝังแน่น",
      type: "ADDON",
      ex: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T14:55:07.017Z",
      icon_key: "1662716153013_Add-ons (41).png",
      name_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      name_en: "Protection & Waterproofing ",
      addon_description_en:
        "Our Protection &amp; Waterproofing Add-On keeps your favourite shoes safe from external factors such as rain and dirt.",
      addon_description_2_en:
        "A protective film prevents moisture from penetrating into the shoes while still keeping them breathable and blocks dirt right at the surface to stop any unremovable stains forming. Our shoe cleaning service not only protects your new and favourite shoes but also extends their durability and longevity and is suitable for shoes of all colours and types, from sneakers to leather shoes. We recommend combining Protection &amp; Waterproofing with our Interior Shoe Cleansing and Shoe Perfume Add-Ons to experience the best of our premium shoe cleaning service.",
      addon_description_th:
        "best of our premium shoe cleaning service. ร้านทำความสะอาดรองเท้ามายลอนดรี้มีบริการเคลือบและกันน้ำ ซึ่งช่วยปกป้องรองเท้าคู่โปรดของคุณให้ปลอดภัยจากปัจจัยภายนอก ทั้งฝนและคราบสกปรกต่างๆ โดยมีฟิล์มเคลือบป้องกันไม่ให้ความชื้นซึมเข้าสู่รองเท้า และยังช่วยระบายอากาศได้ดี พร้อมทั้งยับยั้งการเกิดคราบสกปรกบนพื้นผิว รวมถึงป้องกันการก่อตัวของคราบที่ฝังแน่น",
      addon_description_2_th:
        "บริการนี้ไม่เพียงแต่ปกป้องรองเท้าคู่ใหม่สุดโปรดของคุณเท่านั้น แต่ยังช่วยยืดอายุการใช้งานให้นานและเหมาะสำหรับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ร้านทำความสะอาดรองเท้า มายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำร่วมกับบริการทำความสะอาดรองเท้า ด้านในและน้ำหอมสำหรับรองเท้า เพื่อบริการสปารองเท้าระดับพรีเมียมที่ดีที่สุด",
      description_en: "Keep your shoes safe and sound",
      description_th: "ปกป้องรองเท้าของคุณให้ปลอดภัย",
      ex_en: "Protection & Waterproofing ",
      ex_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      addon_description_2:
        "บริการนี้ไม่เพียงแต่ปกป้องรองเท้าคู่ใหม่สุดโปรดของคุณเท่านั้น แต่ยังช่วยยืดอายุการใช้งานให้นานและเหมาะสำหรับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ร้านทำความสะอาดรองเท้า มายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำร่วมกับบริการทำความสะอาดรองเท้า ด้านในและน้ำหอมสำหรับรองเท้า เพื่อบริการสปารองเท้าระดับพรีเมียมที่ดีที่สุด",
    },
    {
      _id: "631428327a1baccc80de71e3",
      language: "EN",
      name: "สำหรับรองเท้า 1 คู่",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662716358264_Add-ons (45).png",
      image_key_mobile: "1662716358638_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Shoes S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:13:53.954Z",
      size: "S",
      price: 395,
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 1 Pair of shoes",
      name_th: "สำหรับรองเท้า 1 คู่",
      addon_description_2:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
    },
    {
      _id: "631428327a1baccd80de71e4",
      language: "EN",
      name: "สำหรับรองเท้า 2 คู่",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662716639481_Add-ons (45).png",
      image_key_mobile: "1662716639823_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Shoes S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:14:06.960Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 2 Pair of shoes",
      name_th: "สำหรับรองเท้า 2 คู่",
      addon_description_2:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
    },
    {
      _id: "631462cf7a1baccc80ef7207",
      language: "EN",
      name: "สำหรับรองเท้า 3 คู่",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662716709914_Add-ons (45).png",
      image_key_mobile: "1662716710303_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      type: "PACKAGE",
      price: 995,
      ex: "แพ็กเกจ My Shoes S, M และ L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:14:19.358Z",
      size: "L",
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 3 Pair of shoes",
      name_th: "สำหรับรองเท้า 3 คู่",
      addon_description_2:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
    },
    {
      _id: "631ac4517cbbbb34e17f8b19",
      language: "EN",
      name: "น้ำยารีดผ้าเรียบ",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ให้ผ้าเรียบเนียนที่สุด",
      image_key_desktop: "1662953321455_Add-ons (12).png",
      image_key_mobile: "1662953321745_Add-ons (12).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      type: "ADDON",
      ex: "น้ำยารีดผ้าเรียบ",
      icon_key: "1662699611185_Add-ons (11).png",
      createdAt: "2022-09-09T04:42:57.735Z",
      updatedAt: "2022-11-16T09:32:13.437Z",
      addon_description_2_en:
        "We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free\nfragrance, and pure ironing perfection as part of our premium laundry service. Smooth Starch\nwill give your laundry the ultimate neat and crisp appearance it deserves. You can only select\n\nthe Smooth Starch Add-On if you have already selected the Iron Add-On.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\n\nซึ่งจะช่วยให้ผ้าของคุณสะอาดเรียบร้อยและสดชื่นมีชีวิตชีวามากที่สุด โปรดเลือกเพิ่มเติม น้ำยารีดผ้าเรียบ\n\nหลังจากเลือก รีดผ้า แล้วเท่านั้น",
      addon_description_en:
        "As an Add-On to our professional laundry service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\n\nซึ่งจะช่วยให้ผ้าของคุณสะอาดเรียบร้อยและสดชื่นมีชีวิตชีวามากที่สุด โปรดเลือกเพิ่มเติม น้ำยารีดผ้าเรียบ\n\nหลังจากเลือก รีดผ้า แล้วเท่านั้น",
    },
    {
      _id: "631ac7117cbbbb34e17f8bb4",
      language: "EN",
      name: "อบแห้งด้วยอุณหภูมิต่ำ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "อบผ้าแห้งโดยใช้อุณหภูมิต่ำ",
      image_key_desktop: "1668591084915_Add-ons (18).png",
      image_key_mobile: "1668591085221_Add-ons (18).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ในฐานะที่ร้านซักอบรีดมายลอนดรี้เป็นมืออาชีพ\n\nเสื้อผ้าทั้งหมดของคุณจะแห้งด้วยอุณหภูมิที่เหมาะสมตามมาตรฐานของเรา",
      type: "ADDON",
      ex: "อบแห้งด้วยอุณหภูมิต่ำ",
      icon_key: "1668591085350_Add-ons (17).png",
      createdAt: "2022-09-09T04:54:41.784Z",
      updatedAt: "2022-11-16T12:51:11.973Z",
      addon_description_2_en:
        "With our special Low Heat Dry Add-On, your laundry will be dried at\na low temperature over a longer period. Use the Special Request box before placing your\nlaundry service order if you want us to dry your laundry at a specific temperature, such as 30°C\n\nor 40°C.",
      addon_description_2_th:
        "เมื่อคุณเลือกเพิ่มเติม\nอบแห้งด้วยอุณหภูมิต่ำ เราจะอบเสื้อผ้าของคุณด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ\nหากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่นเช่น 30 หรือ 40 องศาเซลเซียส\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As standard when you use our professional laundry service, we dry your laundry at an\nappropriate temperature.",
      addon_description_th:
        "ในฐานะที่ร้านซักอบรีดมายลอนดรี้เป็นมืออาชีพ\n\nเสื้อผ้าทั้งหมดของคุณจะแห้งด้วยอุณหภูมิที่เหมาะสมตามมาตรฐานของเรา",
      description_en: "Drying at a low temperature",
      description_th: "อบผ้าแห้งโดยใช้อุณหภูมิต่ำ",
      ex_en: "Low Heat Dry",
      ex_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      name_en: "Low Heat Dry",
      name_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      addon_description_2:
        "เมื่อคุณเลือกเพิ่มเติม\nอบแห้งด้วยอุณหภูมิต่ำ เราจะอบเสื้อผ้าของคุณด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ\nหากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่นเช่น 30 หรือ 40 องศาเซลเซียส\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631adaa316368678b8ed8e59",
      language: "EN",
      name: "น้ำหอมสำหรับซักผ้า",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ให้ความสดชื่นสุดพิเศษ",
      image_key_desktop: "1662704288283_Add-ons (4).png",
      image_key_mobile: "1662704288867_Add-ons (4).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำหอมสำหรับซักผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการซักไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      type: "ADDON",
      ex: "น้ำหอมสำหรับซักผ้า",
      icon_key: "1662704289024_Add-ons (5).png",
      createdAt: "2022-09-09T06:18:11.475Z",
      updatedAt: "2022-11-16T09:33:44.927Z",
      addon_description_2_en:
        "You will smell the Laundry Perfume not only directly after\nwashing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Laundry Perfume does not contain fabric softeners.\nHowever, if you have known allergies you should consider whether this Add-On is suitable for\nyou. Our tip: choose Laundry Perfume every time you use our professional laundry service for\n\nthe best long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับซักผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับซักผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Laundry Perfume is suitable for all\ntypes of fabrics (incl. microfiber and functional wear) and comes with a long-lasting and\nfresh flowery fragrance day after day.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำหอมสำหรับซักผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการซักไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Laundry Perfume",
      ex_th: "น้ำหอมสำหรับซักผ้า",
      name_en: "Laundry Perfume",
      name_th: "น้ำหอมสำหรับซักผ้า",
      addon_description_2:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับซักผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับซักผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
    },
    {
      _id: "631adb1416368678b8ed8e5e",
      language: "EN",
      name: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "คืนประกายขาวสดใส",
      image_key_desktop: "1668591998344_white_shirt.png",
      image_key_mobile: "1668591998663_white_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nซึ่งได้รับการดีไซน์เป็นพิเศษเพื่อขจัดคราบสีเทาและสีเหลืองออกจากผ้าขาว\nทำให้กลับมาขาวสว่างสดใสดังเดิมมากที่สุด นอกจากนี้ตัวเลือก ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nยังใช้ได้กับเสื้อผ้าทั่วไป (รวมถึงผ้าขาวที่มีสีอื่นอยู่ด้วย) เพื่อให้กลับมาขาวเปล่งประกายได้อีกครั้ง\nเมื่อคุณเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง เราจะดูแลผ้าขาวของคุณแยกจากผ้าอื่นๆ",
      type: "ADDON",
      ex: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      icon_key: "1668591998771_Default.png",
      createdAt: "2022-09-09T06:20:04.856Z",
      updatedAt: "2022-11-16T09:49:29.916Z",
      addon_description_2_en:
        "Make Whites White Again can be applied with any type of practical clothes (as well\nas white clothes with colour elements) to make them shine brilliant white again. When you\nchoose our Make White White Again Add-On, we separate all the suitable white fabrics\nincluded in your laundry and treat them separately. Of course, all your other chosen Add-Ons\nstill apply as well. If you want us to focus on some of your whites only or in particular, please tell\n\nus in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะผ้าสีขาวบางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A value-added option of our premium laundry service is the Make Whites White Again Add-\nOn which was especially designed to remove the effects of greying and yellowing from white\nfabrics to give them back their original uniform and bright whiteness to the highest extent\npossible.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nซึ่งได้รับการดีไซน์เป็นพิเศษเพื่อขจัดคราบสีเทาและสีเหลืองออกจากผ้าขาว\nทำให้กลับมาขาวสว่างสดใสดังเดิมมากที่สุด นอกจากนี้ตัวเลือก ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nยังใช้ได้กับเสื้อผ้าทั่วไป (รวมถึงผ้าขาวที่มีสีอื่นอยู่ด้วย) เพื่อให้กลับมาขาวเปล่งประกายได้อีกครั้ง\nเมื่อคุณเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง เราจะดูแลผ้าขาวของคุณแยกจากผ้าอื่นๆ",
      description_en: "Revive the shining white colour",
      description_th: "คืนประกายขาวสดใส",
      ex_en: "Make Whites White Again",
      ex_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      name_en: "Make Whites White Again",
      name_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      addon_description_2:
        "ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะผ้าสีขาวบางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631adb9016368678b8ed8e62",
      language: "EN",
      name: "ผลิตภัณฑ์ซักผ้าออร์แกนิค",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ตัวเลือกดีที่สุดสำหรับทุกคน",
      image_key_desktop: "1662704526308_Add-ons (16).png",
      image_key_mobile: "1662704526640_Add-ons (16).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิค\n\nซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ\nนอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย\nและยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ",
      type: "ADDON",
      ex: "t",
      icon_key: "1662704526746_Add-ons (6).png",
      createdAt: "2022-09-09T06:22:08.116Z",
      updatedAt: "2022-11-16T07:51:49.741Z",
      addon_description_2_en:
        "select the free of charge No Softener Add-On. Organic products are especially gentle to the\nenvironment and therefore strongly recommended. PS: We use a variety of locally and\ninternationally sourced Organic Wash products in our premium laundry service. Use the\nSpecial Request box before placing your laundry service order to tell us your preferences and\n\nwe will fulfil your request whenever possible.",
      addon_description_2_th:
        "กรุณาเลือกเพิ่มเติม ไม่ใช้น้ำยาปรับผ้านุ่ม ผลิตภัณฑ์ออร์แกนิคเป็นมิตรกับสิ่งแวดล้อม\nจึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้ เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service our Organic Wash comes with no dyes,\nfragrances or preservatives. Our organic detergents and softeners contain only plant-based,\nnaturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents\nand softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do\nnot wish us to use softener in your Organic Wash as part of our quality laundry service, please",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิค\n\nซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ\nนอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย\nและยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ",
      description_en: "The best organic laundry choice",
      description_th: "ตัวเลือกดีที่สุดสำหรับทุกคน",
      ex_en: "e",
      ex_th: "t",
      name_en: "Organic Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าออร์แกนิค",
      addon_description_2:
        "กรุณาเลือกเพิ่มเติม ไม่ใช้น้ำยาปรับผ้านุ่ม ผลิตภัณฑ์ออร์แกนิคเป็นมิตรกับสิ่งแวดล้อม\nจึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้ เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631adbfc16368678b8ed8e66",
      language: "EN",
      name: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "คืนสภาพสีดำอย่างแท้จริง",
      image_key_desktop: "1668592348437_black_shirt.png",
      image_key_mobile: "1668592348780_black_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าดำกลับมาสีดำอีกครั้ง\nซึ่งจะช่วยฟื้นคืนสภาพเฉดสีดำให้กลับมาเข้มดังเดิมและปกป้องผ้าสีดำให้ดูดีเหมือนใหม่\n\nช่วยให้สีที่ตกและซีดจางกลับมามีสีดำเข้มอีกครั้ง",
      type: "ADDON",
      ex: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      icon_key: "1668592348904_Default 2.png",
      createdAt: "2022-09-09T06:23:56.397Z",
      updatedAt: "2022-11-16T09:52:29.518Z",
      addon_description_2_en:
        "Washed-out and faded black clothes will be revived and their colour\nrestored. We recommend repeating the application of our Make Blacks Black Again Add-On\nevery time you notice that your clothes are beginning to fade. When you choose our Make\nBlacks Black Again Add-On, we separate all the suitable black clothes included in your laundry\nand treat them separately. Of course, all your other chosen Add-Ons still apply as well. If you\nwant us to focus on some of your black items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "เราขอแนะนำให้ใช้ตัวเลือกนี้ซ้ำทุกครั้งที่คุณสังเกตเห็นว่าเสื้อผ้าเริ่มมีสีจางลง เมื่อคุณเลือกเพิ่มเติม\nให้ผ้าดำกลับมาสีดำอีกครั้ง เราจะดูแลผ้าสีดำของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ\nที่คุณเลือกจะถูกนำไปใช้ด้วย หากคุณต้องการให้เราเน้นเฉพาะผ้าสีดำบางตัวหรือจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้า\n\nมายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Blacks Black Again Add-On which\nrevives and protects the deep black shade of all your black clothes to make them look as\ngood as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าดำกลับมาสีดำอีกครั้ง\nซึ่งจะช่วยฟื้นคืนสภาพเฉดสีดำให้กลับมาเข้มดังเดิมและปกป้องผ้าสีดำให้ดูดีเหมือนใหม่\n\nช่วยให้สีที่ตกและซีดจางกลับมามีสีดำเข้มอีกครั้ง",
      description_en: "Revive the true black colour",
      description_th: "คืนสภาพสีดำอย่างแท้จริง",
      ex_en: "Make Blacks Black Again",
      ex_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      name_en: "Make Blacks Black Again",
      name_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      addon_description_2:
        "เราขอแนะนำให้ใช้ตัวเลือกนี้ซ้ำทุกครั้งที่คุณสังเกตเห็นว่าเสื้อผ้าเริ่มมีสีจางลง เมื่อคุณเลือกเพิ่มเติม\nให้ผ้าดำกลับมาสีดำอีกครั้ง เราจะดูแลผ้าสีดำของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ\nที่คุณเลือกจะถูกนำไปใช้ด้วย หากคุณต้องการให้เราเน้นเฉพาะผ้าสีดำบางตัวหรือจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้า\n\nมายลอนดรี้",
    },
    {
      _id: "631adc6816368678b8ed8e6a",
      language: "EN",
      name: "ผลิตภัณฑ์ซักผ้าสำหรับเด็ก",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "เหมาะสำหรับผิวบอบบางของเด็กทารก",
      image_key_desktop: "1662704743693_Add-ons (20).png",
      image_key_mobile: "1662704744064_Add-ons (20).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ซักผ้าสำหรับเด็ก\n\nซึ่งได้รับการออกแบบเป็นพิเศษเพื่อผิวบอบบางและผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า\nป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้",
      type: "ADDON",
      ex: "t",
      icon_key: "1662704744202_Add-ons (19).png",
      createdAt: "2022-09-09T06:25:44.737Z",
      updatedAt: "2022-11-16T07:52:28.602Z",
      addon_description_2_en:
        "Baby Wash detergents and softeners we use in our quality laundry service are hypoallergenic\nand free of dyes but still strong in removing all the stains your baby loves to make. If you wish\nus to use only detergent and no softener in your Baby Wash, please select the free of charge\nNo Softener Add-On. Good to know: We use a variety of locally and internationally sourced\nBaby Wash products in our premium laundry service. Use the Special Request box before\nplacing your laundry service order to tell us your preferences and we will fulfil your request\n\nwhenever possible.",
      addon_description_2_th:
        "หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าสำหรับเด็กของคุณ กรุณาเลือกเพิ่มเติม\nไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ เรามีผลิตภัณฑ์ซักผ้าสำหรับเด็กทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Baby Wash is specially designed for\nsensitive skin requirements and dermatologically tested to prevent allergic reactions.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ซักผ้าสำหรับเด็ก\n\nซึ่งได้รับการออกแบบเป็นพิเศษเพื่อผิวบอบบางและผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า\nป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้",
      description_en: "Ideal for sensitive baby skin",
      description_th: "เหมาะสำหรับผิวบอบบางของเด็กทารก",
      ex_en: "e",
      ex_th: "t",
      name_en: "Baby Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าสำหรับเด็ก",
      addon_description_2:
        "หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าสำหรับเด็กของคุณ กรุณาเลือกเพิ่มเติม\nไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ เรามีผลิตภัณฑ์ซักผ้าสำหรับเด็กทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631adccc16368678b8ed8e6e",
      language: "EN",
      name: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "สำหรับผ้าเดนิมสีน้ำเงินแท้",
      image_key_desktop: "1668592518986_jean.png",
      image_key_mobile: "1668592519291_jean.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nซึ่งจะช่วยฟื้นคืนสภาพสีน้ำเงินกลับมาดังเดิมและรักษาภาพลักษณ์อันคลาสสิกของผ้าเดนิมให้กับยีนส์สีน้ำเงิน\nไม่ว่าจะเป็นกางเกง กระโปรง แจ็คเก็ต หรือเสื้อเชิ้ต เพื่อทำให้กลับมาดูดีเหมือนใหม่อีกครั้ง",
      type: "ADDON",
      ex: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      icon_key: "1668592519406_Default 3.png",
      createdAt: "2022-09-09T06:27:24.518Z",
      updatedAt: "2022-11-16T09:55:19.780Z",
      addon_description_2_en:
        "Washed-\nout and faded colours will be replaced and the typical jeans look will be restored and\nmaintained. We recommend Make Jeans Blue Again solely for classic blue denim items in\norder to give them back their original intensity. When you choose our Make Jeans Blue Again\nAdd-On, we separate all the suitable blue jeans and other denim fabrics included in your\nlaundry and treat them separately. Of course, all your other chosen Add-Ons still apply as well.\nIf you want us to focus on some denim items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "ช่วยให้สีที่ตกและซีดจางกลับมาสีน้ำเงินเข้มอีกครั้ง อีกทั้งฟื้นฟูสภาพและคงเอกลักษณ์ของยีนส์ไว้\nเราขอแนะนำตัวเลือก ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง ใช้กับผ้าเดนิมสีน้ำเงินคลาสสิกเท่านั้น\nเพื่อให้สีของผ้ากลับมาเข้มดั่งเดิม เมื่อคุณเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nเราจะดูแลยีนส์สีน้ำเงินและผ้าเดนิมของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะยีนส์บางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Jeans Blue Again Add-On which\nrevives the original blue colour and protects the classic denim look of all your blue denim\njeans, trousers, skirts, jackets and shirts, to make them look as good as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nซึ่งจะช่วยฟื้นคืนสภาพสีน้ำเงินกลับมาดังเดิมและรักษาภาพลักษณ์อันคลาสสิกของผ้าเดนิมให้กับยีนส์สีน้ำเงิน\nไม่ว่าจะเป็นกางเกง กระโปรง แจ็คเก็ต หรือเสื้อเชิ้ต เพื่อทำให้กลับมาดูดีเหมือนใหม่อีกครั้ง",
      description_en: "For genuine blue denim",
      description_th: "สำหรับผ้าเดนิมสีน้ำเงินแท้",
      ex_en: "Make Jeans Blue Again",
      ex_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      name_en: "Make Jeans Blue Again",
      name_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      addon_description_2:
        "ช่วยให้สีที่ตกและซีดจางกลับมาสีน้ำเงินเข้มอีกครั้ง อีกทั้งฟื้นฟูสภาพและคงเอกลักษณ์ของยีนส์ไว้\nเราขอแนะนำตัวเลือก ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง ใช้กับผ้าเดนิมสีน้ำเงินคลาสสิกเท่านั้น\nเพื่อให้สีของผ้ากลับมาเข้มดั่งเดิม เมื่อคุณเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nเราจะดูแลยีนส์สีน้ำเงินและผ้าเดนิมของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะยีนส์บางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631add2516368678b8ed8e72",
      language: "EN",
      name: "ขจัดคราบ",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ขจัดคราบต่างๆอย่างละเอียด",
      image_key_desktop: "1662704932262_Add-ons (24).png",
      image_key_mobile: "1662704932575_Add-ons (24).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้จะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด เราสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต\nมายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา\nคราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้",
      type: "ADDON",
      ex: "t",
      icon_key: "1662704932707_Add-ons (23).png",
      createdAt: "2022-09-09T06:28:53.237Z",
      updatedAt: "2022-11-16T12:52:35.070Z",
      addon_description_2_en:
        "water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle\nwax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on\nsome items of your laundry in particular, you can tell us in the Special Request box before\n\nplacing your laundry service order.",
      addon_description_2_th:
        "เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์\n\nหมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล\nหากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "When you select the Stain Removal Add-On, our professional laundry service team screens\nevery item of your laundry from head to toe and makes every effort to remove any stains we\nfind. We can remove many kinds of stains, such as oil, sauces, ketchup, chocolate,\nmayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk,\nyogurt, cream, mould, blood, pus, ballpoint pens, ink, felt tip pens, highlighters, coloured pencils,",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้จะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด เราสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต\nมายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา\nคราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้",
      description_en: "Removing stains from A to Z",
      description_th: "ขจัดคราบต่างๆอย่างละเอียด",
      ex_en: "e",
      ex_th: "t",
      name_en: "Stain Removal",
      name_th: "ขจัดคราบ",
      addon_description_2:
        "เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์\n\nหมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล\nหากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631add7b16368678b8ed8e76",
      language: "EN",
      name: "แขวน",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "เราแขวนด้วยไม้แขวนของคุณ",
      image_key_desktop: "1668592982195_Add-ons (22).png",
      image_key_mobile: "1668592982478_Add-ons (22).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า\nหากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      type: "ADDON",
      ex: "แขวน",
      icon_key: "1668592982585_Add-ons (21).png",
      createdAt: "2022-09-09T06:30:19.518Z",
      updatedAt: "2022-11-16T10:03:02.861Z",
      addon_description_2_en:
        "Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your laundry. If there are any specific items in your laundry\nwhich you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your laundry service order.",
      addon_description_2_th: "",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we can hang up all hangable\nclothes on YOUR hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า\nหากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2: "",
    },
    {
      _id: "631aecbfad41fef36839ec6d",
      language: "EN",
      name: "หมอน",
      status: false,
      description: "สำหรับหมอน 2 ใบ",
      image_key_desktop: "1662708926562_Add-ons (30).png",
      image_key_mobile: "1662708926877_Add-ons (30).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักผ้ามายลอนดรี้ยินดีที่จะดูแลหมอนของคุณด้วย\nโดยเราสามารถรับหมอนได้สูงสุด 2 ใบ ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      type: "EXTRA",
      price: 100,
      ex: "หมอน",
      icon_key: "1662708927048_Add-ons (29).png",
      createdAt: "2022-09-09T07:35:27.424Z",
      updatedAt: "2022-11-16T14:41:33.446Z",
      addon_description_2:
        "ทั้งนี้บริการซักหมอนของเรารวมการซักและอบแห้งเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ\nทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับหมอนโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_2_en:
        "Please be informed that we can pick up a maximum of 2\npillows in addition to your regular laundry for each order. Our pillow service includes washing\nand drying as default. All other Add-Ons chosen for your laundry will apply for the pillows\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_th:
        "ทั้งนี้บริการซักหมอนของเรารวมการซักและอบแห้งเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ\nทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับหมอนโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your pillows as well as part of\nour professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักผ้ามายลอนดรี้ยินดีที่จะดูแลหมอนของคุณด้วย\nโดยเราสามารถรับหมอนได้สูงสุด 2 ใบ ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 2 pillows",
      description_th: "สำหรับหมอน 2 ใบ",
      ex_en: "Pillows",
      ex_th: "หมอน",
      name_en: "Pillows",
      name_th: "หมอน",
    },
    {
      _id: "631aed49fb27f882880c3093",
      language: "EN",
      name: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      status: false,
      description: "สำหรับ 1 ผืน",
      image_key_desktop: "1662709064359_Add-ons (32).png",
      image_key_mobile: "1662709064672_Add-ons (32).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "นอกจากการซักผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง\nทั้งนี้บริการผ้าปูที่นอนหรือปลอกผ้านวมของเรารวมการซักและรีดเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ",
      type: "EXTRA",
      price: 150,
      ex: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      icon_key: "1662709064774_Add-ons (31).png",
      createdAt: "2022-09-09T07:37:45.144Z",
      updatedAt: "2022-11-16T14:42:13.787Z",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular laundry for each order.\nOur bed sheet or duvet cover service includes washing AND ironing as default. All other Add-\nOns chosen for your laundry will apply for the bed sheet or duvet cover automatically, unless\nyou advise us differently in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง\nทั้งนี้บริการผ้าปูที่นอนหรือปลอกผ้านวมของเรารวมการซักและรีดเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Bed Sheet or Duvet Cover",
      ex_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      name_en: "Bed Sheet or Duvet Cover",
      name_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      addon_description_2:
        "ทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631b005d08f6c6a6bd127b01",
      language: "EN",
      name: "แขวน",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "เราแขวนด้วยไม้แขวนของคุณ",
      image_key_desktop: "1662713948630_Add-ons (22).png",
      image_key_mobile: "1662713948971_Add-ons (22).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า",
      type: "ADDON",
      ex: "แขวน",
      icon_key: "1662713949093_Add-ons (21).png",
      createdAt: "2022-09-09T08:59:09.812Z",
      updatedAt: "2022-11-16T15:17:25.996Z",
      addon_description_2_en:
        "which you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we can hang up all hangable\nclothes on YOUR hangers. Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your order. If there are any specific items in your order",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631b00a1d51e9672eb237938",
      language: "EN",
      name: "น้ำหอมสำหรับรีดผ้า",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "ให้ความสดชื่นสุดพิเศษ",
      image_key_desktop: "1662714017029_Add-ons (4).png",
      image_key_mobile: "1662714017427_Add-ons (4).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำหอมสำหรับรีดผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการรีดไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      type: "ADDON",
      ex: "น้ำหอมสำหรับรีดผ้า",
      icon_key: "1662714017569_Add-ons (5).png",
      createdAt: "2022-09-09T09:00:17.934Z",
      updatedAt: "2022-11-16T15:17:54.435Z",
      addon_description_2_en:
        "You will smell the Ironing Perfume not only directly after\nironing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Ironing Perfume does not contain fabric softeners.\nHowever, if you have known allergies, you should consider whether this Add-On is suitable for\nyou. Our tip: choose Ironing Perfume every time you use our professional ironing service for the\n\nbest long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับรีดผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับรีดผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, our Ironing Perfume is suitable for all types\nof fabrics (incl. microfiber and functional wear) and comes with a long-lasting and fresh\nflowery fragrance day after day.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำหอมสำหรับรีดผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการรีดไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Ironing Perfume",
      ex_th: "น้ำหอมสำหรับรีดผ้า",
      name_en: "Ironing Perfume",
      name_th: "น้ำหอมสำหรับรีดผ้า",
      addon_description_2:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับรีดผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับรีดผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
    },
    {
      _id: "631b00f0d51e9672eb23794b",
      language: "EN",
      name: "แขวนพิเศษ",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "เราแขวนด้วยไม้แขวนของเรา",
      image_key_desktop: "1662714096131_Add-ons (26).png",
      image_key_mobile: "1662714096477_Add-ons (26).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      type: "ADDON",
      ex: "แขวนพิเศษ",
      icon_key: "1662714096607_Add-ons (25).png",
      createdAt: "2022-09-09T09:01:36.978Z",
      updatedAt: "2022-11-16T15:18:34.118Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your order which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631b0159d51e9672eb23797c",
      language: "EN",
      name: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "เพื่อการรีดผ้าที่ถูกสุขอนามัย",
      image_key_desktop: "1662714200531_Add-ons (13).png",
      image_key_mobile: "1662714200900_Add-ons (13).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย\n\nซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส รวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย\n\nช่วยเพิ่มระดับของการรีดผ้าให้ถูกสุขอนามัยยิ่งขึ้น",
      type: "ADDON",
      ex: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      icon_key: "1662714201026_Add-ons (8).png",
      createdAt: "2022-09-09T09:03:21.398Z",
      updatedAt: "2022-11-16T15:19:19.256Z",
      addon_description_2_en:
        "extra layer of support for an even more hygienically-clean ironing service, our Antibacterial\nSanitiser is free of bleach and can be used with all types of fabrics including children’s clothes.\n\nWe recommend Antibacterial Sanitiser for every ironing service.",
      addon_description_2_th:
        "นอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\n\nรวมทั้งเสื้อผ้าเด็กด้วย\n\nเราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียทุกครั้งที่คุณใช้บริการรีดผ้าของเรา",
      addon_description_en:
        "As part of our professional ironing service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย\n\nซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส รวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย\n\nช่วยเพิ่มระดับของการรีดผ้าให้ถูกสุขอนามัยยิ่งขึ้น",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการรีดผ้าที่ถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "นอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\n\nรวมทั้งเสื้อผ้าเด็กด้วย\n\nเราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียทุกครั้งที่คุณใช้บริการรีดผ้าของเรา",
    },
    {
      _id: "631b01dcd51e9672eb2379af",
      language: "EN",
      name: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      status: false,
      description: "สำหรับ 1 ผืน",
      image_key_desktop: "1662714331435_Add-ons (32).png",
      image_key_mobile: "1662714331763_Add-ons (32).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "นอกจากการรีดผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      type: "EXTRA",
      price: 150,
      ex: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      icon_key: "1662714331974_Add-ons (31).png",
      createdAt: "2022-09-09T09:05:32.438Z",
      updatedAt: "2022-11-16T15:21:01.478Z",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the bed sheet or duvet cover automatically,\nunless you advise us differently in the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ\n\nทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular ironing, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional ironing service.",
      addon_description_th:
        "นอกจากการรีดผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Duvet Cover or Bed Sheet ",
      ex_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      name_en: "Duvet Cover or Bed Sheet ",
      name_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      addon_description_2:
        "ส่วนเพิ่มเติมอื่นๆ\n\nทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631b094c8d95618757de7d7f",
      language: "EN",
      name: "ทำความสะอาดรองเท้าด้านใน",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "คืนสุขอนามัยอย่างล้ำลึกถึงพื้นรองเท้า",
      image_key_desktop: "1662716235912_Add-ons (43).png",
      image_key_mobile: "1662716236277_Add-ons (43).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "ร้านทำความสะอาดรองเท้ามายลอนดรี้ให้คุณแน่ใจว่ารองเท้าของคุณจะดูดีเหมือนใหม่อีกครั้ง นี่เป็นมาตรฐานบริการของเรา หากคุณต้องการให้รองเท้าดูดีจากภายนอก และมีสุขอนามัยที่ดีจากภายในด้วย เราขอแนะนำให้คุณเลือกบริการทำความสะอาดรองเท้าด้านใน",
      type: "ADDON",
      ex: "ทำความสะอาดรองเท้าด้านใน",
      icon_key: "1662716236437_Add-ons (44).png",
      createdAt: "2022-09-09T09:37:17.020Z",
      updatedAt: "2022-11-16T14:56:48.536Z",
      name_th: "ทำความสะอาดรองเท้าด้านใน",
      name_en: "Deodorant & Disinfection ",
      addon_description_en:
        "With our premium shoe cleaning service, we ensure your shoes look as good as new again – this is our professional shoe cleaning service standard. If you not only want your shoes to look neat on the outside but also care about their inner hygiene, we recommend choosing our Interior Shoe Cleansing Add-On,",
      addon_description_2_en:
        "where we will particularly focus on cleaning and disinfecting the often forgotten interior of your shoes, including the insoles as well. Combining Interior Shoe Cleaning with our other Protection &amp; Waterproofing and Shoe Perfume Add-Ons will give your most treasured shoes the ultimate spa experience they deserve. Our professional shoe cleaning service is available for shoes of all colours and types, from sneakers to leather shoes, while we specialise in white shoes and white sneakers made from leather or other modern fabrics.",
      addon_description_th:
        "ร้านทำความสะอาดรองเท้ามายลอนดรี้ให้คุณแน่ใจว่ารองเท้าของคุณจะดูดีเหมือนใหม่อีกครั้ง นี่เป็นมาตรฐานบริการของเรา หากคุณต้องการให้รองเท้าดูดีจากภายนอก และมีสุขอนามัยที่ดีจากภายในด้วย เราขอแนะนำให้คุณเลือกบริการทำความสะอาดรองเท้าด้านใน",
      addon_description_2_th:
        "ซึ่งจะเน้นการทำความสะอาดและฆ่าเชื้อโรครองเท้าด้านในที่มักถูกมองข้าม รวมถึงพื้นรองเท้าด้วย ร้านทำความสะอาดรองเท้ามายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมทำความสะอาดรองเท้าด้านในร่วมกับ ผลิตภัณฑ์เคลือบและกันน้ำและน้ำหอมสำหรับรองเท้า เพื่อสัมผัสประสบการณ์สปารองเท้าขั้นสูงสุด เรายินดีให้บริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง และยังเชี่ยวชาญในการทำความสะอาดรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัยด้วย",
      description_en: "Makes your shoes smell like new",
      description_th: "คืนสุขอนามัยอย่างล้ำลึกถึงพื้นรองเท้า",
      ex_en: "Deodorant & Disinfection ",
      ex_th: "ทำความสะอาดรองเท้าด้านใน",
      addon_description_2:
        "ซึ่งจะเน้นการทำความสะอาดและฆ่าเชื้อโรครองเท้าด้านในที่มักถูกมองข้าม รวมถึงพื้นรองเท้าด้วย ร้านทำความสะอาดรองเท้ามายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมทำความสะอาดรองเท้าด้านในร่วมกับ ผลิตภัณฑ์เคลือบและกันน้ำและน้ำหอมสำหรับรองเท้า เพื่อสัมผัสประสบการณ์สปารองเท้าขั้นสูงสุด เรายินดีให้บริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง และยังเชี่ยวชาญในการทำความสะอาดรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัยด้วย",
    },
    {
      _id: "63720392a142589973ec1e9a",
      language: "EN",
      name: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "เราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆ",
      image_key_desktop: "1668587084343_Add-ons (10).png",
      image_key_mobile: "1668587084846_Add-ons (10).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ให้คุณมั่นใจว่าเราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆในการซักผ้าของคุณ ชัดเจน ง่าย และฟรี",
      type: "ADDON",
      ex: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      icon_key: "1668587084964_Add-ons (9).png",
      createdAt: "2022-11-14T09:00:02.224Z",
      updatedAt: "2022-11-16T12:54:02.992Z",
      addon_description_2_en: "",
      addon_description_2_th: "",
      addon_description_en:
        "You can rely on us not to use any softener with your laundry – clear, easy and free of charge.",
      addon_description_th:
        "ให้คุณมั่นใจว่าเราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆในการซักผ้าของคุณ ชัดเจน ง่าย และฟรี",
      description_en: "We will not use Softener at all",
      description_th: "เราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆ",
      ex_en: "No Softener ",
      ex_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      name_en: "No Softener ",
      name_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      addon_description_2: "",
    },
    {
      _id: "637203f8a142589973ec1ea0",
      language: "EN",
      name: "แขวนพิเศษ",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "เราแขวนด้วยไม้แขวนของเรา",
      image_key_desktop: "1668593118092_Add-ons (26).png",
      image_key_mobile: "1668593118353_Add-ons (26).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      type: "ADDON",
      ex: "แขวนพิเศษ",
      icon_key: "1668593118489_Add-ons (25).png",
      createdAt: "2022-11-14T09:01:44.505Z",
      updatedAt: "2022-11-16T10:05:18.764Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your laundry which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your laundry service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "63720417a142589973ec1ea9",
      language: "EN",
      name: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "เพื่อการซักผ้าที่สะอาดถูกสุขอนามัย",
      image_key_desktop: "1670562040139_1668587273739_Add-ons (13).png",
      image_key_mobile: "1668587274101_Add-ons (13).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย ซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส\nรวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย",
      type: "ADDON",
      ex: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      icon_key: "1668587274241_Add-ons (8).png",
      createdAt: "2022-11-14T09:02:15.384Z",
      updatedAt: "2022-12-09T05:00:41.761Z",
      addon_description_2_en:
        "Providing an\nextra layer of support to the detergent for an even more hygienically-clean laundry service, our\nAntibacterial Sanitiser is free of bleach and can be used with all types of fabrics including\nchildren’s clothes. We recommend Antibacterial Sanitiser for every wash, while for particularly\nhigh hygiene demands, it can be combined with our High Temperature Wash Add-On option to\n\ncreate your very own customised laundry service experience.",
      addon_description_2_th:
        "ช่วยเพิ่มประสิทธิภาพของการซักผ้าให้สะอาดถูกสุขอนามัยยิ่งขึ้น\nนอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\nรวมทั้งเสื้อผ้าเด็กด้วย เราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียสำหรับทุกการซักผ้า\nโดยใช้ร่วมกับตัวเลือกเพิ่มเติมการซักด้วยอุณหภูมิสูง เพื่อสุขอนามัยขั้นพิเศษ",
      addon_description_en:
        "As part of our professional laundry service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย ซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส\nรวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการซักผ้าที่สะอาดถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "ช่วยเพิ่มประสิทธิภาพของการซักผ้าให้สะอาดถูกสุขอนามัยยิ่งขึ้น\nนอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\nรวมทั้งเสื้อผ้าเด็กด้วย เราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียสำหรับทุกการซักผ้า\nโดยใช้ร่วมกับตัวเลือกเพิ่มเติมการซักด้วยอุณหภูมิสูง เพื่อสุขอนามัยขั้นพิเศษ",
    },
  ],
  water: [
    {
      _id: "6314264c7a1baccc80de71b5",
      language: "EN",
      name: "ขวด 350 มิลลิลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      image_key_desktop: "1662709691037_Frame 52878 (1).png",
      image_key_mobile: "1662709691409_Frame 52878 (1).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 50,
      ex: "ขวด 350 มิลลิลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-18T07:08:20.308Z",
      icon_key: "1662709691547_Frame 52878.png",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 16 bottles (48 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      ex_en: "350 ml bottle",
      ex_th: "ขวด 350 มิลลิลิตร",
      name_en: "350 ml bottle",
      name_th: "ขวด 350 มิลลิลิตร",
    },
    {
      _id: "6314264c7a1baccc80de71b6",
      language: "EN",
      name: "ขวด 1.5 ลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      image_key_desktop: "1662709539412_Add-ons (36).png",
      image_key_mobile: "1662709539762_Add-ons (36).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 100,
      ex: "ขวด 1.5 ลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:06.225Z",
      icon_key: "1662709539873_Add-ons (35).png",
      addon_description_2_en:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 6 bottles (18 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "1.5 l bottle",
      name_th: "ขวด 1.5 ลิตร",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
    },
    {
      _id: "6314264c7a1baccc80de71c6",
      language: "EN",
      name: "ขวด 600 มิลลิลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      image_key_desktop: "1662709814171_Add-ons (38).png",
      image_key_mobile: "1662709814550_Add-ons (38).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 150,
      ex: "ขวด 1.5 ลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:12.696Z",
      icon_key: "1662709814728_Add-ons (37).png",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 12 bottles (36 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "600 ml bottle",
      name_th: "ขวด 600 มิลลิลิตร",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
    },
  ],
  childrens: [
    {
      _id: "631ac7117cbbbb34e17f8bb4",
      language: "EN",
      name: "อบแห้งด้วยอุณหภูมิต่ำ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "อบผ้าแห้งโดยใช้อุณหภูมิต่ำ",
      image_key_desktop: "1668591084915_Add-ons (18).png",
      image_key_mobile: "1668591085221_Add-ons (18).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ในฐานะที่ร้านซักอบรีดมายลอนดรี้เป็นมืออาชีพ\n\nเสื้อผ้าทั้งหมดของคุณจะแห้งด้วยอุณหภูมิที่เหมาะสมตามมาตรฐานของเรา",
      type: "ADDON",
      ex: "อบแห้งด้วยอุณหภูมิต่ำ",
      icon_key: "1668591085350_Add-ons (17).png",
      createdAt: "2022-09-09T04:54:41.784Z",
      updatedAt: "2022-11-16T12:51:11.973Z",
      addon_description_2_en:
        "With our special Low Heat Dry Add-On, your laundry will be dried at\na low temperature over a longer period. Use the Special Request box before placing your\nlaundry service order if you want us to dry your laundry at a specific temperature, such as 30°C\n\nor 40°C.",
      addon_description_2_th:
        "เมื่อคุณเลือกเพิ่มเติม\nอบแห้งด้วยอุณหภูมิต่ำ เราจะอบเสื้อผ้าของคุณด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ\nหากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่นเช่น 30 หรือ 40 องศาเซลเซียส\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As standard when you use our professional laundry service, we dry your laundry at an\nappropriate temperature.",
      addon_description_th:
        "ในฐานะที่ร้านซักอบรีดมายลอนดรี้เป็นมืออาชีพ\n\nเสื้อผ้าทั้งหมดของคุณจะแห้งด้วยอุณหภูมิที่เหมาะสมตามมาตรฐานของเรา",
      description_en: "Drying at a low temperature",
      description_th: "อบผ้าแห้งโดยใช้อุณหภูมิต่ำ",
      ex_en: "Low Heat Dry",
      ex_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      name_en: "Low Heat Dry",
      name_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      addon_description_2:
        "เมื่อคุณเลือกเพิ่มเติม\nอบแห้งด้วยอุณหภูมิต่ำ เราจะอบเสื้อผ้าของคุณด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ\nหากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่นเช่น 30 หรือ 40 องศาเซลเซียส\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631b0159d51e9672eb23797c",
      language: "EN",
      name: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "เพื่อการรีดผ้าที่ถูกสุขอนามัย",
      image_key_desktop: "1662714200531_Add-ons (13).png",
      image_key_mobile: "1662714200900_Add-ons (13).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย\n\nซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส รวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย\n\nช่วยเพิ่มระดับของการรีดผ้าให้ถูกสุขอนามัยยิ่งขึ้น",
      type: "ADDON",
      ex: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      icon_key: "1662714201026_Add-ons (8).png",
      createdAt: "2022-09-09T09:03:21.398Z",
      updatedAt: "2022-11-16T15:19:19.256Z",
      addon_description_2_en:
        "extra layer of support for an even more hygienically-clean ironing service, our Antibacterial\nSanitiser is free of bleach and can be used with all types of fabrics including children’s clothes.\n\nWe recommend Antibacterial Sanitiser for every ironing service.",
      addon_description_2_th:
        "นอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\n\nรวมทั้งเสื้อผ้าเด็กด้วย\n\nเราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียทุกครั้งที่คุณใช้บริการรีดผ้าของเรา",
      addon_description_en:
        "As part of our professional ironing service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย\n\nซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส รวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย\n\nช่วยเพิ่มระดับของการรีดผ้าให้ถูกสุขอนามัยยิ่งขึ้น",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการรีดผ้าที่ถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "นอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\n\nรวมทั้งเสื้อผ้าเด็กด้วย\n\nเราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียทุกครั้งที่คุณใช้บริการรีดผ้าของเรา",
    },
    {
      _id: "631adc6816368678b8ed8e6a",
      language: "EN",
      name: "ผลิตภัณฑ์ซักผ้าสำหรับเด็ก",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "เหมาะสำหรับผิวบอบบางของเด็กทารก",
      image_key_desktop: "1662704743693_Add-ons (20).png",
      image_key_mobile: "1662704744064_Add-ons (20).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ซักผ้าสำหรับเด็ก\n\nซึ่งได้รับการออกแบบเป็นพิเศษเพื่อผิวบอบบางและผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า\nป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้",
      type: "ADDON",
      ex: "t",
      icon_key: "1662704744202_Add-ons (19).png",
      createdAt: "2022-09-09T06:25:44.737Z",
      updatedAt: "2022-11-16T07:52:28.602Z",
      addon_description_2_en:
        "Baby Wash detergents and softeners we use in our quality laundry service are hypoallergenic\nand free of dyes but still strong in removing all the stains your baby loves to make. If you wish\nus to use only detergent and no softener in your Baby Wash, please select the free of charge\nNo Softener Add-On. Good to know: We use a variety of locally and internationally sourced\nBaby Wash products in our premium laundry service. Use the Special Request box before\nplacing your laundry service order to tell us your preferences and we will fulfil your request\n\nwhenever possible.",
      addon_description_2_th:
        "หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าสำหรับเด็กของคุณ กรุณาเลือกเพิ่มเติม\nไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ เรามีผลิตภัณฑ์ซักผ้าสำหรับเด็กทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Baby Wash is specially designed for\nsensitive skin requirements and dermatologically tested to prevent allergic reactions.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ซักผ้าสำหรับเด็ก\n\nซึ่งได้รับการออกแบบเป็นพิเศษเพื่อผิวบอบบางและผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า\nป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้",
      description_en: "Ideal for sensitive baby skin",
      description_th: "เหมาะสำหรับผิวบอบบางของเด็กทารก",
      ex_en: "e",
      ex_th: "t",
      name_en: "Baby Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าสำหรับเด็ก",
      addon_description_2:
        "หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าสำหรับเด็กของคุณ กรุณาเลือกเพิ่มเติม\nไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ เรามีผลิตภัณฑ์ซักผ้าสำหรับเด็กทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631b094c8d95618757de7d7f",
      language: "EN",
      name: "ทำความสะอาดรองเท้าด้านใน",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "คืนสุขอนามัยอย่างล้ำลึกถึงพื้นรองเท้า",
      image_key_desktop: "1662716235912_Add-ons (43).png",
      image_key_mobile: "1662716236277_Add-ons (43).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "ร้านทำความสะอาดรองเท้ามายลอนดรี้ให้คุณแน่ใจว่ารองเท้าของคุณจะดูดีเหมือนใหม่อีกครั้ง นี่เป็นมาตรฐานบริการของเรา หากคุณต้องการให้รองเท้าดูดีจากภายนอก และมีสุขอนามัยที่ดีจากภายในด้วย เราขอแนะนำให้คุณเลือกบริการทำความสะอาดรองเท้าด้านใน",
      type: "ADDON",
      ex: "ทำความสะอาดรองเท้าด้านใน",
      icon_key: "1662716236437_Add-ons (44).png",
      createdAt: "2022-09-09T09:37:17.020Z",
      updatedAt: "2022-11-16T14:56:48.536Z",
      name_th: "ทำความสะอาดรองเท้าด้านใน",
      name_en: "Deodorant & Disinfection ",
      addon_description_en:
        "With our premium shoe cleaning service, we ensure your shoes look as good as new again – this is our professional shoe cleaning service standard. If you not only want your shoes to look neat on the outside but also care about their inner hygiene, we recommend choosing our Interior Shoe Cleansing Add-On,",
      addon_description_2_en:
        "where we will particularly focus on cleaning and disinfecting the often forgotten interior of your shoes, including the insoles as well. Combining Interior Shoe Cleaning with our other Protection &amp; Waterproofing and Shoe Perfume Add-Ons will give your most treasured shoes the ultimate spa experience they deserve. Our professional shoe cleaning service is available for shoes of all colours and types, from sneakers to leather shoes, while we specialise in white shoes and white sneakers made from leather or other modern fabrics.",
      addon_description_th:
        "ร้านทำความสะอาดรองเท้ามายลอนดรี้ให้คุณแน่ใจว่ารองเท้าของคุณจะดูดีเหมือนใหม่อีกครั้ง นี่เป็นมาตรฐานบริการของเรา หากคุณต้องการให้รองเท้าดูดีจากภายนอก และมีสุขอนามัยที่ดีจากภายในด้วย เราขอแนะนำให้คุณเลือกบริการทำความสะอาดรองเท้าด้านใน",
      addon_description_2_th:
        "ซึ่งจะเน้นการทำความสะอาดและฆ่าเชื้อโรครองเท้าด้านในที่มักถูกมองข้าม รวมถึงพื้นรองเท้าด้วย ร้านทำความสะอาดรองเท้ามายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมทำความสะอาดรองเท้าด้านในร่วมกับ ผลิตภัณฑ์เคลือบและกันน้ำและน้ำหอมสำหรับรองเท้า เพื่อสัมผัสประสบการณ์สปารองเท้าขั้นสูงสุด เรายินดีให้บริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง และยังเชี่ยวชาญในการทำความสะอาดรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัยด้วย",
      description_en: "Makes your shoes smell like new",
      description_th: "คืนสุขอนามัยอย่างล้ำลึกถึงพื้นรองเท้า",
      ex_en: "Deodorant & Disinfection ",
      ex_th: "ทำความสะอาดรองเท้าด้านใน",
      addon_description_2:
        "ซึ่งจะเน้นการทำความสะอาดและฆ่าเชื้อโรครองเท้าด้านในที่มักถูกมองข้าม รวมถึงพื้นรองเท้าด้วย ร้านทำความสะอาดรองเท้ามายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมทำความสะอาดรองเท้าด้านในร่วมกับ ผลิตภัณฑ์เคลือบและกันน้ำและน้ำหอมสำหรับรองเท้า เพื่อสัมผัสประสบการณ์สปารองเท้าขั้นสูงสุด เรายินดีให้บริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง และยังเชี่ยวชาญในการทำความสะอาดรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัยด้วย",
    },
    {
      _id: "631adccc16368678b8ed8e6e",
      language: "EN",
      name: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "สำหรับผ้าเดนิมสีน้ำเงินแท้",
      image_key_desktop: "1668592518986_jean.png",
      image_key_mobile: "1668592519291_jean.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nซึ่งจะช่วยฟื้นคืนสภาพสีน้ำเงินกลับมาดังเดิมและรักษาภาพลักษณ์อันคลาสสิกของผ้าเดนิมให้กับยีนส์สีน้ำเงิน\nไม่ว่าจะเป็นกางเกง กระโปรง แจ็คเก็ต หรือเสื้อเชิ้ต เพื่อทำให้กลับมาดูดีเหมือนใหม่อีกครั้ง",
      type: "ADDON",
      ex: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      icon_key: "1668592519406_Default 3.png",
      createdAt: "2022-09-09T06:27:24.518Z",
      updatedAt: "2022-11-16T09:55:19.780Z",
      addon_description_2_en:
        "Washed-\nout and faded colours will be replaced and the typical jeans look will be restored and\nmaintained. We recommend Make Jeans Blue Again solely for classic blue denim items in\norder to give them back their original intensity. When you choose our Make Jeans Blue Again\nAdd-On, we separate all the suitable blue jeans and other denim fabrics included in your\nlaundry and treat them separately. Of course, all your other chosen Add-Ons still apply as well.\nIf you want us to focus on some denim items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "ช่วยให้สีที่ตกและซีดจางกลับมาสีน้ำเงินเข้มอีกครั้ง อีกทั้งฟื้นฟูสภาพและคงเอกลักษณ์ของยีนส์ไว้\nเราขอแนะนำตัวเลือก ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง ใช้กับผ้าเดนิมสีน้ำเงินคลาสสิกเท่านั้น\nเพื่อให้สีของผ้ากลับมาเข้มดั่งเดิม เมื่อคุณเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nเราจะดูแลยีนส์สีน้ำเงินและผ้าเดนิมของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะยีนส์บางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Jeans Blue Again Add-On which\nrevives the original blue colour and protects the classic denim look of all your blue denim\njeans, trousers, skirts, jackets and shirts, to make them look as good as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nซึ่งจะช่วยฟื้นคืนสภาพสีน้ำเงินกลับมาดังเดิมและรักษาภาพลักษณ์อันคลาสสิกของผ้าเดนิมให้กับยีนส์สีน้ำเงิน\nไม่ว่าจะเป็นกางเกง กระโปรง แจ็คเก็ต หรือเสื้อเชิ้ต เพื่อทำให้กลับมาดูดีเหมือนใหม่อีกครั้ง",
      description_en: "For genuine blue denim",
      description_th: "สำหรับผ้าเดนิมสีน้ำเงินแท้",
      ex_en: "Make Jeans Blue Again",
      ex_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      name_en: "Make Jeans Blue Again",
      name_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      addon_description_2:
        "ช่วยให้สีที่ตกและซีดจางกลับมาสีน้ำเงินเข้มอีกครั้ง อีกทั้งฟื้นฟูสภาพและคงเอกลักษณ์ของยีนส์ไว้\nเราขอแนะนำตัวเลือก ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง ใช้กับผ้าเดนิมสีน้ำเงินคลาสสิกเท่านั้น\nเพื่อให้สีของผ้ากลับมาเข้มดั่งเดิม เมื่อคุณเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nเราจะดูแลยีนส์สีน้ำเงินและผ้าเดนิมของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะยีนส์บางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631b005d08f6c6a6bd127b01",
      language: "EN",
      name: "แขวน",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "เราแขวนด้วยไม้แขวนของคุณ",
      image_key_desktop: "1662713948630_Add-ons (22).png",
      image_key_mobile: "1662713948971_Add-ons (22).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า",
      type: "ADDON",
      ex: "แขวน",
      icon_key: "1662713949093_Add-ons (21).png",
      createdAt: "2022-09-09T08:59:09.812Z",
      updatedAt: "2022-11-16T15:17:25.996Z",
      addon_description_2_en:
        "which you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we can hang up all hangable\nclothes on YOUR hangers. Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your order. If there are any specific items in your order",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631add7b16368678b8ed8e76",
      language: "EN",
      name: "แขวน",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "เราแขวนด้วยไม้แขวนของคุณ",
      image_key_desktop: "1668592982195_Add-ons (22).png",
      image_key_mobile: "1668592982478_Add-ons (22).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า\nหากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      type: "ADDON",
      ex: "แขวน",
      icon_key: "1668592982585_Add-ons (21).png",
      createdAt: "2022-09-09T06:30:19.518Z",
      updatedAt: "2022-11-16T10:03:02.861Z",
      addon_description_2_en:
        "Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your laundry. If there are any specific items in your laundry\nwhich you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your laundry service order.",
      addon_description_2_th: "",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we can hang up all hangable\nclothes on YOUR hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า\nหากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2: "",
    },
    {
      _id: "631b00f0d51e9672eb23794b",
      language: "EN",
      name: "แขวนพิเศษ",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "เราแขวนด้วยไม้แขวนของเรา",
      image_key_desktop: "1662714096131_Add-ons (26).png",
      image_key_mobile: "1662714096477_Add-ons (26).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      type: "ADDON",
      ex: "แขวนพิเศษ",
      icon_key: "1662714096607_Add-ons (25).png",
      createdAt: "2022-09-09T09:01:36.978Z",
      updatedAt: "2022-11-16T15:18:34.118Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your order which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631adb1416368678b8ed8e5e",
      language: "EN",
      name: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "คืนประกายขาวสดใส",
      image_key_desktop: "1668591998344_white_shirt.png",
      image_key_mobile: "1668591998663_white_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nซึ่งได้รับการดีไซน์เป็นพิเศษเพื่อขจัดคราบสีเทาและสีเหลืองออกจากผ้าขาว\nทำให้กลับมาขาวสว่างสดใสดังเดิมมากที่สุด นอกจากนี้ตัวเลือก ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nยังใช้ได้กับเสื้อผ้าทั่วไป (รวมถึงผ้าขาวที่มีสีอื่นอยู่ด้วย) เพื่อให้กลับมาขาวเปล่งประกายได้อีกครั้ง\nเมื่อคุณเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง เราจะดูแลผ้าขาวของคุณแยกจากผ้าอื่นๆ",
      type: "ADDON",
      ex: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      icon_key: "1668591998771_Default.png",
      createdAt: "2022-09-09T06:20:04.856Z",
      updatedAt: "2022-11-16T09:49:29.916Z",
      addon_description_2_en:
        "Make Whites White Again can be applied with any type of practical clothes (as well\nas white clothes with colour elements) to make them shine brilliant white again. When you\nchoose our Make White White Again Add-On, we separate all the suitable white fabrics\nincluded in your laundry and treat them separately. Of course, all your other chosen Add-Ons\nstill apply as well. If you want us to focus on some of your whites only or in particular, please tell\n\nus in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะผ้าสีขาวบางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A value-added option of our premium laundry service is the Make Whites White Again Add-\nOn which was especially designed to remove the effects of greying and yellowing from white\nfabrics to give them back their original uniform and bright whiteness to the highest extent\npossible.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nซึ่งได้รับการดีไซน์เป็นพิเศษเพื่อขจัดคราบสีเทาและสีเหลืองออกจากผ้าขาว\nทำให้กลับมาขาวสว่างสดใสดังเดิมมากที่สุด นอกจากนี้ตัวเลือก ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nยังใช้ได้กับเสื้อผ้าทั่วไป (รวมถึงผ้าขาวที่มีสีอื่นอยู่ด้วย) เพื่อให้กลับมาขาวเปล่งประกายได้อีกครั้ง\nเมื่อคุณเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง เราจะดูแลผ้าขาวของคุณแยกจากผ้าอื่นๆ",
      description_en: "Revive the shining white colour",
      description_th: "คืนประกายขาวสดใส",
      ex_en: "Make Whites White Again",
      ex_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      name_en: "Make Whites White Again",
      name_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      addon_description_2:
        "ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะผ้าสีขาวบางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "63134c67185a14333bd12ea1",
      language: "EN",
      name: "รีดผ้า",
      s: 1,
      m: 100,
      l: 150,
      status: true,
      description: "บริการรีดผ้าเรียบ ไร้รอยยับ",
      image_key_desktop: "1662699151208_Add-ons (7).png",
      image_key_mobile: "1662699151533_Add-ons (7).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้มีบริการรีดผ้าให้คุณ สำหรับผ้าทุกชิ้นที่เหมาะต่อการรีด ทั้งเสื้อเชิ้ต ชุดกระโปรง\n\nกางเกง ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอนให้คุณแน่ใจ\nหากมีรายการใดที่คุณไม่ต้องการให้เรารีด หรือมีสิ่งใดที่เราต้องให้ความสนใจเป็นพิเศษ",
      type: "ADDON",
      ex: "รีดผ้า",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-12-19T04:40:08.766Z",
      icon_key: "1662633765156_44_Property 1=Variant27.png",
      addon_description_2:
        "เราจะไม่ใช้น้ำยารีดผ้าเรียบใดๆ ในการรีดหรือซักผ้า\n\nฐานรองรีดของเราใช้เทคโนโลยีใหม่ล่าสุดเพื่อให้เสื้อผ้าของคุณเรียบสวยไร้รอยยับมากที่สุด\nหากคุณต้องการความเรียบเนียน กลิ่นหอม และความสมบูรณ์แบบในการรีดขั้นสูงสุด โปรดเลือกเพิ่มเติม\n\nน้ำยารีดผ้าเรียบ หลังจากเลือก รีดผ้า แล้ว",
      addon_description_2_en:
        "As our quality laundry service standard, we do not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. However, to meet your individual laundry service requirements, and if you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the Smooth Starch Add-On after you have already selected the Iron Add-On.",
      addon_description_2_th:
        "เราจะไม่ใช้น้ำยารีดผ้าเรียบใดๆ ในการรีดหรือซักผ้า\n\nฐานรองรีดของเราใช้เทคโนโลยีใหม่ล่าสุดเพื่อให้เสื้อผ้าของคุณเรียบสวยไร้รอยยับมากที่สุด\nหากคุณต้องการความเรียบเนียน กลิ่นหอม และความสมบูรณ์แบบในการรีดขั้นสูงสุด โปรดเลือกเพิ่มเติม\n\nน้ำยารีดผ้าเรียบ หลังจากเลือก รีดผ้า แล้ว",
      addon_description_en:
        "As an Add-On to our professional laundry service, we iron EVERY piece of your laundry that is suitable for ironing. Shirts, dresses, trousers, towels, pillow cases and more, all ironed to creaseless perfection at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your laundry service order.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้มีบริการรีดผ้าให้คุณ สำหรับผ้าทุกชิ้นที่เหมาะต่อการรีด ทั้งเสื้อเชิ้ต ชุดกระโปรง\n\nกางเกง ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอนให้คุณแน่ใจ\nหากมีรายการใดที่คุณไม่ต้องการให้เรารีด หรือมีสิ่งใดที่เราต้องให้ความสนใจเป็นพิเศษ",
      description_en: "Ironing items by smooth starch",
      description_th: "บริการรีดผ้าเรียบ ไร้รอยยับ",
      name_en: "Iron",
      name_th: "รีดผ้า",
      ex_en: "Iron",
      ex_th: "รีดผ้า",
    },
    {
      _id: "631adaa316368678b8ed8e59",
      language: "EN",
      name: "น้ำหอมสำหรับซักผ้า",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ให้ความสดชื่นสุดพิเศษ",
      image_key_desktop: "1662704288283_Add-ons (4).png",
      image_key_mobile: "1662704288867_Add-ons (4).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำหอมสำหรับซักผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการซักไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      type: "ADDON",
      ex: "น้ำหอมสำหรับซักผ้า",
      icon_key: "1662704289024_Add-ons (5).png",
      createdAt: "2022-09-09T06:18:11.475Z",
      updatedAt: "2022-11-16T09:33:44.927Z",
      addon_description_2_en:
        "You will smell the Laundry Perfume not only directly after\nwashing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Laundry Perfume does not contain fabric softeners.\nHowever, if you have known allergies you should consider whether this Add-On is suitable for\nyou. Our tip: choose Laundry Perfume every time you use our professional laundry service for\n\nthe best long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับซักผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับซักผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Laundry Perfume is suitable for all\ntypes of fabrics (incl. microfiber and functional wear) and comes with a long-lasting and\nfresh flowery fragrance day after day.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำหอมสำหรับซักผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการซักไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Laundry Perfume",
      ex_th: "น้ำหอมสำหรับซักผ้า",
      name_en: "Laundry Perfume",
      name_th: "น้ำหอมสำหรับซักผ้า",
      addon_description_2:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับซักผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับซักผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
    },
    {
      _id: "631b00a1d51e9672eb237938",
      language: "EN",
      name: "น้ำหอมสำหรับรีดผ้า",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "ให้ความสดชื่นสุดพิเศษ",
      image_key_desktop: "1662714017029_Add-ons (4).png",
      image_key_mobile: "1662714017427_Add-ons (4).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำหอมสำหรับรีดผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการรีดไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      type: "ADDON",
      ex: "น้ำหอมสำหรับรีดผ้า",
      icon_key: "1662714017569_Add-ons (5).png",
      createdAt: "2022-09-09T09:00:17.934Z",
      updatedAt: "2022-11-16T15:17:54.435Z",
      addon_description_2_en:
        "You will smell the Ironing Perfume not only directly after\nironing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Ironing Perfume does not contain fabric softeners.\nHowever, if you have known allergies, you should consider whether this Add-On is suitable for\nyou. Our tip: choose Ironing Perfume every time you use our professional ironing service for the\n\nbest long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับรีดผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับรีดผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, our Ironing Perfume is suitable for all types\nof fabrics (incl. microfiber and functional wear) and comes with a long-lasting and fresh\nflowery fragrance day after day.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำหอมสำหรับรีดผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการรีดไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Ironing Perfume",
      ex_th: "น้ำหอมสำหรับรีดผ้า",
      name_en: "Ironing Perfume",
      name_th: "น้ำหอมสำหรับรีดผ้า",
      addon_description_2:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับรีดผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับรีดผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
    },
    {
      _id: "631adbfc16368678b8ed8e66",
      language: "EN",
      name: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "คืนสภาพสีดำอย่างแท้จริง",
      image_key_desktop: "1668592348437_black_shirt.png",
      image_key_mobile: "1668592348780_black_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าดำกลับมาสีดำอีกครั้ง\nซึ่งจะช่วยฟื้นคืนสภาพเฉดสีดำให้กลับมาเข้มดังเดิมและปกป้องผ้าสีดำให้ดูดีเหมือนใหม่\n\nช่วยให้สีที่ตกและซีดจางกลับมามีสีดำเข้มอีกครั้ง",
      type: "ADDON",
      ex: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      icon_key: "1668592348904_Default 2.png",
      createdAt: "2022-09-09T06:23:56.397Z",
      updatedAt: "2022-11-16T09:52:29.518Z",
      addon_description_2_en:
        "Washed-out and faded black clothes will be revived and their colour\nrestored. We recommend repeating the application of our Make Blacks Black Again Add-On\nevery time you notice that your clothes are beginning to fade. When you choose our Make\nBlacks Black Again Add-On, we separate all the suitable black clothes included in your laundry\nand treat them separately. Of course, all your other chosen Add-Ons still apply as well. If you\nwant us to focus on some of your black items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "เราขอแนะนำให้ใช้ตัวเลือกนี้ซ้ำทุกครั้งที่คุณสังเกตเห็นว่าเสื้อผ้าเริ่มมีสีจางลง เมื่อคุณเลือกเพิ่มเติม\nให้ผ้าดำกลับมาสีดำอีกครั้ง เราจะดูแลผ้าสีดำของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ\nที่คุณเลือกจะถูกนำไปใช้ด้วย หากคุณต้องการให้เราเน้นเฉพาะผ้าสีดำบางตัวหรือจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้า\n\nมายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Blacks Black Again Add-On which\nrevives and protects the deep black shade of all your black clothes to make them look as\ngood as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าดำกลับมาสีดำอีกครั้ง\nซึ่งจะช่วยฟื้นคืนสภาพเฉดสีดำให้กลับมาเข้มดังเดิมและปกป้องผ้าสีดำให้ดูดีเหมือนใหม่\n\nช่วยให้สีที่ตกและซีดจางกลับมามีสีดำเข้มอีกครั้ง",
      description_en: "Revive the true black colour",
      description_th: "คืนสภาพสีดำอย่างแท้จริง",
      ex_en: "Make Blacks Black Again",
      ex_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      name_en: "Make Blacks Black Again",
      name_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      addon_description_2:
        "เราขอแนะนำให้ใช้ตัวเลือกนี้ซ้ำทุกครั้งที่คุณสังเกตเห็นว่าเสื้อผ้าเริ่มมีสีจางลง เมื่อคุณเลือกเพิ่มเติม\nให้ผ้าดำกลับมาสีดำอีกครั้ง เราจะดูแลผ้าสีดำของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ\nที่คุณเลือกจะถูกนำไปใช้ด้วย หากคุณต้องการให้เราเน้นเฉพาะผ้าสีดำบางตัวหรือจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้า\n\nมายลอนดรี้",
    },
    {
      _id: "637203f8a142589973ec1ea0",
      language: "EN",
      name: "แขวนพิเศษ",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "เราแขวนด้วยไม้แขวนของเรา",
      image_key_desktop: "1668593118092_Add-ons (26).png",
      image_key_mobile: "1668593118353_Add-ons (26).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      type: "ADDON",
      ex: "แขวนพิเศษ",
      icon_key: "1668593118489_Add-ons (25).png",
      createdAt: "2022-11-14T09:01:44.505Z",
      updatedAt: "2022-11-16T10:05:18.764Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your laundry which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your laundry service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "63720417a142589973ec1ea9",
      language: "EN",
      name: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "เพื่อการซักผ้าที่สะอาดถูกสุขอนามัย",
      image_key_desktop: "1670562040139_1668587273739_Add-ons (13).png",
      image_key_mobile: "1668587274101_Add-ons (13).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย ซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส\nรวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย",
      type: "ADDON",
      ex: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      icon_key: "1668587274241_Add-ons (8).png",
      createdAt: "2022-11-14T09:02:15.384Z",
      updatedAt: "2022-12-09T05:00:41.761Z",
      addon_description_2_en:
        "Providing an\nextra layer of support to the detergent for an even more hygienically-clean laundry service, our\nAntibacterial Sanitiser is free of bleach and can be used with all types of fabrics including\nchildren’s clothes. We recommend Antibacterial Sanitiser for every wash, while for particularly\nhigh hygiene demands, it can be combined with our High Temperature Wash Add-On option to\n\ncreate your very own customised laundry service experience.",
      addon_description_2_th:
        "ช่วยเพิ่มประสิทธิภาพของการซักผ้าให้สะอาดถูกสุขอนามัยยิ่งขึ้น\nนอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\nรวมทั้งเสื้อผ้าเด็กด้วย เราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียสำหรับทุกการซักผ้า\nโดยใช้ร่วมกับตัวเลือกเพิ่มเติมการซักด้วยอุณหภูมิสูง เพื่อสุขอนามัยขั้นพิเศษ",
      addon_description_en:
        "As part of our professional laundry service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย ซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส\nรวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการซักผ้าที่สะอาดถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "ช่วยเพิ่มประสิทธิภาพของการซักผ้าให้สะอาดถูกสุขอนามัยยิ่งขึ้น\nนอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\nรวมทั้งเสื้อผ้าเด็กด้วย เราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียสำหรับทุกการซักผ้า\nโดยใช้ร่วมกับตัวเลือกเพิ่มเติมการซักด้วยอุณหภูมิสูง เพื่อสุขอนามัยขั้นพิเศษ",
    },
    {
      _id: "63720392a142589973ec1e9a",
      language: "EN",
      name: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "เราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆ",
      image_key_desktop: "1668587084343_Add-ons (10).png",
      image_key_mobile: "1668587084846_Add-ons (10).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ให้คุณมั่นใจว่าเราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆในการซักผ้าของคุณ ชัดเจน ง่าย และฟรี",
      type: "ADDON",
      ex: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      icon_key: "1668587084964_Add-ons (9).png",
      createdAt: "2022-11-14T09:00:02.224Z",
      updatedAt: "2022-11-16T12:54:02.992Z",
      addon_description_2_en: "",
      addon_description_2_th: "",
      addon_description_en:
        "You can rely on us not to use any softener with your laundry – clear, easy and free of charge.",
      addon_description_th:
        "ให้คุณมั่นใจว่าเราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆในการซักผ้าของคุณ ชัดเจน ง่าย และฟรี",
      description_en: "We will not use Softener at all",
      description_th: "เราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆ",
      ex_en: "No Softener ",
      ex_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      name_en: "No Softener ",
      name_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      addon_description_2: "",
    },
    {
      _id: "631413c80fd8fc3bfd89d79e",
      language: "EN",
      name: "ซักด้วยอุณหภูมิสูง",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "เราซักที่ 60 องศาเซลเซียส",
      image_key_desktop: "1668590690011_Add-ons (15).png",
      image_key_mobile: "1668590690508_Add-ons (15).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ขอแนะนำให้ซักผ้าด้วยอุณหภูมิสูงที่ 60 องศาเซลเซียส สำหรับผ้าเช็ดตัว เครื่องนอน\nเสื้อผ้าเด็กทารกเป็นมาตรฐาน หรือสำหรับเสื้อผ้าทั่วไปหลังจากที่หายจากอาการหวัดหรือติดเชื้อไวรัสแล้ว",
      ex: "ซักด้วยอุณหภูมิสูง",
      createdAt: "2022-09-04T02:56:08.859Z",
      updatedAt: "2022-11-18T11:58:42.380Z",
      type: "ADDON",
      icon_key: "1668590690623_Add-ons (14).png",
      addon_description_2_en:
        "With our High Temperature Wash, your laundry\nwill be hygienically clean, while bacteria and viruses will be eliminated. If you have specific high\nhygiene requirements, we recommend combining our High Temperature Wash with our\nAntibacterial Sanitiser Add-On to create the complete clean and sanitised laundry service. You\ncan tell us in the Special Request box before placing your laundry service order if you want us\nto wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude\n\nspecific items from the High Temperature Wash and treat them separately.",
      addon_description_2_th:
        "ด้วยการซักอุณหภูมิสูงของเราทำให้ผ้าสะอาดถูกสุขอนามัย และยังฆ่าเชื้อแบคทีเรียและไวรัสได้อีกด้วย\nขอแนะนำให้รวมการซักด้วยอุณหภูมิสูงกับผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียเพื่อสุขอนามัยขั้นพิเศษ\n\nหากคุณต้องการให้เราซักที่อุณหภูมิอื่นเช่น 50 หรือ 90 องศาเซลเซียส\nหรือประสงค์จะแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As a professional laundry service, we recommend the High Temperature Wash at 60°C Add-\nOn for towels, bedding and baby clothes as standard or for your regular clothes after you\nhave recovered from a cold or viral infection.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ขอแนะนำให้ซักผ้าด้วยอุณหภูมิสูงที่ 60 องศาเซลเซียส สำหรับผ้าเช็ดตัว เครื่องนอน\nเสื้อผ้าเด็กทารกเป็นมาตรฐาน หรือสำหรับเสื้อผ้าทั่วไปหลังจากที่หายจากอาการหวัดหรือติดเชื้อไวรัสแล้ว",
      description_en: "We wash at 60°C",
      description_th: "เราซักที่ 60 องศาเซลเซียส",
      name_en: "High Temperature Wash",
      name_th: "ซักด้วยอุณหภูมิสูง",
      ex_en: "High Temperature Wash ",
      ex_th: "ซักด้วยอุณหภูมิสูง",
      addon_description_2:
        "ด้วยการซักอุณหภูมิสูงของเราทำให้ผ้าสะอาดถูกสุขอนามัย และยังฆ่าเชื้อแบคทีเรียและไวรัสได้อีกด้วย\nขอแนะนำให้รวมการซักด้วยอุณหภูมิสูงกับผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียเพื่อสุขอนามัยขั้นพิเศษ\n\nหากคุณต้องการให้เราซักที่อุณหภูมิอื่นเช่น 50 หรือ 90 องศาเซลเซียส\nหรือประสงค์จะแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631adb9016368678b8ed8e62",
      language: "EN",
      name: "ผลิตภัณฑ์ซักผ้าออร์แกนิค",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ตัวเลือกดีที่สุดสำหรับทุกคน",
      image_key_desktop: "1662704526308_Add-ons (16).png",
      image_key_mobile: "1662704526640_Add-ons (16).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิค\n\nซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ\nนอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย\nและยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ",
      type: "ADDON",
      ex: "t",
      icon_key: "1662704526746_Add-ons (6).png",
      createdAt: "2022-09-09T06:22:08.116Z",
      updatedAt: "2022-11-16T07:51:49.741Z",
      addon_description_2_en:
        "select the free of charge No Softener Add-On. Organic products are especially gentle to the\nenvironment and therefore strongly recommended. PS: We use a variety of locally and\ninternationally sourced Organic Wash products in our premium laundry service. Use the\nSpecial Request box before placing your laundry service order to tell us your preferences and\n\nwe will fulfil your request whenever possible.",
      addon_description_2_th:
        "กรุณาเลือกเพิ่มเติม ไม่ใช้น้ำยาปรับผ้านุ่ม ผลิตภัณฑ์ออร์แกนิคเป็นมิตรกับสิ่งแวดล้อม\nจึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้ เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service our Organic Wash comes with no dyes,\nfragrances or preservatives. Our organic detergents and softeners contain only plant-based,\nnaturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents\nand softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do\nnot wish us to use softener in your Organic Wash as part of our quality laundry service, please",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิค\n\nซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ\nนอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย\nและยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ",
      description_en: "The best organic laundry choice",
      description_th: "ตัวเลือกดีที่สุดสำหรับทุกคน",
      ex_en: "e",
      ex_th: "t",
      name_en: "Organic Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าออร์แกนิค",
      addon_description_2:
        "กรุณาเลือกเพิ่มเติม ไม่ใช้น้ำยาปรับผ้านุ่ม ผลิตภัณฑ์ออร์แกนิคเป็นมิตรกับสิ่งแวดล้อม\nจึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้ เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "63134c67185a14333bd12da2",
      language: "EN",
      name: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "ปกป้องรองเท้าของคุณให้ปลอดภัย",
      image_key_desktop: "1662716152579_Add-ons (42).png",
      image_key_mobile: "1662716152884_Add-ons (42).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "best of our premium shoe cleaning service. ร้านทำความสะอาดรองเท้ามายลอนดรี้มีบริการเคลือบและกันน้ำ ซึ่งช่วยปกป้องรองเท้าคู่โปรดของคุณให้ปลอดภัยจากปัจจัยภายนอก ทั้งฝนและคราบสกปรกต่างๆ โดยมีฟิล์มเคลือบป้องกันไม่ให้ความชื้นซึมเข้าสู่รองเท้า และยังช่วยระบายอากาศได้ดี พร้อมทั้งยับยั้งการเกิดคราบสกปรกบนพื้นผิว รวมถึงป้องกันการก่อตัวของคราบที่ฝังแน่น",
      type: "ADDON",
      ex: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T14:55:07.017Z",
      icon_key: "1662716153013_Add-ons (41).png",
      name_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      name_en: "Protection & Waterproofing ",
      addon_description_en:
        "Our Protection &amp; Waterproofing Add-On keeps your favourite shoes safe from external factors such as rain and dirt.",
      addon_description_2_en:
        "A protective film prevents moisture from penetrating into the shoes while still keeping them breathable and blocks dirt right at the surface to stop any unremovable stains forming. Our shoe cleaning service not only protects your new and favourite shoes but also extends their durability and longevity and is suitable for shoes of all colours and types, from sneakers to leather shoes. We recommend combining Protection &amp; Waterproofing with our Interior Shoe Cleansing and Shoe Perfume Add-Ons to experience the best of our premium shoe cleaning service.",
      addon_description_th:
        "best of our premium shoe cleaning service. ร้านทำความสะอาดรองเท้ามายลอนดรี้มีบริการเคลือบและกันน้ำ ซึ่งช่วยปกป้องรองเท้าคู่โปรดของคุณให้ปลอดภัยจากปัจจัยภายนอก ทั้งฝนและคราบสกปรกต่างๆ โดยมีฟิล์มเคลือบป้องกันไม่ให้ความชื้นซึมเข้าสู่รองเท้า และยังช่วยระบายอากาศได้ดี พร้อมทั้งยับยั้งการเกิดคราบสกปรกบนพื้นผิว รวมถึงป้องกันการก่อตัวของคราบที่ฝังแน่น",
      addon_description_2_th:
        "บริการนี้ไม่เพียงแต่ปกป้องรองเท้าคู่ใหม่สุดโปรดของคุณเท่านั้น แต่ยังช่วยยืดอายุการใช้งานให้นานและเหมาะสำหรับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ร้านทำความสะอาดรองเท้า มายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำร่วมกับบริการทำความสะอาดรองเท้า ด้านในและน้ำหอมสำหรับรองเท้า เพื่อบริการสปารองเท้าระดับพรีเมียมที่ดีที่สุด",
      description_en: "Keep your shoes safe and sound",
      description_th: "ปกป้องรองเท้าของคุณให้ปลอดภัย",
      ex_en: "Protection & Waterproofing ",
      ex_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      addon_description_2:
        "บริการนี้ไม่เพียงแต่ปกป้องรองเท้าคู่ใหม่สุดโปรดของคุณเท่านั้น แต่ยังช่วยยืดอายุการใช้งานให้นานและเหมาะสำหรับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ร้านทำความสะอาดรองเท้า มายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำร่วมกับบริการทำความสะอาดรองเท้า ด้านในและน้ำหอมสำหรับรองเท้า เพื่อบริการสปารองเท้าระดับพรีเมียมที่ดีที่สุด",
    },
    {
      _id: "63134c67185a14333bd12ea2",
      language: "EN",
      name: "น้ำยารีดผ้าเรียบ",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "ให้ผ้าเรียบเนียนที่สุด",
      image_key_desktop: "1662713749933_Add-ons (12).png",
      image_key_mobile: "1662713750525_Add-ons (12).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      type: "ADDON",
      ex: "น้ำยารีดผ้าเรียบ",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T15:16:45.196Z",
      icon_key: "1662634995246_41_Property 1=Smooth Starch.png",
      addon_description_2_en:
        "fragrance, and pure ironing perfection as part of our premium ironing service. Smooth Starch\nwill give your clothes and bedding items the ultimate neat and crisp appearance.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\nซึ่งจะช่วยให้ผ้าและเครื่องนอนของคุณเรียบเนียนสดชื่นมีชีวิตชีวามากที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer. We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\nซึ่งจะช่วยให้ผ้าและเครื่องนอนของคุณเรียบเนียนสดชื่นมีชีวิตชีวามากที่สุด",
    },
    {
      _id: "631ac4517cbbbb34e17f8b19",
      language: "EN",
      name: "น้ำยารีดผ้าเรียบ",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ให้ผ้าเรียบเนียนที่สุด",
      image_key_desktop: "1662953321455_Add-ons (12).png",
      image_key_mobile: "1662953321745_Add-ons (12).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      type: "ADDON",
      ex: "น้ำยารีดผ้าเรียบ",
      icon_key: "1662699611185_Add-ons (11).png",
      createdAt: "2022-09-09T04:42:57.735Z",
      updatedAt: "2022-11-16T09:32:13.437Z",
      addon_description_2_en:
        "We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free\nfragrance, and pure ironing perfection as part of our premium laundry service. Smooth Starch\nwill give your laundry the ultimate neat and crisp appearance it deserves. You can only select\n\nthe Smooth Starch Add-On if you have already selected the Iron Add-On.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\n\nซึ่งจะช่วยให้ผ้าของคุณสะอาดเรียบร้อยและสดชื่นมีชีวิตชีวามากที่สุด โปรดเลือกเพิ่มเติม น้ำยารีดผ้าเรียบ\n\nหลังจากเลือก รีดผ้า แล้วเท่านั้น",
      addon_description_en:
        "As an Add-On to our professional laundry service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\n\nซึ่งจะช่วยให้ผ้าของคุณสะอาดเรียบร้อยและสดชื่นมีชีวิตชีวามากที่สุด โปรดเลือกเพิ่มเติม น้ำยารีดผ้าเรียบ\n\nหลังจากเลือก รีดผ้า แล้วเท่านั้น",
    },
    {
      _id: "631add2516368678b8ed8e72",
      language: "EN",
      name: "ขจัดคราบ",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ขจัดคราบต่างๆอย่างละเอียด",
      image_key_desktop: "1662704932262_Add-ons (24).png",
      image_key_mobile: "1662704932575_Add-ons (24).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้จะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด เราสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต\nมายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา\nคราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้",
      type: "ADDON",
      ex: "t",
      icon_key: "1662704932707_Add-ons (23).png",
      createdAt: "2022-09-09T06:28:53.237Z",
      updatedAt: "2022-11-16T12:52:35.070Z",
      addon_description_2_en:
        "water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle\nwax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on\nsome items of your laundry in particular, you can tell us in the Special Request box before\n\nplacing your laundry service order.",
      addon_description_2_th:
        "เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์\n\nหมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล\nหากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "When you select the Stain Removal Add-On, our professional laundry service team screens\nevery item of your laundry from head to toe and makes every effort to remove any stains we\nfind. We can remove many kinds of stains, such as oil, sauces, ketchup, chocolate,\nmayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk,\nyogurt, cream, mould, blood, pus, ballpoint pens, ink, felt tip pens, highlighters, coloured pencils,",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้จะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด เราสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต\nมายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา\nคราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้",
      description_en: "Removing stains from A to Z",
      description_th: "ขจัดคราบต่างๆอย่างละเอียด",
      ex_en: "e",
      ex_th: "t",
      name_en: "Stain Removal",
      name_th: "ขจัดคราบ",
      addon_description_2:
        "เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์\n\nหมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล\nหากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
  ],
};

export const mock_data_pricing_en = {
  addons: [
    {
      _id: "63134c67185a14333bd12ea1",
      language: "EN",
      name: "Iron",
      s: 1,
      m: 100,
      l: 150,
      status: true,
      description: "Ironing items by smooth starch",
      image_key_desktop: "1662699151208_Add-ons (7).png",
      image_key_mobile: "1662699151533_Add-ons (7).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, we iron EVERY piece of your laundry that is suitable for ironing. Shirts, dresses, trousers, towels, pillow cases and more, all ironed to creaseless perfection at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your laundry service order.",
      type: "ADDON",
      ex: "Iron",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-12-19T04:40:08.766Z",
      icon_key: "1662633765156_44_Property 1=Variant27.png",
      addon_description_2:
        "As our quality laundry service standard, we do not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. However, to meet your individual laundry service requirements, and if you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the Smooth Starch Add-On after you have already selected the Iron Add-On.",
      addon_description_2_en:
        "As our quality laundry service standard, we do not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. However, to meet your individual laundry service requirements, and if you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the Smooth Starch Add-On after you have already selected the Iron Add-On.",
      addon_description_2_th:
        "เราจะไม่ใช้น้ำยารีดผ้าเรียบใดๆ ในการรีดหรือซักผ้า\n\nฐานรองรีดของเราใช้เทคโนโลยีใหม่ล่าสุดเพื่อให้เสื้อผ้าของคุณเรียบสวยไร้รอยยับมากที่สุด\nหากคุณต้องการความเรียบเนียน กลิ่นหอม และความสมบูรณ์แบบในการรีดขั้นสูงสุด โปรดเลือกเพิ่มเติม\n\nน้ำยารีดผ้าเรียบ หลังจากเลือก รีดผ้า แล้ว",
      addon_description_en:
        "As an Add-On to our professional laundry service, we iron EVERY piece of your laundry that is suitable for ironing. Shirts, dresses, trousers, towels, pillow cases and more, all ironed to creaseless perfection at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your laundry service order.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้มีบริการรีดผ้าให้คุณ สำหรับผ้าทุกชิ้นที่เหมาะต่อการรีด ทั้งเสื้อเชิ้ต ชุดกระโปรง\n\nกางเกง ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอนให้คุณแน่ใจ\nหากมีรายการใดที่คุณไม่ต้องการให้เรารีด หรือมีสิ่งใดที่เราต้องให้ความสนใจเป็นพิเศษ",
      description_en: "Ironing items by smooth starch",
      description_th: "บริการรีดผ้าเรียบ ไร้รอยยับ",
      name_en: "Iron",
      name_th: "รีดผ้า",
      ex_en: "Iron",
      ex_th: "รีดผ้า",
    },
    {
      _id: "631413c80fd8fc3bfd89d79e",
      language: "EN",
      name: "High Temperature Wash",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "We wash at 60°C",
      image_key_desktop: "1668590690011_Add-ons (15).png",
      image_key_mobile: "1668590690508_Add-ons (15).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As a professional laundry service, we recommend the High Temperature Wash at 60°C Add-\nOn for towels, bedding and baby clothes as standard or for your regular clothes after you\nhave recovered from a cold or viral infection.",
      ex: "High Temperature Wash ",
      createdAt: "2022-09-04T02:56:08.859Z",
      updatedAt: "2022-11-18T11:58:42.380Z",
      type: "ADDON",
      icon_key: "1668590690623_Add-ons (14).png",
      addon_description_2_en:
        "With our High Temperature Wash, your laundry\nwill be hygienically clean, while bacteria and viruses will be eliminated. If you have specific high\nhygiene requirements, we recommend combining our High Temperature Wash with our\nAntibacterial Sanitiser Add-On to create the complete clean and sanitised laundry service. You\ncan tell us in the Special Request box before placing your laundry service order if you want us\nto wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude\n\nspecific items from the High Temperature Wash and treat them separately.",
      addon_description_2_th:
        "ด้วยการซักอุณหภูมิสูงของเราทำให้ผ้าสะอาดถูกสุขอนามัย และยังฆ่าเชื้อแบคทีเรียและไวรัสได้อีกด้วย\nขอแนะนำให้รวมการซักด้วยอุณหภูมิสูงกับผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียเพื่อสุขอนามัยขั้นพิเศษ\n\nหากคุณต้องการให้เราซักที่อุณหภูมิอื่นเช่น 50 หรือ 90 องศาเซลเซียส\nหรือประสงค์จะแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As a professional laundry service, we recommend the High Temperature Wash at 60°C Add-\nOn for towels, bedding and baby clothes as standard or for your regular clothes after you\nhave recovered from a cold or viral infection.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ขอแนะนำให้ซักผ้าด้วยอุณหภูมิสูงที่ 60 องศาเซลเซียส สำหรับผ้าเช็ดตัว เครื่องนอน\nเสื้อผ้าเด็กทารกเป็นมาตรฐาน หรือสำหรับเสื้อผ้าทั่วไปหลังจากที่หายจากอาการหวัดหรือติดเชื้อไวรัสแล้ว",
      description_en: "We wash at 60°C",
      description_th: "เราซักที่ 60 องศาเซลเซียส",
      name_en: "High Temperature Wash",
      name_th: "ซักด้วยอุณหภูมิสูง",
      ex_en: "High Temperature Wash ",
      ex_th: "ซักด้วยอุณหภูมิสูง",
      addon_description_2:
        "With our High Temperature Wash, your laundry\nwill be hygienically clean, while bacteria and viruses will be eliminated. If you have specific high\nhygiene requirements, we recommend combining our High Temperature Wash with our\nAntibacterial Sanitiser Add-On to create the complete clean and sanitised laundry service. You\ncan tell us in the Special Request box before placing your laundry service order if you want us\nto wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude\n\nspecific items from the High Temperature Wash and treat them separately.",
    },
    {
      _id: "6314264c7a1baccc80de71b5",
      language: "EN",
      name: "350 ml bottle",
      status: false,
      description: "We deliver 3 packs of 16 bottles (48 bottles)",
      image_key_desktop: "1662709691037_Frame 52878 (1).png",
      image_key_mobile: "1662709691409_Frame 52878 (1).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      type: "WATER",
      price: 50,
      ex: "350 ml bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-18T07:08:20.308Z",
      icon_key: "1662709691547_Frame 52878.png",
      addon_description_2:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 16 bottles (48 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      ex_en: "350 ml bottle",
      ex_th: "ขวด 350 มิลลิลิตร",
      name_en: "350 ml bottle",
      name_th: "ขวด 350 มิลลิลิตร",
    },
    {
      _id: "631428327a1baccc80de71c2",
      language: "EN",
      name: "Up to 22 pieces or 1 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662707669485_Add-ons (27).png",
      image_key_mobile: "1662707669866_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      type: "PACKAGE",
      ex: "My Wash Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-12-06T08:36:06.839Z",
      size: "S",
      price: 1,
      master: true,
      master_type: "My Wash",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 22 pieces or 1 x My Laundry Bag",
      name_th: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
    },
    {
      _id: "63142d2e7a1baccc80de71f6",
      language: "EN",
      name: "Comforter or Duvet Insert",
      status: false,
      description: "For 1 piece",
      image_key_desktop: "1662708818450_Add-ons (28).png",
      image_key_mobile: "1662708818835_Add-ons (28).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "In addition to your regular laundry, we are happy to take care of your comforter or duvet\ninsert as well as part of our professional laundry service.",
      type: "EXTRA",
      price: 50,
      ex: "Comforter or Duvet Insert",
      createdAt: "2022-09-04T04:44:30.024Z",
      updatedAt: "2022-11-16T14:40:27.166Z",
      icon_key: "1662633859153_13_Property 1=Comforter or Duvet Insert.png",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 comforter or duvet insert in addition to your regular laundry for each order.\nOur comforter or duvet insert service includes washing AND ironing, where possible, as default.\nAll other Add-Ons chosen for your laundry will apply for the comforter or duvet insert\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_th:
        "ทั้งนี้บริการผ้านวมหรือผ้าห่มของเรารวมการซักและรีด หากรีดได้ เป็นมาตรฐาน\n\nส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\n\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your comforter or duvet\ninsert as well as part of our professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Comforter or Duvet Insert",
      ex_th: "ผ้านวม หรือ ผ้าห่ม",
      name_en: "Comforter or Duvet Insert",
      name_th: "ผ้านวม หรือ ผ้าห่ม",
      addon_description_2:
        "Please be informed that we can pick\nup a maximum of 1 comforter or duvet insert in addition to your regular laundry for each order.\nOur comforter or duvet insert service includes washing AND ironing, where possible, as default.\nAll other Add-Ons chosen for your laundry will apply for the comforter or duvet insert\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
    },
    {
      _id: "63142e637a1baccc80de71ff",
      language: "EN",
      name: "Up to 44 pieces or 2 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662707802497_Add-ons (27).png",
      image_key_mobile: "1662707802853_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      type: "PACKAGE",
      ex: "My Wash Packages: S, M and L",
      createdAt: "2022-09-04T04:49:39.328Z",
      updatedAt: "2022-11-16T15:11:14.871Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Wash",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 44 pieces or 2 x My Laundry Bag",
      name_th: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "631462cf7a1baccc80de7205",
      language: "EN",
      name: "Up to 66 pieces or 3 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662707883149_Add-ons (27).png",
      image_key_mobile: "1662707883497_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      type: "PACKAGE",
      price: 995,
      ex: "My Wash Packages: S, M and L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:28:02.766Z",
      size: "L",
      master: true,
      master_type: "My Wash",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 66 pieces or 3 x My Laundry Bag",
      name_th: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "63134c67185a14333bd12ea2",
      language: "EN",
      name: "Smooth Starch",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "For the ultimate ironing results",
      image_key_desktop: "1662713749933_Add-ons (12).png",
      image_key_mobile: "1662713750525_Add-ons (12).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an Add-On to our professional ironing service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer. We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free",
      type: "ADDON",
      ex: "Smooth Starch",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T15:16:45.196Z",
      icon_key: "1662634995246_41_Property 1=Smooth Starch.png",
      addon_description_2_en:
        "fragrance, and pure ironing perfection as part of our premium ironing service. Smooth Starch\nwill give your clothes and bedding items the ultimate neat and crisp appearance.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\nซึ่งจะช่วยให้ผ้าและเครื่องนอนของคุณเรียบเนียนสดชื่นมีชีวิตชีวามากที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer. We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "fragrance, and pure ironing perfection as part of our premium ironing service. Smooth Starch\nwill give your clothes and bedding items the ultimate neat and crisp appearance.",
    },
    {
      _id: "6314264c7a1baccc80de71b6",
      language: "EN",
      name: "1.5 l bottle",
      status: false,
      description: "We deliver 3 packs of 6 bottles (18 bottles)",
      image_key_desktop: "1662709539412_Add-ons (36).png",
      image_key_mobile: "1662709539762_Add-ons (36).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      type: "WATER",
      price: 100,
      ex: "1.5 l bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:06.225Z",
      icon_key: "1662709539873_Add-ons (35).png",
      addon_description_2_en:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 6 bottles (18 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "1.5 l bottle",
      name_th: "ขวด 1.5 ลิตร",
      addon_description_2:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
    },
    {
      _id: "631428327a1baccc80de71c3",
      language: "EN",
      name: "Up to 22 pieces or 1 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662715257667_Add-ons (40).png",
      image_key_mobile: "1662715258054_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      type: "PACKAGE",
      ex: "My Iron Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:23:35.419Z",
      size: "S",
      price: 395,
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 22 pieces or 1 x My Laundry Bag",
      name_th: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "63142d2e7a1baccc80de71f7",
      language: "EN",
      name: "Comforter or Duvet Insert",
      status: false,
      description: "For 1 piece",
      image_key_desktop: "1662714264226_Add-ons (28).png",
      image_key_mobile: "1662714264591_Add-ons (28).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "In addition to your regular ironing, we are happy to take care of your comforter or duvet insert\nas well as part of our professional ironing service.",
      type: "EXTRA",
      price: 50,
      ex: "Comforter or Duvet Insert",
      createdAt: "2022-09-04T04:44:30.024Z",
      updatedAt: "2022-11-16T15:19:59.658Z",
      icon_key: "1662635128836_13_Property 1=Comforter or Duvet Insert.png",
      addon_description_2_en:
        "Please be informed that we can pick up a\nmaximum of 1 comforter or duvet insert in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the comforter or duvet insert automatically,\nunless you advise us differently in the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular ironing, we are happy to take care of your comforter or duvet insert\nas well as part of our professional ironing service.",
      addon_description_th:
        "นอกจากการรีดผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Comforter or Duvet Insert",
      ex_th: "ผ้านวม หรือ ผ้าห่ม",
      name_en: "Comforter or Duvet Insert",
      name_th: "ผ้านวม หรือ ผ้าห่ม",
      addon_description_2:
        "Please be informed that we can pick up a\nmaximum of 1 comforter or duvet insert in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the comforter or duvet insert automatically,\nunless you advise us differently in the Special Request box before placing your ironing service\n\norder.",
    },
    {
      _id: "631428327a1baccc80de71d4",
      language: "EN",
      name: "Up to 44 pieces or 2 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662715436595_Add-ons (40).png",
      image_key_mobile: "1662715436948_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      type: "PACKAGE",
      ex: "My Iron Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:25:03.421Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 44 pieces or 2 x My Laundry Bag",
      name_th: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "631462cf7a1baccc80de7207",
      language: "EN",
      name: "Up to 66 pieces or 3 x My Laundry Bag",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662715520829_Add-ons (40).png",
      image_key_mobile: "1662715521203_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      type: "PACKAGE",
      price: 995,
      ex: "My Iron Packages: S, M and L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:26:26.865Z",
      size: "L",
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 66 pieces or 3 x My Laundry Bag",
      name_th: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
    },
    {
      _id: "6314264c7a1baccc80de71c6",
      language: "EN",
      name: "600 ml bottle",
      status: false,
      description: "We deliver 3 packs of 12 bottles (36 bottles)",
      image_key_desktop: "1662709814171_Add-ons (38).png",
      image_key_mobile: "1662709814550_Add-ons (38).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      type: "WATER",
      price: 150,
      ex: "1.5 l bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:12.696Z",
      icon_key: "1662709814728_Add-ons (37).png",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 12 bottles (36 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "600 ml bottle",
      name_th: "ขวด 600 มิลลิลิตร",
      addon_description_2:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
    },
    {
      _id: "631428327a1baccc80de71d3",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 5 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Description for the Pop-up at Add-Ons",
      type: "PACKAGE",
      ex: "Up to 5 pieces",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-15T10:08:29.184Z",
      size: "S",
      price: 745,
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Description for the Pop-up at Add-Ons",
      addon_description_2_th: "Description for the Pop-up at Add-Ons",
      addon_description_en: "Description for the Pop-up at Add-Ons",
      addon_description_th: "Description for the Pop-up at Add-Ons",
      description_en: "Up to 5 pieces",
      description_th: "Up to 5 pieces",
      ex_en: "Up to 5 pieces",
      ex_th: "Up to 5 pieces",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Description for the Pop-up at Add-Ons",
    },
    {
      _id: "631428327a1baccc80de71e4",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 10 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Description for the Pop-up at Add-Ons",
      type: "PACKAGE",
      ex: "Up to 10 pieces",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-15T10:09:07.157Z",
      size: "M",
      price: 1045,
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Description for the Pop-up at Add-Ons",
      addon_description_2_th: "Description for the Pop-up at Add-Ons",
      addon_description_en: "Description for the Pop-up at Add-Ons",
      addon_description_th: "Description for the Pop-up at Add-Ons",
      description_en: "Up to 10 pieces",
      description_th: "Up to 10 pieces",
      ex_en: "Up to 10 pieces",
      ex_th: "Up to 10 pieces",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Description for the Pop-up at Add-Ons",
    },
    {
      _id: "631462cf7a1baccc80de72f7",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 15 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Ex. Lorem ipsum dolor sit amet ...",
      type: "PACKAGE",
      price: 1345,
      ex: "Title for the Pop-up at Add-Ons",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-15T10:09:30.272Z",
      size: "L",
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_2_th: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_en: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_th: "Ex. Lorem ipsum dolor sit amet ...",
      description_en: "Up to 15 pieces",
      description_th: "Up to 15 pieces",
      ex_en: "Title for the Pop-up at Add-Ons",
      ex_th: "Title for the Pop-up at Add-Ons",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Ex. Lorem ipsum dolor sit amet ...",
    },
    {
      _id: "63134c67185a14333bd12da2",
      language: "EN",
      name: "Protection & Waterproofing ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Keep your shoes safe and sound",
      image_key_desktop: "1662716152579_Add-ons (42).png",
      image_key_mobile: "1662716152884_Add-ons (42).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "Our Protection &amp; Waterproofing Add-On keeps your favourite shoes safe from external factors such as rain and dirt.",
      type: "ADDON",
      ex: "Protection & Waterproofing ",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T14:55:07.017Z",
      icon_key: "1662716153013_Add-ons (41).png",
      name_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      name_en: "Protection & Waterproofing ",
      addon_description_en:
        "Our Protection &amp; Waterproofing Add-On keeps your favourite shoes safe from external factors such as rain and dirt.",
      addon_description_2_en:
        "A protective film prevents moisture from penetrating into the shoes while still keeping them breathable and blocks dirt right at the surface to stop any unremovable stains forming. Our shoe cleaning service not only protects your new and favourite shoes but also extends their durability and longevity and is suitable for shoes of all colours and types, from sneakers to leather shoes. We recommend combining Protection &amp; Waterproofing with our Interior Shoe Cleansing and Shoe Perfume Add-Ons to experience the best of our premium shoe cleaning service.",
      addon_description_th:
        "best of our premium shoe cleaning service. ร้านทำความสะอาดรองเท้ามายลอนดรี้มีบริการเคลือบและกันน้ำ ซึ่งช่วยปกป้องรองเท้าคู่โปรดของคุณให้ปลอดภัยจากปัจจัยภายนอก ทั้งฝนและคราบสกปรกต่างๆ โดยมีฟิล์มเคลือบป้องกันไม่ให้ความชื้นซึมเข้าสู่รองเท้า และยังช่วยระบายอากาศได้ดี พร้อมทั้งยับยั้งการเกิดคราบสกปรกบนพื้นผิว รวมถึงป้องกันการก่อตัวของคราบที่ฝังแน่น",
      addon_description_2_th:
        "บริการนี้ไม่เพียงแต่ปกป้องรองเท้าคู่ใหม่สุดโปรดของคุณเท่านั้น แต่ยังช่วยยืดอายุการใช้งานให้นานและเหมาะสำหรับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ร้านทำความสะอาดรองเท้า มายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำร่วมกับบริการทำความสะอาดรองเท้า ด้านในและน้ำหอมสำหรับรองเท้า เพื่อบริการสปารองเท้าระดับพรีเมียมที่ดีที่สุด",
      description_en: "Keep your shoes safe and sound",
      description_th: "ปกป้องรองเท้าของคุณให้ปลอดภัย",
      ex_en: "Protection & Waterproofing ",
      ex_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      addon_description_2:
        "A protective film prevents moisture from penetrating into the shoes while still keeping them breathable and blocks dirt right at the surface to stop any unremovable stains forming. Our shoe cleaning service not only protects your new and favourite shoes but also extends their durability and longevity and is suitable for shoes of all colours and types, from sneakers to leather shoes. We recommend combining Protection &amp; Waterproofing with our Interior Shoe Cleansing and Shoe Perfume Add-Ons to experience the best of our premium shoe cleaning service.",
    },
    {
      _id: "631428327a1baccc80de71e3",
      language: "EN",
      name: "For 1 Pair of shoes",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662716358264_Add-ons (45).png",
      image_key_mobile: "1662716358638_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      type: "PACKAGE",
      ex: "My Shoes Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:13:53.954Z",
      size: "S",
      price: 395,
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 1 Pair of shoes",
      name_th: "สำหรับรองเท้า 1 คู่",
      addon_description_2:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
    },
    {
      _id: "631428327a1baccd80de71e4",
      language: "EN",
      name: "For 2 Pair of shoes",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662716639481_Add-ons (45).png",
      image_key_mobile: "1662716639823_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      type: "PACKAGE",
      ex: "My Shoes Packages: S, M and L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:14:06.960Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 2 Pair of shoes",
      name_th: "สำหรับรองเท้า 2 คู่",
      addon_description_2:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
    },
    {
      _id: "631462cf7a1baccc80ef7207",
      language: "EN",
      name: "For 3 Pair of shoes",
      status: false,
      description: "Returned in 24 Hours",
      image_key_desktop: "1662716709914_Add-ons (45).png",
      image_key_mobile: "1662716710303_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      type: "PACKAGE",
      price: 995,
      ex: "My Shoes Packages: S, M and L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:14:19.358Z",
      size: "L",
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 3 Pair of shoes",
      name_th: "สำหรับรองเท้า 3 คู่",
      addon_description_2:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
    },
    {
      _id: "631ac4517cbbbb34e17f8b19",
      language: "EN",
      name: "Smooth Starch",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "For the ultimate ironing results",
      image_key_desktop: "1662953321455_Add-ons (12).png",
      image_key_mobile: "1662953321745_Add-ons (12).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer.",
      type: "ADDON",
      ex: "Smooth Starch",
      icon_key: "1662699611185_Add-ons (11).png",
      createdAt: "2022-09-09T04:42:57.735Z",
      updatedAt: "2022-11-16T09:32:13.437Z",
      addon_description_2_en:
        "We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free\nfragrance, and pure ironing perfection as part of our premium laundry service. Smooth Starch\nwill give your laundry the ultimate neat and crisp appearance it deserves. You can only select\n\nthe Smooth Starch Add-On if you have already selected the Iron Add-On.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\n\nซึ่งจะช่วยให้ผ้าของคุณสะอาดเรียบร้อยและสดชื่นมีชีวิตชีวามากที่สุด โปรดเลือกเพิ่มเติม น้ำยารีดผ้าเรียบ\n\nหลังจากเลือก รีดผ้า แล้วเท่านั้น",
      addon_description_en:
        "As an Add-On to our professional laundry service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free\nfragrance, and pure ironing perfection as part of our premium laundry service. Smooth Starch\nwill give your laundry the ultimate neat and crisp appearance it deserves. You can only select\n\nthe Smooth Starch Add-On if you have already selected the Iron Add-On.",
    },
    {
      _id: "631ac7117cbbbb34e17f8bb4",
      language: "EN",
      name: "Low Heat Dry",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Drying at a low temperature",
      image_key_desktop: "1668591084915_Add-ons (18).png",
      image_key_mobile: "1668591085221_Add-ons (18).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As standard when you use our professional laundry service, we dry your laundry at an\nappropriate temperature.",
      type: "ADDON",
      ex: "Low Heat Dry",
      icon_key: "1668591085350_Add-ons (17).png",
      createdAt: "2022-09-09T04:54:41.784Z",
      updatedAt: "2022-11-16T12:51:11.973Z",
      addon_description_2_en:
        "With our special Low Heat Dry Add-On, your laundry will be dried at\na low temperature over a longer period. Use the Special Request box before placing your\nlaundry service order if you want us to dry your laundry at a specific temperature, such as 30°C\n\nor 40°C.",
      addon_description_2_th:
        "เมื่อคุณเลือกเพิ่มเติม\nอบแห้งด้วยอุณหภูมิต่ำ เราจะอบเสื้อผ้าของคุณด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ\nหากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่นเช่น 30 หรือ 40 องศาเซลเซียส\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As standard when you use our professional laundry service, we dry your laundry at an\nappropriate temperature.",
      addon_description_th:
        "ในฐานะที่ร้านซักอบรีดมายลอนดรี้เป็นมืออาชีพ\n\nเสื้อผ้าทั้งหมดของคุณจะแห้งด้วยอุณหภูมิที่เหมาะสมตามมาตรฐานของเรา",
      description_en: "Drying at a low temperature",
      description_th: "อบผ้าแห้งโดยใช้อุณหภูมิต่ำ",
      ex_en: "Low Heat Dry",
      ex_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      name_en: "Low Heat Dry",
      name_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      addon_description_2:
        "With our special Low Heat Dry Add-On, your laundry will be dried at\na low temperature over a longer period. Use the Special Request box before placing your\nlaundry service order if you want us to dry your laundry at a specific temperature, such as 30°C\n\nor 40°C.",
    },
    {
      _id: "631adaa316368678b8ed8e59",
      language: "EN",
      name: "Laundry Perfume",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "The extra kick of freshness",
      image_key_desktop: "1662704288283_Add-ons (4).png",
      image_key_mobile: "1662704288867_Add-ons (4).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, our Laundry Perfume is suitable for all\ntypes of fabrics (incl. microfiber and functional wear) and comes with a long-lasting and\nfresh flowery fragrance day after day.",
      type: "ADDON",
      ex: "Laundry Perfume",
      icon_key: "1662704289024_Add-ons (5).png",
      createdAt: "2022-09-09T06:18:11.475Z",
      updatedAt: "2022-11-16T09:33:44.927Z",
      addon_description_2_en:
        "You will smell the Laundry Perfume not only directly after\nwashing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Laundry Perfume does not contain fabric softeners.\nHowever, if you have known allergies you should consider whether this Add-On is suitable for\nyou. Our tip: choose Laundry Perfume every time you use our professional laundry service for\n\nthe best long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับซักผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับซักผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Laundry Perfume is suitable for all\ntypes of fabrics (incl. microfiber and functional wear) and comes with a long-lasting and\nfresh flowery fragrance day after day.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำหอมสำหรับซักผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการซักไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Laundry Perfume",
      ex_th: "น้ำหอมสำหรับซักผ้า",
      name_en: "Laundry Perfume",
      name_th: "น้ำหอมสำหรับซักผ้า",
      addon_description_2:
        "You will smell the Laundry Perfume not only directly after\nwashing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Laundry Perfume does not contain fabric softeners.\nHowever, if you have known allergies you should consider whether this Add-On is suitable for\nyou. Our tip: choose Laundry Perfume every time you use our professional laundry service for\n\nthe best long-lasting smell.",
    },
    {
      _id: "631adb1416368678b8ed8e5e",
      language: "EN",
      name: "Make Whites White Again",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Revive the shining white colour",
      image_key_desktop: "1668591998344_white_shirt.png",
      image_key_mobile: "1668591998663_white_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "A value-added option of our premium laundry service is the Make Whites White Again Add-\nOn which was especially designed to remove the effects of greying and yellowing from white\nfabrics to give them back their original uniform and bright whiteness to the highest extent\npossible.",
      type: "ADDON",
      ex: "Make Whites White Again",
      icon_key: "1668591998771_Default.png",
      createdAt: "2022-09-09T06:20:04.856Z",
      updatedAt: "2022-11-16T09:49:29.916Z",
      addon_description_2_en:
        "Make Whites White Again can be applied with any type of practical clothes (as well\nas white clothes with colour elements) to make them shine brilliant white again. When you\nchoose our Make White White Again Add-On, we separate all the suitable white fabrics\nincluded in your laundry and treat them separately. Of course, all your other chosen Add-Ons\nstill apply as well. If you want us to focus on some of your whites only or in particular, please tell\n\nus in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะผ้าสีขาวบางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A value-added option of our premium laundry service is the Make Whites White Again Add-\nOn which was especially designed to remove the effects of greying and yellowing from white\nfabrics to give them back their original uniform and bright whiteness to the highest extent\npossible.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nซึ่งได้รับการดีไซน์เป็นพิเศษเพื่อขจัดคราบสีเทาและสีเหลืองออกจากผ้าขาว\nทำให้กลับมาขาวสว่างสดใสดังเดิมมากที่สุด นอกจากนี้ตัวเลือก ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nยังใช้ได้กับเสื้อผ้าทั่วไป (รวมถึงผ้าขาวที่มีสีอื่นอยู่ด้วย) เพื่อให้กลับมาขาวเปล่งประกายได้อีกครั้ง\nเมื่อคุณเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง เราจะดูแลผ้าขาวของคุณแยกจากผ้าอื่นๆ",
      description_en: "Revive the shining white colour",
      description_th: "คืนประกายขาวสดใส",
      ex_en: "Make Whites White Again",
      ex_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      name_en: "Make Whites White Again",
      name_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      addon_description_2:
        "Make Whites White Again can be applied with any type of practical clothes (as well\nas white clothes with colour elements) to make them shine brilliant white again. When you\nchoose our Make White White Again Add-On, we separate all the suitable white fabrics\nincluded in your laundry and treat them separately. Of course, all your other chosen Add-Ons\nstill apply as well. If you want us to focus on some of your whites only or in particular, please tell\n\nus in the Special Request box before placing your laundry service order.",
    },
    {
      _id: "631adb9016368678b8ed8e62",
      language: "EN",
      name: "Organic Wash",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "The best organic laundry choice",
      image_key_desktop: "1662704526308_Add-ons (16).png",
      image_key_mobile: "1662704526640_Add-ons (16).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service our Organic Wash comes with no dyes,\nfragrances or preservatives. Our organic detergents and softeners contain only plant-based,\nnaturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents\nand softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do\nnot wish us to use softener in your Organic Wash as part of our quality laundry service, please",
      type: "ADDON",
      ex: "e",
      icon_key: "1662704526746_Add-ons (6).png",
      createdAt: "2022-09-09T06:22:08.116Z",
      updatedAt: "2022-11-16T07:51:49.741Z",
      addon_description_2_en:
        "select the free of charge No Softener Add-On. Organic products are especially gentle to the\nenvironment and therefore strongly recommended. PS: We use a variety of locally and\ninternationally sourced Organic Wash products in our premium laundry service. Use the\nSpecial Request box before placing your laundry service order to tell us your preferences and\n\nwe will fulfil your request whenever possible.",
      addon_description_2_th:
        "กรุณาเลือกเพิ่มเติม ไม่ใช้น้ำยาปรับผ้านุ่ม ผลิตภัณฑ์ออร์แกนิคเป็นมิตรกับสิ่งแวดล้อม\nจึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้ เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service our Organic Wash comes with no dyes,\nfragrances or preservatives. Our organic detergents and softeners contain only plant-based,\nnaturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents\nand softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do\nnot wish us to use softener in your Organic Wash as part of our quality laundry service, please",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิค\n\nซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ\nนอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย\nและยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ",
      description_en: "The best organic laundry choice",
      description_th: "ตัวเลือกดีที่สุดสำหรับทุกคน",
      ex_en: "e",
      ex_th: "t",
      name_en: "Organic Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าออร์แกนิค",
      addon_description_2:
        "select the free of charge No Softener Add-On. Organic products are especially gentle to the\nenvironment and therefore strongly recommended. PS: We use a variety of locally and\ninternationally sourced Organic Wash products in our premium laundry service. Use the\nSpecial Request box before placing your laundry service order to tell us your preferences and\n\nwe will fulfil your request whenever possible.",
    },
    {
      _id: "631adbfc16368678b8ed8e66",
      language: "EN",
      name: "Make Blacks Black Again",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "Revive the true black colour",
      image_key_desktop: "1668592348437_black_shirt.png",
      image_key_mobile: "1668592348780_black_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "A speciality of our premium laundry service is the Make Blacks Black Again Add-On which\nrevives and protects the deep black shade of all your black clothes to make them look as\ngood as new again.",
      type: "ADDON",
      ex: "Make Blacks Black Again",
      icon_key: "1668592348904_Default 2.png",
      createdAt: "2022-09-09T06:23:56.397Z",
      updatedAt: "2022-11-16T09:52:29.518Z",
      addon_description_2_en:
        "Washed-out and faded black clothes will be revived and their colour\nrestored. We recommend repeating the application of our Make Blacks Black Again Add-On\nevery time you notice that your clothes are beginning to fade. When you choose our Make\nBlacks Black Again Add-On, we separate all the suitable black clothes included in your laundry\nand treat them separately. Of course, all your other chosen Add-Ons still apply as well. If you\nwant us to focus on some of your black items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "เราขอแนะนำให้ใช้ตัวเลือกนี้ซ้ำทุกครั้งที่คุณสังเกตเห็นว่าเสื้อผ้าเริ่มมีสีจางลง เมื่อคุณเลือกเพิ่มเติม\nให้ผ้าดำกลับมาสีดำอีกครั้ง เราจะดูแลผ้าสีดำของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ\nที่คุณเลือกจะถูกนำไปใช้ด้วย หากคุณต้องการให้เราเน้นเฉพาะผ้าสีดำบางตัวหรือจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้า\n\nมายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Blacks Black Again Add-On which\nrevives and protects the deep black shade of all your black clothes to make them look as\ngood as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าดำกลับมาสีดำอีกครั้ง\nซึ่งจะช่วยฟื้นคืนสภาพเฉดสีดำให้กลับมาเข้มดังเดิมและปกป้องผ้าสีดำให้ดูดีเหมือนใหม่\n\nช่วยให้สีที่ตกและซีดจางกลับมามีสีดำเข้มอีกครั้ง",
      description_en: "Revive the true black colour",
      description_th: "คืนสภาพสีดำอย่างแท้จริง",
      ex_en: "Make Blacks Black Again",
      ex_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      name_en: "Make Blacks Black Again",
      name_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      addon_description_2:
        "Washed-out and faded black clothes will be revived and their colour\nrestored. We recommend repeating the application of our Make Blacks Black Again Add-On\nevery time you notice that your clothes are beginning to fade. When you choose our Make\nBlacks Black Again Add-On, we separate all the suitable black clothes included in your laundry\nand treat them separately. Of course, all your other chosen Add-Ons still apply as well. If you\nwant us to focus on some of your black items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
    },
    {
      _id: "631adc6816368678b8ed8e6a",
      language: "EN",
      name: "Baby Wash",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Ideal for sensitive baby skin",
      image_key_desktop: "1662704743693_Add-ons (20).png",
      image_key_mobile: "1662704744064_Add-ons (20).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an Add-On to our professional laundry service, our Baby Wash is specially designed for\nsensitive skin requirements and dermatologically tested to prevent allergic reactions.",
      type: "ADDON",
      ex: "e",
      icon_key: "1662704744202_Add-ons (19).png",
      createdAt: "2022-09-09T06:25:44.737Z",
      updatedAt: "2022-11-16T07:52:28.602Z",
      addon_description_2_en:
        "Baby Wash detergents and softeners we use in our quality laundry service are hypoallergenic\nand free of dyes but still strong in removing all the stains your baby loves to make. If you wish\nus to use only detergent and no softener in your Baby Wash, please select the free of charge\nNo Softener Add-On. Good to know: We use a variety of locally and internationally sourced\nBaby Wash products in our premium laundry service. Use the Special Request box before\nplacing your laundry service order to tell us your preferences and we will fulfil your request\n\nwhenever possible.",
      addon_description_2_th:
        "หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าสำหรับเด็กของคุณ กรุณาเลือกเพิ่มเติม\nไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ เรามีผลิตภัณฑ์ซักผ้าสำหรับเด็กทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Baby Wash is specially designed for\nsensitive skin requirements and dermatologically tested to prevent allergic reactions.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ซักผ้าสำหรับเด็ก\n\nซึ่งได้รับการออกแบบเป็นพิเศษเพื่อผิวบอบบางและผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า\nป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้",
      description_en: "Ideal for sensitive baby skin",
      description_th: "เหมาะสำหรับผิวบอบบางของเด็กทารก",
      ex_en: "e",
      ex_th: "t",
      name_en: "Baby Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าสำหรับเด็ก",
      addon_description_2:
        "Baby Wash detergents and softeners we use in our quality laundry service are hypoallergenic\nand free of dyes but still strong in removing all the stains your baby loves to make. If you wish\nus to use only detergent and no softener in your Baby Wash, please select the free of charge\nNo Softener Add-On. Good to know: We use a variety of locally and internationally sourced\nBaby Wash products in our premium laundry service. Use the Special Request box before\nplacing your laundry service order to tell us your preferences and we will fulfil your request\n\nwhenever possible.",
    },
    {
      _id: "631adccc16368678b8ed8e6e",
      language: "EN",
      name: "Make Jeans Blue Again",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "For genuine blue denim",
      image_key_desktop: "1668592518986_jean.png",
      image_key_mobile: "1668592519291_jean.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "A speciality of our premium laundry service is the Make Jeans Blue Again Add-On which\nrevives the original blue colour and protects the classic denim look of all your blue denim\njeans, trousers, skirts, jackets and shirts, to make them look as good as new again.",
      type: "ADDON",
      ex: "Make Jeans Blue Again",
      icon_key: "1668592519406_Default 3.png",
      createdAt: "2022-09-09T06:27:24.518Z",
      updatedAt: "2022-11-16T09:55:19.780Z",
      addon_description_2_en:
        "Washed-\nout and faded colours will be replaced and the typical jeans look will be restored and\nmaintained. We recommend Make Jeans Blue Again solely for classic blue denim items in\norder to give them back their original intensity. When you choose our Make Jeans Blue Again\nAdd-On, we separate all the suitable blue jeans and other denim fabrics included in your\nlaundry and treat them separately. Of course, all your other chosen Add-Ons still apply as well.\nIf you want us to focus on some denim items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "ช่วยให้สีที่ตกและซีดจางกลับมาสีน้ำเงินเข้มอีกครั้ง อีกทั้งฟื้นฟูสภาพและคงเอกลักษณ์ของยีนส์ไว้\nเราขอแนะนำตัวเลือก ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง ใช้กับผ้าเดนิมสีน้ำเงินคลาสสิกเท่านั้น\nเพื่อให้สีของผ้ากลับมาเข้มดั่งเดิม เมื่อคุณเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nเราจะดูแลยีนส์สีน้ำเงินและผ้าเดนิมของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะยีนส์บางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Jeans Blue Again Add-On which\nrevives the original blue colour and protects the classic denim look of all your blue denim\njeans, trousers, skirts, jackets and shirts, to make them look as good as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nซึ่งจะช่วยฟื้นคืนสภาพสีน้ำเงินกลับมาดังเดิมและรักษาภาพลักษณ์อันคลาสสิกของผ้าเดนิมให้กับยีนส์สีน้ำเงิน\nไม่ว่าจะเป็นกางเกง กระโปรง แจ็คเก็ต หรือเสื้อเชิ้ต เพื่อทำให้กลับมาดูดีเหมือนใหม่อีกครั้ง",
      description_en: "For genuine blue denim",
      description_th: "สำหรับผ้าเดนิมสีน้ำเงินแท้",
      ex_en: "Make Jeans Blue Again",
      ex_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      name_en: "Make Jeans Blue Again",
      name_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      addon_description_2:
        "Washed-\nout and faded colours will be replaced and the typical jeans look will be restored and\nmaintained. We recommend Make Jeans Blue Again solely for classic blue denim items in\norder to give them back their original intensity. When you choose our Make Jeans Blue Again\nAdd-On, we separate all the suitable blue jeans and other denim fabrics included in your\nlaundry and treat them separately. Of course, all your other chosen Add-Ons still apply as well.\nIf you want us to focus on some denim items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
    },
    {
      _id: "631add2516368678b8ed8e72",
      language: "EN",
      name: "Stain Removal",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "Removing stains from A to Z",
      image_key_desktop: "1662704932262_Add-ons (24).png",
      image_key_mobile: "1662704932575_Add-ons (24).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "When you select the Stain Removal Add-On, our professional laundry service team screens\nevery item of your laundry from head to toe and makes every effort to remove any stains we\nfind. We can remove many kinds of stains, such as oil, sauces, ketchup, chocolate,\nmayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk,\nyogurt, cream, mould, blood, pus, ballpoint pens, ink, felt tip pens, highlighters, coloured pencils,",
      type: "ADDON",
      ex: "e",
      icon_key: "1662704932707_Add-ons (23).png",
      createdAt: "2022-09-09T06:28:53.237Z",
      updatedAt: "2022-11-16T12:52:35.070Z",
      addon_description_2_en:
        "water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle\nwax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on\nsome items of your laundry in particular, you can tell us in the Special Request box before\n\nplacing your laundry service order.",
      addon_description_2_th:
        "เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์\n\nหมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล\nหากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "When you select the Stain Removal Add-On, our professional laundry service team screens\nevery item of your laundry from head to toe and makes every effort to remove any stains we\nfind. We can remove many kinds of stains, such as oil, sauces, ketchup, chocolate,\nmayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk,\nyogurt, cream, mould, blood, pus, ballpoint pens, ink, felt tip pens, highlighters, coloured pencils,",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้จะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด เราสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต\nมายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา\nคราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้",
      description_en: "Removing stains from A to Z",
      description_th: "ขจัดคราบต่างๆอย่างละเอียด",
      ex_en: "e",
      ex_th: "t",
      name_en: "Stain Removal",
      name_th: "ขจัดคราบ",
      addon_description_2:
        "water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle\nwax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on\nsome items of your laundry in particular, you can tell us in the Special Request box before\n\nplacing your laundry service order.",
    },
    {
      _id: "631add7b16368678b8ed8e76",
      language: "EN",
      name: "Hang",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "We hang on YOUR hangers",
      image_key_desktop: "1668592982195_Add-ons (22).png",
      image_key_mobile: "1668592982478_Add-ons (22).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an optional Add-On of our professional laundry service, we can hang up all hangable\nclothes on YOUR hangers.",
      type: "ADDON",
      ex: "Hang",
      icon_key: "1668592982585_Add-ons (21).png",
      createdAt: "2022-09-09T06:30:19.518Z",
      updatedAt: "2022-11-16T10:03:02.861Z",
      addon_description_2_en:
        "Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your laundry. If there are any specific items in your laundry\nwhich you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your laundry service order.",
      addon_description_2_th: "",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we can hang up all hangable\nclothes on YOUR hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า\nหากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2:
        "Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your laundry. If there are any specific items in your laundry\nwhich you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your laundry service order.",
    },
    {
      _id: "631aecbfad41fef36839ec6d",
      language: "EN",
      name: "Pillows",
      status: false,
      description: "For 2 pillows",
      image_key_desktop: "1662708926562_Add-ons (30).png",
      image_key_mobile: "1662708926877_Add-ons (30).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "In addition to your regular laundry, we are happy to take care of your pillows as well as part of\nour professional laundry service.",
      type: "EXTRA",
      price: 100,
      ex: "Pillows",
      icon_key: "1662708927048_Add-ons (29).png",
      createdAt: "2022-09-09T07:35:27.424Z",
      updatedAt: "2022-11-16T14:41:33.446Z",
      addon_description_2:
        "Please be informed that we can pick up a maximum of 2\npillows in addition to your regular laundry for each order. Our pillow service includes washing\nand drying as default. All other Add-Ons chosen for your laundry will apply for the pillows\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_en:
        "Please be informed that we can pick up a maximum of 2\npillows in addition to your regular laundry for each order. Our pillow service includes washing\nand drying as default. All other Add-Ons chosen for your laundry will apply for the pillows\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_th:
        "ทั้งนี้บริการซักหมอนของเรารวมการซักและอบแห้งเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ\nทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับหมอนโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your pillows as well as part of\nour professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักผ้ามายลอนดรี้ยินดีที่จะดูแลหมอนของคุณด้วย\nโดยเราสามารถรับหมอนได้สูงสุด 2 ใบ ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 2 pillows",
      description_th: "สำหรับหมอน 2 ใบ",
      ex_en: "Pillows",
      ex_th: "หมอน",
      name_en: "Pillows",
      name_th: "หมอน",
    },
    {
      _id: "631aed49fb27f882880c3093",
      language: "EN",
      name: "Bed Sheet or Duvet Cover",
      status: false,
      description: "For 1 piece",
      image_key_desktop: "1662709064359_Add-ons (32).png",
      image_key_mobile: "1662709064672_Add-ons (32).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "In addition to your regular laundry, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional laundry service.",
      type: "EXTRA",
      price: 150,
      ex: "Bed Sheet or Duvet Cover",
      icon_key: "1662709064774_Add-ons (31).png",
      createdAt: "2022-09-09T07:37:45.144Z",
      updatedAt: "2022-11-16T14:42:13.787Z",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular laundry for each order.\nOur bed sheet or duvet cover service includes washing AND ironing as default. All other Add-\nOns chosen for your laundry will apply for the bed sheet or duvet cover automatically, unless\nyou advise us differently in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง\nทั้งนี้บริการผ้าปูที่นอนหรือปลอกผ้านวมของเรารวมการซักและรีดเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Bed Sheet or Duvet Cover",
      ex_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      name_en: "Bed Sheet or Duvet Cover",
      name_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      addon_description_2:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular laundry for each order.\nOur bed sheet or duvet cover service includes washing AND ironing as default. All other Add-\nOns chosen for your laundry will apply for the bed sheet or duvet cover automatically, unless\nyou advise us differently in the Special Request box before placing your laundry service order.",
    },
    {
      _id: "631b005d08f6c6a6bd127b01",
      language: "EN",
      name: "Hang",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "We hang on YOUR hangers",
      image_key_desktop: "1662713948630_Add-ons (22).png",
      image_key_mobile: "1662713948971_Add-ons (22).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an optional Add-On of our professional ironing service, we can hang up all hangable\nclothes on YOUR hangers. Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your order. If there are any specific items in your order",
      type: "ADDON",
      ex: "Hang",
      icon_key: "1662713949093_Add-ons (21).png",
      createdAt: "2022-09-09T08:59:09.812Z",
      updatedAt: "2022-11-16T15:17:25.996Z",
      addon_description_2_en:
        "which you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we can hang up all hangable\nclothes on YOUR hangers. Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your order. If there are any specific items in your order",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2:
        "which you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your ironing service order.",
    },
    {
      _id: "631b00a1d51e9672eb237938",
      language: "EN",
      name: "Ironing Perfume",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "The extra kick of freshness",
      image_key_desktop: "1662714017029_Add-ons (4).png",
      image_key_mobile: "1662714017427_Add-ons (4).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an Add-On to our professional ironing service, our Ironing Perfume is suitable for all types\nof fabrics (incl. microfiber and functional wear) and comes with a long-lasting and fresh\nflowery fragrance day after day.",
      type: "ADDON",
      ex: "Ironing Perfume",
      icon_key: "1662714017569_Add-ons (5).png",
      createdAt: "2022-09-09T09:00:17.934Z",
      updatedAt: "2022-11-16T15:17:54.435Z",
      addon_description_2_en:
        "You will smell the Ironing Perfume not only directly after\nironing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Ironing Perfume does not contain fabric softeners.\nHowever, if you have known allergies, you should consider whether this Add-On is suitable for\nyou. Our tip: choose Ironing Perfume every time you use our professional ironing service for the\n\nbest long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับรีดผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับรีดผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, our Ironing Perfume is suitable for all types\nof fabrics (incl. microfiber and functional wear) and comes with a long-lasting and fresh\nflowery fragrance day after day.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำหอมสำหรับรีดผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการรีดไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Ironing Perfume",
      ex_th: "น้ำหอมสำหรับรีดผ้า",
      name_en: "Ironing Perfume",
      name_th: "น้ำหอมสำหรับรีดผ้า",
      addon_description_2:
        "You will smell the Ironing Perfume not only directly after\nironing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Ironing Perfume does not contain fabric softeners.\nHowever, if you have known allergies, you should consider whether this Add-On is suitable for\nyou. Our tip: choose Ironing Perfume every time you use our professional ironing service for the\n\nbest long-lasting smell.",
    },
    {
      _id: "631b00f0d51e9672eb23794b",
      language: "EN",
      name: "Hang Plus+",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "We hang on OUR hangers",
      image_key_desktop: "1662714096131_Add-ons (26).png",
      image_key_mobile: "1662714096477_Add-ons (26).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As an optional Add-On of our professional ironing service, we hang all hangable clothes on\nOUR basic hangers.",
      type: "ADDON",
      ex: "Hang Plus+",
      icon_key: "1662714096607_Add-ons (25).png",
      createdAt: "2022-09-09T09:01:36.978Z",
      updatedAt: "2022-11-16T15:18:34.118Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your order which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your order which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your ironing service\n\norder.",
    },
    {
      _id: "631b0159d51e9672eb23797c",
      language: "EN",
      name: "Antibacterial Sanitiser",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "For hygienically-clean laundry",
      image_key_desktop: "1662714200531_Add-ons (13).png",
      image_key_mobile: "1662714200900_Add-ons (13).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "As part of our professional ironing service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      type: "ADDON",
      ex: "Antibacterial Sanitiser",
      icon_key: "1662714201026_Add-ons (8).png",
      createdAt: "2022-09-09T09:03:21.398Z",
      updatedAt: "2022-11-16T15:19:19.256Z",
      addon_description_2_en:
        "extra layer of support for an even more hygienically-clean ironing service, our Antibacterial\nSanitiser is free of bleach and can be used with all types of fabrics including children’s clothes.\n\nWe recommend Antibacterial Sanitiser for every ironing service.",
      addon_description_2_th:
        "นอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\n\nรวมทั้งเสื้อผ้าเด็กด้วย\n\nเราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียทุกครั้งที่คุณใช้บริการรีดผ้าของเรา",
      addon_description_en:
        "As part of our professional ironing service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย\n\nซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส รวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย\n\nช่วยเพิ่มระดับของการรีดผ้าให้ถูกสุขอนามัยยิ่งขึ้น",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการรีดผ้าที่ถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "extra layer of support for an even more hygienically-clean ironing service, our Antibacterial\nSanitiser is free of bleach and can be used with all types of fabrics including children’s clothes.\n\nWe recommend Antibacterial Sanitiser for every ironing service.",
    },
    {
      _id: "631b01dcd51e9672eb2379af",
      language: "EN",
      name: "Duvet Cover or Bed Sheet ",
      status: false,
      description: "For 1 piece",
      image_key_desktop: "1662714331435_Add-ons (32).png",
      image_key_mobile: "1662714331763_Add-ons (32).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "In addition to your regular ironing, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional ironing service.",
      type: "EXTRA",
      price: 150,
      ex: "Duvet Cover or Bed Sheet ",
      icon_key: "1662714331974_Add-ons (31).png",
      createdAt: "2022-09-09T09:05:32.438Z",
      updatedAt: "2022-11-16T15:21:01.478Z",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the bed sheet or duvet cover automatically,\nunless you advise us differently in the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ\n\nทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular ironing, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional ironing service.",
      addon_description_th:
        "นอกจากการรีดผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Duvet Cover or Bed Sheet ",
      ex_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      name_en: "Duvet Cover or Bed Sheet ",
      name_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      addon_description_2:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the bed sheet or duvet cover automatically,\nunless you advise us differently in the Special Request box before placing your ironing service order.",
    },
    {
      _id: "631b094c8d95618757de7d7f",
      language: "EN",
      name: "Deodorant & Disinfection ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "Makes your shoes smell like new",
      image_key_desktop: "1662716235912_Add-ons (43).png",
      image_key_mobile: "1662716236277_Add-ons (43).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "With our premium shoe cleaning service, we ensure your shoes look as good as new again – this is our professional shoe cleaning service standard. If you not only want your shoes to look neat on the outside but also care about their inner hygiene, we recommend choosing our Interior Shoe Cleansing Add-On,",
      type: "ADDON",
      ex: "Deodorant & Disinfection ",
      icon_key: "1662716236437_Add-ons (44).png",
      createdAt: "2022-09-09T09:37:17.020Z",
      updatedAt: "2022-11-16T14:56:48.536Z",
      name_th: "ทำความสะอาดรองเท้าด้านใน",
      name_en: "Deodorant & Disinfection ",
      addon_description_en:
        "With our premium shoe cleaning service, we ensure your shoes look as good as new again – this is our professional shoe cleaning service standard. If you not only want your shoes to look neat on the outside but also care about their inner hygiene, we recommend choosing our Interior Shoe Cleansing Add-On,",
      addon_description_2_en:
        "where we will particularly focus on cleaning and disinfecting the often forgotten interior of your shoes, including the insoles as well. Combining Interior Shoe Cleaning with our other Protection &amp; Waterproofing and Shoe Perfume Add-Ons will give your most treasured shoes the ultimate spa experience they deserve. Our professional shoe cleaning service is available for shoes of all colours and types, from sneakers to leather shoes, while we specialise in white shoes and white sneakers made from leather or other modern fabrics.",
      addon_description_th:
        "ร้านทำความสะอาดรองเท้ามายลอนดรี้ให้คุณแน่ใจว่ารองเท้าของคุณจะดูดีเหมือนใหม่อีกครั้ง นี่เป็นมาตรฐานบริการของเรา หากคุณต้องการให้รองเท้าดูดีจากภายนอก และมีสุขอนามัยที่ดีจากภายในด้วย เราขอแนะนำให้คุณเลือกบริการทำความสะอาดรองเท้าด้านใน",
      addon_description_2_th:
        "ซึ่งจะเน้นการทำความสะอาดและฆ่าเชื้อโรครองเท้าด้านในที่มักถูกมองข้าม รวมถึงพื้นรองเท้าด้วย ร้านทำความสะอาดรองเท้ามายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมทำความสะอาดรองเท้าด้านในร่วมกับ ผลิตภัณฑ์เคลือบและกันน้ำและน้ำหอมสำหรับรองเท้า เพื่อสัมผัสประสบการณ์สปารองเท้าขั้นสูงสุด เรายินดีให้บริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง และยังเชี่ยวชาญในการทำความสะอาดรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัยด้วย",
      description_en: "Makes your shoes smell like new",
      description_th: "คืนสุขอนามัยอย่างล้ำลึกถึงพื้นรองเท้า",
      ex_en: "Deodorant & Disinfection ",
      ex_th: "ทำความสะอาดรองเท้าด้านใน",
      addon_description_2:
        "where we will particularly focus on cleaning and disinfecting the often forgotten interior of your shoes, including the insoles as well. Combining Interior Shoe Cleaning with our other Protection &amp; Waterproofing and Shoe Perfume Add-Ons will give your most treasured shoes the ultimate spa experience they deserve. Our professional shoe cleaning service is available for shoes of all colours and types, from sneakers to leather shoes, while we specialise in white shoes and white sneakers made from leather or other modern fabrics.",
    },
    {
      _id: "63720392a142589973ec1e9a",
      language: "EN",
      name: "No Softener ",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "We will not use Softener at all",
      image_key_desktop: "1668587084343_Add-ons (10).png",
      image_key_mobile: "1668587084846_Add-ons (10).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "You can rely on us not to use any softener with your laundry – clear, easy and free of charge.",
      type: "ADDON",
      ex: "No Softener ",
      icon_key: "1668587084964_Add-ons (9).png",
      createdAt: "2022-11-14T09:00:02.224Z",
      updatedAt: "2022-11-16T12:54:02.992Z",
      addon_description_2_en: "",
      addon_description_2_th: "",
      addon_description_en:
        "You can rely on us not to use any softener with your laundry – clear, easy and free of charge.",
      addon_description_th:
        "ให้คุณมั่นใจว่าเราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆในการซักผ้าของคุณ ชัดเจน ง่าย และฟรี",
      description_en: "We will not use Softener at all",
      description_th: "เราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆ",
      ex_en: "No Softener ",
      ex_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      name_en: "No Softener ",
      name_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      addon_description_2: "",
    },
    {
      _id: "637203f8a142589973ec1ea0",
      language: "EN",
      name: "Hang Plus+",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "We hang on OUR hangers",
      image_key_desktop: "1668593118092_Add-ons (26).png",
      image_key_mobile: "1668593118353_Add-ons (26).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As an optional Add-On of our professional laundry service, we hang all hangable clothes on\nOUR basic hangers.",
      type: "ADDON",
      ex: "Hang Plus+",
      icon_key: "1668593118489_Add-ons (25).png",
      createdAt: "2022-11-14T09:01:44.505Z",
      updatedAt: "2022-11-16T10:05:18.764Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your laundry which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your laundry service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your laundry which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your laundry service\n\norder.",
    },
    {
      _id: "63720417a142589973ec1ea9",
      language: "EN",
      name: "Antibacterial Sanitiser",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "For hygienically-clean laundry",
      image_key_desktop: "1670562040139_1668587273739_Add-ons (13).png",
      image_key_mobile: "1668587274101_Add-ons (13).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "As part of our professional laundry service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      type: "ADDON",
      ex: "Antibacterial Sanitiser",
      icon_key: "1668587274241_Add-ons (8).png",
      createdAt: "2022-11-14T09:02:15.384Z",
      updatedAt: "2022-12-09T05:00:41.761Z",
      addon_description_2_en:
        "Providing an\nextra layer of support to the detergent for an even more hygienically-clean laundry service, our\nAntibacterial Sanitiser is free of bleach and can be used with all types of fabrics including\nchildren’s clothes. We recommend Antibacterial Sanitiser for every wash, while for particularly\nhigh hygiene demands, it can be combined with our High Temperature Wash Add-On option to\n\ncreate your very own customised laundry service experience.",
      addon_description_2_th:
        "ช่วยเพิ่มประสิทธิภาพของการซักผ้าให้สะอาดถูกสุขอนามัยยิ่งขึ้น\nนอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\nรวมทั้งเสื้อผ้าเด็กด้วย เราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียสำหรับทุกการซักผ้า\nโดยใช้ร่วมกับตัวเลือกเพิ่มเติมการซักด้วยอุณหภูมิสูง เพื่อสุขอนามัยขั้นพิเศษ",
      addon_description_en:
        "As part of our professional laundry service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย ซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส\nรวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการซักผ้าที่สะอาดถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "Providing an\nextra layer of support to the detergent for an even more hygienically-clean laundry service, our\nAntibacterial Sanitiser is free of bleach and can be used with all types of fabrics including\nchildren’s clothes. We recommend Antibacterial Sanitiser for every wash, while for particularly\nhigh hygiene demands, it can be combined with our High Temperature Wash Add-On option to\n\ncreate your very own customised laundry service experience.",
    },
  ],
  water: [
    {
      _id: "6314264c7a1baccc80de71b5",
      language: "EN",
      name: "350 ml bottle",
      status: false,
      description: "We deliver 3 packs of 16 bottles (48 bottles)",
      image_key_desktop: "1662709691037_Frame 52878 (1).png",
      image_key_mobile: "1662709691409_Frame 52878 (1).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      type: "WATER",
      price: 50,
      ex: "350 ml bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-18T07:08:20.308Z",
      icon_key: "1662709691547_Frame 52878.png",
      addon_description_2:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 16 bottles (48 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      ex_en: "350 ml bottle",
      ex_th: "ขวด 350 มิลลิลิตร",
      name_en: "350 ml bottle",
      name_th: "ขวด 350 มิลลิลิตร",
    },
    {
      _id: "6314264c7a1baccc80de71b6",
      language: "EN",
      name: "1.5 l bottle",
      status: false,
      description: "We deliver 3 packs of 6 bottles (18 bottles)",
      image_key_desktop: "1662709539412_Add-ons (36).png",
      image_key_mobile: "1662709539762_Add-ons (36).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      type: "WATER",
      price: 100,
      ex: "1.5 l bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:06.225Z",
      icon_key: "1662709539873_Add-ons (35).png",
      addon_description_2_en:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 6 bottles (18 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "1.5 l bottle",
      name_th: "ขวด 1.5 ลิตร",
      addon_description_2:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
    },
    {
      _id: "6314264c7a1baccc80de71c6",
      language: "EN",
      name: "600 ml bottle",
      status: false,
      description: "We deliver 3 packs of 12 bottles (36 bottles)",
      image_key_desktop: "1662709814171_Add-ons (38).png",
      image_key_mobile: "1662709814550_Add-ons (38).png",
      addon_description:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      type: "WATER",
      price: 150,
      ex: "1.5 l bottle",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:12.696Z",
      icon_key: "1662709814728_Add-ons (37).png",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 12 bottles (36 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "600 ml bottle",
      name_th: "ขวด 600 มิลลิลิตร",
      addon_description_2:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
    },
  ],
  childrens: [],
};

export const mock_data_pricing_th = {
  addons: [
    {
      _id: "63134c67185a14333bd12ea1",
      language: "EN",
      name: "รีดผ้า",
      s: 1,
      m: 100,
      l: 150,
      status: true,
      description: "บริการรีดผ้าเรียบ ไร้รอยยับ",
      image_key_desktop: "1662699151208_Add-ons (7).png",
      image_key_mobile: "1662699151533_Add-ons (7).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้มีบริการรีดผ้าให้คุณ สำหรับผ้าทุกชิ้นที่เหมาะต่อการรีด ทั้งเสื้อเชิ้ต ชุดกระโปรง\n\nกางเกง ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอนให้คุณแน่ใจ\nหากมีรายการใดที่คุณไม่ต้องการให้เรารีด หรือมีสิ่งใดที่เราต้องให้ความสนใจเป็นพิเศษ",
      type: "ADDON",
      ex: "รีดผ้า",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-12-19T04:40:08.766Z",
      icon_key: "1662633765156_44_Property 1=Variant27.png",
      addon_description_2:
        "เราจะไม่ใช้น้ำยารีดผ้าเรียบใดๆ ในการรีดหรือซักผ้า\n\nฐานรองรีดของเราใช้เทคโนโลยีใหม่ล่าสุดเพื่อให้เสื้อผ้าของคุณเรียบสวยไร้รอยยับมากที่สุด\nหากคุณต้องการความเรียบเนียน กลิ่นหอม และความสมบูรณ์แบบในการรีดขั้นสูงสุด โปรดเลือกเพิ่มเติม\n\nน้ำยารีดผ้าเรียบ หลังจากเลือก รีดผ้า แล้ว",
      addon_description_2_en:
        "As our quality laundry service standard, we do not use any smooth starch when ironing (or washing). Our ironing stations use the latest technology to achieve totally crease-free laundry. However, to meet your individual laundry service requirements, and if you would like to achieve the ultimate level of smoothness, fragrance and pure ironing perfection, please select the Smooth Starch Add-On after you have already selected the Iron Add-On.",
      addon_description_2_th:
        "เราจะไม่ใช้น้ำยารีดผ้าเรียบใดๆ ในการรีดหรือซักผ้า\n\nฐานรองรีดของเราใช้เทคโนโลยีใหม่ล่าสุดเพื่อให้เสื้อผ้าของคุณเรียบสวยไร้รอยยับมากที่สุด\nหากคุณต้องการความเรียบเนียน กลิ่นหอม และความสมบูรณ์แบบในการรีดขั้นสูงสุด โปรดเลือกเพิ่มเติม\n\nน้ำยารีดผ้าเรียบ หลังจากเลือก รีดผ้า แล้ว",
      addon_description_en:
        "As an Add-On to our professional laundry service, we iron EVERY piece of your laundry that is suitable for ironing. Shirts, dresses, trousers, towels, pillow cases and more, all ironed to creaseless perfection at a fixed price with no surprises. If there is any specific item in your laundry that you do not wish us to iron or if there is something that requires special attention, please tell us via the Special Request box before placing your laundry service order.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้มีบริการรีดผ้าให้คุณ สำหรับผ้าทุกชิ้นที่เหมาะต่อการรีด ทั้งเสื้อเชิ้ต ชุดกระโปรง\n\nกางเกง ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอนให้คุณแน่ใจ\nหากมีรายการใดที่คุณไม่ต้องการให้เรารีด หรือมีสิ่งใดที่เราต้องให้ความสนใจเป็นพิเศษ",
      description_en: "Ironing items by smooth starch",
      description_th: "บริการรีดผ้าเรียบ ไร้รอยยับ",
      name_en: "Iron",
      name_th: "รีดผ้า",
      ex_en: "Iron",
      ex_th: "รีดผ้า",
    },
    {
      _id: "631413c80fd8fc3bfd89d79e",
      language: "EN",
      name: "ซักด้วยอุณหภูมิสูง",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "เราซักที่ 60 องศาเซลเซียส",
      image_key_desktop: "1668590690011_Add-ons (15).png",
      image_key_mobile: "1668590690508_Add-ons (15).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ขอแนะนำให้ซักผ้าด้วยอุณหภูมิสูงที่ 60 องศาเซลเซียส สำหรับผ้าเช็ดตัว เครื่องนอน\nเสื้อผ้าเด็กทารกเป็นมาตรฐาน หรือสำหรับเสื้อผ้าทั่วไปหลังจากที่หายจากอาการหวัดหรือติดเชื้อไวรัสแล้ว",
      ex: "ซักด้วยอุณหภูมิสูง",
      createdAt: "2022-09-04T02:56:08.859Z",
      updatedAt: "2022-11-18T11:58:42.380Z",
      type: "ADDON",
      icon_key: "1668590690623_Add-ons (14).png",
      addon_description_2_en:
        "With our High Temperature Wash, your laundry\nwill be hygienically clean, while bacteria and viruses will be eliminated. If you have specific high\nhygiene requirements, we recommend combining our High Temperature Wash with our\nAntibacterial Sanitiser Add-On to create the complete clean and sanitised laundry service. You\ncan tell us in the Special Request box before placing your laundry service order if you want us\nto wash your laundry at a specific temperature, such as 50°C or 90°C, or if you wish to exclude\n\nspecific items from the High Temperature Wash and treat them separately.",
      addon_description_2_th:
        "ด้วยการซักอุณหภูมิสูงของเราทำให้ผ้าสะอาดถูกสุขอนามัย และยังฆ่าเชื้อแบคทีเรียและไวรัสได้อีกด้วย\nขอแนะนำให้รวมการซักด้วยอุณหภูมิสูงกับผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียเพื่อสุขอนามัยขั้นพิเศษ\n\nหากคุณต้องการให้เราซักที่อุณหภูมิอื่นเช่น 50 หรือ 90 องศาเซลเซียส\nหรือประสงค์จะแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As a professional laundry service, we recommend the High Temperature Wash at 60°C Add-\nOn for towels, bedding and baby clothes as standard or for your regular clothes after you\nhave recovered from a cold or viral infection.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ขอแนะนำให้ซักผ้าด้วยอุณหภูมิสูงที่ 60 องศาเซลเซียส สำหรับผ้าเช็ดตัว เครื่องนอน\nเสื้อผ้าเด็กทารกเป็นมาตรฐาน หรือสำหรับเสื้อผ้าทั่วไปหลังจากที่หายจากอาการหวัดหรือติดเชื้อไวรัสแล้ว",
      description_en: "We wash at 60°C",
      description_th: "เราซักที่ 60 องศาเซลเซียส",
      name_en: "High Temperature Wash",
      name_th: "ซักด้วยอุณหภูมิสูง",
      ex_en: "High Temperature Wash ",
      ex_th: "ซักด้วยอุณหภูมิสูง",
      addon_description_2:
        "ด้วยการซักอุณหภูมิสูงของเราทำให้ผ้าสะอาดถูกสุขอนามัย และยังฆ่าเชื้อแบคทีเรียและไวรัสได้อีกด้วย\nขอแนะนำให้รวมการซักด้วยอุณหภูมิสูงกับผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียเพื่อสุขอนามัยขั้นพิเศษ\n\nหากคุณต้องการให้เราซักที่อุณหภูมิอื่นเช่น 50 หรือ 90 องศาเซลเซียส\nหรือประสงค์จะแยกบางรายการออกจากการซักด้วยอุณหภูมิสูง\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "6314264c7a1baccc80de71b5",
      language: "EN",
      name: "ขวด 350 มิลลิลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      image_key_desktop: "1662709691037_Frame 52878 (1).png",
      image_key_mobile: "1662709691409_Frame 52878 (1).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 50,
      ex: "ขวด 350 มิลลิลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-18T07:08:20.308Z",
      icon_key: "1662709691547_Frame 52878.png",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 16 bottles (48 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      ex_en: "350 ml bottle",
      ex_th: "ขวด 350 มิลลิลิตร",
      name_en: "350 ml bottle",
      name_th: "ขวด 350 มิลลิลิตร",
    },
    {
      _id: "631428327a1baccc80de71c2",
      language: "EN",
      name: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662707669485_Add-ons (27).png",
      image_key_mobile: "1662707669866_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Wash S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-12-06T08:36:06.839Z",
      size: "S",
      price: 1,
      master: true,
      master_type: "My Wash",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 22 pieces or 1 x My Laundry Bag",
      name_th: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
    },
    {
      _id: "63142d2e7a1baccc80de71f6",
      language: "EN",
      name: "ผ้านวม หรือ ผ้าห่ม",
      status: false,
      description: "สำหรับ 1 ผืน",
      image_key_desktop: "1662708818450_Add-ons (28).png",
      image_key_mobile: "1662708818835_Add-ons (28).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      type: "EXTRA",
      price: 50,
      ex: "ผ้านวม หรือ ผ้าห่ม",
      createdAt: "2022-09-04T04:44:30.024Z",
      updatedAt: "2022-11-16T14:40:27.166Z",
      icon_key: "1662633859153_13_Property 1=Comforter or Duvet Insert.png",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 comforter or duvet insert in addition to your regular laundry for each order.\nOur comforter or duvet insert service includes washing AND ironing, where possible, as default.\nAll other Add-Ons chosen for your laundry will apply for the comforter or duvet insert\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_th:
        "ทั้งนี้บริการผ้านวมหรือผ้าห่มของเรารวมการซักและรีด หากรีดได้ เป็นมาตรฐาน\n\nส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\n\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your comforter or duvet\ninsert as well as part of our professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Comforter or Duvet Insert",
      ex_th: "ผ้านวม หรือ ผ้าห่ม",
      name_en: "Comforter or Duvet Insert",
      name_th: "ผ้านวม หรือ ผ้าห่ม",
      addon_description_2:
        "ทั้งนี้บริการผ้านวมหรือผ้าห่มของเรารวมการซักและรีด หากรีดได้ เป็นมาตรฐาน\n\nส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\n\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "63142e637a1baccc80de71ff",
      language: "EN",
      name: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662707802497_Add-ons (27).png",
      image_key_mobile: "1662707802853_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Wash S, M และ L",
      createdAt: "2022-09-04T04:49:39.328Z",
      updatedAt: "2022-11-16T15:11:14.871Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Wash",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 44 pieces or 2 x My Laundry Bag",
      name_th: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
    },
    {
      _id: "631462cf7a1baccc80de7205",
      language: "EN",
      name: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662707883149_Add-ons (27).png",
      image_key_mobile: "1662707883497_Add-ons (27).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      price: 995,
      ex: "แพ็กเกจ My Wash S, M และ L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:28:02.766Z",
      size: "L",
      master: true,
      master_type: "My Wash",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all subsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up the original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Wash S Package; two full My Laundry Bags are equal to the My Wash M Package, and three full My Laundry Bags are equal to the My Wash L Package – The My Laundry Service is that easy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
      addon_description_en:
        "The My Wash S, M and L Packages offer you three options when using our professional laundry\nservice that includes the washing &amp; folding of 22 (S), 44 (M) or 66 (L) items of clothing, towels,\npillow cases and more at a fixed price – regardless of their combined weight – with no\nsurprises. You can customise My Wash with various Add-Ons such as Iron if you wish your\nitems to be ironed and we can also take care of your bedding items. PS: 1 pair of socks is equal\n\nto 1 piece – fair and easy!",
      addon_description_th:
        "My Wash มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการซักและพับผ้า 22 ชิ้น (S), 44 ชิ้น (M) และ 66\n\nชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Wash กับตัวเลือกเพิ่มเติมอื่นๆ เช่น รีด\nหากคุณต้องการให้เรารีดผ้าของคุณ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ ถุงเท้า 1 คู่\n\nเท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Wash Packages: S, M and L",
      ex_th: "แพ็กเกจ My Wash S, M และ L",
      name_en: "Up to 66 pieces or 3 x My Laundry Bag",
      name_th: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\n\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป\n\nคุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\n\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nWash S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Wash L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการซักผ้าของเรา!",
    },
    {
      _id: "63134c67185a14333bd12ea2",
      language: "EN",
      name: "น้ำยารีดผ้าเรียบ",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "ให้ผ้าเรียบเนียนที่สุด",
      image_key_desktop: "1662713749933_Add-ons (12).png",
      image_key_mobile: "1662713750525_Add-ons (12).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      type: "ADDON",
      ex: "น้ำยารีดผ้าเรียบ",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T15:16:45.196Z",
      icon_key: "1662634995246_41_Property 1=Smooth Starch.png",
      addon_description_2_en:
        "fragrance, and pure ironing perfection as part of our premium ironing service. Smooth Starch\nwill give your clothes and bedding items the ultimate neat and crisp appearance.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\nซึ่งจะช่วยให้ผ้าและเครื่องนอนของคุณเรียบเนียนสดชื่นมีชีวิตชีวามากที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer. We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\nซึ่งจะช่วยให้ผ้าและเครื่องนอนของคุณเรียบเนียนสดชื่นมีชีวิตชีวามากที่สุด",
    },
    {
      _id: "6314264c7a1baccc80de71b6",
      language: "EN",
      name: "ขวด 1.5 ลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      image_key_desktop: "1662709539412_Add-ons (36).png",
      image_key_mobile: "1662709539762_Add-ons (36).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 100,
      ex: "ขวด 1.5 ลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:06.225Z",
      icon_key: "1662709539873_Add-ons (35).png",
      addon_description_2_en:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 6 bottles (18 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "1.5 l bottle",
      name_th: "ขวด 1.5 ลิตร",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
    },
    {
      _id: "631428327a1baccc80de71c3",
      language: "EN",
      name: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662715257667_Add-ons (40).png",
      image_key_mobile: "1662715258054_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Iron S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:23:35.419Z",
      size: "S",
      price: 395,
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 22 pieces or 1 x My Laundry Bag",
      name_th: "มากถึง 22 ชิ้น หรือ 1 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
    },
    {
      _id: "63142d2e7a1baccc80de71f7",
      language: "EN",
      name: "ผ้านวม หรือ ผ้าห่ม",
      status: false,
      description: "สำหรับ 1 ผืน",
      image_key_desktop: "1662714264226_Add-ons (28).png",
      image_key_mobile: "1662714264591_Add-ons (28).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "นอกจากการรีดผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      type: "EXTRA",
      price: 50,
      ex: "ผ้านวม หรือ ผ้าห่ม",
      createdAt: "2022-09-04T04:44:30.024Z",
      updatedAt: "2022-11-16T15:19:59.658Z",
      icon_key: "1662635128836_13_Property 1=Comforter or Duvet Insert.png",
      addon_description_2_en:
        "Please be informed that we can pick up a\nmaximum of 1 comforter or duvet insert in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the comforter or duvet insert automatically,\nunless you advise us differently in the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular ironing, we are happy to take care of your comforter or duvet insert\nas well as part of our professional ironing service.",
      addon_description_th:
        "นอกจากการรีดผ้าตามปกติแล้ว ร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้านวมหรือผ้าห่มของคุณด้วย\nโดยเราสามารถรับผ้านวมหรือผ้าห่มได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Comforter or Duvet Insert",
      ex_th: "ผ้านวม หรือ ผ้าห่ม",
      name_en: "Comforter or Duvet Insert",
      name_th: "ผ้านวม หรือ ผ้าห่ม",
      addon_description_2:
        "ส่วนเพิ่มเติมอื่นๆทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้านวมหรือผ้าห่มโดยอัตโนมัติ\nเว้นแต่จะแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631428327a1baccc80de71d4",
      language: "EN",
      name: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662715436595_Add-ons (40).png",
      image_key_mobile: "1662715436948_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Iron S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:25:03.421Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 44 pieces or 2 x My Laundry Bag",
      name_th: "มากถึง 44 ชิ้น หรือ 2 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
    },
    {
      _id: "631462cf7a1baccc80de7207",
      language: "EN",
      name: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662715520829_Add-ons (40).png",
      image_key_mobile: "1662715521203_Add-ons (40).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      type: "PACKAGE",
      price: 995,
      ex: "แพ็กเกจ My Iron S, M และ L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:26:26.865Z",
      size: "L",
      master: true,
      master_type: "My Iron",
      addon_description_2_en:
        "Good to know: After your first order, you will receive our original My Laundry Bags for free. For all\nsubsequent laundry orders, you don’t need to count the pieces anymore as you can just fill up\nthe original My Laundry Bag until its full regardless of how many pieces are inside or how\nmuch it weighs as long as you can still close the bag properly. One full My Laundry Bag is equal\nto the My Iron S Package; two full My Laundry Bags are equal to the My Iron M Package, and\nthree full My Laundry Bags are equal to the My Iron L Package – The My Laundry Service is that\n\neasy!\n\nWe are glad to serve you with our laundry expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
      addon_description_en:
        "The My Iron S, M and L Packages offer you three options when you use our professional laundry\nservice (you wash and we iron for you) that includes the ironing &amp; folding of 22 (S), 44 (M) or 66\n(L) items of clothing, towels, pillow cases and more at a fixed price – regardless of their\ncombined weight – with no surprises. You can customise the My Iron with various Add-Ons\nsuch as Smooth Starch if you want to experience an extra level of smoothness, odour-free\nfragrance and pure ironing perfection and we can also take care of your bedding items.\n\nPS: 1 pair of socks is equal to 1 piece – fair and easy!",
      addon_description_th:
        "My Iron คุณซักเอง เรารีดให้ มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการรีดและพับผ้า 22 ชิ้น (S), 44\nชิ้น (M) และ 66 ชิ้น (L) สำหรับเสื้อผ้า ผ้าเช็ดตัว ปลอกหมอน และอื่นๆ ในราคาแน่นอน ให้คุณแน่ใจ\nโดยไม่คำนึงถึงน้ำหนักรวม คุณสามารถรวม My Iron กับตัวเลือกเพิ่มเติมอื่นๆ เช่น น้ำยารีดผ้าเรียบ\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ นอกจากนี้เรายินดีดูแลเครื่องนอนของคุณด้วย หมายเหตุ\n\nถุงเท้า 1 คู่ เท่ากับ 1 ชิ้น ยุติธรรมและง่ายจริงๆ",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Iron Packages: S, M and L",
      ex_th: "แพ็กเกจ My Iron S, M และ L",
      name_en: "Up to 66 pieces or 3 x My Laundry Bag",
      name_th: "มากถึง 66 ชิ้น หรือ 3 ถุงใส่ผ้ามายลอนดรี้",
      addon_description_2:
        "ข้อมูลน่ารู้ หลังจากสั่งออเดอร์ครั้งแรก คุณจะได้รับถุงใส่ผ้ามายลอนดรี้ฟรี\nจากนั้นในการสั่งออเดอร์ครั้งต่อไป คุณไม่จำเป็นต้องนับจำนวนผ้าว่ามีกี่ชิ้นหรือน้ำหนักเท่าไหร่\nเพียงแค่คุณต้องปิดถุงใส่ผ้ามายลอนดรี้ให้เรียบร้อย โดยหนึ่งถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My\n\nIron S สองถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron M\n\nและสามถุงใส่ผ้ามายลอนดรี้เทียบเท่ากับแพ็กเกจ My Iron L ร้านซักผ้ามายลอนดรี้ทำให้คุณสะดวกจริงๆ\n\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการรีดผ้าของเรา!",
    },
    {
      _id: "6314264c7a1baccc80de71c6",
      language: "EN",
      name: "ขวด 600 มิลลิลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      image_key_desktop: "1662709814171_Add-ons (38).png",
      image_key_mobile: "1662709814550_Add-ons (38).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 150,
      ex: "ขวด 1.5 ลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:12.696Z",
      icon_key: "1662709814728_Add-ons (37).png",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 12 bottles (36 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "600 ml bottle",
      name_th: "ขวด 600 มิลลิลิตร",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
    },
    {
      _id: "631428327a1baccc80de71d3",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 5 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Description for the Pop-up at Add-Ons",
      type: "PACKAGE",
      ex: "Up to 5 pieces",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-15T10:08:29.184Z",
      size: "S",
      price: 745,
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Description for the Pop-up at Add-Ons",
      addon_description_2_th: "Description for the Pop-up at Add-Ons",
      addon_description_en: "Description for the Pop-up at Add-Ons",
      addon_description_th: "Description for the Pop-up at Add-Ons",
      description_en: "Up to 5 pieces",
      description_th: "Up to 5 pieces",
      ex_en: "Up to 5 pieces",
      ex_th: "Up to 5 pieces",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Description for the Pop-up at Add-Ons",
    },
    {
      _id: "631428327a1baccc80de71e4",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 10 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Description for the Pop-up at Add-Ons",
      type: "PACKAGE",
      ex: "Up to 10 pieces",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-15T10:09:07.157Z",
      size: "M",
      price: 1045,
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Description for the Pop-up at Add-Ons",
      addon_description_2_th: "Description for the Pop-up at Add-Ons",
      addon_description_en: "Description for the Pop-up at Add-Ons",
      addon_description_th: "Description for the Pop-up at Add-Ons",
      description_en: "Up to 10 pieces",
      description_th: "Up to 10 pieces",
      ex_en: "Up to 10 pieces",
      ex_th: "Up to 10 pieces",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Description for the Pop-up at Add-Ons",
    },
    {
      _id: "631462cf7a1baccc80de72f7",
      language: "EN",
      name: "Returned in 24 Hours",
      status: false,
      description: "Up to 15 pieces",
      image_key_desktop: "",
      image_key_mobile: "",
      master_id: "6310a3d1f095c39af2b75043",
      addon_description: "Ex. Lorem ipsum dolor sit amet ...",
      type: "PACKAGE",
      price: 1345,
      ex: "Title for the Pop-up at Add-Ons",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-15T10:09:30.272Z",
      size: "L",
      master: true,
      master_type: "My Dry",
      addon_description_2_en: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_2_th: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_en: "Ex. Lorem ipsum dolor sit amet ...",
      addon_description_th: "Ex. Lorem ipsum dolor sit amet ...",
      description_en: "Up to 15 pieces",
      description_th: "Up to 15 pieces",
      ex_en: "Title for the Pop-up at Add-Ons",
      ex_th: "Title for the Pop-up at Add-Ons",
      name_en: "Returned in 24 Hours",
      name_th: "Returned in 24 Hours",
      addon_description_2: "Ex. Lorem ipsum dolor sit amet ...",
    },
    {
      _id: "63134c67185a14333bd12da2",
      language: "EN",
      name: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "ปกป้องรองเท้าของคุณให้ปลอดภัย",
      image_key_desktop: "1662716152579_Add-ons (42).png",
      image_key_mobile: "1662716152884_Add-ons (42).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "best of our premium shoe cleaning service. ร้านทำความสะอาดรองเท้ามายลอนดรี้มีบริการเคลือบและกันน้ำ ซึ่งช่วยปกป้องรองเท้าคู่โปรดของคุณให้ปลอดภัยจากปัจจัยภายนอก ทั้งฝนและคราบสกปรกต่างๆ โดยมีฟิล์มเคลือบป้องกันไม่ให้ความชื้นซึมเข้าสู่รองเท้า และยังช่วยระบายอากาศได้ดี พร้อมทั้งยับยั้งการเกิดคราบสกปรกบนพื้นผิว รวมถึงป้องกันการก่อตัวของคราบที่ฝังแน่น",
      type: "ADDON",
      ex: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      createdAt: "2022-09-03T12:45:27.793Z",
      updatedAt: "2022-11-16T14:55:07.017Z",
      icon_key: "1662716153013_Add-ons (41).png",
      name_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      name_en: "Protection & Waterproofing ",
      addon_description_en:
        "Our Protection &amp; Waterproofing Add-On keeps your favourite shoes safe from external factors such as rain and dirt.",
      addon_description_2_en:
        "A protective film prevents moisture from penetrating into the shoes while still keeping them breathable and blocks dirt right at the surface to stop any unremovable stains forming. Our shoe cleaning service not only protects your new and favourite shoes but also extends their durability and longevity and is suitable for shoes of all colours and types, from sneakers to leather shoes. We recommend combining Protection &amp; Waterproofing with our Interior Shoe Cleansing and Shoe Perfume Add-Ons to experience the best of our premium shoe cleaning service.",
      addon_description_th:
        "best of our premium shoe cleaning service. ร้านทำความสะอาดรองเท้ามายลอนดรี้มีบริการเคลือบและกันน้ำ ซึ่งช่วยปกป้องรองเท้าคู่โปรดของคุณให้ปลอดภัยจากปัจจัยภายนอก ทั้งฝนและคราบสกปรกต่างๆ โดยมีฟิล์มเคลือบป้องกันไม่ให้ความชื้นซึมเข้าสู่รองเท้า และยังช่วยระบายอากาศได้ดี พร้อมทั้งยับยั้งการเกิดคราบสกปรกบนพื้นผิว รวมถึงป้องกันการก่อตัวของคราบที่ฝังแน่น",
      addon_description_2_th:
        "บริการนี้ไม่เพียงแต่ปกป้องรองเท้าคู่ใหม่สุดโปรดของคุณเท่านั้น แต่ยังช่วยยืดอายุการใช้งานให้นานและเหมาะสำหรับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ร้านทำความสะอาดรองเท้า มายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำร่วมกับบริการทำความสะอาดรองเท้า ด้านในและน้ำหอมสำหรับรองเท้า เพื่อบริการสปารองเท้าระดับพรีเมียมที่ดีที่สุด",
      description_en: "Keep your shoes safe and sound",
      description_th: "ปกป้องรองเท้าของคุณให้ปลอดภัย",
      ex_en: "Protection & Waterproofing ",
      ex_th: "ผลิตภัณฑ์เคลือบและกันน้ำ",
      addon_description_2:
        "บริการนี้ไม่เพียงแต่ปกป้องรองเท้าคู่ใหม่สุดโปรดของคุณเท่านั้น แต่ยังช่วยยืดอายุการใช้งานให้นานและเหมาะสำหรับรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง ร้านทำความสะอาดรองเท้า มายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมผลิตภัณฑ์เคลือบและกันน้ำร่วมกับบริการทำความสะอาดรองเท้า ด้านในและน้ำหอมสำหรับรองเท้า เพื่อบริการสปารองเท้าระดับพรีเมียมที่ดีที่สุด",
    },
    {
      _id: "631428327a1baccc80de71e3",
      language: "EN",
      name: "สำหรับรองเท้า 1 คู่",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662716358264_Add-ons (45).png",
      image_key_mobile: "1662716358638_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Shoes S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:13:53.954Z",
      size: "S",
      price: 395,
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 1 Pair of shoes",
      name_th: "สำหรับรองเท้า 1 คู่",
      addon_description_2:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
    },
    {
      _id: "631428327a1baccd80de71e4",
      language: "EN",
      name: "สำหรับรองเท้า 2 คู่",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662716639481_Add-ons (45).png",
      image_key_mobile: "1662716639823_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      type: "PACKAGE",
      ex: "แพ็กเกจ My Shoes S, M และ L",
      createdAt: "2022-09-04T04:23:14.659Z",
      updatedAt: "2022-11-16T15:14:06.960Z",
      size: "M",
      price: 695,
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 2 Pair of shoes",
      name_th: "สำหรับรองเท้า 2 คู่",
      addon_description_2:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
    },
    {
      _id: "631462cf7a1baccc80ef7207",
      language: "EN",
      name: "สำหรับรองเท้า 3 คู่",
      status: false,
      description: "ส่งคืนภายใน 24 ชั่วโมง",
      image_key_desktop: "1662716709914_Add-ons (45).png",
      image_key_mobile: "1662716710303_Add-ons (45).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      type: "PACKAGE",
      price: 995,
      ex: "แพ็กเกจ My Shoes S, M และ L",
      createdAt: "2022-09-04T08:33:19.397Z",
      updatedAt: "2022-11-16T15:14:19.358Z",
      size: "L",
      master: true,
      master_type: "My Shoes",
      addon_description_2_en:
        "Good to know: As a premium shoe cleaning service we clean shoes of all colours and types,\nfrom sneakers to leather shoes, while we specialise in white sneakers made from leather or other modern fabrics.\n\nWe are glad to serve you with our shoe cleaning expertise!",
      addon_description_2_th:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
      addon_description_en:
        "The My Shoes S, M and L Packages offer you three options when you use our premium shoe\ncleaning service that includes the cleaning of 1 pair (S), 2 pairs (M) or 3 pairs (L) of shoes at a\nfixed price and with no surprises. You can customise My Shoes with various Add-Ons such as Protection & Waterproofing for ultimate shoe cleaning results.",
      addon_description_th:
        "My Shoes มี 3 แพ็กเกจ S, M และ L ให้คุณเลือก ซึ่งรวมการทำความสะอาดรองเท้า 1 คู่ (S), 2 คู่ (M) หรือ 3 คู่ (L) ในราคาแน่นอน ให้คุณแน่ใจ คุณสามารถรวม My Shoes กับตัวเลือกเพิ่มเติมอื่นๆ เช่น\nผลิตภัณฑ์เคลือบและกันน้ำ เพื่อผลลัพธ์ที่ดีที่สุดในการทำความสะอาดรองเท้า",
      description_en: "Returned in 24 Hours",
      description_th: "ส่งคืนภายใน 24 ชั่วโมง",
      ex_en: "My Shoes Packages: S, M and L",
      ex_th: "แพ็กเกจ My Shoes S, M และ L",
      name_en: "For 3 Pair of shoes",
      name_th: "สำหรับรองเท้า 3 คู่",
      addon_description_2:
        "ข้อมูลน่ารู้ ร้านซักรองเท้ามายลอนดรี้ทำความสะอาดรองเท้าทุกสีทุกประเภท\n\nตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง\n\nเรายังเชี่ยวชาญในการซักรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัย\nเรายินดีให้บริการด้วยความเป็นมืออาชีพด้านการทำความสะอาดรองเท้าของเรา!",
    },
    {
      _id: "631ac4517cbbbb34e17f8b19",
      language: "EN",
      name: "น้ำยารีดผ้าเรียบ",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ให้ผ้าเรียบเนียนที่สุด",
      image_key_desktop: "1662953321455_Add-ons (12).png",
      image_key_mobile: "1662953321745_Add-ons (12).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      type: "ADDON",
      ex: "น้ำยารีดผ้าเรียบ",
      icon_key: "1662699611185_Add-ons (11).png",
      createdAt: "2022-09-09T04:42:57.735Z",
      updatedAt: "2022-11-16T09:32:13.437Z",
      addon_description_2_en:
        "We recommend Smooth Starch if you\nwant to go beyond pure ironing and experience an extra level of smoothness, odour-free\nfragrance, and pure ironing perfection as part of our premium laundry service. Smooth Starch\nwill give your laundry the ultimate neat and crisp appearance it deserves. You can only select\n\nthe Smooth Starch Add-On if you have already selected the Iron Add-On.",
      addon_description_2_th:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\n\nซึ่งจะช่วยให้ผ้าของคุณสะอาดเรียบร้อยและสดชื่นมีชีวิตชีวามากที่สุด โปรดเลือกเพิ่มเติม น้ำยารีดผ้าเรียบ\n\nหลังจากเลือก รีดผ้า แล้วเท่านั้น",
      addon_description_en:
        "As an Add-On to our professional laundry service, we use Smooth Starch to make your\nlaundry feel smoother, smell better and last longer.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำยารีดผ้าเรียบเพื่อให้ผ้าเรียบเนียน มีกลิ่นหอม และอยู่ทรงนาน\n\nหากคุณต้องการสัมผัสความเรียบเนียนอีกระดับ ปราศจากกลิ่นอับชื้น",
      description_en: "For the ultimate ironing results",
      description_th: "ให้ผ้าเรียบเนียนที่สุด",
      name_en: "Smooth Starch",
      name_th: "น้ำยารีดผ้าเรียบ",
      ex_en: "Smooth Starch",
      ex_th: "น้ำยารีดผ้าเรียบ",
      addon_description_2:
        "ให้ความสมบูรณ์แบบในการรีดอย่างแท้จริง เราขอแนะนำน้ำยารีดผ้าเรียบ\n\nซึ่งจะช่วยให้ผ้าของคุณสะอาดเรียบร้อยและสดชื่นมีชีวิตชีวามากที่สุด โปรดเลือกเพิ่มเติม น้ำยารีดผ้าเรียบ\n\nหลังจากเลือก รีดผ้า แล้วเท่านั้น",
    },
    {
      _id: "631ac7117cbbbb34e17f8bb4",
      language: "EN",
      name: "อบแห้งด้วยอุณหภูมิต่ำ",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "อบผ้าแห้งโดยใช้อุณหภูมิต่ำ",
      image_key_desktop: "1668591084915_Add-ons (18).png",
      image_key_mobile: "1668591085221_Add-ons (18).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ในฐานะที่ร้านซักอบรีดมายลอนดรี้เป็นมืออาชีพ\n\nเสื้อผ้าทั้งหมดของคุณจะแห้งด้วยอุณหภูมิที่เหมาะสมตามมาตรฐานของเรา",
      type: "ADDON",
      ex: "อบแห้งด้วยอุณหภูมิต่ำ",
      icon_key: "1668591085350_Add-ons (17).png",
      createdAt: "2022-09-09T04:54:41.784Z",
      updatedAt: "2022-11-16T12:51:11.973Z",
      addon_description_2_en:
        "With our special Low Heat Dry Add-On, your laundry will be dried at\na low temperature over a longer period. Use the Special Request box before placing your\nlaundry service order if you want us to dry your laundry at a specific temperature, such as 30°C\n\nor 40°C.",
      addon_description_2_th:
        "เมื่อคุณเลือกเพิ่มเติม\nอบแห้งด้วยอุณหภูมิต่ำ เราจะอบเสื้อผ้าของคุณด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ\nหากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่นเช่น 30 หรือ 40 องศาเซลเซียส\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As standard when you use our professional laundry service, we dry your laundry at an\nappropriate temperature.",
      addon_description_th:
        "ในฐานะที่ร้านซักอบรีดมายลอนดรี้เป็นมืออาชีพ\n\nเสื้อผ้าทั้งหมดของคุณจะแห้งด้วยอุณหภูมิที่เหมาะสมตามมาตรฐานของเรา",
      description_en: "Drying at a low temperature",
      description_th: "อบผ้าแห้งโดยใช้อุณหภูมิต่ำ",
      ex_en: "Low Heat Dry",
      ex_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      name_en: "Low Heat Dry",
      name_th: "อบแห้งด้วยอุณหภูมิต่ำ",
      addon_description_2:
        "เมื่อคุณเลือกเพิ่มเติม\nอบแห้งด้วยอุณหภูมิต่ำ เราจะอบเสื้อผ้าของคุณด้วยอุณหภูมิต่ำเป็นระยะเวลานานกว่าปกติ\nหากคุณต้องการให้เราอบแห้งที่อุณหภูมิอื่นเช่น 30 หรือ 40 องศาเซลเซียส\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631adaa316368678b8ed8e59",
      language: "EN",
      name: "น้ำหอมสำหรับซักผ้า",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ให้ความสดชื่นสุดพิเศษ",
      image_key_desktop: "1662704288283_Add-ons (4).png",
      image_key_mobile: "1662704288867_Add-ons (4).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำหอมสำหรับซักผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการซักไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      type: "ADDON",
      ex: "น้ำหอมสำหรับซักผ้า",
      icon_key: "1662704289024_Add-ons (5).png",
      createdAt: "2022-09-09T06:18:11.475Z",
      updatedAt: "2022-11-16T09:33:44.927Z",
      addon_description_2_en:
        "You will smell the Laundry Perfume not only directly after\nwashing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Laundry Perfume does not contain fabric softeners.\nHowever, if you have known allergies you should consider whether this Add-On is suitable for\nyou. Our tip: choose Laundry Perfume every time you use our professional laundry service for\n\nthe best long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับซักผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับซักผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Laundry Perfume is suitable for all\ntypes of fabrics (incl. microfiber and functional wear) and comes with a long-lasting and\nfresh flowery fragrance day after day.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำหอมสำหรับซักผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการซักไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Laundry Perfume",
      ex_th: "น้ำหอมสำหรับซักผ้า",
      name_en: "Laundry Perfume",
      name_th: "น้ำหอมสำหรับซักผ้า",
      addon_description_2:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับซักผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับซักผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
    },
    {
      _id: "631adb1416368678b8ed8e5e",
      language: "EN",
      name: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "คืนประกายขาวสดใส",
      image_key_desktop: "1668591998344_white_shirt.png",
      image_key_mobile: "1668591998663_white_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nซึ่งได้รับการดีไซน์เป็นพิเศษเพื่อขจัดคราบสีเทาและสีเหลืองออกจากผ้าขาว\nทำให้กลับมาขาวสว่างสดใสดังเดิมมากที่สุด นอกจากนี้ตัวเลือก ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nยังใช้ได้กับเสื้อผ้าทั่วไป (รวมถึงผ้าขาวที่มีสีอื่นอยู่ด้วย) เพื่อให้กลับมาขาวเปล่งประกายได้อีกครั้ง\nเมื่อคุณเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง เราจะดูแลผ้าขาวของคุณแยกจากผ้าอื่นๆ",
      type: "ADDON",
      ex: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      icon_key: "1668591998771_Default.png",
      createdAt: "2022-09-09T06:20:04.856Z",
      updatedAt: "2022-11-16T09:49:29.916Z",
      addon_description_2_en:
        "Make Whites White Again can be applied with any type of practical clothes (as well\nas white clothes with colour elements) to make them shine brilliant white again. When you\nchoose our Make White White Again Add-On, we separate all the suitable white fabrics\nincluded in your laundry and treat them separately. Of course, all your other chosen Add-Ons\nstill apply as well. If you want us to focus on some of your whites only or in particular, please tell\n\nus in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะผ้าสีขาวบางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A value-added option of our premium laundry service is the Make Whites White Again Add-\nOn which was especially designed to remove the effects of greying and yellowing from white\nfabrics to give them back their original uniform and bright whiteness to the highest extent\npossible.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nซึ่งได้รับการดีไซน์เป็นพิเศษเพื่อขจัดคราบสีเทาและสีเหลืองออกจากผ้าขาว\nทำให้กลับมาขาวสว่างสดใสดังเดิมมากที่สุด นอกจากนี้ตัวเลือก ให้ผ้าขาวกลับมาสีขาวอีกครั้ง\nยังใช้ได้กับเสื้อผ้าทั่วไป (รวมถึงผ้าขาวที่มีสีอื่นอยู่ด้วย) เพื่อให้กลับมาขาวเปล่งประกายได้อีกครั้ง\nเมื่อคุณเลือกเพิ่มเติม ให้ผ้าขาวกลับมาสีขาวอีกครั้ง เราจะดูแลผ้าขาวของคุณแยกจากผ้าอื่นๆ",
      description_en: "Revive the shining white colour",
      description_th: "คืนประกายขาวสดใส",
      ex_en: "Make Whites White Again",
      ex_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      name_en: "Make Whites White Again",
      name_th: "ให้ผ้าขาวกลับมาสีขาวอีกครั้ง",
      addon_description_2:
        "ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะผ้าสีขาวบางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631adb9016368678b8ed8e62",
      language: "EN",
      name: "ผลิตภัณฑ์ซักผ้าออร์แกนิค",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ตัวเลือกดีที่สุดสำหรับทุกคน",
      image_key_desktop: "1662704526308_Add-ons (16).png",
      image_key_mobile: "1662704526640_Add-ons (16).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิค\n\nซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ\nนอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย\nและยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ",
      type: "ADDON",
      ex: "t",
      icon_key: "1662704526746_Add-ons (6).png",
      createdAt: "2022-09-09T06:22:08.116Z",
      updatedAt: "2022-11-16T07:51:49.741Z",
      addon_description_2_en:
        "select the free of charge No Softener Add-On. Organic products are especially gentle to the\nenvironment and therefore strongly recommended. PS: We use a variety of locally and\ninternationally sourced Organic Wash products in our premium laundry service. Use the\nSpecial Request box before placing your laundry service order to tell us your preferences and\n\nwe will fulfil your request whenever possible.",
      addon_description_2_th:
        "กรุณาเลือกเพิ่มเติม ไม่ใช้น้ำยาปรับผ้านุ่ม ผลิตภัณฑ์ออร์แกนิคเป็นมิตรกับสิ่งแวดล้อม\nจึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้ เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service our Organic Wash comes with no dyes,\nfragrances or preservatives. Our organic detergents and softeners contain only plant-based,\nnaturally-sourced and mineral ingredients. Dermatologically tested, our organic detergents\nand softeners are perfectly gentle to sensitive skin but still strong in removing stains. If you do\nnot wish us to use softener in your Organic Wash as part of our quality laundry service, please",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้น้ำยาซักผ้าและปรับผ้านุ่มออร์แกนิค\n\nซึ่งประกอบด้วยส่วนผสมจากพืชที่มาจากธรรมชาติและแร่ธาตุเท่านั้น ไม่มีสี น้ำหอม หรือวัตถุกันเสียใดๆ\nนอกจากนี้ยังผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่าเป็นผลิตภัณฑ์ที่อ่อนโยนต่อผิวบอบบางแพ้ง่าย\nและยังคงขจัดคราบสกปรกได้ดี หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าออร์แกนิคของคุณ",
      description_en: "The best organic laundry choice",
      description_th: "ตัวเลือกดีที่สุดสำหรับทุกคน",
      ex_en: "e",
      ex_th: "t",
      name_en: "Organic Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าออร์แกนิค",
      addon_description_2:
        "กรุณาเลือกเพิ่มเติม ไม่ใช้น้ำยาปรับผ้านุ่ม ผลิตภัณฑ์ออร์แกนิคเป็นมิตรกับสิ่งแวดล้อม\nจึงขอแนะนำให้ใช้ในการซักผ้าอย่างยิ่ง นอกจากนี้ เรามีผลิตภัณฑ์ซักผ้าออร์แกนิคทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631adbfc16368678b8ed8e66",
      language: "EN",
      name: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "คืนสภาพสีดำอย่างแท้จริง",
      image_key_desktop: "1668592348437_black_shirt.png",
      image_key_mobile: "1668592348780_black_shirt.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าดำกลับมาสีดำอีกครั้ง\nซึ่งจะช่วยฟื้นคืนสภาพเฉดสีดำให้กลับมาเข้มดังเดิมและปกป้องผ้าสีดำให้ดูดีเหมือนใหม่\n\nช่วยให้สีที่ตกและซีดจางกลับมามีสีดำเข้มอีกครั้ง",
      type: "ADDON",
      ex: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      icon_key: "1668592348904_Default 2.png",
      createdAt: "2022-09-09T06:23:56.397Z",
      updatedAt: "2022-11-16T09:52:29.518Z",
      addon_description_2_en:
        "Washed-out and faded black clothes will be revived and their colour\nrestored. We recommend repeating the application of our Make Blacks Black Again Add-On\nevery time you notice that your clothes are beginning to fade. When you choose our Make\nBlacks Black Again Add-On, we separate all the suitable black clothes included in your laundry\nand treat them separately. Of course, all your other chosen Add-Ons still apply as well. If you\nwant us to focus on some of your black items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "เราขอแนะนำให้ใช้ตัวเลือกนี้ซ้ำทุกครั้งที่คุณสังเกตเห็นว่าเสื้อผ้าเริ่มมีสีจางลง เมื่อคุณเลือกเพิ่มเติม\nให้ผ้าดำกลับมาสีดำอีกครั้ง เราจะดูแลผ้าสีดำของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ\nที่คุณเลือกจะถูกนำไปใช้ด้วย หากคุณต้องการให้เราเน้นเฉพาะผ้าสีดำบางตัวหรือจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้า\n\nมายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Blacks Black Again Add-On which\nrevives and protects the deep black shade of all your black clothes to make them look as\ngood as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ผ้าดำกลับมาสีดำอีกครั้ง\nซึ่งจะช่วยฟื้นคืนสภาพเฉดสีดำให้กลับมาเข้มดังเดิมและปกป้องผ้าสีดำให้ดูดีเหมือนใหม่\n\nช่วยให้สีที่ตกและซีดจางกลับมามีสีดำเข้มอีกครั้ง",
      description_en: "Revive the true black colour",
      description_th: "คืนสภาพสีดำอย่างแท้จริง",
      ex_en: "Make Blacks Black Again",
      ex_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      name_en: "Make Blacks Black Again",
      name_th: "ให้ผ้าดำกลับมาสีดำอีกครั้ง",
      addon_description_2:
        "เราขอแนะนำให้ใช้ตัวเลือกนี้ซ้ำทุกครั้งที่คุณสังเกตเห็นว่าเสื้อผ้าเริ่มมีสีจางลง เมื่อคุณเลือกเพิ่มเติม\nให้ผ้าดำกลับมาสีดำอีกครั้ง เราจะดูแลผ้าสีดำของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ\nที่คุณเลือกจะถูกนำไปใช้ด้วย หากคุณต้องการให้เราเน้นเฉพาะผ้าสีดำบางตัวหรือจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้า\n\nมายลอนดรี้",
    },
    {
      _id: "631adc6816368678b8ed8e6a",
      language: "EN",
      name: "ผลิตภัณฑ์ซักผ้าสำหรับเด็ก",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "เหมาะสำหรับผิวบอบบางของเด็กทารก",
      image_key_desktop: "1662704743693_Add-ons (20).png",
      image_key_mobile: "1662704744064_Add-ons (20).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ซักผ้าสำหรับเด็ก\n\nซึ่งได้รับการออกแบบเป็นพิเศษเพื่อผิวบอบบางและผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า\nป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้",
      type: "ADDON",
      ex: "t",
      icon_key: "1662704744202_Add-ons (19).png",
      createdAt: "2022-09-09T06:25:44.737Z",
      updatedAt: "2022-11-16T07:52:28.602Z",
      addon_description_2_en:
        "Baby Wash detergents and softeners we use in our quality laundry service are hypoallergenic\nand free of dyes but still strong in removing all the stains your baby loves to make. If you wish\nus to use only detergent and no softener in your Baby Wash, please select the free of charge\nNo Softener Add-On. Good to know: We use a variety of locally and internationally sourced\nBaby Wash products in our premium laundry service. Use the Special Request box before\nplacing your laundry service order to tell us your preferences and we will fulfil your request\n\nwhenever possible.",
      addon_description_2_th:
        "หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าสำหรับเด็กของคุณ กรุณาเลือกเพิ่มเติม\nไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ เรามีผลิตภัณฑ์ซักผ้าสำหรับเด็กทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "As an Add-On to our professional laundry service, our Baby Wash is specially designed for\nsensitive skin requirements and dermatologically tested to prevent allergic reactions.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ซักผ้าสำหรับเด็ก\n\nซึ่งได้รับการออกแบบเป็นพิเศษเพื่อผิวบอบบางและผ่านการทดสอบโดยแพทย์ผิวหนังแล้วว่า\nป้องกันการระคายเคือง ไม่ก่อให้เกิดอาการแพ้ ใดๆ ไม่มีสี และขจัดคราบต่างๆที่เกิดจากลูกน้อยของคุณได้",
      description_en: "Ideal for sensitive baby skin",
      description_th: "เหมาะสำหรับผิวบอบบางของเด็กทารก",
      ex_en: "e",
      ex_th: "t",
      name_en: "Baby Wash",
      name_th: "ผลิตภัณฑ์ซักผ้าสำหรับเด็ก",
      addon_description_2:
        "หากคุณไม่ต้องการให้เราใช้น้ำยาปรับผ้านุ่มในการซักผ้าสำหรับเด็กของคุณ กรุณาเลือกเพิ่มเติม\nไม่ใช้น้ำยาปรับผ้านุ่ม ข้อมูลน่ารู้ เรามีผลิตภัณฑ์ซักผ้าสำหรับเด็กทั้งในและต่างประเทศ\nกรุณาบอกความประสงค์ในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631adccc16368678b8ed8e6e",
      language: "EN",
      name: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "สำหรับผ้าเดนิมสีน้ำเงินแท้",
      image_key_desktop: "1668592518986_jean.png",
      image_key_mobile: "1668592519291_jean.png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nซึ่งจะช่วยฟื้นคืนสภาพสีน้ำเงินกลับมาดังเดิมและรักษาภาพลักษณ์อันคลาสสิกของผ้าเดนิมให้กับยีนส์สีน้ำเงิน\nไม่ว่าจะเป็นกางเกง กระโปรง แจ็คเก็ต หรือเสื้อเชิ้ต เพื่อทำให้กลับมาดูดีเหมือนใหม่อีกครั้ง",
      type: "ADDON",
      ex: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      icon_key: "1668592519406_Default 3.png",
      createdAt: "2022-09-09T06:27:24.518Z",
      updatedAt: "2022-11-16T09:55:19.780Z",
      addon_description_2_en:
        "Washed-\nout and faded colours will be replaced and the typical jeans look will be restored and\nmaintained. We recommend Make Jeans Blue Again solely for classic blue denim items in\norder to give them back their original intensity. When you choose our Make Jeans Blue Again\nAdd-On, we separate all the suitable blue jeans and other denim fabrics included in your\nlaundry and treat them separately. Of course, all your other chosen Add-Ons still apply as well.\nIf you want us to focus on some denim items only or in particular, please tell us in the Special\n\nRequest box before placing your laundry service order.",
      addon_description_2_th:
        "ช่วยให้สีที่ตกและซีดจางกลับมาสีน้ำเงินเข้มอีกครั้ง อีกทั้งฟื้นฟูสภาพและคงเอกลักษณ์ของยีนส์ไว้\nเราขอแนะนำตัวเลือก ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง ใช้กับผ้าเดนิมสีน้ำเงินคลาสสิกเท่านั้น\nเพื่อให้สีของผ้ากลับมาเข้มดั่งเดิม เมื่อคุณเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nเราจะดูแลยีนส์สีน้ำเงินและผ้าเดนิมของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะยีนส์บางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "A speciality of our premium laundry service is the Make Jeans Blue Again Add-On which\nrevives the original blue colour and protects the classic denim look of all your blue denim\njeans, trousers, skirts, jackets and shirts, to make them look as good as new again.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้มีตัวเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nซึ่งจะช่วยฟื้นคืนสภาพสีน้ำเงินกลับมาดังเดิมและรักษาภาพลักษณ์อันคลาสสิกของผ้าเดนิมให้กับยีนส์สีน้ำเงิน\nไม่ว่าจะเป็นกางเกง กระโปรง แจ็คเก็ต หรือเสื้อเชิ้ต เพื่อทำให้กลับมาดูดีเหมือนใหม่อีกครั้ง",
      description_en: "For genuine blue denim",
      description_th: "สำหรับผ้าเดนิมสีน้ำเงินแท้",
      ex_en: "Make Jeans Blue Again",
      ex_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      name_en: "Make Jeans Blue Again",
      name_th: "ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง",
      addon_description_2:
        "ช่วยให้สีที่ตกและซีดจางกลับมาสีน้ำเงินเข้มอีกครั้ง อีกทั้งฟื้นฟูสภาพและคงเอกลักษณ์ของยีนส์ไว้\nเราขอแนะนำตัวเลือก ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง ใช้กับผ้าเดนิมสีน้ำเงินคลาสสิกเท่านั้น\nเพื่อให้สีของผ้ากลับมาเข้มดั่งเดิม เมื่อคุณเลือกเพิ่มเติม ให้ยีนส์กลับมาสีน้ำเงินอีกครั้ง\n\nเราจะดูแลยีนส์สีน้ำเงินและผ้าเดนิมของคุณแยกจากผ้าอื่นๆ ส่วนเพิ่มเติมอื่นๆ ที่คุณเลือกจะถูกนำไปใช้ด้วย\n\nหากคุณต้องการให้เราเน้นเฉพาะยีนส์บางตัวหรือจุดใดเป็นพิเศษ\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631add2516368678b8ed8e72",
      language: "EN",
      name: "ขจัดคราบ",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "ขจัดคราบต่างๆอย่างละเอียด",
      image_key_desktop: "1662704932262_Add-ons (24).png",
      image_key_mobile: "1662704932575_Add-ons (24).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้จะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด เราสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต\nมายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา\nคราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้",
      type: "ADDON",
      ex: "t",
      icon_key: "1662704932707_Add-ons (23).png",
      createdAt: "2022-09-09T06:28:53.237Z",
      updatedAt: "2022-11-16T12:52:35.070Z",
      addon_description_2_en:
        "water colours, grass, soil, pollen, make-up, lipstick, body lotion, nail polish, grease, resin, candle\nwax, industrial oil, tar, chewing gum, glue, rust, deodorant and sweat. If you want us to focus on\nsome items of your laundry in particular, you can tell us in the Special Request box before\n\nplacing your laundry service order.",
      addon_description_2_th:
        "เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์\n\nหมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล\nหากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "When you select the Stain Removal Add-On, our professional laundry service team screens\nevery item of your laundry from head to toe and makes every effort to remove any stains we\nfind. We can remove many kinds of stains, such as oil, sauces, ketchup, chocolate,\nmayonnaise, fat, butter, red wine, tea, coffee, fruits, vegetables, cacao, ice cream, eggs, milk,\nyogurt, cream, mould, blood, pus, ballpoint pens, ink, felt tip pens, highlighters, coloured pencils,",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้จะตรวจสอบเสื้อผ้าของคุณทุกจุดอย่างละเอียดเพื่อขจัดคราบออกอย่างหมดจดให้มากที่สุด เราสามารถขจัดคราบได้หลายประเภท ไม่ว่าจะเป็น คราบน้ำมัน น้ำจิ้ม ซอสมะเขือเทศ ช็อกโกแลต\nมายองเนส คราบไขมัน เนย ไวน์แดง ชา กาแฟ ผลไม้ ผัก โกโก้ ไอศกรีม ไข่ นม โยเกิร์ต ครีม เชื้อรา\nคราบเลือด หนอง ปากกาลูกลื่น น้ำหมึก ปากกาเมจิ ปากกาไฮไลท์ ดินสอสี สีน้ำ หญ้า ดิน เกสรดอกไม้",
      description_en: "Removing stains from A to Z",
      description_th: "ขจัดคราบต่างๆอย่างละเอียด",
      ex_en: "e",
      ex_th: "t",
      name_en: "Stain Removal",
      name_th: "ขจัดคราบ",
      addon_description_2:
        "เครื่องสำอาง ลิปสติก โลชั่นทาตัว ยาทาเล็บ จารบี เรซิ่น เทียนขี้ผึ้ง น้ำมันอุตสาหกรรม น้ำมันดินหรือทาร์\n\nหมากฝรั่ง กาว สนิม ผลิตภัณฑ์ระงับกลิ่นกายและคราบเหงื่อไคล\nหากคุณต้องการให้เราเน้นขจัดคราบจุดใดเป็นพิเศษ\n\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
    },
    {
      _id: "631add7b16368678b8ed8e76",
      language: "EN",
      name: "แขวน",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "เราแขวนด้วยไม้แขวนของคุณ",
      image_key_desktop: "1668592982195_Add-ons (22).png",
      image_key_mobile: "1668592982478_Add-ons (22).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า\nหากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      type: "ADDON",
      ex: "แขวน",
      icon_key: "1668592982585_Add-ons (21).png",
      createdAt: "2022-09-09T06:30:19.518Z",
      updatedAt: "2022-11-16T10:03:02.861Z",
      addon_description_2_en:
        "Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your laundry. If there are any specific items in your laundry\nwhich you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your laundry service order.",
      addon_description_2_th: "",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we can hang up all hangable\nclothes on YOUR hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า\nหากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2: "",
    },
    {
      _id: "631aecbfad41fef36839ec6d",
      language: "EN",
      name: "หมอน",
      status: false,
      description: "สำหรับหมอน 2 ใบ",
      image_key_desktop: "1662708926562_Add-ons (30).png",
      image_key_mobile: "1662708926877_Add-ons (30).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักผ้ามายลอนดรี้ยินดีที่จะดูแลหมอนของคุณด้วย\nโดยเราสามารถรับหมอนได้สูงสุด 2 ใบ ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      type: "EXTRA",
      price: 100,
      ex: "หมอน",
      icon_key: "1662708927048_Add-ons (29).png",
      createdAt: "2022-09-09T07:35:27.424Z",
      updatedAt: "2022-11-16T14:41:33.446Z",
      addon_description_2:
        "ทั้งนี้บริการซักหมอนของเรารวมการซักและอบแห้งเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ\nทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับหมอนโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_2_en:
        "Please be informed that we can pick up a maximum of 2\npillows in addition to your regular laundry for each order. Our pillow service includes washing\nand drying as default. All other Add-Ons chosen for your laundry will apply for the pillows\nautomatically, unless you advise us differently in the Special Request box before placing your\n\nlaundry service order.",
      addon_description_2_th:
        "ทั้งนี้บริการซักหมอนของเรารวมการซักและอบแห้งเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ\nทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับหมอนโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักผ้ามายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your pillows as well as part of\nour professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว ร้านซักผ้ามายลอนดรี้ยินดีที่จะดูแลหมอนของคุณด้วย\nโดยเราสามารถรับหมอนได้สูงสุด 2 ใบ ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 2 pillows",
      description_th: "สำหรับหมอน 2 ใบ",
      ex_en: "Pillows",
      ex_th: "หมอน",
      name_en: "Pillows",
      name_th: "หมอน",
    },
    {
      _id: "631aed49fb27f882880c3093",
      language: "EN",
      name: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      status: false,
      description: "สำหรับ 1 ผืน",
      image_key_desktop: "1662709064359_Add-ons (32).png",
      image_key_mobile: "1662709064672_Add-ons (32).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "นอกจากการซักผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง\nทั้งนี้บริการผ้าปูที่นอนหรือปลอกผ้านวมของเรารวมการซักและรีดเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ",
      type: "EXTRA",
      price: 150,
      ex: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      icon_key: "1662709064774_Add-ons (31).png",
      createdAt: "2022-09-09T07:37:45.144Z",
      updatedAt: "2022-11-16T14:42:13.787Z",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular laundry for each order.\nOur bed sheet or duvet cover service includes washing AND ironing as default. All other Add-\nOns chosen for your laundry will apply for the bed sheet or duvet cover automatically, unless\nyou advise us differently in the Special Request box before placing your laundry service order.",
      addon_description_2_th:
        "ทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular laundry, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional laundry service.",
      addon_description_th:
        "นอกจากการซักผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง\nทั้งนี้บริการผ้าปูที่นอนหรือปลอกผ้านวมของเรารวมการซักและรีดเป็นมาตรฐาน ส่วนเพิ่มเติมอื่นๆ",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Bed Sheet or Duvet Cover",
      ex_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      name_en: "Bed Sheet or Duvet Cover",
      name_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      addon_description_2:
        "ทั้งหมดที่คุณเลือกสำหรับการซักรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631b005d08f6c6a6bd127b01",
      language: "EN",
      name: "แขวน",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "เราแขวนด้วยไม้แขวนของคุณ",
      image_key_desktop: "1662713948630_Add-ons (22).png",
      image_key_mobile: "1662713948971_Add-ons (22).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า",
      type: "ADDON",
      ex: "แขวน",
      icon_key: "1662713949093_Add-ons (21).png",
      createdAt: "2022-09-09T08:59:09.812Z",
      updatedAt: "2022-11-16T15:17:25.996Z",
      addon_description_2_en:
        "which you wish us to hang up, or which you wish us to exclude from hanging up, please tell us\n\nvia the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we can hang up all hangable\nclothes on YOUR hangers. Kindly ensure you provide enough hangers inside the laundry bag or\nin a separate bag when we pick up your order. If there are any specific items in your order",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนของคุณ\n\nกรุณาตรวจสอบให้แน่ใจว่าคุณมีไม้แขวนเพียงพอในถุงใส่ผ้าหรือใส่แยกต่างหากในถุงอื่นเวลาเรามารับผ้า",
      description_en: "We hang on YOUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของคุณ",
      ex_en: "Hang",
      ex_th: "แขวน",
      name_en: "Hang",
      name_th: "แขวน",
      addon_description_2:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631b00a1d51e9672eb237938",
      language: "EN",
      name: "น้ำหอมสำหรับรีดผ้า",
      s: 50,
      m: 100,
      l: 150,
      status: false,
      description: "ให้ความสดชื่นสุดพิเศษ",
      image_key_desktop: "1662714017029_Add-ons (4).png",
      image_key_mobile: "1662714017427_Add-ons (4).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำหอมสำหรับรีดผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการรีดไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      type: "ADDON",
      ex: "น้ำหอมสำหรับรีดผ้า",
      icon_key: "1662714017569_Add-ons (5).png",
      createdAt: "2022-09-09T09:00:17.934Z",
      updatedAt: "2022-11-16T15:17:54.435Z",
      addon_description_2_en:
        "You will smell the Ironing Perfume not only directly after\nironing, but also when your clothes are in the wardrobe and when you wear them. Start your\nday with the extra kick of freshness! Our Ironing Perfume does not contain fabric softeners.\nHowever, if you have known allergies, you should consider whether this Add-On is suitable for\nyou. Our tip: choose Ironing Perfume every time you use our professional ironing service for the\n\nbest long-lasting smell.",
      addon_description_2_th:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับรีดผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับรีดผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
      addon_description_en:
        "As an Add-On to our professional ironing service, our Ironing Perfume is suitable for all types\nof fabrics (incl. microfiber and functional wear) and comes with a long-lasting and fresh\nflowery fragrance day after day.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้น้ำหอมสำหรับรีดผ้า ซึ่งเหมาะกับผ้าทุกประเภท\n\n(รวมถึงไมโครไฟเบอร์และเสื้อผ้าในกิจกรรมต่างๆด้วย) และยังให้กลิ่นหอมสดชื่นของดอกไม้ที่ติดทนยาวนาน\n\nคุณจะได้กลิ่นหอมตั้งแต่หลังการรีดไปจนถึงในตู้เสื้อผ้าและเวลาสวมใส่",
      description_en: "The extra kick of freshness",
      description_th: "ให้ความสดชื่นสุดพิเศษ",
      ex_en: "Ironing Perfume",
      ex_th: "น้ำหอมสำหรับรีดผ้า",
      name_en: "Ironing Perfume",
      name_th: "น้ำหอมสำหรับรีดผ้า",
      addon_description_2:
        "เริ่มต้นวันใหม่ด้วยความสดชื่นสุดพิเศษ!\n\nน้ำหอมสำหรับรีดผ้าของเราไม่มีส่วนผสมของผลิตภัณฑ์ปรับผ้านุ่มใดๆ หากคุณมีอาการแพ้\n\nควรพิจารณาว่าตัวเลือกเพิ่มเติมนี้เหมาะกับคุณหรือไม่\n\nเราขอแนะนำให้เลือกน้ำหอมสำหรับรีดผ้าทุกครั้งที่ใช้บริการ เพื่อให้ผ้ามีกลิ่นหอมยาวนานที่สุด",
    },
    {
      _id: "631b00f0d51e9672eb23794b",
      language: "EN",
      name: "แขวนพิเศษ",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "เราแขวนด้วยไม้แขวนของเรา",
      image_key_desktop: "1662714096131_Add-ons (26).png",
      image_key_mobile: "1662714096477_Add-ons (26).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      type: "ADDON",
      ex: "แขวนพิเศษ",
      icon_key: "1662714096607_Add-ons (25).png",
      createdAt: "2022-09-09T09:01:36.978Z",
      updatedAt: "2022-11-16T15:18:34.118Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your order which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your ironing service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional ironing service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631b0159d51e9672eb23797c",
      language: "EN",
      name: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      s: 80,
      m: 100,
      l: 150,
      status: false,
      description: "เพื่อการรีดผ้าที่ถูกสุขอนามัย",
      image_key_desktop: "1662714200531_Add-ons (13).png",
      image_key_mobile: "1662714200900_Add-ons (13).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย\n\nซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส รวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย\n\nช่วยเพิ่มระดับของการรีดผ้าให้ถูกสุขอนามัยยิ่งขึ้น",
      type: "ADDON",
      ex: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      icon_key: "1662714201026_Add-ons (8).png",
      createdAt: "2022-09-09T09:03:21.398Z",
      updatedAt: "2022-11-16T15:19:19.256Z",
      addon_description_2_en:
        "extra layer of support for an even more hygienically-clean ironing service, our Antibacterial\nSanitiser is free of bleach and can be used with all types of fabrics including children’s clothes.\n\nWe recommend Antibacterial Sanitiser for every ironing service.",
      addon_description_2_th:
        "นอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\n\nรวมทั้งเสื้อผ้าเด็กด้วย\n\nเราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียทุกครั้งที่คุณใช้บริการรีดผ้าของเรา",
      addon_description_en:
        "As part of our professional ironing service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย\n\nซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส รวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย\n\nช่วยเพิ่มระดับของการรีดผ้าให้ถูกสุขอนามัยยิ่งขึ้น",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการรีดผ้าที่ถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "นอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\n\nรวมทั้งเสื้อผ้าเด็กด้วย\n\nเราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียทุกครั้งที่คุณใช้บริการรีดผ้าของเรา",
    },
    {
      _id: "631b01dcd51e9672eb2379af",
      language: "EN",
      name: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      status: false,
      description: "สำหรับ 1 ผืน",
      image_key_desktop: "1662714331435_Add-ons (32).png",
      image_key_mobile: "1662714331763_Add-ons (32).png",
      master_id: "6310a3cff095c39af2b75041",
      addon_description:
        "นอกจากการรีดผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      type: "EXTRA",
      price: 150,
      ex: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      icon_key: "1662714331974_Add-ons (31).png",
      createdAt: "2022-09-09T09:05:32.438Z",
      updatedAt: "2022-11-16T15:21:01.478Z",
      addon_description_2_en:
        "Please be informed that we can pick\nup a maximum of 1 bed sheet or duvet cover in addition to your regular items for each order. All\nother Add-Ons chosen for your ironing will apply to the bed sheet or duvet cover automatically,\nunless you advise us differently in the Special Request box before placing your ironing service order.",
      addon_description_2_th:
        "ส่วนเพิ่มเติมอื่นๆ\n\nทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "In addition to your regular ironing, we are happy to take care of your bed sheets or duvet\ncovers as well as part of our professional ironing service.",
      addon_description_th:
        "นอกจากการรีดผ้าตามปกติแล้ว\n\nร้านซักอบรีดมายลอนดรี้ยินดีที่จะดูแลผ้าปูที่นอนหรือปลอกผ้านวมของคุณด้วย\nโดยเราสามารถรับผ้าปูที่นอนหรือปลอกผ้านวมได้สูงสุด 1 ผืน ต่อการสั่งออเดอร์ในแต่ละครั้ง",
      description_en: "For 1 piece",
      description_th: "สำหรับ 1 ผืน",
      ex_en: "Duvet Cover or Bed Sheet ",
      ex_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      name_en: "Duvet Cover or Bed Sheet ",
      name_th: "ผ้าปูที่นอน หรือ ปลอกผ้านวม",
      addon_description_2:
        "ส่วนเพิ่มเติมอื่นๆ\n\nทั้งหมดที่คุณเลือกสำหรับการรีดเสื้อผ้าจะถูกนำไปใช้กับผ้าปูที่นอนหรือปลอกผ้านวมโดยอัตโนมัติ\nเว้นแต่คุณจะแจ้งเราในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "631b094c8d95618757de7d7f",
      language: "EN",
      name: "ทำความสะอาดรองเท้าด้านใน",
      s: 80,
      m: 100,
      l: 150,
      status: true,
      description: "คืนสุขอนามัยอย่างล้ำลึกถึงพื้นรองเท้า",
      image_key_desktop: "1662716235912_Add-ons (43).png",
      image_key_mobile: "1662716236277_Add-ons (43).png",
      master_id: "6310a3d1f095c39af2b75045",
      addon_description:
        "ร้านทำความสะอาดรองเท้ามายลอนดรี้ให้คุณแน่ใจว่ารองเท้าของคุณจะดูดีเหมือนใหม่อีกครั้ง นี่เป็นมาตรฐานบริการของเรา หากคุณต้องการให้รองเท้าดูดีจากภายนอก และมีสุขอนามัยที่ดีจากภายในด้วย เราขอแนะนำให้คุณเลือกบริการทำความสะอาดรองเท้าด้านใน",
      type: "ADDON",
      ex: "ทำความสะอาดรองเท้าด้านใน",
      icon_key: "1662716236437_Add-ons (44).png",
      createdAt: "2022-09-09T09:37:17.020Z",
      updatedAt: "2022-11-16T14:56:48.536Z",
      name_th: "ทำความสะอาดรองเท้าด้านใน",
      name_en: "Deodorant & Disinfection ",
      addon_description_en:
        "With our premium shoe cleaning service, we ensure your shoes look as good as new again – this is our professional shoe cleaning service standard. If you not only want your shoes to look neat on the outside but also care about their inner hygiene, we recommend choosing our Interior Shoe Cleansing Add-On,",
      addon_description_2_en:
        "where we will particularly focus on cleaning and disinfecting the often forgotten interior of your shoes, including the insoles as well. Combining Interior Shoe Cleaning with our other Protection &amp; Waterproofing and Shoe Perfume Add-Ons will give your most treasured shoes the ultimate spa experience they deserve. Our professional shoe cleaning service is available for shoes of all colours and types, from sneakers to leather shoes, while we specialise in white shoes and white sneakers made from leather or other modern fabrics.",
      addon_description_th:
        "ร้านทำความสะอาดรองเท้ามายลอนดรี้ให้คุณแน่ใจว่ารองเท้าของคุณจะดูดีเหมือนใหม่อีกครั้ง นี่เป็นมาตรฐานบริการของเรา หากคุณต้องการให้รองเท้าดูดีจากภายนอก และมีสุขอนามัยที่ดีจากภายในด้วย เราขอแนะนำให้คุณเลือกบริการทำความสะอาดรองเท้าด้านใน",
      addon_description_2_th:
        "ซึ่งจะเน้นการทำความสะอาดและฆ่าเชื้อโรครองเท้าด้านในที่มักถูกมองข้าม รวมถึงพื้นรองเท้าด้วย ร้านทำความสะอาดรองเท้ามายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมทำความสะอาดรองเท้าด้านในร่วมกับ ผลิตภัณฑ์เคลือบและกันน้ำและน้ำหอมสำหรับรองเท้า เพื่อสัมผัสประสบการณ์สปารองเท้าขั้นสูงสุด เรายินดีให้บริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง และยังเชี่ยวชาญในการทำความสะอาดรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัยด้วย",
      description_en: "Makes your shoes smell like new",
      description_th: "คืนสุขอนามัยอย่างล้ำลึกถึงพื้นรองเท้า",
      ex_en: "Deodorant & Disinfection ",
      ex_th: "ทำความสะอาดรองเท้าด้านใน",
      addon_description_2:
        "ซึ่งจะเน้นการทำความสะอาดและฆ่าเชื้อโรครองเท้าด้านในที่มักถูกมองข้าม รวมถึงพื้นรองเท้าด้วย ร้านทำความสะอาดรองเท้ามายลอนดรี้ขอแนะนำให้ใช้ตัวเลือกเพิ่มเติมทำความสะอาดรองเท้าด้านในร่วมกับ ผลิตภัณฑ์เคลือบและกันน้ำและน้ำหอมสำหรับรองเท้า เพื่อสัมผัสประสบการณ์สปารองเท้าขั้นสูงสุด เรายินดีให้บริการทำความสะอาดรองเท้าทุกสีทุกประเภท ตั้งแต่รองเท้าผ้าใบไปจนถึงรองเท้าหนัง และยังเชี่ยวชาญในการทำความสะอาดรองเท้าผ้าใบสีขาวที่ทำจากหนังหรือวัสดุทันสมัยด้วย",
    },
    {
      _id: "63720392a142589973ec1e9a",
      language: "EN",
      name: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "เราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆ",
      image_key_desktop: "1668587084343_Add-ons (10).png",
      image_key_mobile: "1668587084846_Add-ons (10).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ให้คุณมั่นใจว่าเราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆในการซักผ้าของคุณ ชัดเจน ง่าย และฟรี",
      type: "ADDON",
      ex: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      icon_key: "1668587084964_Add-ons (9).png",
      createdAt: "2022-11-14T09:00:02.224Z",
      updatedAt: "2022-11-16T12:54:02.992Z",
      addon_description_2_en: "",
      addon_description_2_th: "",
      addon_description_en:
        "You can rely on us not to use any softener with your laundry – clear, easy and free of charge.",
      addon_description_th:
        "ให้คุณมั่นใจว่าเราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆในการซักผ้าของคุณ ชัดเจน ง่าย และฟรี",
      description_en: "We will not use Softener at all",
      description_th: "เราจะไม่ใส่น้ำยาปรับผ้านุ่มใดๆ",
      ex_en: "No Softener ",
      ex_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      name_en: "No Softener ",
      name_th: "ไม่ใช้น้ำยาปรับผ้านุ่ม",
      addon_description_2: "",
    },
    {
      _id: "637203f8a142589973ec1ea0",
      language: "EN",
      name: "แขวนพิเศษ",
      s: 50,
      m: 50,
      l: 50,
      status: true,
      description: "เราแขวนด้วยไม้แขวนของเรา",
      image_key_desktop: "1668593118092_Add-ons (26).png",
      image_key_mobile: "1668593118353_Add-ons (26).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      type: "ADDON",
      ex: "แขวนพิเศษ",
      icon_key: "1668593118489_Add-ons (25).png",
      createdAt: "2022-11-14T09:01:44.505Z",
      updatedAt: "2022-11-16T10:05:18.764Z",
      addon_description_2_en:
        "You do not need to provide any hangers for us. If there are any specific\nitems included in your laundry which you wish us to hang up, or which you wish us to exclude\nfrom hanging up, please tell us via the Special Request box before placing your laundry service\n\norder.",
      addon_description_2_th:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
      addon_description_en:
        "As an optional Add-On of our professional laundry service, we hang all hangable clothes on\nOUR basic hangers.",
      addon_description_th:
        "ร้านซักอบรีดมายลอนดรี้แขวนเสื้อผ้าที่แขวนได้ทั้งหมดบนไม้แขวนมาตรฐานของเรา\n\nคุณไม่จำเป็นต้องเตรียมไม้แขวนเอง",
      description_en: "We hang on OUR hangers",
      description_th: "เราแขวนด้วยไม้แขวนของเรา",
      ex_en: "Hang Plus+",
      ex_th: "แขวนพิเศษ",
      name_en: "Hang Plus+",
      name_th: "แขวนพิเศษ",
      addon_description_2:
        "หากมีรายการใดที่คุณเจาะจงให้เราแขวนหรือประสงค์จะแยกบางรายการออกจากการแขวน\nกรุณาแจ้งในช่องความต้องการพิเศษก่อนสั่งออเดอร์กับร้านซักอบรีดมายลอนดรี้",
    },
    {
      _id: "63720417a142589973ec1ea9",
      language: "EN",
      name: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      s: 50,
      m: 100,
      l: 150,
      status: true,
      description: "เพื่อการซักผ้าที่สะอาดถูกสุขอนามัย",
      image_key_desktop: "1670562040139_1668587273739_Add-ons (13).png",
      image_key_mobile: "1668587274101_Add-ons (13).png",
      master_id: "6310a054f095c39af2b7503e",
      addon_description:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย ซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส\nรวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย",
      type: "ADDON",
      ex: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      icon_key: "1668587274241_Add-ons (8).png",
      createdAt: "2022-11-14T09:02:15.384Z",
      updatedAt: "2022-12-09T05:00:41.761Z",
      addon_description_2_en:
        "Providing an\nextra layer of support to the detergent for an even more hygienically-clean laundry service, our\nAntibacterial Sanitiser is free of bleach and can be used with all types of fabrics including\nchildren’s clothes. We recommend Antibacterial Sanitiser for every wash, while for particularly\nhigh hygiene demands, it can be combined with our High Temperature Wash Add-On option to\n\ncreate your very own customised laundry service experience.",
      addon_description_2_th:
        "ช่วยเพิ่มประสิทธิภาพของการซักผ้าให้สะอาดถูกสุขอนามัยยิ่งขึ้น\nนอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\nรวมทั้งเสื้อผ้าเด็กด้วย เราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียสำหรับทุกการซักผ้า\nโดยใช้ร่วมกับตัวเลือกเพิ่มเติมการซักด้วยอุณหภูมิสูง เพื่อสุขอนามัยขั้นพิเศษ",
      addon_description_en:
        "As part of our professional laundry service, our Antibacterial Sanitiser Add-On has been\ndeveloped to kill bacteria and viruses on clothes, including the corona virus.",
      addon_description_th:
        "ร้านซักผ้ามายลอนดรี้ใช้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย ซึ่งได้รับการพัฒนาให้สามารถฆ่าเชื้อแบคทีเรียและไวรัส\nรวมถึงไวรัสโคโรนาที่อยู่ในเสื้อผ้าด้วย",
      description_en: "For hygienically-clean laundry",
      description_th: "เพื่อการซักผ้าที่สะอาดถูกสุขอนามัย",
      ex_en: "Antibacterial Sanitiser",
      ex_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      name_en: "Antibacterial Sanitiser",
      name_th: "ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรีย",
      addon_description_2:
        "ช่วยเพิ่มประสิทธิภาพของการซักผ้าให้สะอาดถูกสุขอนามัยยิ่งขึ้น\nนอกจากนี้ผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียยังปราศจากสารฟอกขาวและสามารถใช้ได้กับผ้าทุกประเภท\nรวมทั้งเสื้อผ้าเด็กด้วย เราขอแนะนำผลิตภัณฑ์ฆ่าเชื้อแบคทีเรียสำหรับทุกการซักผ้า\nโดยใช้ร่วมกับตัวเลือกเพิ่มเติมการซักด้วยอุณหภูมิสูง เพื่อสุขอนามัยขั้นพิเศษ",
    },
  ],
  water: [
    {
      _id: "6314264c7a1baccc80de71b5",
      language: "EN",
      name: "ขวด 350 มิลลิลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      image_key_desktop: "1662709691037_Frame 52878 (1).png",
      image_key_mobile: "1662709691409_Frame 52878 (1).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 50,
      ex: "ขวด 350 มิลลิลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-18T07:08:20.308Z",
      icon_key: "1662709691547_Frame 52878.png",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 16 X 350 ml bottles of Finn\nDrinking Water for a total of 48 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 350 มิลลิลิตร จำนวน 3 แพ็ก แพ็กละ 16 ขวด\nรวมทั้งหมด 48 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 16 bottles (48 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 16 ขวด (48 ขวด)",
      ex_en: "350 ml bottle",
      ex_th: "ขวด 350 มิลลิลิตร",
      name_en: "350 ml bottle",
      name_th: "ขวด 350 มิลลิลิตร",
    },
    {
      _id: "6314264c7a1baccc80de71b6",
      language: "EN",
      name: "ขวด 1.5 ลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      image_key_desktop: "1662709539412_Add-ons (36).png",
      image_key_mobile: "1662709539762_Add-ons (36).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 100,
      ex: "ขวด 1.5 ลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:06.225Z",
      icon_key: "1662709539873_Add-ons (35).png",
      addon_description_2_en:
        "boxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 6 X 1.5 l bottles of Finn\nDrinking Water for a total of 18 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each\norder to a total of 3 packs of one bottle size due to the capacity limitations of our delivery",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 1.5 ลิตรจำนวน 3 แพ็ก แพ็กละ 6 ขวด รวมทั้งหมด 18\n\nขวด\n\nทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 6 bottles (18 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 6 ขวด (18 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "1.5 l bottle",
      name_th: "ขวด 1.5 ลิตร",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
    },
    {
      _id: "6314264c7a1baccc80de71c6",
      language: "EN",
      name: "ขวด 600 มิลลิลิตร",
      status: false,
      description: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      image_key_desktop: "1662709814171_Add-ons (38).png",
      image_key_mobile: "1662709814550_Add-ons (38).png",
      addon_description:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      type: "WATER",
      price: 150,
      ex: "ขวด 1.5 ลิตร",
      createdAt: "2022-09-04T04:15:08.618Z",
      updatedAt: "2022-11-16T14:53:12.696Z",
      icon_key: "1662709814728_Add-ons (37).png",
      addon_description_2_en:
        "order to a total of 3 packs of one bottle size due to the capacity limitations of our delivery\nboxes. Finn Drinking Water is a premium quality drinking water brand that is quickly growing in\npopularity due to its extraordinary taste and attractive pricing strategy compared to\ninternational brands. Try Finn one time and you will never want any other brand of drinking\n\nwater again!",
      addon_description_2_th:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
      addon_description_en:
        "Finn – Drinking Water For You! This package contains 3 packs of 12 X 600 ml bottles of Finn\nDrinking Water for a total of 36 bottles. Each time you book our professional laundry service or\nshoe cleaning service, you now also have the option of ordering our family-owned Finn\nDrinking Water to be delivered to your doorstep when we pick up your order. We limit each",
      addon_description_th:
        "ฟิน น้ำดื่มสำหรับคุณ! แพ็กเกจนี้ประกอบด้วยน้ำดื่ม 600 มิลลิลิตรจำนวน 3 แพ็ก แพ็กละ 12 ขวด รวมทั้งหมด\n\n36 ขวด ทุกครั้งที่คุณใช้บริการซักผ้าหรือทำความสะอาดรองเท้าของเรา\nคุณสามารถเลือกสั่งน้ำดื่มฟินไปส่งถึงหน้าบ้าน เวลาเราไปรับออเดอร์ของคุณ",
      description_en: "We deliver 3 packs of 12 bottles (36 bottles)",
      description_th: "เราส่งน้ำ 3 แพ็ก แพ็กละ 12 ขวด (36 ขวด)",
      ex_en: "1.5 l bottle",
      ex_th: "ขวด 1.5 ลิตร",
      name_en: "600 ml bottle",
      name_th: "ขวด 600 มิลลิลิตร",
      addon_description_2:
        "เราจำกัดการสั่งน้ำดื่มฟินขนาดเดียวกันทั้งหมด 3 แพ็กต่อหนึ่งออเดอร์\nเนื่องด้วยพื้นที่จำกัดของกล่องรับส่งสินค้า น้ำดื่มฟินเป็นน้ำดื่มคุณภาพระดับพรีเมียม\n\nซึ่งกำลังเป็นที่นิยมอย่างรวดเร็ว ด้วยรสชาติที่ดีและราคาที่เหมาะสมเมื่อเทียบกับยี่ห้ออื่นๆ ลองดื่มฟินสักครั้ง\n\nแล้วคุณจะไม่อยากดื่มยี่ห้ออื่นอีกเลย!",
    },
  ],
  childrens: [],
};

export const mock_calender = [
  {
    _id: "647cc342da80e0600c875438",
    date: "19 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 0,
    season_mix_booked: 0,
    season_mix_remaining: 0,
    status: false,
    location: "BANGKOK",
    day: "2023-06-19T17:00:50.536Z",
    showDate: "6.19.2023",
    createdAt: "2023-06-04T17:00:50.616Z",
    updatedAt: "2023-06-16T01:21:37.663Z",
  },
  {
    _id: "647e14c26f3f9afbc9969b46",
    date: "20 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 0,
    season_mix_booked: 0,
    season_mix_remaining: 0,
    status: false,
    location: "BANGKOK",
    day: "2023-06-20T17:00:50.643Z",
    showDate: "6.20.2023",
    createdAt: "2023-06-05T17:00:50.719Z",
    updatedAt: "2023-06-19T03:46:36.182Z",
  },
  {
    _id: "647f66420712306959fcb9a3",
    date: "21 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 0,
    season_mix_booked: 0,
    season_mix_remaining: 0,
    status: false,
    location: "BANGKOK",
    day: "2023-06-21T17:00:50.830Z",
    showDate: "6.21.2023",
    createdAt: "2023-06-06T17:00:50.971Z",
    updatedAt: "2023-06-19T03:46:36.320Z",
  },
  {
    _id: "6480b7c27f7b47d402d44136",
    date: "22 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 0,
    season_mix_booked: 0,
    season_mix_remaining: 0,
    status: false,
    location: "BANGKOK",
    day: "2023-06-22T17:00:50.663Z",
    showDate: "6.22.2023",
    createdAt: "2023-06-07T17:00:50.809Z",
    updatedAt: "2023-06-14T07:34:28.263Z",
  },
  {
    _id: "6482094242a594b04f0324c4",
    date: "23 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 0,
    season_mix_booked: 0,
    season_mix_remaining: 0,
    status: false,
    location: "BANGKOK",
    day: "2023-06-23T17:00:50.488Z",
    showDate: "6.23.2023",
    createdAt: "2023-06-08T17:00:50.572Z",
    updatedAt: "2023-06-14T07:34:33.368Z",
  },
  {
    _id: "64835ac2abef1aabeb18daa2",
    date: "24 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 0,
    season_mix_booked: 0,
    season_mix_remaining: 0,
    status: false,
    location: "BANGKOK",
    day: "2023-06-24T17:00:50.537Z",
    showDate: "6.24.2023",
    createdAt: "2023-06-09T17:00:50.757Z",
    updatedAt: "2023-06-14T07:34:38.263Z",
  },
  {
    _id: "6484ac424bc4bd34d9891601",
    date: "25 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 0,
    season_mix_booked: 0,
    season_mix_remaining: 0,
    status: false,
    location: "BANGKOK",
    day: "2023-06-25T17:00:50.437Z",
    showDate: "6.25.2023",
    createdAt: "2023-06-10T17:00:50.859Z",
    updatedAt: "2023-06-14T07:34:44.041Z",
  },
  {
    _id: "6485fdc254eca6ea21e47ace",
    date: "26 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 30,
    season_mix_booked: 0,
    season_mix_remaining: 30,
    status: false,
    location: "BANGKOK",
    day: "2023-06-26T17:00:50.651Z",
    showDate: "6.26.2023",
    createdAt: "2023-06-11T17:00:50.741Z",
    updatedAt: "2023-06-14T07:34:48.905Z",
  },
  {
    _id: "64874f42ac93c88fa9ec40b3",
    date: "27 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 30,
    season_mix_booked: 0,
    season_mix_remaining: 30,
    status: false,
    location: "BANGKOK",
    day: "2023-06-27T17:00:50.523Z",
    showDate: "6.27.2023",
    createdAt: "2023-06-12T17:00:50.598Z",
    updatedAt: "2023-06-14T07:34:53.882Z",
  },
  {
    _id: "6488a0c29e76e45ffc6a3eef",
    date: "28 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 30,
    season_mix_booked: 0,
    season_mix_remaining: 30,
    status: false,
    location: "BANGKOK",
    day: "2023-06-28T17:00:50.621Z",
    showDate: "6.28.2023",
    createdAt: "2023-06-13T17:00:50.692Z",
    updatedAt: "2023-06-14T07:34:58.703Z",
  },
  {
    _id: "6489f24293f0c434868c4294",
    date: "29 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 30,
    season_mix_booked: 0,
    season_mix_remaining: 30,
    status: false,
    location: "BANGKOK",
    day: "2023-06-29T17:00:50.760Z",
    showDate: "6.29.2023",
    createdAt: "2023-06-14T17:00:50.843Z",
    updatedAt: "2023-06-15T04:49:30.606Z",
  },
  {
    _id: "648b43c2fa9fd83200f2380a",
    date: "30 June",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 30,
    season_mix_booked: 0,
    season_mix_remaining: 30,
    status: false,
    location: "BANGKOK",
    day: "2023-06-30T17:00:50.376Z",
    showDate: "6.30.2023",
    createdAt: "2023-06-15T17:00:50.453Z",
    updatedAt: "2023-06-19T00:51:30.366Z",
  },
  {
    _id: "648c95427c4dd008aa8f751c",
    date: "1 July",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 30,
    season_mix_booked: 0,
    season_mix_remaining: 30,
    status: false,
    location: "BANGKOK",
    day: "2023-07-01T17:00:50.760Z",
    showDate: "7.1.2023",
    createdAt: "2023-06-16T17:00:50.836Z",
    updatedAt: "2023-06-19T00:51:34.486Z",
  },
  {
    _id: "648de6c24cd0d7a35119e2d9",
    date: "2 July",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 30,
    season_mix_booked: 0,
    season_mix_remaining: 30,
    status: false,
    location: "BANGKOK",
    day: "2023-07-02T17:00:50.396Z",
    showDate: "7.2.2023",
    createdAt: "2023-06-17T17:00:50.472Z",
    updatedAt: "2023-06-19T00:51:39.264Z",
  },
  {
    _id: "648f38421241f551ed822e87",
    date: "3 July",
    season_one_planned: 0,
    season_one_booked: 0,
    season_one_remaining: 0,
    season_two_planned: 0,
    season_two_booked: 0,
    season_two_remaining: 0,
    season_three_planned: 0,
    season_three_booked: 0,
    season_three_remaining: 0,
    season_four_planned: 0,
    season_four_booked: 0,
    season_four_remaining: 0,
    season_five_planned: 0,
    season_five_booked: 0,
    season_five_remaining: 0,
    season_six_planned: 0,
    season_six_booked: 0,
    season_six_remaining: 0,
    season_mix_planned: 30,
    season_mix_booked: 0,
    season_mix_remaining: 30,
    status: false,
    location: "BANGKOK",
    day: "2023-07-03T17:00:50.458Z",
    showDate: "7.3.2023",
    createdAt: "2023-06-18T17:00:50.532Z",
    updatedAt: "2023-06-19T00:51:46.724Z",
  },
];
